webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumbs_vue__ = __webpack_require__(71);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bd48251_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumbs_vue__ = __webpack_require__(144);
function injectStyle (ssrContext) {
  __webpack_require__(143)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5bd48251"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumbs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bd48251_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumbs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatusBar_vue__ = __webpack_require__(73);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67573909_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatusBar_vue__ = __webpack_require__(152);
function injectStyle (ssrContext) {
  __webpack_require__(148)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67573909"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatusBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67573909_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatusBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}

/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Signin__ = __webpack_require__(135);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var $ = window.$;
var firebase = window.firebase;
var db = firebase.firestore();

function logError(errorCode, error) {
  console.log(errorCode);
  console.log(error);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Signin: __WEBPACK_IMPORTED_MODULE_2__components_Signin__["a" /* default */]
  },
  data: function data() {
    return {
      appPathPrefix: window.location.hostname === 'localhost' ? '' : '',
      detachKnownDataListener: null,
      detachMemoSetsListener: null,
      detachSharedMemoSetsListener: null,
      detachTextListener: null,
      detachUsersListener: null,
      memoSets: null,
      knownData: null,
      languages: [{ countryCode: 'cn', name: '中文' }, { countryCode: 'de', name: 'Deutsch' }, { countryCode: 'gb', name: 'English (UK)' }, { countryCode: 'us', name: 'English (US)' }, { countryCode: 'es', name: 'Español' }, { countryCode: 'fr', name: 'Français' }],
      ready: false,
      sharedMemoSets: null,
      statuses: {},
      statusesTimeout: null,
      text: {},
      textEnglish: {
        commonAdd: 'Add',
        commonCancel: 'Cancel',
        commonDelete: 'Delete',
        commonOK: 'OK',
        commonRedo: 'Redo',
        commonRows: 'Rows',
        commonSearchPlaceholder: 'Search...',
        commonStatus: 'Status',
        commonUndo: 'Undo',
        memoSetActions: 'Actions',
        memoSetAddAudio: 'Add Audio',
        memoSetAddColumn: 'Add Column',
        memoSetAddImage: 'Add Image',
        memoSetAddQuestion: 'Add Question',
        memoSetAddRows: 'Add Rows',
        memoSetAddToMyMemoSets: 'Add to My Memo Sets',
        memoSetAll: 'All',
        memoSetAlreadyPublic: 'This memo set is already shared publicly.',
        memoSetApplyToSubsequentRowsLeft: 'Apply to',
        memoSetApplyToSubsequentRowsRight: 'subsequent rows',
        memoSetAsAbove: 'as above',
        memoSetAuthor: 'Author',
        memoSetBackgroundPhoto: 'Background Photo',
        memoSetClip: 'Clip',
        memoSetColumns: 'Columns',
        memoSetCongrats: 'Congratulations, you’re up to date for this memo set!',
        memoSetCongratsContinue: 'You can continue reviewing if you like.',
        memoSetCongratsGroup: 'Congratulations, you’re up to date for the selected group!',
        memoSetCongratsGroups: 'Congratulations, you’re up to date for the selected groups!',
        memoSetCongratsQuestion: 'Congratulations, you’re up to date for the selected question!',
        memoSetCongratsQuestions: 'Congratulations, you’re up to date for the selected questions!',
        memoSetCongratsQuestionGroup: 'Congratulations, you’re up to date for the selected question and group!',
        memoSetCongratsQuestionGroups: 'Congratulations, you’re up to date for the selected question and groups!',
        memoSetCongratsQuestionsGroup: 'Congratulations, you’re up to date for the selected questions and group!',
        memoSetCongratsQuestionsGroups: 'Congratulations, you’re up to date for the selected questions and groups!',
        memoSetCopy: 'Copy',
        memoSetCopyMemoSet: 'Copy Memo Set',
        memoSetCoverImage: 'Cover Image',
        memoSetDefaultColumn1: 'Column 1',
        memoSetDefaultColumn2: 'Column 2',
        memoSetDefaultDescription: 'Enter any notes about the memo set here...',
        memoSetDefaultQuestion: 'What is the <toField> for <fromField> *?',
        memoSetDefaultQuestionFromImage: 'What is the <toField> for this <fromField>?<br><br>*',
        memoSetDefaultQuestionFromImageToSummaryImage: 'What is the summary image for this <fromField>?<br><br>*',
        memoSetDefaultQuestionFromSummaryImage: 'What is the <toField> for this summary image?<br><br>*',
        memoSetDefaultQuestionToSummaryImage: 'What is the summary image for <fromField> *?',
        memoSetDelete: 'Delete',
        memoSetDeleteColumn: 'Delete Column',
        memoSetDeleteImage: 'Delete Image',
        memoSetDeleteMemoSet: 'Delete Memo Set',
        memoSetDeleteMemoSetContent: 'Are you sure you want to delete the memo set *?',
        memoSetDeleteRows: 'Delete Rows',
        memoSetDescription: 'Description',
        memoSetEditQuestion: 'Edit Question',
        memoSetErase: 'Erase',
        memoSetExample: 'Example',
        memoSetExportData: 'Export Data',
        memoSetExportSuccessful: 'Export Successful',
        memoSetExportSuccessfulDetail: 'The memo set’s data has been copied to your clipboard, and can now be pasted into a spreadsheet or text document.',
        memoSetExportUnsuccessful: 'Export Unsuccessful',
        memoSetExportUnsuccessfulDetail: 'Oops, something has gone wrong. The memo set’s data was not exported.',
        memoSetFlipHorizontal: 'Flip Horizontal',
        memoSetFlipVertical: 'Flip Vertical',
        memoSetFolder: 'Folder',
        memoSetFromColumn: 'From Column',
        memoSetGoToMyMemoSet: 'Go to My Memo Set',
        memoSetGroup: 'Group',
        memoSetGroups: 'Groups',
        memoSetLearn: 'Learn',
        memoSetMoveColumn: 'Move Column',
        memoSetMoveRows: 'Move Rows',
        memoSetMyRating: 'My Rating',
        memoSetNewFolderLabel: 'New Folder',
        memoSetNewFolderItem: '(New Folder)',
        memoSetNewNamePre: 'Copy of ',
        memoSetNewNamePost: '',
        memoSetNextRows: 'Next Rows',
        memoSetNoData: 'No data!',
        memoSetNoGroups: 'No groups are selected!',
        memoSetNone: 'None',
        memoSetNoQuestionsDefinedHdr: 'No questions are defined!',
        memoSetNoQuestionsDefined: 'Add a question to use the Learn feature.',
        memoSetNoQuestionsSelected: 'No questions are selected!',
        memoSetNotes: 'Notes',
        memoSetOptions: 'Options',
        memoSetOriginalAuthor: 'Original Author',
        memoSetPanLock: 'Pan Lock',
        memoSetPasteImageHere: 'Paste image here...',
        memoSetPopulateColumn: 'Populate Column',
        memoSetPreviousRows: 'Previous Rows',
        memoSetPrint: 'Print',
        memoSetPublic: 'Public',
        memoSetQuestion: 'Question',
        memoSetQuestions: 'Questions',
        memoSetRemoveColor: 'Remove Color',
        memoSetResetLearning: 'Reset Learning',
        memoSetReset: 'Are you sure you want to reset your learning data for this memo set?',
        memoSetResetGroup: 'Are you sure you want to reset your learning data for the selected group?',
        memoSetResetGroups: 'Are you sure you want to reset your learning data for the selected groups?',
        memoSetResetQuestion: 'Are you sure you want to reset your learning data for the selected question?',
        memoSetResetQuestions: 'Are you sure you want to reset your learning data for the selected questions?',
        memoSetResetQuestionGroup: 'Are you sure you want to reset your learning data for the selected question and group?',
        memoSetResetQuestionGroups: 'Are you sure you want to reset your learning data for the selected question and groups?',
        memoSetResetQuestionsGroup: 'Are you sure you want to reset your learning data for the selected questions and group?',
        memoSetResetQuestionsGroups: 'Are you sure you want to reset your learning data for the selected questions and groups?',
        memoSetRow: 'Row',
        memoSetSendToBack: 'Send to Back',
        memoSetSetCoverImage: 'Set Cover Image',
        memoSetShare: 'Share',
        memoSetSharedWith: 'Shared With',
        memoSetSortRows: 'Sort Rows',
        memoSetSuitable: 'Please ensure that any content shared publicly is suitable for children.',
        memoSetSummaryImage: 'Summary Image',
        memoSetTabData: 'Data',
        memoSetTabInfo: 'Info',
        memoSetTabLearn: 'Learn',
        memoSetTabQuestions: 'Questions',
        memoSetTitle: 'Title',
        memoSetToColumn: 'To Column',
        memoSetUploadingImage: 'Uploading image...',
        memoSetUploadingImages: 'Uploading <remaining> images...',
        memoSetUseBackgroundPhotos: 'Use Background Photos',
        memoSetUseGroups: 'Use Groups',
        memoSetUsernameOrEmail: 'Username or email address...',
        memoSetUseSummaryImages: 'Use Summary Images',
        memoSetViewQuestion: 'Question',
        memoSetWalkThrough: 'Walk Through',
        memoSetZoomIn: 'Zoom In',
        memoSetZoomOut: 'Zoom Out',
        memoSetZoomToSelected: 'Zoom to Selected',
        memoSetsAddAFolder: 'Add a folder',
        memoSetsAddAMemoSet: 'Add a memo set',
        memoSetsColumnImage: 'Image',
        memoSetsColumnMemoSet: 'Memo Set',
        memoSetsColumnRows: 'Rows',
        memoSetsDefaultTitle: 'New memo set',
        memoSetsNewFolder: 'New Folder',
        navForum: 'Forum',
        navHome: 'Home',
        navInfoContactUs: 'Contact Us',
        navInfoGuide: 'Guide',
        navInfoPrivacy: 'Privacy Policy',
        navInfoTerms: 'Terms of Use',
        navInfoTitle: 'Information',
        navLanguageTitle: 'Language',
        navMemoSets: 'My Memo Sets',
        navPublicMemoSets: 'Public Memo Sets',
        navSharedMemoSets: 'Shared With Me',
        navTutorials: 'Tutorials',
        navUserMyAccount: 'My Account',
        navUserSignOut: 'Sign Out',
        publicAuthor: 'Author',
        publicNoMemoSets: 'No memo sets were found.',
        publicRating: 'Average Rating'
      },
      touch: false,
      user: {},
      window: {
        height: window.innerHeight,
        width: window.innerWidth
      }
    };
  },

  computed: {
    mobile: function mobile() {
      return this.window.width < 767;
    }
  },
  created: function created() {
    window.vmApp = this;
    var self = this;
    // Add window resize listener
    window.addEventListener('resize', function (event) {
      self.window.height = window.innerHeight;
      self.window.width = window.innerWidth;
    });
    firebase.auth().onAuthStateChanged(function (user) {
      if (self.detachUsersListener) {
        self.detachUsersListener();
        self.detachUsersListener = null;
      }
      if (self.detachKnownDataListener) {
        self.detachKnownDataListener();
        self.detachKnownDataListener = null;
      }
      if (self.detachMemoSetsListener) {
        self.detachMemoSetsListener();
        self.detachMemoSetsListener = null;
      }
      if (self.detachSharedMemoSetsListener) {
        self.detachSharedMemoSetsListener();
        self.detachSharedMemoSetsListener = null;
      }
      if (user) {
        // Listen to user data
        self.detachUsersListener = db.doc('users/' + user.uid).onSnapshot(function (doc) {
          if (doc.exists) {
            // Save previous language code
            var previousUiLanguage = self.user.uiLanguage || '';
            // Update user data
            self.user = doc.data();
            self.user.id = user.uid;
            // Load text if we don't already have it
            if (self.user.uiLanguage !== previousUiLanguage) {
              self.loadText();
            }
          }
        }, function (error) {
          logError('App_onAuthStateChanged_1', error);
        });
        // Listen to memo sets data
        self.detachMemoSetsListener = db.collection('users/' + user.uid + '/memoSets').onSnapshot(function (snapshot) {
          // Populate memoSets array
          self.memoSets = [];
          snapshot.forEach(function (doc) {
            var memoSetIds = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(doc.data());
            memoSetIds.forEach(function (memoSetId) {
              var memoSet = doc.data()[memoSetId];
              memoSet.docId = doc.id;
              memoSet.memoSetId = memoSetId;
              self.memoSets.push(memoSet);
            });
          });
        }, function (error) {
          logError('App_onAuthStateChanged_2', error);
        });
        // Listen to known data
        self.detachKnownDataListener = db.doc('users/' + user.uid + '/knownData/doc').onSnapshot(function (doc) {
          self.knownData = doc.data() || {};
          self.calculateStatuses();
        }, function (error) {
          logError('App_onAuthStateChanged_3', error);
        });
        // Listen to shared with me data
        self.detachSharedMemoSetsListener = db.collection('users/' + user.uid + '/sharedWithMe').onSnapshot(function (snapshot) {
          self.sharedMemoSets = [];
          snapshot.forEach(function (doc) {
            var memoSet = doc.data();
            memoSet.memoSetId = doc.id;
            self.sharedMemoSets.push(memoSet);
          });
        }, function (error) {
          logError('App_onAuthStateChanged_4', error);
        });
      } else {
        self.user = {
          uiLanguage: 'us'
        };
        self.loadText();
        // START PROTOTYPE CODE
        /*
        const xhr = new XMLHttpRequest()
        xhr.open('POST', '/server', true)
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
        xhr.onreadystatechange = () => {
          if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
            // TODO - write this
          }
        }
        xhr.send()
        */
        // END PROTOTYPE CODE
      }
    });
  },
  mounted: function mounted() {
    // Initialize dropdown in menu
    $('.ui.dropdown').dropdown();
  },

  methods: {
    calculateStatuses: function calculateStatuses() {
      var _this = this;

      var adjustedBaseTimestamp = void 0,
          adjustedNextDue = void 0,
          adjustedNow = void 0,
          adjustedTimestamp = void 0,
          dueCount = void 0,
          extraDueCount = void 0,
          knownCount = void 0,
          memoSetKnownData = void 0,
          unknownCount = void 0;
      // Cancel any pending timeout
      if (this.statusesTimeout !== null) {
        clearTimeout(this.statusesTimeout);
        this.statusesTimeout = null;
      }
      this.statuses = {};
      adjustedNow = Math.round(Date.now() / 10000);
      adjustedNextDue = Infinity;
      // For each memo set
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.knownData).forEach(function (memoSetId) {
        // Determine statuses from known data
        memoSetKnownData = _this.knownData[memoSetId];
        adjustedBaseTimestamp = memoSetKnownData[2];
        unknownCount = memoSetKnownData[0];
        extraDueCount = memoSetKnownData.filter(function (adjustedOffset, index) {
          return index > 2 && adjustedBaseTimestamp + adjustedOffset <= adjustedNow;
        }).length;
        dueCount = memoSetKnownData[1] + extraDueCount;
        knownCount = memoSetKnownData.length - 3 - extraDueCount;
        _this.statuses[memoSetId] = {
          due: dueCount,
          known: knownCount,
          unknown: unknownCount
          // Check whether the next due timestamp for the memo set is the least so far
        };for (var i = 3; i < memoSetKnownData.length; i++) {
          adjustedTimestamp = adjustedBaseTimestamp + memoSetKnownData[i];
          if (adjustedTimestamp <= adjustedNow) continue;
          // Here, memoSetKnownData[i] is the closest future timestamp
          if (adjustedTimestamp < adjustedNextDue) {
            adjustedNextDue = adjustedTimestamp;
          }
          break;
        }
      });
      // Schedule the next calculation
      if (adjustedNextDue !== Infinity) {
        this.statusesTimeout = setTimeout(this.calculateStatuses, (adjustedNextDue - adjustedNow) * 10000);
      }
    },
    clearSearch: function clearSearch() {
      if (window.aoms && window.aoms.memoSetSearchText) {
        window.aoms.memoSetSearchText = '';
      }
    },
    hideSidebar: function hideSidebar() {
      $('.ui.sidebar').sidebar('hide');
    },
    loadText: function loadText() {
      var self = this;
      // Detach previous text listener, if any
      if (this.detachTextListener) {
        this.detachTextListener();
        this.detachTextListener = null;
      }
      if (this.user.uiLanguage === 'us') {
        this.text = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.textEnglish);
        this.ready = true;
      } else {
        // Listen to text in user's language
        this.detachTextListener = db.doc('text/' + this.user.uiLanguage).onSnapshot(function (doc) {
          if (doc.exists) {
            // Start with English text
            self.text = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, self.textEnglish);
            // Apply user's language text
            self.text = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, self.text, doc.data());
            self.ready = true;
          }
        }, function (error) {
          logError('App_loadText', error);
        });
      }
    },
    setLanguage: function setLanguage(countryCode) {
      // Update users record
      db.doc('users/' + this.user.id).update({
        uiLanguage: countryCode
      }).catch(function (error) {
        logError('App_setLanguage', error);
      });
    },
    showSidebar: function showSidebar() {
      $('.ui.sidebar').sidebar({
        context: '#app',
        dimPage: false,
        onHide: function onHide() {
          // Revert history if not already done - this covers the case when the user closes the modal without using the back button
          if (window.history.state.sidebar) {
            window.history.back();
          }
        },
        onShow: function onShow() {
          // Push to history so that back button closes the sidebar
          window.history.pushState({ sidebar: true }, '', window.location.href);
          // Hide sidebar on history entry change
          window.onpopstate = function () {
            $('.ui.sidebar').sidebar('hide');
          };
        }
      }).sidebar('setting', 'transition', 'overlay').sidebar('setting', 'mobileTransition', 'overlay').sidebar('show');
    },
    sidebarGo: function sidebarGo(to) {
      // Note: route to new page before hiding the sidebar so that window.history.state.sidebar isn't true when the sidebar is hidden
      // Route to selected page
      this.$router.push(to);
      // Close sidebar
      $('.ui.sidebar').sidebar('hide');
    },
    signOutClick: function signOutClick() {
      var self = this;
      if (this.detachUsersListener) {
        this.detachUsersListener();
        this.detachUsersListener = null;
      }
      firebase.auth().signOut().then(function () {
        self.$router.push('/');
      });
    }
  }
});

/***/ }),
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var firebase = window.firebase;
var firestore = firebase.firestore();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'signin',
  data: function data() {
    return {
      appPathPrefix: window.location.hostname === 'localhost' ? '' : '',
      email: '',
      emailLinkChecked: false,
      emailStatus: 'initial',
      signingIn: false,
      userId: '',
      userStatus: 'unknown'
    };
  },
  created: function created() {
    var self = this;
    window.vmSignin = this;
    this.checkEmailLinkSignin();
    firebase.auth().onAuthStateChanged(function (user) {
      if (!user) {
        self.userStatus = 'not signed in';
      }
    });
  },

  methods: {
    checkEmailLinkSignin: function checkEmailLinkSignin() {
      var cleanUri = void 0,
          email = void 0;
      var self = this;
      if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
        email = window.localStorage.getItem('emailForSignIn');
        if (!email) {
          email = window.prompt('Please provide your email for confirmation');
        }
        firebase.auth().signInWithEmailLink(email, window.location.href).then(function (result) {
          window.localStorage.removeItem('emailForSignIn');
          // Remove sign in parameters from URL
          cleanUri = location.protocol + '//' + location.host + location.pathname;
          window.history.replaceState({}, document.title, cleanUri);
        }).catch(function (error) {
          console.error(error);
        }).finally(function () {
          self.emailLinkChecked = true;
        });
      } else {
        this.emailLinkChecked = true;
      }
    },
    sendSignInEmail: function sendSignInEmail() {
      var self = this;
      var actionCodeSettings = {
        url: window.location.href,
        handleCodeInApp: true
      };
      firebase.auth().sendSignInLinkToEmail(this.email, actionCodeSettings).then(function () {
        window.localStorage.setItem('emailForSignIn', self.email);
        self.emailStatus = 'sent';
      }).catch(function (error) {
        console.error(error);
      });
    },
    signInClick: function signInClick() {
      var self = this;
      var unsubscribe = void 0;
      if (!this.email || this.email.indexOf('@') === -1) return;
      // Blur email input - emailStatus is reset on focus
      document.getElementById('email').blur();
      this.emailStatus = 'sending';
      firestore.collection('appCheckAccess').add({
        emailLower: this.email.toLowerCase(),
        timestamp: firebase.firestore.FieldValue.serverTimestamp()
      }).then(function (docRef) {
        unsubscribe = firestore.collection('appCheckAccessResults').doc(docRef.id).onSnapshot(function (doc) {
          if (doc.exists && doc.data().done) {
            if (doc.data().hasAccess) {
              self.sendSignInEmail();
            } else {
              self.emailStatus = 'no access';
            }
            // Stop listening
            unsubscribe();
          }
        });
      }).catch(function (error) {
        console.error('Error adding document: ', error);
      });
    }
  },
  props: ['text', 'user']
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Breadcrumbs__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var firebase = window.firebase;
var db = firebase.firestore();

function logError(errorCode, error) {
  console.log(errorCode);
  console.log(error);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'adminSignin',
  components: {
    Breadcrumbs: __WEBPACK_IMPORTED_MODULE_0__components_Breadcrumbs__["a" /* default */]
  },
  data: function data() {
    return {
      signingIn: false,
      userId: ''
    };
  },

  computed: {
    breadcrumbs: function breadcrumbs() {
      return [{ label: this.text.navHome, to: '/' }, { label: 'Admin Signin' }];
    }
  },
  methods: {
    signIn: function signIn() {
      var _this = this;

      if (this.userId) {
        this.signingIn = true;
        db.collection('adminSignin').add({
          timestamp: firebase.firestore.FieldValue.serverTimestamp(),
          userId: this.userId
        }).then(function (docRef) {
          var unsubscribe = docRef.onSnapshot(function (doc) {
            if (doc.exists) {
              var token = doc.data().token;
              if (token) {
                // Remove listener
                unsubscribe();
                // Remove adminSignin doc
                docRef.delete().catch(function (error) {
                  logError('AdminSignin_signIn_1', error);
                });
                firebase.auth().signInWithCustomToken(token).then(function () {
                  // Route to Home page
                  _this.$router.push('/');
                }).catch(function (error) {
                  logError('AdminSignin_signIn_2', error);
                });
              }
            }
          });
        }).catch(function (error) {
          logError('AdminSignin_signIn_3', error);
        });
      }
    }
  },
  props: ['text', 'user']
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'breadcrumbs',
  props: ['breadcrumbs']
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Breadcrumbs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StatusBar__ = __webpack_require__(43);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  components: {
    Breadcrumbs: __WEBPACK_IMPORTED_MODULE_2__components_Breadcrumbs__["a" /* default */],
    StatusBar: __WEBPACK_IMPORTED_MODULE_3__components_StatusBar__["a" /* default */]
  },
  data: function data() {
    return {};
  },

  computed: {
    breadcrumbs: function breadcrumbs() {
      return [{ label: this.text.navHome }];
    },
    reviewMemoSets: function reviewMemoSets() {
      var _this = this;

      // TODO - handle initial loading and case where user has no memo sets
      if (!this.memoSets) return [];
      if (!this.statuses) return [];
      var reviewMemoSets = this.memoSets.map(function (memoSet) {
        var statuses = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this.statuses[memoSet.memoSetId] || {});
        statuses.speed = 'slow';
        return {
          coverImage: memoSet.coverImage,
          docId: memoSet.docId,
          memoSetId: memoSet.memoSetId,
          slug: memoSet.slug,
          statuses: statuses,
          title: memoSet.title
        };
      }).filter(function (memoSet) {
        return memoSet.statuses.due > 0;
      });
      // Sort memo sets by number of due items
      reviewMemoSets.sort(function (a, b) {
        return a.statuses.due - b.statuses.due;
      });
      return reviewMemoSets;
    },
    summary: function summary() {
      var _this2 = this;

      var summary = {
        activeMemoSets: 0,
        itemsKnown: 0,
        itemsDue: 0
      };
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.statuses).forEach(function (memoSet) {
        summary.activeMemoSets++;
        summary.itemsKnown += _this2.statuses[memoSet].known;
        summary.itemsDue += _this2.statuses[memoSet].due;
      });
      return summary;
    }
  },
  created: function created() {
    // TEMP - for debugging
    window.vmHome = this;
    // Set memo set source - used by the MemoSet component
    window.aoms = window.aoms || {};
    window.aoms.memoSetSource = 'Home';
    this.setPageTitle();
  },
  methods: {
    setPageTitle: function setPageTitle() {
      if (this.text && this.text.navHome) {
        document.title = this.text.navHome + ' - MemQ';
      }
    }
  },
  props: ['memoSets', 'mobile', 'sharedMemoSets', 'statuses', 'text', 'touch', 'user', 'window'],
  watch: {
    text: function text(newText) {
      this.setPageTitle();
    }
  }
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log10__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log10__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'status-bar',
  props: ['mobile', 'page', 'statuses', 'window'],
  data: function data() {
    return {
      display: {
        known: -1,
        due: -1,
        unknown: -1
      },
      numbersTransition: {
        // Note: duration in milliseconds should match the bar transition time
        duration: 0,
        from: {
          known: 0,
          due: 0,
          unknown: 0
        },
        startTime: 0,
        timeoutDuration: 50,
        to: {
          known: 0,
          due: 0,
          unknown: 0
        }
      }
    };
  },

  created: function created() {
    // For debugging
    window.vmsb = this;
    // Display initial figures
    this.display.known = this.statuses.known;
    this.display.due = this.statuses.due;
    this.display.unknown = this.statuses.unknown;
  },
  computed: {
    percents: function percents() {
      var percents = void 0;
      if (this.total) {
        percents = {
          known: this.statuses.known / this.total * 100,
          due: this.statuses.due / this.total * 100,
          unknown: this.statuses.unknown / this.total * 100
        };
      } else {
        percents = {};
      }
      return percents;
    },
    showIcon: function showIcon() {
      var _this = this;

      var items = void 0,
          showIcon = void 0,
          width = void 0,
          widthNeeded = void 0;
      if (!this.total) return {};
      showIcon = {};
      items = ['due', 'known', 'unknown'];
      items.forEach(function (item) {
        width = _this.statusBarWidth * _this.display[item] / _this.total;
        // Need enough width for the number of digits plus 3. Each character is approximately 8px wide
        widthNeeded = (Math.ceil(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log10___default()(_this.display[item])) + 3) * 8;
        showIcon[item] = width >= widthNeeded;
      });
      return showIcon;
    },
    statusBarWidth: function statusBarWidth() {
      var columnWidth = void 0,
          innerWrapperMargin = void 0,
          padding = void 0,
          tableWidth = void 0,
          width = void 0;
      // Assume 1rem = 16px - may not be true, but doesn't matter too much, as this is only used to determine when the status bar icons appear
      var rem = 16;
      if (this.page === 'Home') {
        tableWidth = this.window.width - (this.mobile ? 2 * rem : 3 * rem);
        columnWidth = tableWidth * 4 / 14;
        padding = 2 * 0.78571429 * rem;
        width = columnWidth - padding;
      }
      if (this.page === 'MemoSet') {
        innerWrapperMargin = this.mobile ? 2 * rem : 3 * rem;
        width = this.window.width - innerWrapperMargin - 5 * rem;
      }
      if (this.page === 'MemoSets') {
        tableWidth = this.window.width - (this.mobile ? 2 * 4 : 3 * rem);
        columnWidth = tableWidth * 4 / 14;
        padding = 2 * 0.78571429 * rem;
        width = columnWidth - padding;
      }
      // Be conservative, particularly for narrow screens
      if (this.window.width < 500) {
        width *= 0.5;
      } else if (this.window.width < 700) {
        width *= 0.6;
      } else {
        width *= 0.9;
      }
      return width;
    },
    total: function total() {
      return this.statuses.known + this.statuses.due + this.statuses.unknown;
    }
  },
  methods: {
    updateDisplay: function updateDisplay() {
      this.numbersTransition.frame++;
      var now = Date.now();
      var fractionDone = (now - this.numbersTransition.startTime) / this.numbersTransition.duration;
      if (fractionDone >= 1) {
        this.display.known = this.numbersTransition.to.known;
        this.display.due = this.numbersTransition.to.due;
        this.display.unknown = this.numbersTransition.to.unknown;
      } else {
        this.display.known = Math.round(this.numbersTransition.from.known + fractionDone * (this.numbersTransition.to.known - this.numbersTransition.from.known));
        this.display.due = Math.round(this.numbersTransition.from.due + fractionDone * (this.numbersTransition.to.due - this.numbersTransition.from.due));
        this.display.unknown = Math.round(this.numbersTransition.from.unknown + fractionDone * (this.numbersTransition.to.unknown - this.numbersTransition.from.unknown));
        setTimeout(this.updateDisplay, this.numbersTransition.timeoutDuration);
      }
    }
  },
  watch: {
    statuses: function statuses(newStatuses, oldStatuses) {
      this.numbersTransition.from = oldStatuses;
      this.numbersTransition.to = newStatuses;
      this.numbersTransition.startTime = Date.now();
      this.numbersTransition.frame = 0;
      switch (newStatuses.speed) {
        case 'fast':
          this.numbersTransition.duration = 500;
          break;
        case 'slow':
          this.numbersTransition.duration = 1500;
          break;
        default:
          this.numbersTransition.duration = 1;
          break;
      }
      // If status bar is appearing, use minimum duration
      if (oldStatuses.known + oldStatuses.due + oldStatuses.unknown === 0) {
        this.numbersTransition.duration = 1;
      }
      // If status bar is not disappearing, update the numbers
      if (newStatuses.known + newStatuses.due + newStatuses.unknown > 0) {
        this.updateDisplay();
      }
    }
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Breadcrumbs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_StatusBar__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_MemoSetMethods__ = __webpack_require__(87);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var $ = window.$;
var firebase = window.firebase;
var db = firebase.firestore();
var MagicWand = window.MagicWand;
// Define radius of draw transparent circle, in pixels
var drawTransparentRadius = 30;
// Define limits for uploaded files
var maxAudioDuration = 10000;
var maxAudioSize = 500000;
var maxCellImageSize = 200;
var maxCoverImageHeight = 1000;
var maxCoverImageWidth = 2000;
var maxImageSize = 3000;
// Define size of background with no photo
var noPhotoSize = 1000;
// Define number of rows to be stored in each Firestore document
var rowsPerDocument = 100;
// Loader HTML - used in Learn modal
var loaderHtml = '<div class="ui small active inline loader"></div>';

window.playAudio = function (event, audioId) {
  document.getElementById(audioId).play();
  // Prevent focus moving to clicked element
  event.preventDefault();
};

function durationForReviewCycle(reviewCycle) {
  var duration = void 0;
  switch (reviewCycle) {
    case 0:
      // 2 minutes
      duration = 2 * 60 * 1000;
      break;
    case 1:
      // 22 hours
      duration = 22 * 60 * 60 * 1000;
      break;
    case 2:
      // 2.8 days
      duration = 2.8 * 24 * 60 * 60 * 1000;
      break;
    case 3:
      // 6.6 days
      duration = 6.6 * 24 * 60 * 60 * 1000;
      break;
    case 4:
      // 22 days
      duration = 22 * 24 * 60 * 60 * 1000;
      break;
    case 5:
      // 60 days
      duration = 60 * 24 * 60 * 60 * 1000;
      break;
    default:
      // 180 days
      duration = 180 * 24 * 60 * 60 * 1000;
      break;
  }
  // Randomize by up to 5% either up or down, so that items don't stay in the same order
  duration = duration * (0.95 + 0.1 * Math.random());
  duration = Math.round(duration);
  return duration;
}

// Function based on https://stackoverflow.com/a/15013465
function extractImageUrlsFromHtml(html) {
  var decodedUrl = void 0,
      match = void 0,
      regex = void 0,
      urls = void 0;
  regex = /<img[^>]+src="([^">]+)/g;
  urls = [];
  match = regex.exec(html);
  while (match) {
    // Replace &amp; with &, etc.
    decodedUrl = htmlDecode(match[1]);
    urls.push(decodedUrl);
    match = regex.exec(html);
  }
  return urls;
}

function getCardNum(cardString) {
  var base = void 0,
      value = void 0,
      valueString = void 0;
  base = -1;
  value = 0;
  cardString = cardString.toUpperCase();
  switch (cardString.slice(-1)) {
    case 'C':
      base = 0;
      break;
    case 'D':
      base = 13;
      break;
    case 'H':
      base = 26;
      break;
    case 'S':
      base = 39;
      break;
  }
  if (base !== -1) {
    valueString = cardString.substring(0, cardString.length - 1);
    switch (valueString) {
      case 'A':
        value = 1;
        break;
      case 'J':
        value = 11;
        break;
      case 'Q':
        value = 12;
        break;
      case 'K':
        value = 13;
        break;
      default:
        if (valueString.length === 1 && valueString >= '2' && valueString <= '9' || valueString === '10') {
          value = parseInt(valueString, 10);
        }
        break;
    }
    if (value) {
      return base + value - 1;
    }
  }
  return -1;
}

// Function from https://stackoverflow.com/a/34064434
function htmlDecode(input) {
  var doc = new DOMParser().parseFromString(input, 'text/html');
  return doc.documentElement.textContent;
}

// Function based on https://stackoverflow.com/a/7473638
function isCaretAtEnd() {
  var nextText = void 0,
      postRange = void 0,
      range = void 0;
  range = window.getSelection().getRangeAt(0);
  postRange = document.createRange();
  postRange.selectNodeContents(event.target);
  postRange.setStart(range.endContainer, range.endOffset);
  nextText = postRange.cloneContents();
  return nextText.textContent.length === 0;
}

function logError(errorCode, error) {
  console.log(errorCode);
  console.log(error);
}

function moveCursorToEndOfContentEditable(element) {
  var range = void 0,
      selection = void 0;
  // Move cursor to end of field
  range = document.createRange();
  range.selectNodeContents(element);
  range.collapse(false);
  selection = window.getSelection();
  selection.removeAllRanges();
  selection.addRange(range);
}

// Function from https://css-tricks.com/snippets/javascript/move-cursor-to-end-of-input/
function moveCursorToEndOfInput(el) {
  if (typeof el.selectionStart === 'number') {
    el.selectionStart = el.selectionEnd = el.value.length;
  } else if (typeof el.createTextRange !== 'undefined') {
    el.focus();
    var range = el.createTextRange();
    range.collapse(false);
    range.select();
  }
}

// Function from https://stackoverflow.com/a/6691294
function pasteHtmlAtCaret(html) {
  var el = void 0,
      frag = void 0,
      lastNode = void 0,
      node = void 0,
      sel = void 0,
      range = void 0;
  if (window.getSelection) {
    // IE9 and non-IE
    sel = window.getSelection();
    if (sel.getRangeAt && sel.rangeCount) {
      range = sel.getRangeAt(0);
      range.deleteContents();
      // Range.createContextualFragment() would be useful here but is
      // only relatively recently standardized and is not supported in
      // some browsers (IE9, for one)
      el = document.createElement('div');
      el.innerHTML = html;
      frag = document.createDocumentFragment();
      while (node = el.firstChild) {
        lastNode = frag.appendChild(node);
      }
      range.insertNode(frag);
      // Preserve the selection
      if (lastNode) {
        range = range.cloneRange();
        range.setStartAfter(lastNode);
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
      }
    }
  } else if (document.selection && document.selection.type !== 'Control') {
    // IE < 9
    document.selection.createRange().pasteHTML(html);
  }
}

// Function from https://stackoverflow.com/questions/6139107/programmatically-select-text-in-a-contenteditable-html-element
function selectElementContents(el) {
  var range = document.createRange();
  range.selectNodeContents(el);
  var sel = window.getSelection();
  sel.removeAllRanges();
  sel.addRange(range);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'memo-set',
  components: {
    Breadcrumbs: __WEBPACK_IMPORTED_MODULE_4__components_Breadcrumbs__["a" /* default */],
    StatusBar: __WEBPACK_IMPORTED_MODULE_5__components_StatusBar__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_MemoSetMethods__["a" /* default */]],
  data: function data() {
    return {
      activeObject: -1,
      activeObjectOverlap: false,
      activeQuestions: [],
      activeTab: '',
      addColumn: {
        addAfterColumn: '0',
        columnHeading: ''
      },
      addCellAudio: {
        file: null,
        loading: false,
        recording: false,
        stream: null,
        uploading: false,
        url: ''
      },
      addCellImage: {
        file: null,
        fileType: '',
        loading: false,
        uploading: false,
        url: ''
      },
      addImage: {
        file: null,
        fileType: '',
        loading: false,
        url: ''
      },
      addPhoto: {
        file: null,
        fileType: '',
        loading: false,
        uploading: false,
        url: ''
      },
      addRows: {
        addBelowRow: '',
        firestoreNewDocs: {},
        firestoreUpdateDocs: {},
        numberOfRows: ''
      },
      alternatives: {},
      animateTransition: false,
      applyToRows: '',
      appPathPrefix: window.location.hostname === 'localhost' ? '' : '',
      audioRecorder: null,
      authorName: '',
      availableHeight: 0,
      availableWidth: 0,
      backCloses: '',
      backgroundPhotoTab: '',
      cachedSanitize: {},
      cachedSanitizeWithStyle: {},
      cellAlternatives: [],
      clipping: false,
      clippingPath: [],
      copyMemoSet: {
        folderId: '',
        newFolderName: '',
        newMemoSetId: '',
        newTitle: '',
        slug: ''
      },
      coverImage: '',
      coverImageLoaded: false,
      createdAt: null,
      ctrlDown: false,
      currentFieldId: '',
      currentRow: -1,
      dataHeight: 0,
      dataVisible: false,
      deleteColumn: {
        deleteColumn: '-1'
      },
      deleteRows: {
        deleteFromRow: '-1',
        deleteToRow: '-1'
      },
      detachDataListener: null,
      detachMemoSetListener: null,
      detachPrivateListener: null,
      detachPublicListener: null,
      description: '',
      descriptionPlaceholder: false,
      docId: '',
      drawing: false,
      editCanvas: null,
      editingCell: false,
      exported: false,
      fieldId: '',
      fields: [],
      firstVisibleRow: 1,
      folderId: '',
      goToRowVal: '1',
      hideTopElements: false,
      hoverObject: -1,
      images: {},
      infoWrapperMaxHeight: 0,
      initialLoad: true,
      lastFieldId: '',
      lastObjectKey: 0,
      learn: {
        allKnown: false,
        answerVisible: false,
        congratsMessage: '',
        contentVisible: false,
        continueArray: [],
        firestoreUpdate: {},
        justAllKnown: false,
        justNoLongerAllKnown: false,
        loadThumbnailFor: '',
        maxResponseTime: '',
        noLongerAllKnown: false,
        previousReviewAfter: 0,
        previousReviewCycle: 0,
        previousReviewItem: {},
        questionIds: [],
        responseTime: 0,
        reviewGroupIds: [],
        reviewItem: {},
        saveOptions: false,
        timestamp: 0,
        tooSlow: false,
        useMaxResponseTime: false
      },
      learnWrapperMaxHeights: [],
      locationHover: false,
      locationRect: {
        height: 0,
        left: 0,
        top: 0,
        width: 0
      },
      locationZIndexTrigger: 0,
      memoSetId: this.$route.params.memoSetId,
      memoSetType: this.$route.path.substring(0, 10) === '/memo-sets' ? 'regular' : this.$route.path.substring(0, 17) === '/public-memo-sets' ? 'public' : 'shared',
      modal: '',
      modalHtml: '',
      modalPhotos: [],
      mode: '',
      moveColumn: {
        columnSeq: '0',
        position: '0'
      },
      moveRows: {
        firstRow: '',
        lastRow: '',
        moveAfter: ''
      },
      movingObject: false,
      myRating: 0,
      objectDirty: false,
      objects: [],
      objectsVisible: true,
      options: {
        useBackgroundPhotos: false,
        useReviewGroups: false,
        useSummaryImages: false
      },
      originalAlternativeIndex: 0,
      ownerId: '',
      ownerName: '',
      panLock: false,
      panning: false,
      pasteCells: {
        columns: 0,
        fieldIndex: 0,
        pasteData: [],
        rowIndex: 0,
        rows: 0
      },
      photo: {},
      photoIndex: -1,
      photoOpacity: 1,
      photoRowIndexes: [],
      photos: [],
      photoTransition: false,
      pinching: false,
      pinchData: {
        centerXRelativeToPhoto: 0,
        centerYRelativeToPhoto: 0,
        distance: 0
      },
      pointerPosX: 0,
      pointerPosY: 0,
      populateColumn: {
        column: '',
        dataSet: '',
        includeRepeated: 'N',
        numValues: ['1', '10'],
        originalNumValues: ['1', '10'],
        significantCard: 'L',
        suits: 'CDSH',
        values: 'A-K'
      },
      printing: false,
      privateAlternatives: {},
      publicAlternatives: {},
      question: {
        deleteVisible: false,
        fromFieldId: '',
        mode: '',
        originalQuestionText: '',
        pendingDelete: false,
        questionId: '',
        questionIndex: 0,
        questionText: '',
        toFieldId: ''
      },
      questions: [],
      questionsWrapperMaxHeight: 0,
      questionText: '',
      ratingsArray: [],
      ready: false,
      rectangleActive: false,
      rectangleResizeHandle: '',
      removeContours: null,
      removeDefaultThreshold: 15,
      removeDownPoint: {
        x: 0,
        y: 0
      },
      removeImageData: null,
      removeMask: null,
      removePanning: false,
      removeThreshold: 0,
      removing: false,
      resetLearningMessage: '',
      resizingObject: false,
      resizingRectangle: false,
      rotatingObject: false,
      rowIndex: 0,
      rows: [],
      saveTableWrapperScrollLeft: 0,
      saveTableWrapperScrollTop: 0,
      selectedAlternativeIndex: 0,
      selectedPhotoIndex: -1,
      setCoverImage: {
        file: null,
        fileType: '',
        loading: false,
        uploading: false,
        url: ''
      },
      share: {
        checkingUser: false,
        noUser: false,
        public: false,
        shareSelf: false,
        showPublicCheckbox: false,
        specific: false,
        username: ''
      },
      sharing: {},
      showRect: {
        height: 0,
        left: 0,
        top: 0,
        width: 0
      },
      slug: this.$route.params.slug,
      sortRows: {
        sortByColumn: '-1'
      },
      statuses: {
        due: 0,
        known: 0,
        speed: '',
        unknown: 0
      },
      summaryImage: {
        backgroundPointerDownTimestamp: 0,
        before: {},
        // createdObjectUrls is an array of all object URLs created using window.URL.createObjectURL
        createdObjectUrls: [],
        firstTouchActiveObject: 0,
        firstTouchClippingPath: [],
        firstTouchRectangleActive: false,
        firstTouchTimestamp: 0,
        imagesRemaining: 0,
        // neededObjectUrls is an array of object URLs created using window.URL.createObjectURL for images uploaded to Firebase storage - we need them for the thumbnails until the Firebase storage image has been downloaded
        neededObjectUrls: [],
        page: '',
        undoArray: [],
        undoArrayIndex: 0,
        undoArrayIndexMax: 0,
        uploading: false,
        uploadingMessage: ''
      },
      tableWrapperMaxHeight: 0,
      tableWrapperScrollLeft: 0,
      thumbnails: [],
      timeouts: {
        audioRecorder: null,
        hideTopElements: null,
        setTableWrapperScrollLeft: null
      },
      title: '',
      useMaxResponseTimeMouseDown: false,
      walkThrough: {
        photoIndex: 0,
        photos: [],
        rowClicked: false,
        stepNum: 0,
        steps: []
      }
    };
  },

  computed: {
    addQuestionEnabled: function addQuestionEnabled() {
      var columnCount = void 0;
      if (!this.fields) return false;
      columnCount = this.fields.length;
      if (this.options.useSummaryImages) columnCount += 1;
      // Number of ordered pairs from n columns is n * (n - 1)
      return this.questions.length < columnCount * (columnCount - 1);
    },
    barButtonMargin: function barButtonMargin() {
      return this.tableWrapperScrollLeft + this.window.width / 2 - 70;
    },
    breadcrumbs: function breadcrumbs() {
      var label = void 0,
          to = void 0;
      if (this.$route.path.substring(0, 10) === '/memo-sets') {
        label = this.text.navMemoSets;
        to = '/memo-sets';
      } else if (this.$route.path.substring(0, 17) === '/public-memo-sets') {
        label = this.text.navPublicMemoSets;
        to = '/public-memo-sets';
      } else if (this.$route.path.substring(0, 17) === '/shared-memo-sets') {
        label = this.text.navSharedMemoSets;
        to = '/shared-memo-sets';
      }
      return [{ label: this.text.navHome, to: '/' }, { label: label, to: to }, { label: this.title }];
    },
    databaseDescription: function databaseDescription() {
      // Return empty string if the description is the default description
      var description = void 0;
      if (this.description === this.text.memoSetDefaultDescription) {
        description = '';
      } else {
        description = this.description;
      }
      return description;
    },
    deleteQuestionVisible: function deleteQuestionVisible() {
      return this.question.mode === 'edit' && this.memoSetType === 'regular' && !this.question.pendingDelete && this.question.fromFieldId === this.questions[this.question.questionIndex].fromFieldId && this.question.toFieldId === this.questions[this.question.questionIndex].toFieldId;
    },
    fieldsById: function fieldsById() {
      var fieldsById = {};
      this.fields.forEach(function (field, fieldIndex) {
        fieldsById[field.fieldId] = {
          fieldIndex: fieldIndex,
          heading: field.heading
        };
      });
      fieldsById['s'] = {
        fieldIndex: 999,
        heading: this.text.memoSetSummaryImage
      };
      return fieldsById;
    },
    learnAnswerHtml: function learnAnswerHtml() {
      var html = void 0;
      html = this.learn.reviewItem.answerHtml;
      // Apply Mathjax after HTML is rendered
      this.$nextTick(function () {
        if (window.MathJax) {
          window.MathJax.typeset(['.learnAnswerHtml']);
        }
      });
      return this.sanitizeWithStyle(html);
    },
    learnQuestionHtml: function learnQuestionHtml() {
      var html = void 0;
      html = this.learn.reviewItem.questionHtml;
      // Apply Mathjax after HTML is rendered
      this.$nextTick(function () {
        if (window.MathJax) {
          window.MathJax.typeset(['.learnQuestionHtml']);
        }
      });
      return this.sanitizeWithStyle(html);
    },
    locationRectangleBorder: function locationRectangleBorder() {
      var border = void 0;
      if (this.locationHover && !this.rectangleActive && !this.panLock) {
        border = '3px solid darkviolet';
      } else {
        border = '2px solid darkviolet';
      }
      return border;
    },
    locationZIndex: function locationZIndex() {
      var locationBoundingRect = void 0,
          locationElement = void 0,
          objBoundingRect = void 0,
          objElement = void 0,
          zIndex = void 0;
      // Dummy dependency on locationZIndexTrigger
      if (this.locationZIndexTrigger === 'x') return 0;
      if (this.rectangleActive) return 1000;
      zIndex = 0;
      locationElement = document.getElementById('locationRectangle');
      if (!locationElement) return 0;
      locationBoundingRect = locationElement.getBoundingClientRect();
      // Loop through objects from the top to the bottom
      for (var objIndex = this.objects.length - 1; objIndex >= 0; objIndex--) {
        objElement = document.getElementById('summaryImageObj_' + objIndex);
        if (!objElement) return 0;
        objBoundingRect = objElement.getBoundingClientRect();
        // If the object completely covers the location
        if (objBoundingRect.left <= locationBoundingRect.left && objBoundingRect.right >= locationBoundingRect.right && objBoundingRect.top <= locationBoundingRect.top && objBoundingRect.bottom >= locationBoundingRect.bottom) {
          // Set the location z-index just above the object's z-index
          zIndex = (objIndex + 1) * 2 + 1;
          break;
        }
      }
      return zIndex;
    },
    memoSetAdded: function memoSetAdded() {
      var _this = this;

      if (!this.memoSetId || !this.memoSets || !this.user.id) return false;
      return this.memoSets.filter(function (memoSet) {
        return memoSet.memoSetId === _this.memoSetId + '_' + _this.user.id;
      }).length;
    },
    modalClass: function modalClass() {
      // Return a class unique to the component instance, so modals can be removed without affecting modals in the next component instance
      return this.memoSetType + '_' + this.memoSetId;
    },
    noStatusBarText: function noStatusBarText() {
      var text = '';
      // If groups are enabled and there are no groups selected
      if (this.options.useReviewGroups && !this.learn.reviewGroupIds.length) {
        text = this.text.memoSetNoGroups;
      }
      // If no questions are selected
      if (!this.learn.questionIds.length) {
        text = this.text.memoSetNoQuestionsSelected;
      }
      // If there is no data for the selected questions/groups
      if (!text && !this.activeQuestions.length) {
        text = this.text.memoSetNoData;
      }
      return text;
    },
    objectCursorStyles: function objectCursorStyles() {
      var _this2 = this;

      var cursorIndexes = void 0,
          handleAngles = void 0,
          output = void 0;
      // Exit if no active object
      if (this.activeObject === -1) return [];
      // Set the initial handle angles
      handleAngles = [315, 0, 45, 90, 135, 180, 225, 270];
      // Add the object's angle
      handleAngles = handleAngles.map(function (angle) {
        return angle + _this2.objects[_this2.activeObject].angle;
      });
      // Create array of indexes
      cursorIndexes = handleAngles.map(function (angle) {
        return Math.round(angle / 45) % 4;
      });
      output = cursorIndexes.map(function (index) {
        return ['ns-resize', 'nesw-resize', 'ew-resize', 'nwse-resize'][index];
      });
      return output;
    },
    originalMemoSetId: function originalMemoSetId() {
      var appendedUserId = '_' + this.user.id;
      if (this.memoSetId.slice(-appendedUserId.length) === appendedUserId) {
        return this.memoSetId.substring(0, this.memoSetId.length - appendedUserId.length);
      } else {
        return this.memoSetId;
      }
    },
    photoIndexes: function photoIndexes() {
      var _this3 = this;

      // Return an array of photoIndex for each memo set row
      return this.rows.map(function (row) {
        return _this3.photos.findIndex(function (photo) {
          return photo.id === row.data.photoId;
        });
      });
    },
    photoThumbnailDimensions: function photoThumbnailDimensions() {
      // Define maximum thumbnail dimensions
      var maxThumbnailWidth = 120;
      var maxThumbnailHeight = 80;
      var output = this.photos.map(function (photo) {
        var thumbnailHeight = void 0,
            thumbnailWidth = void 0;
        if (photo.width / photo.height > maxThumbnailWidth / maxThumbnailHeight) {
          // Width is the limiting factor
          thumbnailWidth = maxThumbnailWidth;
          thumbnailHeight = photo.height * thumbnailWidth / photo.width;
        } else {
          // Height is the limiting factor
          thumbnailHeight = maxThumbnailHeight;
          thumbnailWidth = photo.width * thumbnailHeight / photo.height;
        }
        return {
          height: thumbnailHeight,
          width: thumbnailWidth
        };
      });
      return output;
    },
    photoTransform: function photoTransform() {
      // This computed function calculates the transform values for the background photo, given photo width/height, showRect left/top/width/height, and window width/height
      // Based on screen pixels: availableHeight, availableWidth, visibleHeight, visibleWidth
      // Based on photo pixels: newHeight, newWidth, showRectExpanded, this.photo
      var availableHeight = void 0,
          availableWidth = void 0,
          newHeight = void 0,
          newWidth = void 0,
          scale = void 0,
          showRectExpanded = void 0,
          translateX = void 0,
          translateY = void 0,
          visibleHeight = void 0,
          visibleWidth = void 0;
      availableWidth = this.window.width - 200;
      // Exit if not in a modal
      if (this.modal !== 'summaryImage' && this.modal !== 'walkThrough') return {};
      // Determine available width and height
      if (this.modal === 'summaryImage') {
        if (document.getElementById('summaryImageMaxWidth')) {
          availableWidth = document.getElementById('summaryImageMaxWidth').offsetWidth;
        }
        availableHeight = this.window.height - 204;
        if (this.mobile) availableHeight += 30;
      }
      if (this.modal === 'walkThrough') {
        if (document.getElementById('walkThroughMaxWidth')) {
          availableWidth = document.getElementById('walkThroughMaxWidth').offsetWidth;
        }
        availableHeight = this.window.height - 100;
        if (!this.mobile) availableHeight += 10;
        if (this.dataVisible) availableHeight -= this.dataHeight;
      }
      showRectExpanded = {
        left: this.showRect.left,
        top: this.showRect.top,
        width: this.showRect.width,
        height: this.showRect.height
      };
      if (showRectExpanded.width / showRectExpanded.height > availableWidth / availableHeight) {
        // Width is the limiting factor
        scale = availableWidth / showRectExpanded.width;
        // We can increase showRectExpanded.height up to availableHeight / scale
        newHeight = availableHeight / scale;
        if (newHeight > this.photo.height) newHeight = this.photo.height;
        // Adjust showRectExpanded.top
        showRectExpanded.top -= (newHeight - showRectExpanded.height) / 2;
        showRectExpanded.height = newHeight;
        if (showRectExpanded.top < 0) showRectExpanded.top = 0;
        if (showRectExpanded.top + showRectExpanded.height > this.photo.height) showRectExpanded.top = this.photo.height - showRectExpanded.height;
      } else {
        // Height is the limiting factor
        scale = availableHeight / showRectExpanded.height;
        // We can increase showRectExpanded.width up to availableWidth / scale
        newWidth = availableWidth / scale;
        if (newWidth > this.photo.width) newWidth = this.photo.width;
        // Adjust showRectExpanded.left
        showRectExpanded.left -= (newWidth - showRectExpanded.width) / 2;
        showRectExpanded.width = newWidth;
        if (showRectExpanded.left < 0) showRectExpanded.left = 0;
        if (showRectExpanded.left + showRectExpanded.width > this.photo.width) showRectExpanded.left = this.photo.width - showRectExpanded.width;
      }
      visibleWidth = showRectExpanded.width * scale;
      visibleHeight = showRectExpanded.height * scale;
      translateX = -showRectExpanded.left;
      translateY = -showRectExpanded.top;
      // Make available height and width accessible to the template
      this.availableHeight = availableHeight;
      this.availableWidth = availableWidth;
      return {
        scale: scale,
        translateX: translateX,
        translateY: translateY,
        visibleHeight: visibleHeight,
        visibleWidth: visibleWidth
      };
    },
    photoUsage: function photoUsage() {
      var photoUsage = void 0,
          photoIds = void 0,
          photoIdsByRow = void 0;
      photoIdsByRow = this.rows.map(function (row) {
        return row.data.photoId;
      });
      // Get unique used photoIds
      photoIds = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(photoIdsByRow))).filter(function (photoId) {
        return photoId;
      });
      photoUsage = {};
      photoIds.forEach(function (photoId) {
        photoUsage[photoId] = {
          firstRowIndex: photoIdsByRow.indexOf(photoId),
          lastRowIndex: photoIdsByRow.lastIndexOf(photoId)
        };
      });
      return photoUsage;
    },
    populateColumnDataExists: function populateColumnDataExists() {
      var fieldId = void 0;
      if (this.populateColumn.column === '') return false;
      fieldId = this.fields[this.populateColumn.column].fieldId;
      return this.rows.some(function (row) {
        return row.data[fieldId];
      });
    },
    populateColumnPreviewHtml: function populateColumnPreviewHtml() {
      var base = void 0,
          firstDigits = void 0,
          firstFormat = void 0,
          formattedValue = void 0,
          html = void 0,
          increment = void 0,
          lastDigits = void 0,
          lastFormat = void 0,
          numberOfValues = void 0;
      if (this.populateColumn.dataSet !== 'n') return '';
      // For convenience
      var first = this.populateColumn.numValues[0];
      var last = this.populateColumn.numValues[1];
      // Handle simple numbers
      if (first === parseInt(first, 10).toString() && last === parseInt(last, 10).toString()) {
        numberOfValues = Math.abs(parseInt(last, 10) - parseInt(first, 10)) + 1;
        // Populate a maximum of 10000 values
        if (numberOfValues <= 10000) {
          // Set increment to 1 if increasing, -1 if decreasing
          increment = parseInt(last, 10) > parseInt(first, 10) ? 1 : -1;
          html = first;
          for (var i = 1; i < 5; i++) {
            var thisValue = (parseInt(first, 10) + i * increment).toString();
            if (i < numberOfValues) {
              html += ', ' + thisValue;
            }
          }
          if (numberOfValues === 6) {
            html += ', ' + last;
          } else if (numberOfValues === 7) {
            html += ', ' + (parseInt(first, 10) + 5 * increment).toString() + ', ' + last;
          } else if (numberOfValues > 7) {
            html += ', ..., ' + last;
          }
        }
      } else {
        // Handle formatted numbers
        // Replace all digits to check the formats match
        firstFormat = first.replace(/\d/g, '<digit>');
        lastFormat = last.replace(/\d/g, '<digit>');
        if (firstFormat === lastFormat) {
          // Extract the digits only
          firstDigits = first.replace(/\D/g, '');
          lastDigits = last.replace(/\D/g, '');
          // Set base to 2 (binary) if all digits are 0 or 1
          base = (firstDigits + lastDigits).replace(/0/g, '').replace(/1/g, '') === '' ? 2 : 10;
          numberOfValues = Math.abs(parseInt(lastDigits, base) - parseInt(firstDigits, base)) + 1;
          // Populate a maximum of 10000 values
          if (numberOfValues <= 10000) {
            // Set increment to 1 if increasing, -1 if decreasing
            increment = parseInt(lastDigits, base) > parseInt(firstDigits, base) ? 1 : -1;
            html = '<div class="inlineBlock">' + first + '</div>';
            for (var _i = 1; _i < 5; _i++) {
              if (_i < numberOfValues) {
                var _thisValue = (parseInt(firstDigits, base) + _i * increment).toString(base);
                // Left pad with zeros
                _thisValue = ('0'.repeat(firstDigits.length) + _thisValue).slice(-firstDigits.length);
                // Add non-numeric formatting
                formattedValue = firstFormat;
                for (var d = 0; d < firstDigits.length; d++) {
                  formattedValue = formattedValue.replace('<digit>', _thisValue.substring(d, d + 1));
                }
                html += ', <div class="inlineBlock">' + formattedValue + '</div>';
              }
            }
            if (numberOfValues === 6) {
              html += ', ' + last;
            } else if (numberOfValues > 6) {
              html += ', ..., <div class="inlineBlock">' + last + '</div>';
            }
          }
        }
      }
      return html;
    },
    questionPreviewHtml: function questionPreviewHtml() {
      if (this.questionStatus !== 'ok') return '';
      var cardStyle = void 0,
          html = void 0,
          prevHtml = void 0,
          rowIndex = void 0;
      // Find the first row with data in the from and to fields
      rowIndex = -1;
      for (var i = 0; i < this.rows.length; i++) {
        if (this.rowHasData(this.rows[i], this.question.fromFieldId, this.question.toFieldId)) {
          rowIndex = i;
          break;
        }
      }
      // Replace new lines with <br>
      html = this.question.questionText.replace(/\r\n/g, '<br>');
      html = html.replace(/\n/g, '<br>');
      // Replace spaces at the start of a line with &nbsp; to allow indenting
      while (true) {
        prevHtml = html;
        html = html.replace(/^((&nbsp;)*)\s/, '$1&nbsp;');
        html = html.replace(/(<br>(&nbsp;)*)\s/g, '$1&nbsp;');
        if (html === prevHtml) break;
      }
      // If example row found
      if (rowIndex !== -1) {
        // If From Column is Summary Image
        if (this.question.fromFieldId === 's') {
          if (!this.thumbnails[rowIndex]) this.createThumbnail(rowIndex);
          html = html.replace('*', '<img src="' + this.thumbnails[rowIndex] + '">');
        } else {
          cardStyle = this.cardStyle(this.rows[rowIndex].data[this.question.fromFieldId]);
          if (cardStyle) {
            html = html.replace('*', '<div style="background-image: ' + cardStyle.backgroundImage + '; background-position: ' + cardStyle.backgroundPosition + '; background-repeat: ' + cardStyle.backgroundRepeat + '; background-size: ' + cardStyle.backgroundSize + '; display: inline-block; height: 184px; width: 164px"></div>');
          } else {
            html = html.replace('*', '<strong>' + this.rows[rowIndex].data[this.question.fromFieldId] + '</strong>');
          }
        }
      }
      // Apply Mathjax
      this.$nextTick(function () {
        if (window.MathJax) {
          window.MathJax.typeset(['.questionPreview']);
        }
      });
      return this.sanitizeWithStyle(html);
    },
    questionStatus: function questionStatus() {
      var _this4 = this;

      var status = void 0;
      if (this.modal !== 'question') return '';
      if (!this.question.fromFieldId || !this.question.toFieldId) {
        status = 'incomplete';
      } else if (this.question.fromFieldId === this.question.toFieldId) {
        status = 'same column';
      } else if (this.questions.findIndex(function (question) {
        return question.fromFieldId === _this4.question.fromFieldId && question.toFieldId === _this4.question.toFieldId && question.questionId !== _this4.question.questionId;
      }) !== -1) {
        status = 'exists';
      } else {
        status = 'ok';
      }
      return status;
    },
    ratingsData: function ratingsData() {
      if (!this.ratingsArray) {
        return {
          count: 0,
          width: 0
        };
      }
      var ratingsData = {
        count: this.ratingsArray.reduce(function (a, b) {
          return a + b;
        }, 0)
        // Count total stars
      };var totalStars = 0;
      this.ratingsArray.forEach(function (stars, starsIndex) {
        totalStars += stars * (starsIndex + 1);
      });
      // Calculate average rating
      var averageRating = this.ratingsCount ? totalStars / this.ratingsCount : 0;
      // Calculate width of the ratings element
      var partialStar = void 0,
          completeStars = void 0,
          width = void 0;
      // If no rating, return 0
      if (!averageRating) {
        ratingsData.width = 0;
      } else {
        // Ensure that average rating is between 1 and 5
        averageRating = Math.max(1, averageRating);
        averageRating = Math.min(5, averageRating);
        // Find number of complete and partial stars
        completeStars = Math.floor(averageRating);
        partialStar = averageRating - completeStars;
        // Set width of complete stars
        width = 0.1 + 1.44 * completeStars;
        // Add width for partial star
        width += partialStar * 1.0;
        // Round to 2 decimal places
        width = Math.round(width * 100) / 100;
        ratingsData.width = width;
      }
      return ratingsData;
    },
    ratingsCount: function ratingsCount() {
      if (!this.ratingsArray) return 0;
      return this.ratingsArray.reduce(function (a, b) {
        return a + b;
      }, 0);
    },
    ratingWidth: function ratingWidth() {
      if (!this.ratingsArray) return 0;
      var totalStars = 0;
      this.ratingsArray.forEach(function (stars, starsIndex) {
        totalStars += stars * (starsIndex + 1);
      });
      // Calculate average rating
      var averageRating = this.ratingsCount ? totalStars / this.ratingsCount : 0;
      // Calculate width of the ratings element
      var partialStar = void 0,
          completeStars = void 0,
          width = void 0;
      // If no rating, return 0
      if (!averageRating) return 0;
      // Ensure that average rating is between 1 and 5
      averageRating = Math.max(1, averageRating);
      averageRating = Math.min(5, averageRating);
      // Find number of complete and partial stars
      completeStars = Math.floor(averageRating);
      partialStar = averageRating - completeStars;
      // Set width of complete stars
      width = 0.1 + 1.44 * completeStars;
      // Add width for partial star
      width += partialStar * 1.0;
      // Round to 2 decimal places
      width = Math.round(width * 100) / 100;
      return width;
    },
    reviewGroupColors: function reviewGroupColors() {
      var groupColors = {};
      var colors = ['teal', 'blue', 'violet', 'purple', 'pink', 'brown', 'orange', 'yellow', 'olive'];
      this.uniqueReviewGroups.forEach(function (reviewGroup, index) {
        groupColors[reviewGroup] = colors[index % colors.length];
      });
      groupColors[''] = 'invisible';
      return groupColors;
    },
    reviewGroupsList: function reviewGroupsList() {
      // Get unique reviewGroup values
      var reviewGroups = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(this.rows.map(function (row) {
        return row.data.reviewGroup || '';
      }))));
      // Sort alphabetically, with empty group at the end
      reviewGroups.sort(function (a, b) {
        if (!a) return 1;
        if (!b) return -1;
        if (a.toLowerCase() < b.toLowerCase()) return -1;
        return 1;
      });
      return reviewGroups;
    },
    responseTimeDisplay: function responseTimeDisplay() {
      var output = void 0;
      output = (Math.round(this.learn.responseTime / 10) / 100).toFixed(2);
      output += ' sec';
      return output;
    },
    selfOwned: function selfOwned() {
      var appendedUserId = '_' + this.user.id;
      if (this.memoSetType === 'regular' && this.memoSetId.slice(-appendedUserId.length) !== appendedUserId) {
        return true;
      } else {
        return false;
      }
    },
    sharingArray: function sharingArray() {
      var _this5 = this;

      var arr = void 0;
      // Exit if no sharing object
      if (!this.sharing) return [];
      arr = [];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.sharing).forEach(function (userId) {
        arr.push({
          displayName: _this5.sharing[userId],
          userId: userId
        });
      });
      // Sort sharing array
      arr.sort(function (a, b) {
        if (a.userId === 'public') return -1;
        if (b.userId === 'public') return 1;
        if (a.displayName < b.displayName) return -1;
        return 1;
      });
      return arr;
    },
    summaryImageLocationRectWithMargin: function summaryImageLocationRectWithMargin() {
      return this.locationRectWithMargin(0.15);
    },
    summaryImageObjectCanvasPadding: function summaryImageObjectCanvasPadding() {
      if (this.mode === 'clip' || this.mode === 'draw') {
        return drawTransparentRadius;
      } else {
        return 0;
      }
    },
    summaryImageUploadingMessage: function summaryImageUploadingMessage() {
      var message = void 0;
      if (!this.summaryImage.imagesRemaining) return '';
      if (this.summaryImage.imagesRemaining === 1) {
        message = this.text.memoSetUploadingImage;
      } else {
        message = this.text.memoSetUploadingImages.replace('<remaining>', this.summaryImage.imagesRemaining.toString());
      }
      return message;
    },
    tabsText: function tabsText() {
      return this.window.width > 500;
    },
    uniqueReviewGroups: function uniqueReviewGroups() {
      // Return an array of unique review groups, in order of appearance
      var uniqueGroups = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(this.rows.map(function (row) {
        return row.data.reviewGroup;
      }).filter(function (reviewGroup) {
        return reviewGroup;
      }))));
      return uniqueGroups;
    },
    verticallyChallenged: function verticallyChallenged() {
      return this.window.height < 800;
    },
    visibleCellAlternatives: function visibleCellAlternatives() {
      return this.cellAlternatives.filter(function (alternative) {
        return !alternative.deleted;
      });
    },
    visibleRows: function visibleRows() {
      var _this6 = this;

      // Return a filtered array containing visible rows
      var filteredRows = void 0;
      // Filter rows to those visible
      filteredRows = this.rows.filter(function (row, rowIndex) {
        return rowIndex + 1 >= _this6.firstVisibleRow && rowIndex + 1 < _this6.firstVisibleRow + _this6.visibleRowsCount;
      });
      return filteredRows;
    },
    visibleRowsCount: function visibleRowsCount() {
      // Show all rows if printing
      if (this.printing) return this.rows.length;
      // Show all rows if there are 100 or fewer, otherwise show 50 rows
      if (this.rows.length > 50 && this.rows.length <= 100) {
        return this.rows.length;
      } else {
        return 50;
      }
    },
    visibleRowsOffset: function visibleRowsOffset() {
      return this.firstVisibleRow - 1;
    },
    walkThroughCurrentPhoto: function walkThroughCurrentPhoto() {
      if (this.modal !== 'walkThrough') return {};
      var stepNum = void 0,
          steps = void 0;
      stepNum = this.walkThrough.stepNum;
      steps = this.walkThrough.steps;
      // Filter walkThrough.photos to find the photo for the current step
      if (steps[stepNum].photoId) {
        return this.walkThrough.photos.filter(function (photo) {
          return photo.id === steps[stepNum].photoId;
        })[0] || {};
      } else {
        return {
          objects: steps[stepNum].objects
        };
      }
    },
    walkThroughEnabled: function walkThroughEnabled() {
      return this.options.useBackgroundPhotos && this.photos.length && this.rows.filter(function (row) {
        return row.data.photoId;
      }).length;
    },
    walkThroughLabelsVisible: function walkThroughLabelsVisible() {
      // Show text on Walk Through button labels if the window is wide enough
      return this.window.width >= 1000;
    },
    walkThroughLocationRectWithMargin: function walkThroughLocationRectWithMargin() {
      return this.locationRectWithMargin(0.08);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.detachDataListener) {
      this.detachDataListener();
      this.detachDataListener = null;
    }
    if (this.detachMemoSetListener) {
      this.detachMemoSetListener();
      this.detachMemoSetListener = null;
    }
    if (this.detachPrivateListener) {
      this.detachPrivateListener();
      this.detachPrivateListener = null;
    }
    if (this.detachPublicListener) {
      this.detachPublicListener();
      this.detachPublicListener = null;
    }
  },
  created: function created() {
    // TEMP - for debugging
    window.vm = this;
    // Scroll to top
    window.scrollTo(0, 0);
    // If the memo sets data is available, we can load the memo set now
    if (this.memoSets) {
      this.initMemoSet();
    }
  },
  destroyed: function destroyed() {
    // Remove window listeners
    window.removeEventListener('mouseup', this.windowPointerUp);
    window.removeEventListener('touchend', this.windowPointerUp);
    window.removeEventListener('keydown', this.windowKeyDown);
    window.removeEventListener('keyup', this.windowKeyUp);
    window.removeEventListener('wheel', this.windowWheel);
    // Close any modals
    $('.ui.modal').modal('hide');
    // Remove modal divs
    $('.ui.modal.' + this.modalClass).remove();
  },
  methods: {
    addAlternativeClick: function addAlternativeClick(rowIndex, fieldId) {
      var row = this.rows[rowIndex];
      // TEMP
      this.$set(row.data, fieldId, '');
      var cell = document.getElementById(fieldId + '_' + rowIndex);
      cell.focus();
    },
    addCellAudioClick: function addCellAudioClick(rowIndex, fieldId) {
      // Save cell info
      this.rowIndex = rowIndex;
      this.fieldId = fieldId;
      // Initialize modal
      this.initAddCellAudio();
      $('.ui.modal.addCellAudio').modal({
        autofocus: false,
        observeChanges: true,
        onApprove: this.addCellAudioSubmit,
        onHidden: this.revertPreventBackHistory,
        onHide: function onHide() {
          document.getElementById('addCellAudio').pause();
        },
        onVisible: this.prepareModalHistory
      }).modal('show');
    },
    addCellAudioSubmit: function addCellAudioSubmit() {
      var audioKey = void 0;
      var self = this;

      function addCellAudio(downloadUrl) {
        var audioHtml = void 0,
            brCount = void 0,
            brLength = void 0,
            remainder = void 0;
        var goToElement = document.getElementById(self.fieldId + '_' + self.rowIndex);
        goToElement.focus();
        moveCursorToEndOfContentEditable(goToElement);
        // Prepare audio HTML
        audioHtml = '<audio id="' + audioKey + '" src="' + downloadUrl + '"></audio>';
        // Add play button HTML
        audioHtml += '<button contenteditable="false" id="play_' + audioKey + '" class="circular ui icon button"><i class="play icon"></i></button>';
        brCount = 0;
        if (goToElement.innerHTML.slice(-4) === '<br>') {
          brCount++;
          brLength = 4;
        }
        if (goToElement.innerHTML.slice(-5) === '<br/>') {
          brCount++;
          brLength = 5;
        }
        if (goToElement.innerHTML.slice(-6) === '<br />') {
          brCount++;
          brLength = 6;
        }
        remainder = goToElement.innerHTML.slice(0, -brLength);
        if (remainder.slice(-4) === '<br>') {
          brCount++;
        }
        if (remainder.slice(-5) === '<br/>') {
          brCount++;
        }
        if (remainder.slice(-6) === '<br />') {
          brCount++;
        }
        // Prepend <br> tags if there is text and there aren't already 2 <br> tags
        if (self.textOnly(goToElement.innerHTML)) {
          if (!brCount) audioHtml = '<br><br>' + audioHtml;
          if (brCount === 1) audioHtml = '<br>' + audioHtml;
        }
        pasteHtmlAtCaret(audioHtml);
        goToElement.blur();
        self.addCellAudio.uploading = false;
        // Close modal
        $('.ui.modal.addCellAudio').modal('hide');
      }

      this.addCellAudio.uploading = true;
      // Get a random key for the audio
      audioKey = this.getImageKey();
      // Upload the audio to Firebase Storage
      firebase.storage().ref('userAudio/' + this.user.id + '/' + audioKey).put(this.addCellAudio.file, { cacheControl: 'max-age=2592000' }).then(function (snapshot) {
        return snapshot.ref.getDownloadURL();
      }).then(function (downloadUrl) {
        addCellAudio(downloadUrl);
      });
      // Prevent modal closing
      return false;
    },
    addCellImageClick: function addCellImageClick(rowIndex, fieldId) {
      var _this7 = this;

      // Save cell info
      this.rowIndex = rowIndex;
      this.fieldId = fieldId;
      // Initialize modal
      this.initAddCellImage();
      // Allow time for previous image to be cleared
      this.$nextTick(function () {
        $('.ui.modal.addCellImage').modal({
          autofocus: false,
          observeChanges: true,
          onApprove: _this7.addCellImageSubmit,
          onHidden: _this7.revertPreventBackHistory,
          onVisible: _this7.prepareModalHistory
        }).modal('show');
      });
    },
    addCellImageEnter: function addCellImageEnter() {
      // Exit if modal is incomplete
      if (!this.addCellImage.url) return;
      this.addCellImageSubmit();
    },
    addCellImageSubmit: function addCellImageSubmit() {
      var canvas = void 0,
          ctx = void 0,
          height = void 0,
          imageDataUrl = void 0,
          imageKey = void 0,
          img = void 0,
          scaleFactor = void 0,
          tempCanvas = void 0,
          tempCtx = void 0,
          width = void 0;
      var self = this;

      function addCellImage(imageDownloadUrl) {
        var brCount = void 0,
            brLength = void 0,
            imgHtml = void 0,
            remainder = void 0;
        var goToElement = document.getElementById(self.fieldId + '_' + self.rowIndex);
        goToElement.focus();
        moveCursorToEndOfContentEditable(goToElement);
        // Prepare image HTML
        imgHtml = '<img src="' + imageDownloadUrl + '">';
        brCount = 0;
        if (goToElement.innerHTML.slice(-4) === '<br>') {
          brCount++;
          brLength = 4;
        }
        if (goToElement.innerHTML.slice(-5) === '<br/>') {
          brCount++;
          brLength = 5;
        }
        if (goToElement.innerHTML.slice(-6) === '<br />') {
          brCount++;
          brLength = 6;
        }
        remainder = goToElement.innerHTML.slice(0, -brLength);
        if (remainder.slice(-4) === '<br>') {
          brCount++;
        }
        if (remainder.slice(-5) === '<br/>') {
          brCount++;
        }
        if (remainder.slice(-6) === '<br />') {
          brCount++;
        }
        // Prepend <br> tags if there is text and there aren't already 2 <br> tags
        if (self.textOnly(goToElement.innerHTML)) {
          if (!brCount) imgHtml = '<br><br>' + imgHtml;
          if (brCount === 1) imgHtml = '<br>' + imgHtml;
        }
        pasteHtmlAtCaret(imgHtml);
        goToElement.blur();
        self.addCellImage.uploading = false;
        // Close modal
        $('.ui.modal.addCellImage').modal('hide');
      }

      this.addCellImage.uploading = true;
      img = document.getElementById('addCellImage');
      // Get a random key for the image
      imageKey = this.getImageKey();
      // If image isn't too large
      if (img.naturalHeight <= maxCellImageSize && img.naturalWidth <= maxCellImageSize) {
        // Upload the image to Firebase Storage
        firebase.storage().ref('userImages/' + this.user.id + '/' + imageKey).put(this.addCellImage.file, { cacheControl: 'max-age=2592000' }).then(function (snapshot) {
          return snapshot.ref.getDownloadURL();
        }).then(function (downloadUrl) {
          addCellImage(downloadUrl);
        });
      } else {
        scaleFactor = Math.min(maxCellImageSize / img.naturalWidth, maxCellImageSize / img.naturalHeight);
        scaleFactor = Math.min(scaleFactor, 1);
        // Limit scale down to half to preserve image quality
        scaleFactor = Math.max(scaleFactor, 0.5);
        tempCanvas = document.createElement('canvas');
        tempCanvas.width = img.naturalWidth * scaleFactor;
        tempCanvas.height = img.naturalHeight * scaleFactor;
        tempCtx = tempCanvas.getContext('2d');
        // Fill with white in case of transparent images
        tempCtx.fillStyle = 'white';
        tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);
        tempCtx.drawImage(img, 0, 0, tempCanvas.width, tempCanvas.height);
        width = tempCanvas.width;
        height = tempCanvas.height;
        while (scaleFactor === 0.5) {
          scaleFactor = Math.min(maxCellImageSize / width, maxCellImageSize / height);
          scaleFactor = Math.max(scaleFactor, 0.5);
          tempCtx.drawImage(tempCanvas, 0, 0, width, height, 0, 0, width * scaleFactor, height * scaleFactor);
          width = width * scaleFactor;
          height = height * scaleFactor;
        }
        // Draw section of tempCanvas onto canvas
        canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        ctx = canvas.getContext('2d');
        ctx.drawImage(tempCanvas, 0, 0, width, height, 0, 0, width, height);
        imageDataUrl = canvas.toDataURL('image/jpeg');
        // Upload the image to Firebase Storage
        firebase.storage().ref('userImages/' + this.user.id + '/' + imageKey).putString(imageDataUrl, 'data_url', { cacheControl: 'max-age=2592000' }).then(function (snapshot) {
          return snapshot.ref.getDownloadURL();
        }).then(function (downloadUrl) {
          addCellImage(downloadUrl);
        });
      }
      // Prevent modal closing
      return false;
    },
    addColumnClick: function addColumnClick() {
      var _this8 = this;

      // Hide Actions popup
      $('.actionsButton').popup('hide');
      this.$nextTick(function () {
        _this8.addColumn.columnHeading = '';
        // Prepare Add After Column dropdown
        _this8.addColumn.addAfterColumn = (_this8.fields.length - 1).toString();
        $('.addColumnAddAfterColumn').dropdown({
          onChange: function onChange(value) {
            _this8.addColumn.addAfterColumn = value;
          },
          showOnFocus: false
        }).dropdown('set selected', _this8.addColumn.addAfterColumn);
        $('.ui.modal.addColumn').modal({
          onApprove: _this8.addColumnSubmit,
          onHidden: _this8.revertPreventBackHistory,
          onVisible: _this8.prepareModalHistory
        }).modal('show');
      });
    },
    addColumnEnter: function addColumnEnter() {
      // Exit if form is incomplete
      if (!this.addColumn.columnHeading) return;
      // Hide modal
      $('.ui.modal.addColumn').modal('hide');
      // Submit form
      this.addColumnSubmit();
    },
    addColumnSubmit: function addColumnSubmit() {
      var fieldId = void 0,
          fieldIndex = void 0;
      // Get next available field ID
      fieldIndex = 0;
      while (true) {
        fieldIndex++;
        fieldId = 'f' + fieldIndex.toString();
        if (!this.fields.filter(function (field) {
          return field.fieldId === fieldId;
        }).length) break;
      }
      // Add field to the fields array
      this.fields.splice(parseInt(this.addColumn.addAfterColumn, 10) + 1, 0, {
        fieldId: fieldId,
        heading: this.addColumn.columnHeading
      });
      this.writeFields();
      this.initSearch();
    },
    addImageClick: function addImageClick(event) {
      // Blur button
      event.target.blur();
      // Switch to Add Image page
      this.summaryImage.page = 'add';
      this.addImage.loading = false;
      this.addImage.url = '';
      document.getElementById('imageFile').value = '';
    },
    addImageFileChange: function addImageFileChange(file) {
      if (file) {
        // Check that file is an image
        if (file.type.substring(0, 6) === 'image/') {
          this.addImage.file = file;
          this.addImage.url = window.URL.createObjectURL(file);
          this.summaryImage.createdObjectUrls.push(this.addImage.url);
        } else {
          document.getElementById('imageFile').value = '';
          alert('Please select an image file.');
        }
      }
    },
    addObjectsForRow: function addObjectsForRow(row, rowIndex) {
      var _this9 = this;

      // Loop through objects for the row
      if (row.data.objects) {
        row.data.objects.forEach(function (obj) {
          _this9.lastObjectKey++;
          _this9.objects.push({
            angle: obj.angle,
            flipX: !!obj.flipX,
            flipY: !!obj.flipY,
            height: obj.height,
            key: _this9.lastObjectKey,
            left: obj.left,
            rowIndex: rowIndex,
            sequence: obj.sequence,
            top: obj.top,
            url: obj.url,
            width: obj.width
          });
        });
      }
    },
    addPhotoFileChange: function addPhotoFileChange(file) {
      if (file) {
        // Check that file is an image
        if (file.type.substring(0, 6) === 'image/') {
          // Show image in the modal
          this.addPhoto.url = window.URL.createObjectURL(file);
          this.addPhoto.file = file;
        } else {
          document.getElementById('photoFile').value = '';
          alert('Please select an image file.');
        }
      }
    },
    addRowsAddRows: function addRowsAddRows(updateDb) {
      var _this10 = this,
          _rows,
          _thumbnails;

      var addBelowRow = void 0,
          docId = void 0,
          docsWithCounts = void 0,
          firestoreNewDocs = void 0,
          firestoreUpdateDocs = void 0,
          newDocsRequired = void 0,
          newRow = void 0,
          newRows = void 0,
          newThumbnails = void 0,
          numberOfRows = void 0,
          rowsAvailable = void 0,
          rowId = void 0;
      addBelowRow = parseInt(this.addRows.addBelowRow, 10) - 1;
      // Ensure addBelowRow is not greater than the max row index
      if (addBelowRow > this.rows.length - 1) addBelowRow = this.rows.length - 1;
      numberOfRows = parseInt(this.addRows.numberOfRows, 10);
      firestoreNewDocs = {};
      newRows = [];
      newThumbnails = [];
      // Create array of existing documents
      var uniqueDocIds = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(this.rows.map(function (row) {
        return row.docId;
      }))));
      docsWithCounts = uniqueDocIds.map(function (docId) {
        return {
          docId: docId,
          new: false,
          rowCount: _this10.rows.filter(function (row) {
            return row.docId === docId;
          }).length
        };
      });
      // Remove any full documents
      docsWithCounts = docsWithCounts.filter(function (docObj) {
        return docObj.rowCount < rowsPerDocument;
      });
      // Calculate number of rows available in existing documents
      rowsAvailable = 0;
      docsWithCounts.forEach(function (docObj) {
        if (docObj.rowCount < rowsPerDocument) {
          rowsAvailable += rowsPerDocument - docObj.rowCount;
        }
      });
      // Calculate number of new documents required
      if (rowsAvailable >= numberOfRows) {
        newDocsRequired = 0;
      } else {
        newDocsRequired = Math.ceil((numberOfRows - rowsAvailable) / rowsPerDocument);
      }
      // Add new documents to docsWithCounts
      for (var i = 0; i < newDocsRequired; i++) {
        docId = this.randomId();
        docsWithCounts.push({
          docId: docId,
          isNew: true,
          rowCount: 0
        });
        // Initialize document for Firestore write
        firestoreNewDocs[docId] = {};
        // Add userId and sharing, for security rules
        firestoreNewDocs[docId].userId = this.user.id;
        if (this.sharing) {
          firestoreNewDocs[docId].sharing = this.sharing;
        }
      }
      // Loop through rows being added
      for (var _i2 = 0; _i2 < numberOfRows; _i2++) {
        // Set docId for the new row
        docId = docsWithCounts[0].docId;
        // Set a random row ID
        rowId = this.randomId();
        // Create a new row object
        newRow = {
          data: {
            seq: addBelowRow + _i2 + 1
          },
          docId: docId,
          rowId: rowId
          // If the row is on a new document
        };if (docsWithCounts[0].isNew) {
          // Prepare Firestore object
          firestoreNewDocs[docId][rowId] = {
            seq: newRow.data.seq
          };
        } else {
          // The row is on an existing document - set seq to a dummy value so the Firestore document will be updated
          newRow.data.seq = -1;
        }
        newRows.push(newRow);
        newThumbnails.push(null);
        // Increment rowCount for the doc
        docsWithCounts[0].rowCount++;
        // Remove docId from docsWithCounts if document is full
        if (docsWithCounts[0].rowCount === rowsPerDocument) {
          docsWithCounts.shift();
        }
      }
      // Insert new rows
      (_rows = this.rows).splice.apply(_rows, [addBelowRow + 1, 0].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(newRows)));
      // Insert new thumbnails
      (_thumbnails = this.thumbnails).splice.apply(_thumbnails, [addBelowRow + 1, 0].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(newThumbnails)));
      // Check/update thumbnails and Mathjax
      this.prepareVisibleRows();
      // Prepare object for updates
      firestoreUpdateDocs = {};
      this.rows.forEach(function (row, rowIndex) {
        // If seq has changed
        if (row.data.seq !== rowIndex) {
          _this10.$set(row.data, 'seq', rowIndex);
          // Create update object for the document if necessary
          if (!firestoreUpdateDocs[row.docId]) firestoreUpdateDocs[row.docId] = {};
          firestoreUpdateDocs[row.docId][row.rowId + '.seq'] = rowIndex;
        }
      });
      if (updateDb) {
        var batch = db.batch();
        // Write new docs
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(firestoreNewDocs).forEach(function (docId) {
          batch.set(db.doc('memoSets/' + _this10.memoSetId + '/rows/' + docId), firestoreNewDocs[docId]);
        });
        // Write update docs
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(firestoreUpdateDocs).forEach(function (docId) {
          batch.update(db.doc('memoSets/' + _this10.memoSetId + '/rows/' + docId), firestoreUpdateDocs[docId]);
        });
        this.writeRowCount(batch);
        batch.commit().catch(function (error) {
          logError('MemoSet_addRowsAddRows', error);
        });
        this.initSearch();
      } else {
        // Save Firestore data for use by populateColumnSubmit or rowFieldPasteSubmit
        this.addRows.firestoreNewDocs = firestoreNewDocs;
        this.addRows.firestoreUpdateDocs = firestoreUpdateDocs;
      }
    },
    addRowsClick: function addRowsClick() {
      var _this11 = this;

      // Hide Actions popup
      $('.actionsButton').popup('hide');
      this.$nextTick(function () {
        _this11.addRows.addBelowRow = _this11.rows.length ? '' : 0;
        _this11.addRows.numberOfRows = '';
        $('.ui.modal.addRows').modal({
          onApprove: _this11.addRowsSubmit,
          onHidden: _this11.revertPreventBackHistory,
          onVisible: _this11.prepareModalHistory
        }).modal('show');
      });
    },
    addRowsEnter: function addRowsEnter() {
      // Check form is complete
      if (!(parseInt(this.addRows.addBelowRow, 10) >= 0) || !(parseInt(this.addRows.numberOfRows, 10) > 0)) return;
      // Hide modal
      $('.ui.modal.addRows').modal('hide');
      // Submit form
      this.addRowsSubmit();
    },
    addRowsSubmit: function addRowsSubmit() {
      // Add rows (writing to the database)
      this.addRowsAddRows(true);
      this.initSearch();
    },
    addSummaryImageUndoEntry: function addSummaryImageUndoEntry(undoEntry) {
      // Add undo entry to undo array
      this.summaryImage.undoArray[this.summaryImage.undoArrayIndex] = undoEntry;
      this.summaryImage.undoArrayIndex++;
      this.summaryImage.undoArrayIndexMax = this.summaryImage.undoArrayIndex;
    },
    addToMyMemoSetsClick: function addToMyMemoSetsClick() {
      var _this12 = this;

      this.copyMemoSet.newTitle = this.title;
      this.copyMemoSet.newFolderName = '';
      this.copyMemoSet.folderId = '';
      this.$nextTick(function () {
        $('.copyMemoSetFolderId').dropdown({
          onChange: function onChange(value) {
            _this12.copyMemoSet.folderId = value;
            if (value === 'new') {
              _this12.$nextTick(function () {
                document.getElementById('newFolderName').focus();
              });
            }
          },
          showOnFocus: false
        }).dropdown('clear');
        $('.ui.modal.copyMemoSet').modal({
          onApprove: _this12.copyMemoSetSubmit
        }).modal('show');
      });
    },
    adjustObjectPositionsForRow: function adjustObjectPositionsForRow(row, oldPhotoId) {
      var location = void 0,
          newPhoto = void 0,
          oldPhoto = void 0,
          scaleFactor = void 0;
      if (oldPhotoId) {
        oldPhoto = this.photos.find(function (photo) {
          return photo.id === oldPhotoId;
        });
      }
      if (row.data.photoId) {
        newPhoto = this.modalPhotos.find(function (photo) {
          return photo.id === row.data.photoId;
        });
      }
      // If background photo has been removed
      if (!newPhoto) {
        location = row.data.location;
        scaleFactor = Math.min(noPhotoSize / location.width, noPhotoSize / location.height);
        if (row.data.objects) {
          row.data.objects.forEach(function (obj) {
            // Translate by location position
            obj.left -= location.left;
            obj.top -= location.top;
            // Scale to fit
            obj.left *= scaleFactor;
            obj.top *= scaleFactor;
            obj.width *= scaleFactor;
            obj.height *= scaleFactor;
          });
        }
      }
      // If background photo has been added
      if (!oldPhoto) {
        row.data.location = row.data.location || {};
        location = row.data.location;
        location.left = 0;
        location.top = 0;
        location.width = Math.min(0.3 * newPhoto.width, 0.3 * newPhoto.height);
        location.height = location.width;
        scaleFactor = Math.min(location.width / noPhotoSize, location.height / noPhotoSize);
        if (row.data.objects) {
          row.data.objects.forEach(function (obj) {
            obj.left *= scaleFactor;
            obj.top *= scaleFactor;
            obj.width *= scaleFactor;
            obj.height *= scaleFactor;
          });
        }
      }
      // If background photo has been changed
      if (newPhoto && oldPhoto) {
        scaleFactor = Math.min(newPhoto.width / oldPhoto.width, newPhoto.height / oldPhoto.height);
        location = row.data.location;
        location.left *= scaleFactor;
        location.top *= scaleFactor;
        location.width *= scaleFactor;
        location.height *= scaleFactor;
        if (row.data.objects) {
          row.data.objects.forEach(function (obj) {
            obj.left *= scaleFactor;
            obj.top *= scaleFactor;
            obj.width *= scaleFactor;
            obj.height *= scaleFactor;
          });
        }
      }
    },
    answerClick: function answerClick(result) {
      var _this13 = this;

      this.learn.reviewItem.rowIndexes.forEach(function (rowIndex) {
        var row = _this13.rows[rowIndex];
        var questionId = _this13.learn.reviewItem.questionId;
        // Add row questions property if required
        if (!row.data.questions) {
          _this13.$set(row.data, 'questions', {});
        }
        // Add row question if required
        if (!row.data.questions[questionId]) {
          _this13.$set(row.data.questions, questionId, {
            reviewAfter: 0,
            reviewCycle: 0
          });
        }
        var question = row.data.questions[questionId];
        if (result === 'correct') {
          // If the item was unknown or due for review, increment its review cycle
          if (!question.reviewCycle || question.reviewAfter < Date.now()) {
            question.reviewCycle++;
          }
          question.reviewAfter = Date.now() + durationForReviewCycle(question.reviewCycle);
        } else {
          question.reviewCycle = 0;
          question.reviewAfter = Date.now() + durationForReviewCycle(0);
        }
        // Update Firestore update object
        if (!_this13.learn.firestoreUpdate[row.docId]) _this13.learn.firestoreUpdate[row.docId] = {};
        _this13.learn.firestoreUpdate[row.docId][row.rowId + '.questions.' + questionId] = {
          reviewAfter: question.reviewAfter,
          reviewCycle: question.reviewCycle
          // Update activeQuestions array
        };var questionIndex = _this13.activeQuestions.findIndex(function (e) {
          return e.rowIndex === rowIndex && e.questionId === questionId;
        });
        var questionObj = _this13.activeQuestions[questionIndex];
        questionObj.reviewAfter = question.reviewAfter;
        questionObj.reviewCycle = question.reviewCycle;
      });
      if (result === 'incorrect') {
        // Hide congratulations message
        $('.message.congratulations').transition('hide');
        if (this.learn.allKnown && !this.learn.noLongerAllKnown) {
          this.learn.noLongerAllKnown = true;
          this.learn.justNoLongerAllKnown = true;
        }
      }
      // Show next item
      this.learn.reviewItem = this.nextReviewItem();
      this.learn.answerVisible = false;
      // Start timer when item visible
      this.startTimerOnNextTick();
    },
    applyMathjax: function applyMathjax() {
      this.$nextTick(function () {
        if (window.MathJax) {
          window.MathJax.typeset(['.tex2jax_process']);
        }
      });
    },
    applyMathjaxToRowDataTables: function applyMathjaxToRowDataTables() {
      this.$nextTick(function () {
        window.MathJax.typeset(['.rowDataTable']);
      });
    },
    backgroundPhotoClick: function backgroundPhotoClick(rowIndex) {
      var _this14 = this;

      if (this.memoSetType !== 'regular') return;
      // Save row index
      this.rowIndex = rowIndex;
      this.sortPhotos();
      this.modalPhotos = this.photos.slice();
      // Initialize modal
      this.initAddPhoto();
      this.applyToRows = '';
      this.selectedPhotoIndex = this.photoIndexes[rowIndex];
      // Set initial tab name
      this.backgroundPhotoTab = this.modalPhotos.length ? 'backgroundPhotoSelect' : 'backgroundPhotoAdd';
      // Allow time for previous image to be cleared
      this.$nextTick(function () {
        $('.ui.modal.backgroundPhoto').modal({
          autofocus: false,
          centered: false,
          onApprove: _this14.backgroundPhotoSubmit,
          onHidden: _this14.revertPreventBackHistory,
          onVisible: _this14.prepareModalHistory
        }).modal('show');
        // Set initial tab
        var initialTab = _this14.modalPhotos.length ? 'backgroundPhotoSelect' : 'backgroundPhotoAdd';
        $('.menu.backgroundPhotoTabs .item').tab('change tab', initialTab);
      });
    },
    backgroundPhotoEnter: function backgroundPhotoEnter() {
      // Exit if modal is incomplete
      if (this.backgroundPhotoTab === 'backgroundPhotoAdd' && !this.addPhoto.url) return;
      // Hide modal
      $('.ui.modal.backgroundPhoto').modal('hide');
      this.backgroundPhotoSubmit();
    },
    backgroundPhotoSubmit: function backgroundPhotoSubmit() {
      if (this.backgroundPhotoTab === 'backgroundPhotoAdd') {
        this.backgroundPhotoSubmitAdd();
        // Prevent modal closing
        return false;
      }
      if (this.backgroundPhotoTab === 'backgroundPhotoSelect') {
        this.backgroundPhotoUpdate();
      }
    },
    backgroundPhotoSubmitAdd: function backgroundPhotoSubmitAdd() {
      var self = this;
      function addPhoto(downloadUrl, height, width) {
        var photoId = self.getImageKey();
        // Update photos array
        self.modalPhotos.push({
          height: height,
          id: photoId,
          url: downloadUrl,
          width: width
        });
        // Update row to use the new photo
        self.selectedPhotoIndex = self.modalPhotos.length - 1;
        self.backgroundPhotoUpdate();
        // Close modal
        $('.ui.modal.backgroundPhoto').modal('hide');
      }
      var canvas = void 0,
          ctx = void 0,
          height = void 0,
          imageDataUrl = void 0,
          imageKey = void 0,
          img = void 0,
          scaleFactor = void 0,
          tempCanvas = void 0,
          tempCtx = void 0,
          width = void 0;
      this.addPhoto.uploading = true;
      img = document.getElementById('addPhotoImage');
      // Get a random key for the image
      imageKey = this.getImageKey();
      // Get photo dimensions
      height = img.naturalHeight;
      width = img.naturalWidth;
      // If image isn't too large
      if (img.naturalHeight <= maxImageSize && img.naturalWidth <= maxImageSize) {
        // Upload the image to Firebase Storage
        firebase.storage().ref('userImages/' + this.user.id + '/' + imageKey).put(this.addPhoto.file, { cacheControl: 'max-age=2592000' }).then(function (snapshot) {
          return snapshot.ref.getDownloadURL();
        }).then(function (downloadUrl) {
          addPhoto(downloadUrl, height, width);
        });
      } else {
        scaleFactor = Math.min(maxImageSize / img.naturalWidth, maxImageSize / img.naturalHeight);
        scaleFactor = Math.min(scaleFactor, 1);
        // Limit scale down to half to preserve image quality
        scaleFactor = Math.max(scaleFactor, 0.5);
        tempCanvas = document.createElement('canvas');
        tempCanvas.width = img.naturalWidth * scaleFactor;
        tempCanvas.height = img.naturalHeight * scaleFactor;
        tempCtx = tempCanvas.getContext('2d');
        // Fill with white in case of transparent images
        tempCtx.fillStyle = 'white';
        tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);
        tempCtx.drawImage(img, 0, 0, tempCanvas.width, tempCanvas.height);
        width = tempCanvas.width;
        height = tempCanvas.height;
        while (scaleFactor === 0.5) {
          scaleFactor = Math.min(maxImageSize / width, maxImageSize / height);
          scaleFactor = Math.max(scaleFactor, 0.5);
          tempCtx.drawImage(tempCanvas, 0, 0, width, height, 0, 0, width * scaleFactor, height * scaleFactor);
          width = width * scaleFactor;
          height = height * scaleFactor;
        }
        // Draw section of tempCanvas onto canvas
        canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        ctx = canvas.getContext('2d');
        ctx.drawImage(tempCanvas, 0, 0, width, height, 0, 0, width, height);
        imageDataUrl = canvas.toDataURL('image/jpeg');
        // Upload the image to Firebase Storage
        firebase.storage().ref('userImages/' + this.user.id + '/' + imageKey).putString(imageDataUrl, 'data_url', { cacheControl: 'max-age=2592000' }).then(function (snapshot) {
          return snapshot.ref.getDownloadURL();
        }).then(function (downloadUrl) {
          addPhoto(downloadUrl, height, width);
        });
      }
    },
    backgroundPhotoUpdate: function backgroundPhotoUpdate() {
      var _this15 = this;

      var firestoreUpdateDocs = void 0,
          fromRowIndex = void 0,
          oldPhotoId = void 0,
          photoId = void 0,
          row = void 0,
          toRowIndex = void 0;
      firestoreUpdateDocs = {};
      // Determine rows to be updated
      fromRowIndex = this.rowIndex;
      toRowIndex = this.rowIndex;
      if (parseInt(this.applyToRows, 10) > 0) {
        toRowIndex = this.rowIndex + parseInt(this.applyToRows, 10);
        if (toRowIndex > this.rows.length - 1) toRowIndex = this.rows.length - 1;
      }
      // If 'no photo' selected
      if (this.selectedPhotoIndex === -1) {
        for (var i = fromRowIndex; i <= toRowIndex; i++) {
          row = this.rows[i];
          oldPhotoId = row.data.photoId;
          if (oldPhotoId) {
            this.$delete(row.data, 'photoId');
            // Update rectangle and object positions
            this.adjustObjectPositionsForRow(row, oldPhotoId);
            // Update firestoreUpdateDocs
            if (!firestoreUpdateDocs[row.docId]) firestoreUpdateDocs[row.docId] = {};
            firestoreUpdateDocs[row.docId][row.rowId + '.photoId'] = firebase.firestore.FieldValue.delete();
            firestoreUpdateDocs[row.docId][row.rowId + '.location'] = row.data.location;
            if (row.data.objects) {
              firestoreUpdateDocs[row.docId][row.rowId + '.objects'] = row.data.objects;
            }
          }
        }
      } else {
        photoId = this.modalPhotos[this.selectedPhotoIndex].id;
        for (var _i3 = fromRowIndex; _i3 <= toRowIndex; _i3++) {
          row = this.rows[_i3];
          oldPhotoId = row.data.photoId;
          if (oldPhotoId !== photoId) {
            row.data.photoId = photoId;
            // Make update reactive
            this.$set(this.rows, _i3, row);
            // Update rectangle and object positions
            this.adjustObjectPositionsForRow(row, oldPhotoId);
            // Update firestoreUpdateDocs
            if (!firestoreUpdateDocs[row.docId]) firestoreUpdateDocs[row.docId] = {};
            firestoreUpdateDocs[row.docId][row.rowId + '.photoId'] = photoId;
            firestoreUpdateDocs[row.docId][row.rowId + '.location'] = row.data.location;
            if (row.data.objects) {
              firestoreUpdateDocs[row.docId][row.rowId + '.objects'] = row.data.objects;
            }
          }
        }
      }
      var batch = db.batch();
      // Update photos array in Firestore, if changed
      if (this.modalPhotos.map(function (p) {
        return p.id;
      }).join() !== this.photos.map(function (p) {
        return p.id;
      }).join()) {
        this.photos = this.modalPhotos.slice();
        batch.update(db.doc('memoSets/' + this.memoSetId), {
          photos: this.photos
        });
        this.updateSharedSummaries(batch, {
          photos: this.photos
        });
      }
      // Update rows in Firestore
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(firestoreUpdateDocs).forEach(function (docId) {
        batch.update(db.doc('memoSets/' + _this15.memoSetId + '/rows/' + docId), firestoreUpdateDocs[docId]);
      });
      batch.commit().catch(function (error) {
        logError('MemoSet_backgroundPhotoUpdate', error);
      });
      // Update thumbnail for affected rows
      for (var _i4 = fromRowIndex; _i4 <= toRowIndex; _i4++) {
        this.createThumbnail(_i4);
      }
    },
    cardStyle: function cardStyle(value) {
      var cardNum = void 0,
          cardNum1 = void 0,
          cardNum2 = void 0,
          spacePos = void 0,
          style = void 0;
      style = null;
      if (value) {
        if ((value.length === 4 || value.length === 5) && value.substring(0, 1) === '(' && value.slice(-1) === ')') {
          cardNum = getCardNum(value.substring(1, value.length - 1));
          if (cardNum !== -1) {
            style = {
              backgroundImage: 'url(\'' + this.appPathPrefix + '/static/cards/english/card' + cardNum + '.svg\')',
              backgroundPosition: '10px 10px',
              backgroundRepeat: 'no-repeat',
              backgroundSize: '120px'
            };
          }
        }
        if (value.length >= 7 && value.length <= 9 && value.substring(0, 1) === '(' && value.slice(-1) === ')') {
          spacePos = value.indexOf(' ');
          if (spacePos === 3 || spacePos === 4) {
            cardNum1 = getCardNum(value.substring(1, spacePos));
            cardNum2 = getCardNum(value.substring(spacePos + 1, value.length - 1));
            if (cardNum1 !== -1 && cardNum2 !== -1) {
              style = {
                backgroundImage: 'url(\'' + this.appPathPrefix + '/static/cards/english/card' + cardNum2 + '.svg\'), url(\'' + this.appPathPrefix + '/static/cards/english/card' + cardNum1 + '.svg\')',
                backgroundPosition: '40px 10px, 4px 10px',
                backgroundRepeat: 'no-repeat, no-repeat',
                backgroundSize: '120px, 120px'
              };
            }
          }
        }
      }
      return style;
    },
    cellAudioFileChange: function cellAudioFileChange(file) {
      if (file) {
        if (file.size > maxAudioSize) {
          alert('Maximum file size exceeded');
          this.initAddCellAudio();
        } else {
          this.addCellAudio.url = window.URL.createObjectURL(file);
          this.addCellAudio.file = file;
        }
      }
    },
    cellClick: function cellClick(event) {
      var contentDiv = void 0;
      if (this.memoSetType !== 'regular') return;
      if (event.target.classList.contains('aligner')) {
        contentDiv = event.target.querySelectorAll('div')[0];
        var fieldIdAndRowIndex = contentDiv.id.split('_');
        this.currentFieldId = fieldIdAndRowIndex[0];
        this.currentRow = parseInt(fieldIdAndRowIndex[1], 10);
        contentDiv.focus();
        moveCursorToEndOfContentEditable(contentDiv);
      }
    },
    cellImageFileChange: function cellImageFileChange(file) {
      if (file) {
        // Check that file is an image
        if (file.type.substring(0, 6) === 'image/') {
          // Show image in the modal
          this.addCellImage.url = window.URL.createObjectURL(file);
          this.addCellImage.file = file;
        } else {
          this.initAddCellImage();
          alert('Please select an image file.');
        }
      }
    },
    cellImageLoad: function cellImageLoad() {
      this.addCellImage.loading = false;
      window.URL.revokeObjectURL(this.addCellImage.url);
    },
    cellImagePaste: function cellImagePaste(event) {
      var items = void 0;
      if (event.clipboardData) {
        items = event.clipboardData.items;
        if (items) {
          for (var i = 0; i < items.length; i++) {
            if (items[i].type.substring(0, 6) === 'image/') {
              this.addCellImage.loading = true;
              this.addCellImage.fileType = items[i].type;
              this.addCellImage.file = items[i].getAsFile();
              this.addCellImage.url = window.URL.createObjectURL(this.addCellImage.file);
              break;
            }
          }
        }
      }
    },
    checkImagesThen: function checkImagesThen(urls, next, args) {
      var _this16 = this;

      var self = this;
      var imagesToLoad = void 0;

      function imageLoaded() {
        imagesToLoad--;
        if (!imagesToLoad) next.apply(undefined, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(args));
      }

      function checkImageLoaded(url) {
        // If the image has loaded
        if (self.images[url].loaded) {
          imageLoaded();
        } else {
          // Keep waiting
          setTimeout(checkImageLoaded, 100, url);
        }
      }

      imagesToLoad = 0;
      urls.forEach(function (url) {
        // If the image is currently being loaded
        if (_this16.images[url] && !_this16.images[url].loaded) {
          imagesToLoad++;
          // Wait for image to load
          setTimeout(checkImageLoaded, 100, url);
        }
        if (!_this16.images[url]) {
          imagesToLoad++;
          _this16.$set(_this16.images, url, {
            image: new Image(),
            loaded: false
          });
          _this16.images[url].image.crossOrigin = 'Anonymous';
          _this16.images[url].image.onload = function () {
            _this16.images[url].loaded = true;
            imageLoaded();
          };
          _this16.images[url].image.src = url;
        }
      });
      // Call next function if all images are loaded
      if (!imagesToLoad) next.apply(undefined, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(args));
    },
    checkRowQuestions: function checkRowQuestions(rowIndex) {
      var _this17 = this;

      var questionsDeleted = void 0;
      var row = this.rows[rowIndex];
      this.questions.forEach(function (question) {
        // If there is question data but no data for the question
        if (row.data.questions && row.data.questions[question.questionId] && !_this17.rowHasData(row, question.fromFieldId, question.toFieldId)) {
          // Remove question from the row
          _this17.$delete(row.data.questions, question.questionId);
          questionsDeleted = true;
        }
      });
      return questionsDeleted;
    },
    checkVisibleThumbnails: function checkVisibleThumbnails() {
      // This function checks that thumbnails exist for all visible rows. If not, it creates them.
      for (var i = this.firstVisibleRow - 1; i < Math.min(this.firstVisibleRow - 1 + this.visibleRowsCount, this.rows.length); i++) {
        if (!this.thumbnails[i]) this.createThumbnail(i);
      }
    },
    clipArea: function clipArea() {
      var canvas = void 0,
          ctx = void 0,
          undoEntry = void 0;
      canvas = document.getElementById('objectCanvas');
      ctx = canvas.getContext('2d');
      ctx.beginPath();
      for (var i = 0; i < this.clippingPath.length; i++) {
        var coords = this.clippingPath[i];
        if (i === 0) {
          ctx.moveTo(coords.x, coords.y);
        } else {
          ctx.lineTo(coords.x, coords.y);
        }
      }
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.clip();
      // Draw image within clipping area
      ctx.drawImage(this.editCanvas, 0, 0);
      var obj = this.objects[this.activeObject];
      obj.url = canvas.toDataURL('image/png');
      this.clipping = false;
      this.mode = 'select';
      this.removeClippingPathUndoEntries();
      // Add an undo entry for the clip
      undoEntry = {
        after: {
          url: obj.url
        },
        before: {
          url: this.summaryImage.before.url
        },
        changeType: 'clip',
        objIndex: this.activeObject
      };
      this.addSummaryImageUndoEntry(undoEntry);
    },
    clipClick: function clipClick() {
      var _this18 = this;

      var ctx = void 0,
          img = void 0;
      // Blur button
      document.getElementById('clipButton').blur();
      if (this.mode === 'draw') this.endDrawMode();
      if (this.mode === 'remove') this.endRemoveMode();
      var obj = this.objects[this.activeObject];
      if (this.mode === 'clip') {
        this.endClipMode();
      } else {
        // Save the object's URL
        this.summaryImage.before = {
          url: obj.url
          // Initialize editCanvas with the object image
        };img = new Image();
        img.crossOrigin = 'Anonymous';
        img.onload = function () {
          _this18.editCanvas = document.createElement('canvas');
          _this18.editCanvas.width = img.naturalWidth;
          _this18.editCanvas.height = img.naturalHeight;
          ctx = _this18.editCanvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          _this18.drawObjectCanvas();
          _this18.mode = 'clip';
          _this18.clippingPath = [];
          _this18.clipping = false;
          _this18.panLock = false;
        };
        img.src = obj.url;
      }
    },
    clippingPathComplete: function clippingPathComplete(coords) {
      var snapPixels = 20;
      var canvas = void 0,
          canvasDistanceFromStart = void 0,
          initialCoords = void 0,
          obj = void 0,
          pointCoords = void 0,
          screenDistanceFromStart = void 0;
      canvas = document.getElementById('objectCanvas');
      obj = this.objects[this.activeObject];
      initialCoords = this.clippingPath[0];
      // Exit if no path yet
      if (!initialCoords) return false;
      canvasDistanceFromStart = Math.sqrt(Math.pow(coords.x - initialCoords.x, 2) + Math.pow(coords.y - initialCoords.y, 2));
      screenDistanceFromStart = canvasDistanceFromStart * this.photoTransform.scale / canvas.width * obj.width;
      // Exit if we're too far from the starting point
      if (screenDistanceFromStart > snapPixels) return false;
      // Exit if we don't have at least 3 points in the clipping path
      if (this.clippingPath.length < 3) return false;
      // Check whether the clipping path has gone far enough from the starting point to be valid
      for (var i = 0; i < this.clippingPath.length; i++) {
        pointCoords = this.clippingPath[i];
        canvasDistanceFromStart = Math.sqrt(Math.pow(pointCoords.x - initialCoords.x, 2) + Math.pow(pointCoords.y - initialCoords.y, 2));
        screenDistanceFromStart = canvasDistanceFromStart * this.photoTransform.scale / canvas.width * obj.width;
        if (screenDistanceFromStart > snapPixels) return true;
      }
      return false;
    },
    clippingPointerDown: function clippingPointerDown(pointer) {
      var canvasCoords = void 0;
      canvasCoords = this.getCanvasCoords(pointer.clientX, pointer.clientY);
      if (this.clippingPathComplete(canvasCoords)) {
        // Perform the clip
        this.clipArea();
      } else {
        this.clipping = true;
        // If the previous undo entry has a clipping path, start with that
        if (this.summaryImage.undoArrayIndex && this.summaryImage.undoArray[this.summaryImage.undoArrayIndex - 1].changeType === 'clippingPath') {
          this.clippingPath = this.summaryImage.undoArray[this.summaryImage.undoArrayIndex - 1].after.slice();
        } else {
          this.clippingPath = [];
        }
        this.clippingPath.push({
          x: canvasCoords.x,
          y: canvasCoords.y
        });
        this.drawObjectCanvas();
        this.drawClippingPath(false);
      }
    },
    clippingPointerMove: function clippingPointerMove(pointer) {
      var canvasCoords = void 0,
          initialCoords = void 0,
          pathComplete = void 0;
      canvasCoords = this.getCanvasCoords(pointer.clientX, pointer.clientY);
      if (this.clipping) {
        initialCoords = this.clippingPath[0];
        if (this.clippingPathComplete(canvasCoords)) {
          this.clipArea();
        } else {
          this.clippingPath.push({
            x: canvasCoords.x,
            y: canvasCoords.y
          });
          this.drawObjectCanvas();
          this.drawClippingPath(false);
        }
      } else {
        // If there is any clipping path, draw a line from the last point to the new point
        if (this.clippingPath.length) {
          initialCoords = this.clippingPath[0];
          if (this.clippingPathComplete(canvasCoords)) {
            canvasCoords = {
              x: initialCoords.x,
              y: initialCoords.y
            };
            pathComplete = true;
          }
          this.drawObjectCanvas();
          this.drawClippingPath(pathComplete, canvasCoords);
        }
      }
    },
    clippingPointerUp: function clippingPointerUp() {
      var undoEntry = void 0;
      // If the previous clipping path is just a point, remove it from the undo array
      if (this.summaryImage.undoArrayIndex && this.summaryImage.undoArray[this.summaryImage.undoArrayIndex - 1].changeType === 'clippingPath' && this.summaryImage.undoArray[this.summaryImage.undoArrayIndex - 1].after.length === 1) {
        this.summaryImage.undoArray.splice(this.summaryImage.undoArrayIndex - 1, 1);
        this.summaryImage.undoArrayIndex--;
      }
      undoEntry = {
        after: this.clippingPath.slice(),
        changeType: 'clippingPath'
      };
      this.addSummaryImageUndoEntry(undoEntry);
      this.drawObjectCanvas();
      this.drawClippingPath(false);
      this.clipping = false;
    },
    closeCongratsClick: function closeCongratsClick() {
      $('.message.congratulations').transition('fade');
    },
    closeLearnModal: function closeLearnModal() {
      $('.ui.modal.learn').modal('hide');
    },
    closeWalkThrough: function closeWalkThrough() {
      $('.ui.modal.walkThrough').modal('hide');
    },
    convertSystemImages: function convertSystemImages(cells) {
      for (var i = 0; i < cells.length; i++) {
        if (/^https:\/\/firebasestorage.*/.test(cells[i])) {
          // Wrap cell in image tag
          cells[i] = '<img src="' + cells[i] + '">';
          // If next cell is the thumbnail, discard it
          if (cells[i + 1] && /^https:\/\/firebasestorage.*_tn/.test(cells[i + 1])) {
            cells.splice(i + 1, 1);
          }
        }
      }
      return cells;
    },
    copiedMemoSetEnter: function copiedMemoSetEnter() {
      // Hide modal
      $('.ui.modal.copiedMemoSet').modal('hide');
      this.copiedMemoSetSubmit();
    },
    copiedMemoSetSubmit: function copiedMemoSetSubmit() {
      this.$router.push('/memo-sets/' + this.copyMemoSet.newMemoSetId + '/' + this.copyMemoSet.slug);
    },
    copyMemoSetClick: function copyMemoSetClick() {
      var _this19 = this;

      document.getElementById('copyMemoSetButton').blur();
      // Initialize new name
      this.copyMemoSet.newTitle = this.text.memoSetNewNamePre + this.title + this.text.memoSetNewNamePost;
      this.copyMemoSet.newFolderName = '';
      // Prepare Folder dropdown
      this.copyMemoSet.folderId = this.folderId;
      $('.copyMemoSetFolderId').dropdown({
        onChange: function onChange(value) {
          _this19.copyMemoSet.folderId = value;
          if (value === 'new') {
            _this19.$nextTick(function () {
              document.getElementById('newFolderName').focus();
            });
          }
        },
        showOnFocus: false
      }).dropdown('set selected', this.copyMemoSet.folderId);
      $('.ui.modal.copyMemoSet').modal({
        onApprove: this.copyMemoSetSubmit
      }).modal('show');
    },
    copyMemoSetEnter: function copyMemoSetEnter() {
      // Exit if form is incomplete
      if (!this.copyMemoSet.newTitle) return;
      // Hide modal
      $('.ui.modal.copyMemoSet').modal('hide');
      this.copyMemoSetSubmit();
    },
    copyMemoSetSubmit: function copyMemoSetSubmit() {
      if (this.memoSetType === 'regular') {
        this.copyMemoSet.newMemoSetId = this.randomId();
      } else {
        this.copyMemoSet.newMemoSetId = this.memoSetId + '_' + this.user.id;
      }
      this.copyMemoSetWrite();
    },
    copyMemoSetWrite: function copyMemoSetWrite() {
      var _this20 = this;

      var folderId = void 0,
          folders = void 0,
          firestoreNewDocs = void 0,
          memoSetObj = void 0,
          seq = void 0,
          updateObj = void 0;
      var docId = this.firstAvailableDocId();
      this.copyMemoSet.slug = this.createMemoSetSlug(this.copyMemoSet.newTitle);
      var batch = db.batch();
      if (this.copyMemoSet.folderId === 'new') {
        // Create the new folder
        folderId = this.nextFolderId();
        folders = this.user.folders.slice();
        folders.push({
          folderId: folderId,
          folderName: this.copyMemoSet.newFolderName
        });
        batch.update(db.doc('users/' + this.user.id), {
          folders: folders
        });
        seq = 0;
      } else {
        folderId = this.copyMemoSet.folderId;
        // Look up folder name for new memo set
        this.copyMemoSet.newFolderName = this.user.folders.filter(function (folder) {
          return folder.folderId === folderId;
        })[0].folderName;
        // Set seq to 1 more than the highest seq in the folder
        seq = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(this.memoSets.filter(function (memoSet) {
          return memoSet.folderId === folderId;
        }).map(function (memoSet) {
          return memoSet.seq;
        })).concat([-1])) + 1;
      }
      // Write memoSets document
      memoSetObj = {
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        description: this.description,
        fields: this.fields,
        options: this.options,
        photos: this.photos,
        questions: this.questions,
        sharing: {},
        userId: this.user.id
      };
      if (this.memoSetType !== 'regular') {
        memoSetObj.authorId = this.ownerId;
        memoSetObj.authorName = this.ownerName;
      }
      batch.set(db.doc('memoSets/' + this.copyMemoSet.newMemoSetId), memoSetObj);
      // Write memo set rows documents
      firestoreNewDocs = {};
      this.rows.forEach(function (row) {
        if (!firestoreNewDocs[row.docId]) firestoreNewDocs[row.docId] = { sharing: {}, userId: _this20.user.id };
        firestoreNewDocs[row.docId][row.rowId] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, row.data);
        // Exclude learning data if copying someone else's memo set
        if (_this20.memoSetType !== 'regular') {
          delete firestoreNewDocs[row.docId][row.rowId].questions;
        }
      });
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(firestoreNewDocs).forEach(function (docId) {
        batch.set(db.doc('memoSets/' + _this20.copyMemoSet.newMemoSetId + '/rows/' + docId), firestoreNewDocs[docId]);
      });
      // Write users/$userId/memoSets/$docId document
      updateObj = {};
      updateObj[this.copyMemoSet.newMemoSetId] = {
        coverImage: this.coverImage,
        folderId: folderId,
        rowCount: this.rows.length,
        seq: seq,
        slug: this.copyMemoSet.slug,
        title: this.copyMemoSet.newTitle
      };
      batch.update(db.doc('users/' + this.user.id + '/memoSets/' + docId), updateObj);
      // If copying our own memo set
      if (this.memoSetType === 'regular') {
        // Write known data for the new copy
        this.updateKnownData(batch, this.copyMemoSet.newMemoSetId);
      }
      batch.commit().then(function () {
        if (_this20.memoSetType === 'regular') {
          $('.ui.modal.copiedMemoSet').modal({
            autofocus: false,
            onApprove: _this20.copiedMemoSetSubmit
          }).modal('show');
        }
      }).catch(function (error) {
        logError('MemoSet_copyMemoSetWrite', error);
      });
    },
    copyOfCanvas: function copyOfCanvas(canvas) {
      var tempCanvas = void 0,
          tempCtx = void 0;
      tempCanvas = document.createElement('canvas');
      tempCanvas.height = canvas.height;
      tempCanvas.width = canvas.width;
      tempCtx = tempCanvas.getContext('2d');
      tempCtx.drawImage(canvas, 0, 0);
      return tempCanvas;
    },
    coverImageClick: function coverImageClick() {
      var _this21 = this;

      if (this.memoSetType !== 'regular') return;
      this.initSetCoverImage();
      // Sort background photos according to use in rows
      this.sortPhotos();
      // Allow time for previous image to be cleared
      this.$nextTick(function () {
        $('.ui.modal.setCoverImage').modal({
          autofocus: false,
          observeChanges: true,
          onApprove: _this21.coverImageSubmit,
          onHidden: _this21.revertPreventBackHistory,
          onVisible: _this21.prepareModalHistory
        }).modal('show');
      });
    },
    coverImageEnter: function coverImageEnter() {
      // Exit if modal is incomplete
      if (!this.setCoverImage.url) return;
      this.coverImageSubmit();
    },
    coverImageLoad: function coverImageLoad() {
      this.setCoverImage.loading = false;
      window.URL.revokeObjectURL(this.setCoverImage.url);
    },
    coverImagePaste: function coverImagePaste(event) {
      var i = void 0,
          items = void 0;
      if (event.clipboardData) {
        items = event.clipboardData.items;
        if (items) {
          for (i = 0; i < items.length; i++) {
            if (items[i].type.substring(0, 6) === 'image/') {
              this.setCoverImage.loading = true;
              this.setCoverImage.fileType = items[i].type;
              this.setCoverImage.file = items[i].getAsFile();
              this.setCoverImage.url = window.URL.createObjectURL(this.setCoverImage.file);
              break;
            }
          }
        }
      }
    },
    coverImageSubmit: function coverImageSubmit() {
      var _this22 = this;

      var canvas = void 0,
          ctx = void 0,
          height = void 0,
          imageDataUrl = void 0,
          imageKey = void 0,
          img = void 0,
          scaleFactor = void 0,
          tempCanvas = void 0,
          tempCtx = void 0,
          width = void 0;
      var self = this;
      // If the cover image is a background photo, no need to upload it
      if (this.photos.some(function (photo) {
        return photo.url === _this22.setCoverImage.url;
      })) {
        this.coverImageUpdate(this.setCoverImage.url);
      } else {
        this.setCoverImage.uploading = true;
        img = document.getElementById('setCoverImage');
        // Get a random key for the image
        imageKey = this.getImageKey();
        // If image is a small image from the desktop, just upload it
        if (img.naturalHeight <= maxCoverImageHeight && img.naturalWidth <= maxCoverImageWidth) {
          // Upload the image to Firebase Storage
          firebase.storage().ref('userImages/' + this.user.id + '/' + imageKey).put(this.setCoverImage.file, { cacheControl: 'max-age=2592000' }).then(function (snapshot) {
            return snapshot.ref.getDownloadURL();
          }).then(function (downloadUrl) {
            self.coverImageUpdate(downloadUrl);
          });
        } else {
          scaleFactor = Math.min(maxCoverImageWidth / img.naturalWidth, maxCoverImageHeight / img.naturalHeight);
          scaleFactor = Math.min(scaleFactor, 1);
          // Limit scale down to half to preserve image quality
          scaleFactor = Math.max(scaleFactor, 0.5);
          tempCanvas = document.createElement('canvas');
          tempCanvas.width = img.naturalWidth * scaleFactor;
          tempCanvas.height = img.naturalHeight * scaleFactor;
          tempCtx = tempCanvas.getContext('2d');
          // Fill with white in case of transparent images
          tempCtx.fillStyle = 'white';
          tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);
          tempCtx.drawImage(img, 0, 0, tempCanvas.width, tempCanvas.height);
          width = tempCanvas.width;
          height = tempCanvas.height;
          while (scaleFactor === 0.5) {
            scaleFactor = Math.min(maxCoverImageWidth / width, maxCoverImageHeight / height);
            scaleFactor = Math.max(scaleFactor, 0.5);
            tempCtx.drawImage(tempCanvas, 0, 0, width, height, 0, 0, width * scaleFactor, height * scaleFactor);
            width = width * scaleFactor;
            height = height * scaleFactor;
          }
          // Draw section of tempCanvas onto canvas
          canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          ctx = canvas.getContext('2d');
          ctx.drawImage(tempCanvas, 0, 0, width, height, 0, 0, width, height);
          imageDataUrl = canvas.toDataURL('image/jpeg');
          // Upload the image to Firebase Storage
          firebase.storage().ref('userImages/' + this.user.id + '/' + imageKey).putString(imageDataUrl, 'data_url', { cacheControl: 'max-age=2592000' }).then(function (snapshot) {
            return snapshot.ref.getDownloadURL();
          }).then(function (downloadUrl) {
            self.coverImageUpdate(downloadUrl);
          });
        }
      }
      // Prevent modal closing
      return false;
    },
    coverImageUpdate: function coverImageUpdate(downloadUrl) {
      this.coverImageLoaded = false;
      this.coverImage = downloadUrl;
      // Update cover image in Firestore
      var batch = db.batch();
      var updateObj = {};
      updateObj[this.memoSetId + '.coverImage'] = this.coverImage;
      batch.update(db.doc('users/' + this.user.id + '/memoSets/' + this.docId), updateObj);
      this.updateSharedSummaries(batch, {
        coverImage: this.coverImage
      });
      batch.commit().catch(function (error) {
        logError('MemoSet_coverImageUpdate', error);
      });
      this.setCoverImage.uploading = false;
      // Close modal
      $('.ui.modal.setCoverImage').modal('hide');
    },
    createThumbnail: function createThumbnail(rowIndex) {
      var currentRow = void 0,
          objects = void 0,
          photo = void 0,
          photoIndex = void 0,
          rowsForPhoto = void 0,
          urls = void 0;
      currentRow = this.rows[rowIndex];
      if (currentRow.data.photoId) {
        // Get memo set rows using the current photo
        rowsForPhoto = this.rows.filter(function (row) {
          return row.data.photoId === currentRow.data.photoId;
        });
        // Initialize array of images to draw
        objects = [];
        // Add background photo
        photoIndex = this.photoIndexes[rowIndex];
        photo = this.photos[photoIndex];
        objects.push({
          angle: 0,
          height: photo.height,
          left: 0,
          sequence: -1,
          top: 0,
          url: photo.url,
          width: photo.width
        });
        // Add object images
        rowsForPhoto.forEach(function (row) {
          if (row.data.objects) {
            row.data.objects.forEach(function (obj) {
              objects.push({
                angle: obj.angle,
                flipX: obj.flipX,
                flipY: obj.flipY,
                height: obj.height,
                left: obj.left,
                sequence: obj.sequence,
                top: obj.top,
                url: obj.tempUrl || obj.url,
                width: obj.width
              });
            });
          }
        });
        // Sort by sequence
        objects.sort(function (a, b) {
          if (a.sequence < b.sequence) return -1;
          return 1;
        });
        urls = objects.map(function (obj) {
          return obj.url;
        });
        this.checkImagesThen(urls, this.createThumbnailWithObjects, [rowIndex, objects]);
      } else {
        // Initialize array of images to draw
        objects = [];
        if (currentRow.data.objects && currentRow.data.objects.length) {
          currentRow.data.objects.forEach(function (obj) {
            objects.push({
              angle: obj.angle,
              flipX: obj.flipX,
              flipY: obj.flipY,
              height: obj.height,
              left: obj.left,
              sequence: obj.sequence,
              top: obj.top,
              url: obj.url,
              width: obj.width
            });
          });
          // Sort by sequence
          objects.sort(function (a, b) {
            if (a.sequence < b.sequence) return -1;
            return 1;
          });
          urls = objects.map(function (obj) {
            return obj.url;
          });
          this.checkImagesThen(urls, this.createThumbnailWithObjects, [rowIndex, objects]);
        } else {
          // No background, no objects
          this.$set(this.thumbnails, rowIndex, null);
        }
      }
    },
    createThumbnailWithObjects: function createThumbnailWithObjects(rowIndex, objects) {
      var _this23 = this;

      var maxThumbnailWidth = 240;
      var maxThumbnailHeight = 150;
      var canvas = void 0,
          ctx = void 0,
          currentRow = void 0,
          location = void 0,
          scale = void 0,
          thumbnailHeight = void 0,
          thumbnailWidth = void 0;
      // Initialize canvas
      canvas = document.createElement('canvas');
      ctx = canvas.getContext('2d');
      currentRow = this.rows[rowIndex];
      // Set canvas size according to location aspect
      if (currentRow.data.photoId) {
        location = currentRow.data.location;
        if (location.width / location.height > maxThumbnailWidth / maxThumbnailHeight) {
          // Width is the limiting factor
          thumbnailWidth = maxThumbnailWidth;
          thumbnailHeight = location.height * thumbnailWidth / location.width;
        } else {
          // Height is the limiting factor
          thumbnailHeight = maxThumbnailHeight;
          thumbnailWidth = location.width * thumbnailHeight / location.height;
        }
        canvas.width = thumbnailWidth;
        canvas.height = thumbnailHeight;
      } else {
        canvas.width = maxThumbnailHeight;
        canvas.height = maxThumbnailHeight;
      }
      // Scale canvas
      if (currentRow.data.photoId) {
        scale = canvas.width / location.width;
      } else {
        scale = canvas.width / noPhotoSize;
      }
      ctx.scale(scale, scale);
      // Translate to location left top
      if (currentRow.data.photoId) {
        ctx.translate(-location.left, -location.top);
      }
      objects.forEach(function (obj) {
        ctx.save();
        ctx.translate(obj.left + obj.width / 2, obj.top + obj.height / 2);
        ctx.rotate(obj.angle * Math.PI / 180);
        // Flip canvas if object flipped
        if (obj.flipX) ctx.scale(-1, 1);
        if (obj.flipY) ctx.scale(1, -1);
        ctx.translate(-(obj.left + obj.width / 2), -(obj.top + obj.height / 2));
        ctx.drawImage(_this23.images[obj.url].image, obj.left, obj.top, obj.width, obj.height);
        ctx.restore();
      });
      this.$set(this.thumbnails, rowIndex, canvas.toDataURL());
      // If learning, update the review item
      if (this.learn.loadThumbnailFor) {
        if (this.learn.loadThumbnailFor === 'question') {
          this.learn.reviewItem.questionHtml = this.learn.reviewItem.questionHtml.replace(loaderHtml, '<img src="' + this.thumbnails[rowIndex] + '">');
          this.startTimerOnNextTick();
        }
        if (this.learn.loadThumbnailFor === 'answer') {
          this.learn.reviewItem.answerHtml = '<img src="' + this.thumbnails[rowIndex] + '">';
        }
        this.learn.loadThumbnailFor = '';
      }
    },
    defaultQuestionText: function defaultQuestionText() {
      var firstRowWithData = void 0,
          fromImage = void 0,
          questionTemplate = void 0;
      // For convenience
      var fromFieldId = this.question.fromFieldId;
      var toFieldId = this.question.toFieldId;
      if (this.questionStatus === 'ok') {
        if (fromFieldId === 's') {
          questionTemplate = this.text.memoSetDefaultQuestionFromSummaryImage;
        } else {
          // Determine whether the first data for the from field contains an image
          firstRowWithData = this.rows.find(function (row) {
            return row.data[fromFieldId] && row.data[fromFieldId].replace(/<br ?\/?>/g, '');
          });
          fromImage = firstRowWithData && firstRowWithData.data[fromFieldId].indexOf('<img ') !== -1;
          if (toFieldId === 's') {
            questionTemplate = fromImage ? this.text.memoSetDefaultQuestionFromImageToSummaryImage : this.text.memoSetDefaultQuestionToSummaryImage;
          } else {
            questionTemplate = fromImage ? this.text.memoSetDefaultQuestionFromImage : this.text.memoSetDefaultQuestion;
          }
        }
        // Replace field name tokens
        this.question.originalQuestionText = questionTemplate.replace('<fromField>', this.fieldsById[fromFieldId].heading).replace('<toField>', this.fieldsById[toFieldId].heading);
        this.question.questionText = this.question.originalQuestionText;
      }
    },
    deleteAlternativeClick: function deleteAlternativeClick(alternativeIndex) {
      this.$set(this.cellAlternatives[alternativeIndex], 'deleted', true);
    },
    deleteColumnClick: function deleteColumnClick() {
      var _this24 = this;

      // Hide Actions popup
      $('.actionsButton').popup('hide');
      this.$nextTick(function () {
        // Prepare Delete Column dropdown
        _this24.deleteColumn.deleteColumn = '-1';
        $('.deleteColumnDeleteColumn').dropdown({
          onChange: function onChange(value) {
            _this24.deleteColumn.deleteColumn = value;
          },
          showOnFocus: false
        }).dropdown('clear');
        $('.ui.modal.deleteColumn').modal({
          onApprove: _this24.deleteColumnSubmit,
          onHidden: _this24.revertPreventBackHistory,
          onVisible: _this24.prepareModalHistory
        }).modal('show');
      });
    },
    deleteColumnEnter: function deleteColumnEnter() {
      // Exit if form is incomplete
      if (this.deleteColumn.deleteColumn === '-1') return;
      // Hide modal
      $('.ui.modal.deleteColumn').modal('hide');
      // Submit form
      this.deleteColumnSubmit();
    },
    deleteColumnSubmit: function deleteColumnSubmit() {
      this.deleteFieldOrQuestion(this.fields[this.deleteColumn.deleteColumn].fieldId, '');
      this.initSearch();
    },
    deleteFieldOrQuestion: function deleteFieldOrQuestion(fieldId, questionId) {
      var _this25 = this;

      var fieldIndex = void 0,
          lastQuestion = void 0,
          memoSetUpdateObj = void 0,
          questionIds = void 0,
          questionIndex = void 0,
          rowsToUpdate = void 0,
          rowUpdateObjs = void 0,
          selectedQuestionIndex = void 0;
      var batch = db.batch();
      // Save count of selected questions
      var initialSelectedQuestionsCount = this.learn.questionIds.length;
      // Initialize update objects
      memoSetUpdateObj = {};
      rowUpdateObjs = {};
      if (fieldId) {
        // Delete field from fields array
        fieldIndex = this.fields.findIndex(function (field) {
          return field.fieldId === fieldId;
        });
        this.fields.splice(fieldIndex, 1);
        memoSetUpdateObj.fields = this.fields;
        // Delete field from row data
        rowsToUpdate = this.rows.filter(function (row) {
          return row.data[fieldId];
        });
        rowsToUpdate.forEach(function (row) {
          _this25.$delete(row.data, fieldId);
          if (!rowUpdateObjs[row.docId]) rowUpdateObjs[row.docId] = {};
          rowUpdateObjs[row.docId][row.rowId + '.' + fieldId] = firebase.firestore.FieldValue.delete();
        });
        // Find any questions involving the field
        questionIds = this.questions.filter(function (question) {
          return question.fromFieldId === fieldId || question.toFieldId === fieldId;
        }).map(function (question) {
          return question.questionId;
        });
      } else {
        questionIds = [questionId];
      }
      // If there are questions to delete
      if (questionIds.length) {
        questionIds.forEach(function (questionId) {
          // Delete question from questions array
          questionIndex = _this25.questions.findIndex(function (question) {
            return question.questionId === questionId;
          });
          _this25.questions.splice(questionIndex, 1);
          // Delete question from row data
          rowsToUpdate = _this25.rows.filter(function (row) {
            return row.data.questions && row.data.questions[questionId];
          });
          rowsToUpdate.forEach(function (row) {
            if (!rowUpdateObjs[row.docId]) rowUpdateObjs[row.docId] = {};
            lastQuestion = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(row.data.questions).length === 1;
            if (lastQuestion) {
              // Delete the entire questions object
              _this25.$delete(row.data, 'questions');
              rowUpdateObjs[row.docId][row.rowId + '.questions'] = firebase.firestore.FieldValue.delete();
            } else {
              // Delete the question
              _this25.$delete(row.data.questions, questionId);
              rowUpdateObjs[row.docId][row.rowId + '.questions'] = row.data.questions;
            }
          });
          // Delete question from selected questions
          selectedQuestionIndex = _this25.learn.questionIds.indexOf(questionId);
          if (selectedQuestionIndex !== -1) {
            _this25.learn.questionIds.splice(selectedQuestionIndex, 1);
          }
        });
        memoSetUpdateObj.questions = this.questions;
      }
      // Update memo set document
      batch.update(db.doc('memoSets/' + this.memoSetId), memoSetUpdateObj);
      // Update row documents
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(rowUpdateObjs).forEach(function (docId) {
        batch.update(db.doc('memoSets/' + _this25.memoSetId + '/rows/' + docId), rowUpdateObjs[docId]);
      });
      // Update selected questions, if changed
      if (this.learn.questionIds.length !== initialSelectedQuestionsCount) {
        this.writeSelectedQuestions(batch);
      }
      // Update known data
      this.updateKnownData(batch, this.memoSetId);
      batch.commit().catch(function (error) {
        logError('MemoSet_deleteFieldOrQuestion', error);
      });
    },
    deleteImageClick: function deleteImageClick() {
      var obj = void 0,
          undoEntry = void 0;
      // Blur button
      document.getElementById('deleteImageButton').blur();
      if (this.mode === 'clip') this.endClipMode();
      if (this.mode === 'draw') this.endDrawMode();
      if (this.mode === 'remove') this.endRemoveMode();
      // Prepare undo entry
      obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.objects[this.activeObject]);
      undoEntry = {
        changeType: 'object delete',
        obj: obj,
        objIndex: this.activeObject
      };
      this.addSummaryImageUndoEntry(undoEntry);
      // Delete active object
      this.objects.splice(this.activeObject, 1);
      this.activeObject = -1;
    },
    deleteMemoSetClick: function deleteMemoSetClick() {
      document.getElementById('deleteMemoSetButton').blur();
      this.modalHtml = this.text.memoSetDeleteMemoSetContent.replace('*', '<strong>' + this.title + '</strong>');
      $('.ui.modal.deleteMemoSet').modal({
        onApprove: this.deleteMemoSetSubmit
      }).modal('show');
    },
    deleteMemoSetEnter: function deleteMemoSetEnter() {
      // Hide modal
      $('.ui.modal.deleteMemoSet').modal('hide');
      // Submit form
      this.deleteMemoSetSubmit();
    },
    deleteMemoSetSubmit: function deleteMemoSetSubmit() {
      var _this26 = this;

      var firestoreDocs = void 0,
          updateObj = void 0;
      var now = new Date();
      // Get date time in format yyyymmddhhmmss
      var dttmString = now.toISOString().replace('T', '').replace('Z', '').replace(/-/g, '').replace(/:/g, '').substring(0, 14);
      var deletedMemoSetId = this.memoSetId + '_del_' + dttmString;
      var batch = db.batch();
      // Write summary data to deletedMemoSets
      batch.set(db.doc('deletedMemoSets/' + deletedMemoSetId), {
        coverImage: this.coverImage,
        createdAt: this.createdAt,
        deletedAt: firebase.firestore.FieldValue.serverTimestamp(),
        description: this.description,
        fields: this.fields,
        options: this.options,
        photos: this.photos,
        questions: this.questions,
        rowCount: this.rows.length,
        sharing: this.sharing,
        slug: this.slug,
        title: this.title,
        userId: this.user.id
      });
      // Delete the memoSets document
      batch.delete(db.doc('memoSets/' + this.memoSetId));
      // Move rows data to deletedMemoSets
      firestoreDocs = {};
      this.rows.forEach(function (row) {
        if (!firestoreDocs[row.docId]) firestoreDocs[row.docId] = { userId: _this26.user.id };
        firestoreDocs[row.docId][row.rowId] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, row.data);
      });
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(firestoreDocs).forEach(function (docId) {
        batch.set(db.doc('deletedMemoSets/' + deletedMemoSetId + '/rows/' + docId), firestoreDocs[docId]);
        batch.delete(db.doc('memoSets/' + _this26.memoSetId + '/rows/' + docId));
      });
      // Delete the field for the memo set in the users/$userId/memoSets/$docId document
      updateObj = {};
      updateObj[this.memoSetId] = firebase.firestore.FieldValue.delete();
      batch.update(db.doc('users/' + this.user.id + '/memoSets/' + this.docId), updateObj);
      batch.commit().catch(function (error) {
        logError('MemoSet_deleteMemoSetSubmit', error);
      });
    },
    deleteKnownData: function deleteKnownData(batch, memoSetId) {
      var updateObj = {};
      updateObj[memoSetId] = firebase.firestore.FieldValue.delete();
      batch.update(db.doc('users/' + this.user.id + '/knownData/doc'), updateObj);
    },
    deletePhotoClick: function deletePhotoClick(photoIndex) {
      this.modalPhotos.splice(photoIndex, 1);
      // Decrement selectedPhotoIndex if the photo deleted is above the selected photo
      if (photoIndex < this.selectedPhotoIndex) this.selectedPhotoIndex--;
    },
    deleteQuestionClick: function deleteQuestionClick(questionIndex) {
      this.question.pendingDelete = true;
      // Scroll to message
      this.$nextTick(function () {
        var questionContent = document.querySelector('.questionContent');
        questionContent.scroll({
          behavior: 'smooth',
          top: questionContent.scrollHeight
        });
      });
    },
    deleteRowsChangeFromRow: function deleteRowsChangeFromRow() {
      // If deleteToRow is less than deleteFromRow, set it to the deleteFromRow value
      if (parseInt(this.deleteRows.deleteToRow, 10) < parseInt(this.deleteRows.deleteFromRow, 10)) {
        this.deleteRows.deleteToRow = this.deleteRows.deleteFromRow;
      }
    },
    deleteRowsClick: function deleteRowsClick() {
      var _this27 = this;

      // Hide Actions popup
      $('.actionsButton').popup('hide');
      this.$nextTick(function () {
        _this27.deleteRows.deleteFromRow = '';
        _this27.deleteRows.deleteToRow = '';
        $('.ui.modal.deleteRows').modal({
          onApprove: _this27.deleteRowsSubmit,
          onHidden: _this27.revertPreventBackHistory,
          onVisible: _this27.prepareModalHistory
        }).modal('show');
      });
    },
    deleteRowsEnter: function deleteRowsEnter() {
      // Exit if form is incomplete or invalid
      if (!(parseInt(this.deleteRows.deleteFromRow, 10) > 0) || !(parseInt(this.deleteRows.deleteToRow, 10) > 0) || parseInt(this.deleteRows.deleteToRow, 10) < parseInt(this.deleteRows.deleteFromRow, 10)) return;
      // Hide modal
      $('.ui.modal.deleteRows').modal('hide');
      // Submit form
      this.deleteRowsSubmit();
    },
    deleteRowsSubmit: function deleteRowsSubmit() {
      var _this28 = this;

      var deleteDocIds = void 0,
          deleteFromRow = void 0,
          deleteToRow = void 0,
          docId = void 0,
          docIds = void 0,
          firestoreDeleteDocIds = void 0,
          firestoreUpdateDocs = void 0,
          rowId = void 0;
      deleteFromRow = parseInt(this.deleteRows.deleteFromRow, 10) - 1;
      deleteToRow = parseInt(this.deleteRows.deleteToRow, 10) - 1;
      firestoreDeleteDocIds = [];
      firestoreUpdateDocs = {};
      // Add rows being deleted to firestoreUpdateDocs
      for (var i = deleteFromRow; i <= deleteToRow; i++) {
        docId = this.rows[i].docId;
        rowId = this.rows[i].rowId;
        if (!firestoreUpdateDocs[docId]) firestoreUpdateDocs[docId] = {};
        firestoreUpdateDocs[docId][rowId] = firebase.firestore.FieldValue.delete();
      }
      // Save doc IDs with rows being deleted
      deleteDocIds = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(firestoreUpdateDocs);
      // Add seq changes to firestoreUpdateDocs
      for (var _i5 = deleteToRow + 1; _i5 < this.rows.length; _i5++) {
        docId = this.rows[_i5].docId;
        rowId = this.rows[_i5].rowId;
        if (!firestoreUpdateDocs[docId]) firestoreUpdateDocs[docId] = {};
        firestoreUpdateDocs[docId][rowId + '.seq'] = _i5;
      }
      this.rows.splice(deleteFromRow, deleteToRow - deleteFromRow + 1);
      // Update thumbnails
      this.thumbnails.splice(deleteFromRow, deleteToRow - deleteFromRow + 1);
      // Check/update thumbnails and Mathjax
      this.prepareVisibleRows();
      // If we're beyond the end of the remaining rows, go to the last page
      if (this.firstVisibleRow > this.rows.length) {
        this.lastRowsClick();
      }
      // If there are no rows left in a document, we want to delete the entire document
      deleteDocIds.forEach(function (docId) {
        if (!_this28.rows.filter(function (row) {
          return row.docId === docId;
        }).length) {
          firestoreDeleteDocIds.push(docId);
        }
      });
      // No need to update any documents being deleted
      firestoreDeleteDocIds.forEach(function (docId) {
        delete firestoreUpdateDocs[docId];
      });
      // Update Firestore
      var batch = db.batch();
      firestoreDeleteDocIds.forEach(function (docId) {
        batch.delete(db.doc('memoSets/' + _this28.memoSetId + '/rows/' + docId));
      });
      docIds = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(firestoreUpdateDocs);
      docIds.forEach(function (docId) {
        batch.update(db.doc('memoSets/' + _this28.memoSetId + '/rows/' + docId), firestoreUpdateDocs[docId]);
      });
      this.writeRowCount(batch);
      batch.commit().catch(function (error) {
        logError('MemoSet_deleteRowsSubmit', error);
      });
      this.initSearch();
    },
    descriptionBlur: function descriptionBlur(event) {
      if (this.sanitize(event.target.innerHTML) !== this.description) {
        this.description = this.sanitize(event.target.innerHTML);
        // If description is blank, set it to the default
        if (!this.description) this.description = this.text.memoSetDefaultDescription;
        var batch = db.batch();
        // Write new description to Firestore
        batch.update(db.doc('memoSets/' + this.memoSetId), {
          description: this.databaseDescription
        });
        this.updateSharedSummaries(batch, {
          description: this.databaseDescription
        });
        batch.commit().catch(function (error) {
          logError('MemoSet_descriptionBlur', error);
        });
        // Set placeholder flag if appropriate
        this.descriptionPlaceholder = this.description === this.text.memoSetDefaultDescription;
      }
      // Update description element to remove any pasted HTML formatting
      event.target.innerHTML = this.description;
    },
    descriptionEnter: function descriptionEnter(event) {
      if (!event.ctrlKey && !event.shiftKey) {
        event.preventDefault();
        event.target.blur();
      }
      if (event.ctrlKey) {
        // Need to use 2 <br> tags if the cursor is at the end and the field does not already end in <br>
        if (isCaretAtEnd() && event.target.innerHTML.slice(-4) !== '<br>' && event.target.innerHTML.slice(-6) !== '<br />') {
          pasteHtmlAtCaret('<br><br>');
        } else {
          pasteHtmlAtCaret('<br>');
        }
      }
    },
    descriptionFocus: function descriptionFocus(event) {
      if (this.description === this.text.memoSetDefaultDescription) {
        selectElementContents(event.target);
      }
    },
    // cursorCoords is an optional argument containing the current cursor coordinates
    drawClippingPath: function drawClippingPath(pathComplete, cursorCoords) {
      var canvas = void 0,
          ctx = void 0;
      canvas = document.getElementById('objectCanvas');
      ctx = canvas.getContext('2d');
      ctx.beginPath();
      ctx.lineWidth = canvas.width / this.objects[this.activeObject].width;
      for (var i = 0; i < this.clippingPath.length; i++) {
        var coords = this.clippingPath[i];
        if (i === 0) {
          ctx.moveTo(coords.x, coords.y);
        } else {
          ctx.lineTo(coords.x, coords.y);
        }
      }
      // Draw line to current cursor position if cursorCoords argument is provided
      if (cursorCoords) {
        ctx.lineTo(cursorCoords.x, cursorCoords.y);
      }
      // Draw closure line if clipping path is complete
      if (pathComplete) {
        ctx.lineTo(this.clippingPath[0].x, this.clippingPath[0].y);
        ctx.setLineDash([5 * ctx.lineWidth, 3 * ctx.lineWidth]);
      }
      ctx.strokeStyle = 'red';
      ctx.stroke();
      ctx.lineWidth = 1;
    },
    drawMove: function drawMove(pointer) {
      var canvas = void 0,
          canvasCoords = void 0,
          ctx = void 0,
          drawCtx = void 0,
          obj = void 0,
          prevCanvasCoords = void 0,
          radiusX = void 0,
          radiusY = void 0,
          theta = void 0;
      canvas = document.getElementById('objectCanvas');
      ctx = canvas.getContext('2d');
      // Draw image from master canvas
      this.drawObjectCanvas();
      obj = this.objects[this.activeObject];
      // Draw transparent hole at cursor position
      canvasCoords = this.getCanvasCoords(pointer.clientX, pointer.clientY);
      radiusX = drawTransparentRadius / this.photoTransform.scale * canvas.width / obj.width;
      radiusY = drawTransparentRadius / this.photoTransform.scale * canvas.height / obj.height;
      ctx.beginPath();
      ctx.ellipse(canvasCoords.x, canvasCoords.y, radiusX, radiusY, 0, 0, 2 * Math.PI);
      ctx.globalCompositeOperation = 'destination-out';
      ctx.fill();
      if (this.drawing) {
        // For smoothness, connect the new point to the previous
        prevCanvasCoords = this.getCanvasCoords(this.pointerPosX, this.pointerPosY);
        ctx.beginPath();
        ctx.moveTo(prevCanvasCoords.x, prevCanvasCoords.y);
        ctx.lineTo(canvasCoords.x, canvasCoords.y);
        // Get angle between the previous point and the new point, relative to the horizontal
        theta = Math.atan2(canvasCoords.y - prevCanvasCoords.y, canvasCoords.x - prevCanvasCoords.x);
        // Calculate line width - similar to https://math.stackexchange.com/a/432907
        ctx.lineWidth = 2 * radiusX * radiusY / Math.sqrt(Math.pow(radiusX * Math.cos(theta), 2) + Math.pow(radiusY * Math.sin(theta), 2));
        ctx.stroke();
        ctx.lineWidth = 1;
        // Save mouse position
        this.pointerPosX = pointer.clientX;
        this.pointerPosY = pointer.clientY;
        // Copy objectCanvas to the object's master canvas
        drawCtx = this.editCanvas.getContext('2d');
        drawCtx.clearRect(0, 0, this.editCanvas.width, this.editCanvas.height);
        drawCtx.drawImage(canvas, 0, 0);
      }
      ctx.globalCompositeOperation = 'source-over';
    },
    drawObjectCanvas: function drawObjectCanvas() {
      var canvas = void 0,
          ctx = void 0;
      canvas = document.getElementById('objectCanvas');
      canvas.width = this.editCanvas.width;
      canvas.height = this.editCanvas.height;
      ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(this.editCanvas, 0, 0);
    },
    drawTransparentClick: function drawTransparentClick() {
      var _this29 = this;

      var ctx = void 0,
          img = void 0;
      // Blur button
      document.getElementById('drawTransparentButton').blur();
      if (this.mode === 'clip') this.endClipMode();
      if (this.mode === 'remove') this.endRemoveMode();
      var obj = this.objects[this.activeObject];
      if (this.mode === 'draw') {
        this.endDrawMode();
      } else {
        // Save the object's URL
        this.summaryImage.before = {
          url: obj.url
          // Initialize editCanvas with the object image
        };img = new Image();
        img.crossOrigin = 'Anonymous';
        img.onload = function () {
          _this29.editCanvas = document.createElement('canvas');
          _this29.editCanvas.width = img.naturalWidth;
          _this29.editCanvas.height = img.naturalHeight;
          ctx = _this29.editCanvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          _this29.drawObjectCanvas();
          _this29.mode = 'draw';
          _this29.drawing = false;
          _this29.panLock = false;
        };
        img.src = obj.url;
      }
    },
    enableAudio: function enableAudio(inputHtml) {
      var audioId = void 0,
          audioIdEnd = void 0,
          audioIdStart = void 0,
          buttonPos = void 0,
          cursorPos = void 0,
          html = void 0;
      cursorPos = 0;
      html = inputHtml;
      buttonPos = html.indexOf('<button contenteditable="false" id="play_', cursorPos);
      while (buttonPos !== -1) {
        audioIdStart = buttonPos + '<button contenteditable="false" id="play_'.length;
        audioIdEnd = html.indexOf('"', audioIdStart);
        audioId = html.substring(audioIdStart, audioIdEnd);
        html = html.substring(0, audioIdEnd + 1) + ' onmousedown="playAudio(event, \'' + audioId + '\')"' + html.substring(audioIdEnd + 1);
        cursorPos = audioIdEnd;
        buttonPos = html.indexOf('<button contenteditable="false" id="play_', cursorPos);
      }
      return html;
    },
    endClipMode: function endClipMode() {
      this.mode = 'select';
      this.removeClippingPathUndoEntries();
      // Avoid image shake when switching from one edit mode to another
      this.animateTransition = false;
    },
    endDrawing: function endDrawing() {
      var undoEntry = void 0,
          wrapperRect = void 0;
      undoEntry = {
        after: {
          canvas: this.copyOfCanvas(document.getElementById('objectCanvas'))
        },
        before: {
          canvas: this.copyOfCanvas(this.summaryImage.before.canvas)
        },
        changeType: 'draw',
        objIndex: this.activeObject
      };
      if (this.summaryImage.before.url) {
        undoEntry.before.url = this.summaryImage.before.url;
        this.summaryImage.before = {};
      }
      this.addSummaryImageUndoEntry(undoEntry);
      this.drawing = false;
      var summaryImageWrapper = document.getElementsByClassName('summaryImageWrapper')[0];
      if (summaryImageWrapper) {
        wrapperRect = summaryImageWrapper.getBoundingClientRect();
        // If drawing ended near edge of visible photo
        if (this.pointerPosX - wrapperRect.left < 80 || wrapperRect.right - this.pointerPosX < 80 || this.pointerPosY - wrapperRect.top < 80 || wrapperRect.bottom - this.pointerPosY < 80) {
          // Pan so that the last draw position is centered
          this.showRect.left -= (wrapperRect.width / 2 - (this.pointerPosX - wrapperRect.left)) / this.photoTransform.scale;
          this.showRect.top -= (wrapperRect.height / 2 - (this.pointerPosY - wrapperRect.top)) / this.photoTransform.scale;
          this.animateTransition = true;
        }
      }
    },
    endDrawMode: function endDrawMode() {
      var obj = this.objects[this.activeObject];
      obj.url = this.editCanvas.toDataURL();
      this.mode = 'select';
      // Avoid image shake when switching from one edit mode to another
      this.animateTransition = false;
    },
    endMovingObject: function endMovingObject() {
      var tempObj = void 0,
          undoEntry = void 0;
      var obj = this.objects[this.activeObject];
      undoEntry = {
        after: {
          left: obj.left,
          sequence: this.activeObject,
          top: obj.top
        },
        before: {
          left: this.summaryImage.before.left,
          sequence: this.summaryImage.before.sequence,
          top: this.summaryImage.before.top
        },
        changeType: 'object move'
        // If the object is in the same position and hasn't moved in front of overlapping objects, set it back to its original index
      };if (undoEntry.after.left === undoEntry.before.left && undoEntry.after.top === undoEntry.before.top && !this.movedInFront()) {
        tempObj = this.objects.pop();
        this.objects.splice(this.summaryImage.before.sequence, 0, tempObj);
        this.activeObject = this.summaryImage.before.sequence;
      } else {
        this.addSummaryImageUndoEntry(undoEntry);
      }
      this.movingObject = false;
      // Check whether object overlaps other objects
      this.setActiveObjectOverlap();
    },
    endMovingRectangle: function endMovingRectangle() {
      var undoEntry = void 0;
      undoEntry = {
        after: {
          left: this.locationRect.left,
          top: this.locationRect.top
        },
        before: {
          left: this.summaryImage.before.left,
          top: this.summaryImage.before.top
        },
        changeType: 'rectangle move'
        // If the rectangle has moved
      };if (undoEntry.after.left !== undoEntry.before.left || undoEntry.after.top !== undoEntry.before.top) {
        this.addSummaryImageUndoEntry(undoEntry);
      }
      this.movingRectangle = false;
    },
    endRemoveMode: function endRemoveMode() {
      var obj = this.objects[this.activeObject];
      obj.url = this.editCanvas.toDataURL();
      this.mode = 'select';
      // Avoid image shake when switching from one edit mode to another
      this.animateTransition = false;
    },
    endResizingObject: function endResizingObject() {
      var undoEntry = void 0;
      var obj = this.objects[this.activeObject];
      undoEntry = {
        after: {
          height: obj.height,
          left: obj.left,
          top: obj.top,
          width: obj.width
        },
        before: {
          height: this.summaryImage.before.height,
          left: this.summaryImage.before.left,
          top: this.summaryImage.before.top,
          width: this.summaryImage.before.width
        },
        changeType: 'object resize',
        objIndex: this.activeObject
        // If the object has been resized
      };if (undoEntry.after.height !== undoEntry.before.height || undoEntry.after.left !== undoEntry.before.left || undoEntry.after.top !== undoEntry.before.top || undoEntry.after.width !== undoEntry.before.width) {
        this.addSummaryImageUndoEntry(undoEntry);
      }
      this.resizingObject = false;
    },
    endResizingRectangle: function endResizingRectangle() {
      var undoEntry = void 0;
      undoEntry = {
        after: {
          height: this.locationRect.height,
          left: this.locationRect.left,
          top: this.locationRect.top,
          width: this.locationRect.width
        },
        before: {
          height: this.summaryImage.before.height,
          left: this.summaryImage.before.left,
          top: this.summaryImage.before.top,
          width: this.summaryImage.before.width
        },
        changeType: 'rectangle resize'
        // If the rectangle has been resized
      };if (undoEntry.after.height !== undoEntry.before.height || undoEntry.after.left !== undoEntry.before.left || undoEntry.after.top !== undoEntry.before.top || undoEntry.after.width !== undoEntry.before.width) {
        this.addSummaryImageUndoEntry(undoEntry);
      }
      this.resizingRectangle = false;
    },
    endRotatingObject: function endRotatingObject() {
      var undoEntry = void 0;
      var obj = this.objects[this.activeObject];
      undoEntry = {
        after: { angle: obj.angle },
        before: { angle: this.summaryImage.before.angle },
        changeType: 'object rotate',
        objIndex: this.activeObject
        // If the object has been rotated
      };if (undoEntry.after.angle !== undoEntry.before.angle) {
        this.addSummaryImageUndoEntry(undoEntry);
      }
      this.rotatingObject = false;
    },
    exportDataClick: function exportDataClick() {
      var _this30 = this;

      var data = void 0,
          textarea = void 0;
      // Hide Actions popup
      $('.actionsButton').popup('hide');
      data = '';
      // Prepare column headings
      this.fields.forEach(function (field) {
        data += field.heading + '\t';
      });
      data += 'Notes' + '\n';
      // Loop through rows
      this.rows.forEach(function (row) {
        // Loop through columns
        _this30.fields.forEach(function (field) {
          data += (row.data[field.fieldId] || '') + '\t';
        });
        data += (row.data.notes || '') + '\n';
      });
      textarea = document.createElement('textarea');
      textarea.value = data;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        if (document.execCommand('copy')) {
          // Copied
          this.exported = true;
        } else {
          // Copy failed
          this.exported = false;
        }
      } catch (error) {
        // Copy failed
        logError('MemoSet_exportDataClick', error);
        this.exported = false;
      }
      document.body.removeChild(textarea);
      $('.ui.modal.exportData').modal({
        autofocus: false,
        onApprove: this.exportDataSubmit
      }).modal('show');
    },
    exportDataEnter: function exportDataEnter() {
      // Hide modal
      $('.ui.modal.exportData').modal('hide');
      this.exportDataSubmit();
    },
    exportDataSubmit: function exportDataSubmit() {},
    firstRowsClick: function firstRowsClick(event) {
      // Blur button
      event.target.blur();
      // Show first rows
      this.firstVisibleRow = 1;
      this.goToRowVal = '1';
      this.scrollToTopLeft();
    },
    flipClick: function flipClick(event, axis) {
      var angleInRadians = void 0,
          flipAxis = void 0,
          flipField = void 0,
          obj = void 0,
          undoEntry = void 0;
      if (this.mode === 'clip') this.endClipMode();
      if (this.mode === 'draw') this.endDrawMode();
      if (this.mode === 'remove') this.endRemoveMode();
      obj = this.objects[this.activeObject];
      angleInRadians = obj.angle * Math.PI / 180;
      flipAxis = axis;
      // If object is rotated more than 45 degrees, switch flip axis
      if (Math.abs(Math.sin(angleInRadians)) > 1 / Math.sqrt(2)) {
        flipAxis = flipAxis === 'x' ? 'y' : 'y';
      }
      flipField = 'flip' + flipAxis.toUpperCase();
      obj[flipField] = !obj[flipField];
      // Prepare undo entry
      undoEntry = {
        changeType: 'object flip',
        flipField: flipField,
        objIndex: this.activeObject
      };
      this.addSummaryImageUndoEntry(undoEntry);
      this.animateTransition = false;
      event.target.blur();
    },
    getCanvasCoords: function getCanvasCoords(pointerPosX, pointerPosY) {
      var angleInRadians = void 0,
          canvas = void 0,
          obj = void 0,
          objCanvasX = void 0,
          objCanvasY = void 0,
          objCenterX = void 0,
          objCenterY = void 0,
          pointerRelativeToCenterX = void 0,
          pointerRelativeToCenterY = void 0,
          rotatedPointerRelativeToCenterX = void 0,
          rotatedPointerRelativeToCenterY = void 0,
          rotatedPointerRelativeToLeftTopX = void 0,
          rotatedPointerRelativeToLeftTopY = void 0;
      obj = this.objects[this.activeObject];
      angleInRadians = obj.angle * Math.PI / 180;
      // Find the center of the object
      canvas = document.getElementById('objectCanvas');
      objCenterX = (canvas.getBoundingClientRect().left + canvas.getBoundingClientRect().right) / 2;
      objCenterY = (canvas.getBoundingClientRect().top + canvas.getBoundingClientRect().bottom) / 2;
      pointerRelativeToCenterX = pointerPosX - objCenterX;
      pointerRelativeToCenterY = pointerPosY - objCenterY;
      // Rotate mouse position counterclockwise to adjust for object's rotation
      rotatedPointerRelativeToCenterX = pointerRelativeToCenterX * Math.cos(angleInRadians) + pointerRelativeToCenterY * Math.sin(angleInRadians);
      rotatedPointerRelativeToCenterY = pointerRelativeToCenterY * Math.cos(angleInRadians) - pointerRelativeToCenterX * Math.sin(angleInRadians);
      rotatedPointerRelativeToLeftTopX = rotatedPointerRelativeToCenterX + 0.5 * obj.width * this.photoTransform.scale;
      rotatedPointerRelativeToLeftTopY = rotatedPointerRelativeToCenterY + 0.5 * obj.height * this.photoTransform.scale;
      objCanvasX = rotatedPointerRelativeToLeftTopX / this.photoTransform.scale * canvas.width / obj.width;
      objCanvasY = rotatedPointerRelativeToLeftTopY / this.photoTransform.scale * canvas.height / obj.height;
      // Flip coordinates if object is flipped
      if (obj.flipX) objCanvasX = canvas.width - objCanvasX;
      if (obj.flipY) objCanvasY = canvas.height - objCanvasY;
      return { x: objCanvasX, y: objCanvasY };
    },
    getImageKey: function getImageKey() {
      var userImagesRef = db.collection('userImages').doc();
      userImagesRef.set({
        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        userId: this.user.id
      }).catch(function (error) {
        logError('MemoSet_getImageKey', error);
      });
      return userImagesRef.id;
    },
    goToRow: function goToRow() {
      var _this31 = this;

      if (parseInt(this.goToRowVal, 10) >= 1 && parseInt(this.goToRowVal, 10) <= this.rows.length) {
        this.firstVisibleRow = parseInt(this.goToRowVal, 10);
        this.goToRowVal = this.firstVisibleRow.toString();
        // Check/update thumbnails and Mathjax
        this.prepareVisibleRows();
        this.scrollToTopLeft();
      } else {
        $('.ui.modal.invalidRowNumber').modal({
          onHidden: function onHidden() {
            var goToRowInput = document.getElementById('goToRow');
            goToRowInput.focus();
            moveCursorToEndOfInput(goToRowInput);
            _this31.revertPreventBackHistory();
          },
          onVisible: this.prepareModalHistory
        }).modal('show');
        this.goToRowVal = this.firstVisibleRow.toString();
      }
    },
    handlePosition: function handlePosition(obj, handle) {
      var angleInRadians = void 0,
          handlePositionX = void 0,
          handlePositionY = void 0;
      angleInRadians = obj.angle * Math.PI / 180;
      if (handle === 'left top') {
        handlePositionX = -obj.width / 2 * Math.cos(angleInRadians) + obj.height / 2 * Math.sin(angleInRadians) + obj.left + obj.width / 2;
        handlePositionY = -obj.width / 2 * Math.sin(angleInRadians) - obj.height / 2 * Math.cos(angleInRadians) + obj.top + obj.height / 2;
      }
      if (handle === 'right bottom') {
        handlePositionX = obj.width / 2 * Math.cos(angleInRadians) - obj.height / 2 * Math.sin(angleInRadians) + obj.left + obj.width / 2;
        handlePositionY = obj.width / 2 * Math.sin(angleInRadians) + obj.height / 2 * Math.cos(angleInRadians) + obj.top + obj.height / 2;
      }
      if (handle === 'left bottom') {
        handlePositionX = -obj.width / 2 * Math.cos(angleInRadians) - obj.height / 2 * Math.sin(angleInRadians) + obj.left + obj.width / 2;
        handlePositionY = -obj.width / 2 * Math.sin(angleInRadians) + obj.height / 2 * Math.cos(angleInRadians) + obj.top + obj.height / 2;
      }
      if (handle === 'right top') {
        handlePositionX = obj.width / 2 * Math.cos(angleInRadians) + obj.height / 2 * Math.sin(angleInRadians) + obj.left + obj.width / 2;
        handlePositionY = obj.width / 2 * Math.sin(angleInRadians) - obj.height / 2 * Math.cos(angleInRadians) + obj.top + obj.height / 2;
      }
      return {
        x: handlePositionX,
        y: handlePositionY
      };
    },
    headingBlur: function headingBlur(event, field, fieldIndex) {
      if (event.target.textContent && event.target.textContent !== field.heading) {
        field.heading = event.target.textContent;
        this.fields[fieldIndex].heading = field.heading;
        this.sortQuestions();
        this.writeFields();
      }
      // Update heading element to (1) remove any pasted HTML formatting (2) revert heading if changed to blank
      event.target.textContent = field.heading;
    },
    headingFocus: function headingFocus(fieldId) {
      this.lastFieldId = fieldId;
    },
    imageLoad: function imageLoad() {
      this.addImage.loading = false;
    },
    imagePaste: function imagePaste(event) {
      // Note: the getAsFile method can be slow, and ideally it would be good to show the loading indicator and process the paste in a timeout, but it doesn't seem possible
      var items = void 0;
      if (event.clipboardData) {
        items = event.clipboardData.items;
        if (items) {
          for (var i = 0; i < items.length; i++) {
            if (items[i].type.substring(0, 6) === 'image/') {
              this.addImage.loading = true;
              this.addImage.fileType = items[i].type;
              this.addImage.file = items[i].getAsFile();
              this.addImage.url = window.URL.createObjectURL(this.addImage.file);
              this.summaryImage.createdObjectUrls.push(this.addImage.url);
              break;
            }
          }
        }
      }
    },
    initAddCellAudio: function initAddCellAudio() {
      this.addCellAudio.file = null;
      this.addCellAudio.loading = false;
      this.addCellAudio.recording = false;
      this.addCellAudio.uploading = false;
      this.addCellAudio.url = '';
      document.getElementById('cellAudioFile').value = '';
    },
    initAddCellImage: function initAddCellImage() {
      this.addCellImage.file = null;
      this.addCellImage.fileType = '';
      this.addCellImage.loading = false;
      this.addCellImage.uploading = false;
      this.addCellImage.url = '';
      document.getElementById('cellImageFile').value = '';
    },
    initAddPhoto: function initAddPhoto() {
      this.addPhoto.file = null;
      this.addPhoto.fileType = '';
      this.addPhoto.loading = false;
      this.addPhoto.uploading = false;
      this.addPhoto.url = '';
      document.getElementById('photoFile').value = '';
    },
    initLearn: function initLearn() {
      var _this32 = this;

      // Wrap in nextTick to ensure checkboxes are rendered
      this.$nextTick(function () {
        // Prepare Questions checkboxes
        $('.ui.checkbox.learnQuestion').checkbox({
          onChange: _this32.setSelectedQuestions
        });
        // Prepare Review Group checkboxes
        $('.ui.checkbox.learnReviewGroup').checkbox({
          onChange: _this32.setSelectedReviewGroups
        });
        // If no questions selected, select all questions
        if (!_this32.learn.questionIds.length) {
          _this32.questions.forEach(function (question) {
            $('#learnQuestion_' + question.questionId).checkbox('set checked');
            _this32.learn.questionIds.push(question.questionId);
          });
        } else {
          // Tick selected questions
          _this32.learn.questionIds.forEach(function (questionId) {
            $('#learnQuestion_' + questionId).checkbox('set checked');
          });
        }
        // If no groups selected, select all groups
        if (_this32.options.useReviewGroups) {
          if (!_this32.learn.reviewGroupIds.length) {
            _this32.reviewGroupsList.forEach(function (reviewGroup, index) {
              $('#learnReviewGroup_' + index).checkbox('set checked');
              _this32.learn.reviewGroupIds.push(index.toString());
            });
          } else {
            // Tick selected groups
            _this32.reviewGroupsList.forEach(function (reviewGroup, index) {
              if (_this32.learn.reviewGroupIds.includes(index.toString())) {
                $('#learnReviewGroup_' + index.toString()).checkbox('set checked');
              } else {
                $('#learnReviewGroup_' + index.toString()).checkbox('set unchecked');
              }
            });
          }
        }
        _this32.prepareActiveQuestions();
        _this32.setStatuses('fast');
        // Prepare maximum response time checkbox
        $('.ui.checkbox.useMaxResponseTime').checkbox({
          onChange: function onChange() {
            var useMaxResponseTime = $('.ui.checkbox.useMaxResponseTime').checkbox('is checked');
            _this32.learn.useMaxResponseTime = useMaxResponseTime;
            if (useMaxResponseTime) {
              _this32.$nextTick(function () {
                document.getElementById('maxResponseTime').focus();
              });
            } else {
              _this32.learn.maxResponseTime = '';
            }
            _this32.learn.saveOptions = true;
          }
        });
      });
    },
    initMemoSet: function initMemoSet() {
      var _this33 = this;

      // Exit if already initialized
      if (this.title) return;
      if (this.memoSetType === 'regular') {
        // Find the memo set
        var matches = this.memoSets.filter(function (memoSet) {
          return memoSet.memoSetId === _this33.memoSetId;
        });
        if (matches.length) {
          this.coverImage = matches[0].coverImage;
          this.docId = matches[0].docId;
          this.folderId = matches[0].folderId;
          this.title = matches[0].title;
          this.setPageTitle();
          // Read memo set detail
          this.readMemoSet();
        } else {
          // Memo set not found - redirect to Memo Sets page
          alert('Sorry, the memo set could not be opened.');
          this.$router.push('/memo-sets');
        }
      }
      if (this.memoSetType === 'public') {
        // Read memo set summary data
        db.doc('publicMemoSets/' + this.memoSetId).get().then(function (doc) {
          if (doc.exists) {
            _this33.coverImage = doc.data().coverImage;
            _this33.description = doc.data().description;
            _this33.ownerId = doc.data().ownerId;
            _this33.ownerName = doc.data().ownerName;
            _this33.ratingsArray = doc.data().ratingsArray;
            _this33.title = doc.data().title;
            _this33.setPageTitle();
          }
          _this33.readMemoSet();
        }).catch(function (error) {
          logError('MemoSet_initMemoSet_1', error);
        });
      }
      if (this.memoSetType === 'shared') {
        // Read memo set summary data
        db.doc('users/' + this.user.id + '/sharedWithMe/' + this.memoSetId).get().then(function (doc) {
          if (doc.exists) {
            _this33.coverImage = doc.data().coverImage;
            _this33.description = doc.data().description;
            _this33.ownerId = doc.data().ownerId;
            _this33.ownerName = doc.data().ownerName;
            _this33.title = doc.data().title;
            _this33.setPageTitle();
          }
          _this33.readMemoSet();
        }).catch(function (error) {
          logError('MemoSet_initMemoSet_2', error);
        });
      }
    },
    initSearch: function initSearch() {
      var _this34 = this;

      var rowHtml = void 0,
          searchFields = void 0,
          source = void 0,
          sourceItem = void 0;
      // Create array of search fields
      searchFields = [];
      this.fields.forEach(function (field) {
        searchFields.push(field.fieldId);
      });
      if (this.options.useReviewGroups) {
        searchFields.push('reviewGroup');
      }
      searchFields.push('notes');
      // Prepare search source data
      source = [];
      if (this.rows.length) {
        this.rows.forEach(function (row, rowIndex) {
          sourceItem = {
            rowNum: rowIndex + 1
          };
          rowHtml = '<table class="ui unstackable table" style="border: 0; zoom: 0.9"><tbody><tr>';
          _this34.fields.forEach(function (field) {
            var cardStyle = _this34.cardStyle(row.data[field.fieldId]);
            if (cardStyle) {
              rowHtml += '<td class="three wide" style="height: 60px; ' + 'background-image: ' + cardStyle.backgroundImage + '; ' + 'background-position: ' + cardStyle.backgroundPosition + '; ' + 'background-repeat: ' + cardStyle.backgroundRepeat + '; ' + 'background-size: ' + cardStyle.backgroundSize + '"></td>';
            } else {
              rowHtml += '<td class="three wide">' + (row.data[field.fieldId] || '') + '</td>';
            }
            sourceItem[field.fieldId] = _this34.textOnly(row.data[field.fieldId] || '');
          });
          if (_this34.options.useReviewGroups) {
            if (row.data.reviewGroup) {
              rowHtml += '<td class="three wide"><div class="ui ' + _this34.reviewGroupColors[row.data.reviewGroup] + ' label">' + row.data.reviewGroup + '</div></td>';
            } else {
              rowHtml += '<td class="three wide"></td>';
            }
          }
          rowHtml += '<td class="three wide">' + (row.data.notes || '') + '</td>';
          sourceItem.reviewGroup = row.data.reviewGroup || '';
          sourceItem.notes = _this34.textOnly(row.data.notes || '');
          rowHtml += '</tr></tbody></table>';
          sourceItem.title = rowHtml;
          source.push(sourceItem);
        });
      }
      $('.ui.search').search({
        cache: false,
        onResultsAdd: function onResultsAdd(html) {
          _this34.$nextTick(function () {
            if (window.MathJax) {
              window.MathJax.typeset(['.search .results']);
            }
          });
        },
        onSelect: function onSelect(result, response) {
          // Move to the selected item
          _this34.firstVisibleRow = result.rowNum;
          // Set Go To Row value
          _this34.goToRowVal = _this34.firstVisibleRow.toString();
          _this34.scrollToTopLeft();
          // Clear search field and hide search results
          $('.ui.search').search('set value', '').search('hide results');
          _this34.$nextTick(function () {
            // Blur search field
            document.getElementById('search').blur();
            // Highlight the selected row
            $('#tableWrapper tbody tr').eq(1).transition({
              animation: 'glow',
              duration: '3s'
            });
          });
          return false;
        },
        showNoResults: false,
        source: source,
        searchFields: searchFields
      });
    },
    initSetCoverImage: function initSetCoverImage() {
      this.setCoverImage.file = null;
      this.setCoverImage.fileType = '';
      this.setCoverImage.loading = false;
      this.setCoverImage.uploading = false;
      this.setCoverImage.url = '';
      document.getElementById('coverImageFile').value = '';
    },
    lastRowsClick: function lastRowsClick(event) {
      // Blur button
      if (event) event.target.blur();
      // Show the last page
      if (this.rows.length) {
        this.firstVisibleRow = Math.floor((this.rows.length - 1) / this.visibleRowsCount) * this.visibleRowsCount + 1;
      } else {
        this.firstVisibleRow = 1;
      }
      this.goToRowVal = this.firstVisibleRow.toString();
      // Check/update thumbnails and Mathjax
      this.prepareVisibleRows();
      this.scrollToTopLeft();
    },
    learnClick: function learnClick() {
      var _this35 = this;

      // Initialize modal data
      this.learn.allKnown = false;
      this.learn.answerVisible = false;
      this.learn.contentVisible = false;
      this.learn.continueArray = [];
      this.learn.previousReviewItem = null;
      this.learn.reviewItem = {};
      // Hide congratulations message
      $('.message.congratulations').transition('hide');
      // Save learn options
      if (this.learn.saveOptions) {
        this.learn.saveOptions = false;
        this.saveLearnOptions();
      }
      // Show Learn modal
      this.modal = 'learn';
      $('.ui.modal.learn').modal({
        autofocus: false,
        onHidden: function onHidden() {
          _this35.modal = '';
          _this35.revertPreventBackHistory();
          // Update status bar after a delay
          setTimeout(function () {
            _this35.setStatuses('slow');
          }, 500);
          // Update learning data in Firestore
          var batch = db.batch();
          _this35.updateLearningInFirestore(batch);
          _this35.updateKnownData(batch, _this35.memoSetId);
          batch.commit().catch(function (error) {
            logError('MemoSet_learnClick_onHidden', error);
          });
        },
        onVisible: function onVisible() {
          _this35.prepareModalHistory();
          // Show the first learn item, and start the timer
          _this35.learn.contentVisible = true;
          _this35.startTimerOnNextTick();
        }
      }).modal('show');
      // Prepare first review item
      this.learn.reviewItem = this.nextReviewItem();
    },
    objectRectWithMargin: function objectRectWithMargin(objIndex) {
      // Based on photo pixels: objRect, this.photo, rectWithMargin
      // margin is the margin around location (relative to location width/height)
      var angleInRadians = void 0,
          centerX = void 0,
          centerY = void 0,
          margin = void 0,
          obj = void 0,
          rectWithMargin = void 0,
          rotatedLeft = void 0,
          rotatedHeight = void 0,
          rotatedTop = void 0,
          rotatedWidth = void 0;
      margin = 60 / Math.min(this.photoTransform.visibleHeight, this.photoTransform.visibleWidth);
      if (objIndex === -1) {
        obj = this.locationRect;
        angleInRadians = 0;
      } else {
        obj = this.objects[objIndex];
        angleInRadians = obj.angle * Math.PI / 180;
      }
      // Reduce margin if object is at an angle
      // Note - no real mathematical basis for this, I just wanted something that goes to 0 at 45 degrees
      margin = margin * Math.abs(Math.cos(angleInRadians * 2));
      // Find the center of the object
      centerX = obj.left + obj.width / 2;
      centerY = obj.top + obj.height / 2;
      // Account for object rotation
      rotatedHeight = Math.abs(Math.cos(angleInRadians)) * obj.height + Math.abs(Math.sin(angleInRadians)) * obj.width;
      rotatedWidth = Math.abs(Math.cos(angleInRadians)) * obj.width + Math.abs(Math.sin(angleInRadians)) * obj.height;
      rotatedLeft = centerX - rotatedWidth / 2;
      rotatedTop = centerY - rotatedHeight / 2;
      rectWithMargin = {
        height: rotatedHeight * (1 + margin * 2),
        left: rotatedLeft - rotatedWidth * margin,
        top: rotatedTop - rotatedHeight * margin,
        width: rotatedWidth * (1 + margin * 2)
        // Adjust rectWithMargin if it is beyond the left side of the photo
      };if (rectWithMargin.left < 0) {
        // Reduce width
        rectWithMargin.width += rectWithMargin.left;
        rectWithMargin.left = 0;
      }
      // Adjust rectWithMargin if it is beyond the top of the photo
      if (rectWithMargin.top < 0) {
        // Reduce height
        rectWithMargin.height += rectWithMargin.top;
        rectWithMargin.top = 0;
      }
      // Adjust rectWithMargin if it is beyond the right side of the photo
      if (rectWithMargin.left + rectWithMargin.width > this.photo.width) {
        rectWithMargin.width = this.photo.width - rectWithMargin.left;
      }
      // Adjust rectWithMargin if it is beyond the bottom of the photo
      if (rectWithMargin.top + rectWithMargin.height > this.photo.height) {
        rectWithMargin.height = this.photo.height - rectWithMargin.top;
      }
      return rectWithMargin;
    },
    locationRectWithMargin: function locationRectWithMargin(margin) {
      // Based on photo pixels: this.locationRect, this.photo, rectWithMargin
      // margin is the margin around location (relative to location width/height)
      var rectWithMargin = void 0;
      rectWithMargin = {
        height: this.locationRect.height * (1 + margin * 2),
        left: this.locationRect.left - this.locationRect.width * margin,
        top: this.locationRect.top - this.locationRect.height * margin,
        width: this.locationRect.width * (1 + margin * 2)
        // Adjust rectWithMargin if it is beyond the left side of the photo
      };if (rectWithMargin.left < 0) {
        // Reduce width
        rectWithMargin.width += rectWithMargin.left;
        rectWithMargin.left = 0;
      }
      // Adjust rectWithMargin if it is beyond the top of the photo
      if (rectWithMargin.top < 0) {
        // Reduce height
        rectWithMargin.height += rectWithMargin.top;
        rectWithMargin.top = 0;
      }
      // Adjust rectWithMargin if it is beyond the right side of the photo
      if (rectWithMargin.left + rectWithMargin.width > this.photo.width) {
        rectWithMargin.width = this.photo.width - rectWithMargin.left;
      }
      // Adjust rectWithMargin if it is beyond the bottom of the photo
      if (rectWithMargin.top + rectWithMargin.height > this.photo.height) {
        rectWithMargin.height = this.photo.height - rectWithMargin.top;
      }
      return rectWithMargin;
    },
    maxResponseTimeBlur: function maxResponseTimeBlur() {
      var _this36 = this;

      var decPos = void 0,
          num = void 0;
      // Find decimal point - may be '.' or ','
      decPos = this.learn.maxResponseTime.indexOf('.');
      if (decPos === -1) {
        decPos = this.learn.maxResponseTime.indexOf(',');
      }
      // Truncate anything beyond 2 decimal places
      if (decPos !== -1) {
        this.learn.maxResponseTime = this.learn.maxResponseTime.substring(0, decPos + 3);
        // Add leading 0 if decimal point is at the start
        if (!decPos) this.learn.maxResponseTime = '0' + this.learn.maxResponseTime;
      }
      // Parse as number
      num = parseFloat(this.learn.maxResponseTime.replace(',', '.'));
      if (!(num > 0)) {
        // If there has been a mousedown on the checkbox, allow time for the checkbox click to be processed
        setTimeout(function () {
          _this36.learn.useMaxResponseTime = false;
          _this36.learn.maxResponseTime = '';
        }, this.useMaxResponseTimeMouseDown ? 500 : 1);
      }
    },
    memoSetLoaded: function memoSetLoaded() {
      // Initialize checkboxes
      $('.ui.checkbox').checkbox();
      // Set statuses
      this.setStatuses('instant');
      this.ready = true;
      // Initialize Learn tab
      if (this.activeTab === 'learn') {
        this.initLearn();
      }
      if (this.initialLoad) {
        this.initialLoad = false;
        // Switch to Learn tab if previously on the Home page
        if (this.memoSetType === 'regular' && window.aoms && window.aoms.memoSetSource === 'Home') {
          $('.menu.mainTabs .item').tab('change tab', 'learn');
        } else {
          // If the title is the default title, focus on it
          var defaultTitleLength = this.text.memoSetsDefaultTitle.length;
          if (this.title.substring(0, defaultTitleLength) === this.text.memoSetsDefaultTitle && (this.title.length === defaultTitleLength || this.title.substring(defaultTitleLength + 1, defaultTitleLength + 2) === '(')) {
            setTimeout(function () {
              selectElementContents(document.getElementById('title'));
            }, 100);
          }
        }
      }
    },
    moveColumnClick: function moveColumnClick() {
      var _this37 = this;

      // Hide Actions popup
      $('.actionsButton').popup('hide');
      this.moveColumn.columnSeq = '-1';
      this.moveColumn.position = '-1';
      // Prepare Column dropdown
      $('.moveColumnColumnSeq').dropdown({
        onChange: function onChange(value) {
          _this37.moveColumn.columnSeq = value;
        },
        showOnFocus: false
      }).dropdown('clear');
      // Prepare Move After dropdown
      $('.moveColumnPosition').dropdown({
        onChange: function onChange(value) {
          _this37.moveColumn.position = value;
        },
        showOnFocus: false
      }).dropdown('clear');
      // Show modal
      $('.ui.modal.moveColumn').modal({
        onApprove: this.moveColumnSubmit,
        onHidden: this.revertPreventBackHistory,
        onVisible: this.prepareModalHistory
      }).modal('show');
    },
    moveColumnEnter: function moveColumnEnter() {
      // Exit if form is incomplete
      if (this.moveColumn.columnSeq === '-1' || this.moveColumn.position === '-1') return;
      // Hide modal
      $('.ui.modal.moveColumn').modal('hide');
      // Submit form
      this.moveColumnSubmit();
    },
    moveColumnSubmit: function moveColumnSubmit() {
      var columnSeq = void 0,
          toPosition = void 0;
      columnSeq = parseInt(this.moveColumn.columnSeq, 10);
      toPosition = parseInt(this.moveColumn.position, 10) - 1;
      this.fields.splice(toPosition, 0, this.fields.splice(columnSeq, 1)[0]);
      this.writeFields();
      this.initSearch();
    },
    movedInFront: function movedInFront() {
      var objElement = void 0,
          objRect1 = void 0,
          objRect2 = void 0;
      // Get the bounding rectangle for the active object
      objRect1 = document.getElementById('summaryImageObj_' + this.activeObject).getBoundingClientRect();
      // Check whether there are any overlapping objects with index >= this.summaryImage.sequence
      for (var objIndex = this.summaryImage.before.sequence; objIndex < this.objects.length - 1; objIndex++) {
        objElement = document.getElementById('summaryImageObj_' + objIndex);
        objRect2 = objElement.getBoundingClientRect();
        if (!(objRect2.right < objRect1.left || objRect2.left > objRect1.right || objRect2.bottom < objRect1.top || objRect2.top > objRect1.bottom)) {
          return true;
        }
      }
      return false;
    },
    moveObject: function moveObject(event) {
      // moveX, moveY, this.pointerPosX, this.pointerPosY are relative to the screen
      var moveX = void 0,
          moveY = void 0;
      // Move object by the amount the pointer has moved
      moveX = event.clientX - this.pointerPosX;
      moveY = event.clientY - this.pointerPosY;
      this.objects[this.activeObject].left += moveX / this.photoTransform.scale;
      this.objects[this.activeObject].top += moveY / this.photoTransform.scale;
      // Set pointer position ready for next move
      this.pointerPosX = event.clientX;
      this.pointerPosY = event.clientY;
    },
    moveRectangle: function moveRectangle(pointer) {
      // adjustX, adjustY are relative to the photo
      // moveX, moveY, this.pointerPosX, this.pointerPosY are relative to the screen
      var adjustX = void 0,
          adjustY = void 0,
          moveX = void 0,
          moveY = void 0;
      adjustX = 0;
      adjustY = 0;
      // Move location rectangle by the amount the pointer has moved
      moveX = pointer.clientX - this.pointerPosX;
      moveY = pointer.clientY - this.pointerPosY;
      this.locationRect.left += moveX / this.photoTransform.scale;
      this.locationRect.top += moveY / this.photoTransform.scale;
      // Prevent rectangle from going too far up
      if (this.locationRect.top < 0) {
        adjustY = -this.locationRect.top;
        this.locationRect.top = 0;
      }
      // Prevent rectangle from going too far left
      if (this.locationRect.left < 0) {
        adjustX = -this.locationRect.left;
        this.locationRect.left = 0;
      }
      // Prevent rectangle from going too far down
      if (this.locationRect.top + this.locationRect.height > this.photo.height) {
        adjustY = this.photo.height - (this.locationRect.top + this.locationRect.height);
        this.locationRect.top = this.photo.height - this.locationRect.height;
      }
      // Prevent rectangle from going too far right
      if (this.locationRect.left + this.locationRect.width > this.photo.width) {
        adjustX = this.photo.width - (this.locationRect.left + this.locationRect.width);
        this.locationRect.left = this.photo.width - this.locationRect.width;
      }
      // Set pointer position ready for next move, but adjust if attempting to move beyond edge of photo
      this.pointerPosX = pointer.clientX + adjustX * this.photoTransform.scale;
      this.pointerPosY = pointer.clientY + adjustY * this.photoTransform.scale;
    },
    moveRowsClick: function moveRowsClick() {
      var _this38 = this;

      // Hide Actions popup
      $('.actionsButton').popup('hide');
      this.$nextTick(function () {
        _this38.moveRows.firstRow = '';
        _this38.moveRows.lastRow = '';
        _this38.moveRows.moveAfter = '';
        $('.ui.modal.moveRows').modal({
          onApprove: _this38.moveRowsSubmit,
          onHidden: _this38.revertPreventBackHistory,
          onVisible: _this38.prepareModalHistory
        }).modal('show');
      });
    },
    moveRowsEnter: function moveRowsEnter() {
      // Exit if form is incomplete or invalid
      var firstRow = parseInt(this.moveRows.firstRow, 10);
      var lastRow = parseInt(this.moveRows.lastRow, 10);
      var moveAfter = parseInt(this.moveRows.moveAfter, 10);
      var rowCount = this.rows.length;
      if (!(firstRow > 0 && firstRow <= lastRow && lastRow <= rowCount && moveAfter >= 0 && moveAfter <= rowCount) || moveAfter >= firstRow - 1 && moveAfter <= lastRow) return;
      // Hide modal
      $('.ui.modal.moveRows').modal('hide');
      // Submit form
      this.moveRowsSubmit();
    },
    moveRowsSubmit: function moveRowsSubmit() {
      var _rows2,
          _thumbnails2,
          _this39 = this;

      var firestoreUpdateDocs = void 0,
          firstRow = void 0,
          lastRow = void 0,
          moveAfter = void 0,
          rowsBeingMoved = void 0,
          thumbnailsBeingMoved = void 0;
      firstRow = parseInt(this.moveRows.firstRow, 10) - 1;
      lastRow = parseInt(this.moveRows.lastRow, 10) - 1;
      moveAfter = parseInt(this.moveRows.moveAfter, 10) - 1;
      rowsBeingMoved = this.rows.splice(firstRow, lastRow - firstRow + 1);
      thumbnailsBeingMoved = this.thumbnails.splice(firstRow, lastRow - firstRow + 1);
      // Ensure that we move the same number of thumbnails as rows - in case thumbnails aren't defined
      thumbnailsBeingMoved.length = rowsBeingMoved.length;
      // If moving rows further down, reduce moveAfter by the number of rows being moved
      if (moveAfter > lastRow) {
        moveAfter -= rowsBeingMoved.length;
      }
      // Insert rows being moved
      (_rows2 = this.rows).splice.apply(_rows2, [moveAfter + 1, 0].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(rowsBeingMoved)));
      // Update thumbnails
      (_thumbnails2 = this.thumbnails).splice.apply(_thumbnails2, [moveAfter + 1, 0].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(thumbnailsBeingMoved)));
      // Check/update thumbnails and Mathjax
      this.prepareVisibleRows();
      // Update Firestore
      firestoreUpdateDocs = {};
      this.rows.forEach(function (row, rowIndex) {
        // If seq has changed
        if (row.data.seq !== rowIndex) {
          _this39.$set(row.data, 'seq', rowIndex);
          // Create update object for the document if necessary
          if (!firestoreUpdateDocs[row.docId]) firestoreUpdateDocs[row.docId] = {};
          firestoreUpdateDocs[row.docId][row.rowId + '.seq'] = rowIndex;
        }
      });
      var batch = db.batch();
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(firestoreUpdateDocs).forEach(function (docId) {
        batch.update(db.doc('memoSets/' + _this39.memoSetId + '/rows/' + docId), firestoreUpdateDocs[docId]);
      });
      batch.commit().catch(function (error) {
        logError('MemoSet_moveRowsSubmit', error);
      });
      this.initSearch();
    },
    nextReviewItem: function nextReviewItem() {
      var self = this;
      var i = void 0,
          len = void 0,
          matches = void 0,
          now = void 0,
          questionsCount = void 0,
          selectedItem = void 0,
          thisItem = void 0;

      function prepareItem(item) {
        var cardStyle = void 0,
            html = void 0,
            prevHtml = void 0,
            question = void 0,
            questionImageUrls = void 0;
        // Initialize loadThumbnailFor
        self.learn.loadThumbnailFor = '';
        // Prepare question fields
        question = self.questions.filter(function (q) {
          return q.questionId === item.questionId;
        })[0];
        // Replace new lines with <br>
        html = question.questionText.replace(/\r\n/g, '<br>');
        html = html.replace(/\n/g, '<br>');
        // Replace spaces at the start of a line with &nbsp; to allow indenting
        while (true) {
          prevHtml = html;
          html = html.replace(/^((&nbsp;)*)\s/, '$1&nbsp;');
          html = html.replace(/(<br>(&nbsp;)*)\s/g, '$1&nbsp;');
          if (html === prevHtml) break;
        }
        // If From Column is Summary Image
        if (question.fromFieldId === 's') {
          // If the summary image thumbnail exists
          if (self.thumbnails[item.rowIndex]) {
            html = html.replace('*', '<img src="' + self.thumbnails[item.rowIndex] + '">');
          } else {
            html = html.replace('*', loaderHtml);
            // Create the summary image thumbnail - inside $nextTick to allow nextReviewItem to finish first
            self.$nextTick(function () {
              self.learn.loadThumbnailFor = 'question';
              self.createThumbnail(item.rowIndex, 'question');
            });
          }
        } else {
          cardStyle = self.cardStyle(self.rows[item.rowIndex].data[question.fromFieldId]);
          if (cardStyle) {
            html = html.replace('*', '<div style="background-image: ' + cardStyle.backgroundImage + '; background-position: ' + cardStyle.backgroundPosition + '; background-repeat: ' + cardStyle.backgroundRepeat + '; background-size: ' + cardStyle.backgroundSize + '; display: inline-block; height: 184px; width: 164px"></div>');
          } else {
            html = html.replace('*', '<strong>' + self.rows[item.rowIndex].data[question.fromFieldId] + '</strong>');
            // Autoplay first question audio
            html = html.replace('<audio', '<audio autoplay');
          }
          // Extract any images from the question
          questionImageUrls = extractImageUrlsFromHtml(html);
          // Load the images, restarting the timer when an image is loaded
          questionImageUrls.forEach(function (url) {
            var img = new Image();
            img.onload = function () {
              self.startTimerOnNextTick();
            };
            img.src = url;
          });
        }
        item.questionHtml = html;
        // If To Column is Summary Image
        if (question.toFieldId === 's') {
          item.rowIndexes = [item.rowIndex];
          // If the summary image thumbnail exists
          if (self.thumbnails[item.rowIndex]) {
            item.answerHtml = '<img src="' + self.thumbnails[item.rowIndex] + '">';
          } else {
            item.answerHtml = '';
            // Create the summary image thumbnail - inside $nextTick to allow nextReviewItem to finish first
            self.$nextTick(function () {
              self.learn.loadThumbnailFor = 'answer';
              self.createThumbnail(item.rowIndex);
            });
          }
        } else {
          // If From Column is summary Image
          if (question.fromFieldId === 's') {
            item.rowIndexes = [item.rowIndex];
          } else {
            // Get array of row indexes that are active for this question
            var activeRowIndexes = self.activeQuestions.filter(function (q) {
              return q.questionId === item.questionId;
            }).map(function (q) {
              return q.rowIndex;
            });
            // Get array of row indexes that have the same from field value and are in the active list
            item.rowIndexes = self.rows.map(function (row, rowIndex) {
              return {
                fromFieldValue: row.data[question.fromFieldId],
                rowIndex: rowIndex
              };
            }).filter(function (row) {
              return row.fromFieldValue === self.rows[item.rowIndex].data[question.fromFieldId] && activeRowIndexes.includes(row.rowIndex);
            }).map(function (row) {
              return row.rowIndex;
            });
          }
          item.answerHtml = '';
          item.rowIndexes.forEach(function (rowIndex) {
            cardStyle = self.cardStyle(self.rows[rowIndex].data[question.toFieldId]);
            if (cardStyle) {
              item.answerHtml += '<div style="background-image: ' + cardStyle.backgroundImage + '; background-position: ' + cardStyle.backgroundPosition + '; background-repeat: ' + cardStyle.backgroundRepeat + '; background-size: ' + cardStyle.backgroundSize + '; display: inline-block; height: 184px; width: 164px"></div><br>';
            } else {
              item.answerHtml += '<strong>' + self.rows[rowIndex].data[question.toFieldId] + '</strong><br>';
            }
          });
        }
        return item;
      }

      now = Date.now();
      if (this.learn.allKnown) {
        if (this.learn.continueArray.length) {
          selectedItem = this.learn.continueArray.pop();
          return prepareItem(selectedItem);
        } else {
          // If no longer all known, select the next unknown item
          if (this.learn.noLongerAllKnown) {
            this.learn.allKnown = false;
            return this.nextReviewItem();
          }
          // Prepare array of all askable questions
          this.learn.continueArray = this.activeQuestions.slice();
          // Sort array randomly
          len = this.learn.continueArray.length;
          for (i = 0; i < len; i++) {
            this.learn.continueArray[i].random = Math.random();
          }
          this.learn.continueArray.sort(function (a, b) {
            if (a.random > b.random) return -1;
            return 1;
          });
          selectedItem = this.learn.continueArray.pop();
          return prepareItem(selectedItem);
        }
      } else {
        questionsCount = this.activeQuestions.length;
        for (i = 0; i < questionsCount; i++) {
          thisItem = this.activeQuestions[i];
          // If the item is unknown
          if (!thisItem.reviewCycle || thisItem.reviewAfter <= now) {
            if (!selectedItem || selectedItem.reviewAfter > now && selectedItem.reviewAfter > thisItem.reviewAfter || thisItem.reviewAfter <= now && thisItem.reviewCycle > selectedItem.reviewCycle || thisItem.reviewAfter <= now && thisItem.reviewCycle === selectedItem.reviewCycle && thisItem.reviewAfter > selectedItem.reviewAfter) {
              selectedItem = {
                questionId: thisItem.questionId,
                reviewAfter: thisItem.reviewAfter,
                reviewCycle: thisItem.reviewCycle,
                rowIndex: thisItem.rowIndex
              };
              matches = 1;
            } else if (selectedItem && thisItem.reviewAfter === selectedItem.reviewAfter && thisItem.reviewCycle === selectedItem.reviewCycle) {
              matches++;
              // Chance of switching to the new item is 1 / matches to give all matches an equal chance
              if (Math.random() < 1 / matches) {
                selectedItem = {
                  questionId: thisItem.questionId,
                  reviewAfter: thisItem.reviewAfter,
                  reviewCycle: thisItem.reviewCycle,
                  rowIndex: thisItem.rowIndex
                };
              }
            }
          }
        }
        if (selectedItem) {
          return prepareItem(selectedItem);
        } else {
          // All items are known - show congratulations message
          this.learn.allKnown = true;
          this.learn.justAllKnown = true;
          this.learn.noLongerAllKnown = false;
          this.setCongratsMessage();
          $('.message.congratulations').transition('show');
          return this.nextReviewItem();
        }
      }
    },
    nextRowsClick: function nextRowsClick(event) {
      // Blur button
      event.target.blur();
      // Show next rows
      this.firstVisibleRow += this.visibleRowsCount;
      this.goToRowVal = this.firstVisibleRow.toString();
      // Check/update thumbnails and Mathjax
      this.prepareVisibleRows();
      this.scrollToTopLeft();
    },
    objectCanvasMouseDown: function objectCanvasMouseDown(event) {
      // Do nothing if panning
      if (this.panLock) return;
      if (this.mode === 'clip') {
        this.clippingPointerDown(event);
      }
      if (this.mode === 'draw') {
        this.startDrawing(event);
      }
      if (this.mode === 'remove') {
        this.removePointerDown(event);
      }
      // Stop propagation to prevent panning
      event.stopPropagation();
    },
    objectCanvasMouseLeave: function objectCanvasMouseLeave() {
      var canvas = void 0,
          ctx = void 0;
      // If drawing, redraw the canvas to avoid leaving a transparent hole
      if (this.mode === 'draw' && !this.panLock) {
        canvas = document.getElementById('objectCanvas');
        ctx = canvas.getContext('2d');
        ctx.drawImage(this.editCanvas, 0, 0);
      }
      // If clipping, redraw the canvas to avoid leaving an unfinished line
      if (this.mode === 'clip' && !this.panLock) {
        this.drawObjectCanvas();
        this.drawClippingPath(false);
      }
    },
    objectCanvasMouseMove: function objectCanvasMouseMove(event) {
      // Do nothing if panning
      if (this.panLock) return;
      if (this.mode === 'clip') {
        this.clippingPointerMove(event);
        event.stopPropagation();
      }
      if (this.mode === 'draw') {
        this.drawMove(event);
        event.stopPropagation();
      }
    },
    objectCanvasTouchMove: function objectCanvasTouchMove(event) {
      // Do nothing if panning
      if (this.panLock) return;
      if (event.touches.length === 1) {
        if (this.mode === 'clip' && this.clipping) {
          this.clippingPointerMove(event.touches[0]);
          event.stopPropagation();
        }
        if (this.mode === 'draw') {
          this.drawMove(event.touches[0]);
          event.stopPropagation();
        }
        if (this.mode === 'remove' && this.removing) {
          this.removePointerMove(event.touches[0]);
          event.stopPropagation();
        }
      }
    },
    objectCanvasTouchStart: function objectCanvasTouchStart(event) {
      // Do nothing if panning
      if (this.panLock) return;
      // If this is the first touch
      if (event.touches.length === 1) {
        this.summaryImage.firstTouchRectangleActive = false;
        this.summaryImage.firstTouchActiveObject = this.activeObject;
        this.summaryImage.firstTouchTimestamp = event.timeStamp;
        if (this.mode === 'clip') {
          this.firstTouchClippingPath = this.clippingPath.slice();
          this.clippingPointerDown(event.touches[0]);
        }
        if (this.mode === 'draw') {
          this.startDrawing(event.touches[0]);
        }
        if (this.mode === 'remove') {
          this.removePointerDown(event.touches[0]);
        }
        // Stop propagation to prevent panning
        event.stopPropagation();
      }
    },
    objectHandleMouseDown: function objectHandleMouseDown(event, handle) {
      this.objectResizeStart(event, handle);
    },
    objectHandleTouchStart: function objectHandleTouchStart(event, handle) {
      // If this is the first touch
      if (event.touches.length === 1) {
        this.objectResizeStart(event.touches[0], handle);
        event.stopPropagation();
      }
    },
    objectMouseDown: function objectMouseDown(objectIndex, event) {
      if (this.mode === 'select' && !this.panLock) {
        this.objectPointerDown(objectIndex, event);
        // Prevent panning
        event.stopPropagation();
      }
    },
    objectMouseEnter: function objectMouseEnter(objectIndex) {
      if (this.mode === 'select' && !this.panLock && !this.movingRectangle && !this.resizingRectangle && !this.movingObject && !this.resizingObject && !this.rotatingObject) {
        this.hoverObject = objectIndex;
      }
    },
    objectMouseLeave: function objectMouseLeave(objectIndex) {
      this.hoverObject = -1;
    },
    objectPointerDown: function objectPointerDown(objectIndex, pointer) {
      var thisObj = void 0;
      // Save before state for undo array
      thisObj = this.objects[objectIndex];
      this.summaryImage.before = {
        left: thisObj.left,
        sequence: objectIndex,
        top: thisObj.top
        // Move object to the top
      };thisObj = this.objects.splice(objectIndex, 1)[0];
      this.objects.push(thisObj);
      this.activeObject = this.objects.length - 1;
      // Reset hoverObject
      this.hoverObject = -1;
      this.rectangleActive = false;
      this.pointerPosX = pointer.clientX;
      this.pointerPosY = pointer.clientY;
      this.movingObject = true;
      this.animateTransition = false;
      // Check whether object overlaps other objects
      this.setActiveObjectOverlap();
    },
    objectResizeStart: function objectResizeStart(pointer, handle) {
      // Save before state for undo array
      var obj = this.objects[this.activeObject];
      this.summaryImage.before = {
        height: obj.height,
        left: obj.left,
        top: obj.top,
        width: obj.width
      };
      this.pointerPosX = pointer.clientX;
      this.pointerPosY = pointer.clientY;
      this.resizingObject = true;
      this.objectResizeHandle = handle;
      this.animateTransition = false;
    },
    objectRotationMouseDown: function objectRotationMouseDown(event) {
      this.objectRotationStart(event);
    },
    objectRotationTouchStart: function objectRotationTouchStart(event, handle) {
      // If this is the first touch
      if (event.touches.length === 1) {
        this.objectRotationStart(event.touches[0], handle);
        event.stopPropagation();
      }
    },
    objectRotationStart: function objectRotationStart(event) {
      // Save before state for undo array
      var obj = this.objects[this.activeObject];
      this.summaryImage.before = {
        angle: obj.angle
      };
      this.rotatingObject = true;
      this.animateTransition = false;
    },
    objectsChanged: function objectsChanged(originalObjects, currentObjects) {
      var _this40 = this;

      if (originalObjects.length !== currentObjects.length) return true;
      // Return true if any element in originalObjects is not the same in currentObjects
      return originalObjects.some(function (origObj) {
        return !currentObjects.find(function (currObj) {
          var samePosition = void 0,
              sameSequence = void 0;
          samePosition = currObj.angle === origObj.angle && !!currObj.flipX === !!origObj.flipX && !!currObj.flipY === !!origObj.flipY && currObj.height === origObj.height && currObj.left === origObj.left && currObj.top === origObj.top && currObj.url === origObj.url && currObj.width === origObj.width;
          if (_this40.overlappingObjects()) {
            sameSequence = currObj.sequence === origObj.sequence;
            return samePosition && sameSequence;
          } else {
            // No objects overlap - ignore sequence changes
            return samePosition;
          }
        });
      });
    },
    objectTouchStart: function objectTouchStart(objectIndex, event) {
      if (event.touches.length === 1) {
        if (this.mode === 'select' && !this.panLock) {
          this.summaryImage.firstTouchActiveObject = this.activeObject;
          this.summaryImage.firstTouchRectangleActive = this.rectangleActive;
          this.summaryImage.firstTouchTimestamp = event.timeStamp;
          this.objectPointerDown(objectIndex, event.touches[0]);
          // Prevent panning
          event.stopPropagation();
        }
      }
    },
    oopsClick: function oopsClick() {
      var _this41 = this;

      if (this.learn.justAllKnown) {
        this.learn.allKnown = false;
        $('.message.congratulations').transition('hide');
        this.learn.continueArray = [];
      }
      if (this.learn.justNoLongerAllKnown) {
        this.learn.allKnown = true;
      }
      // Revert to the previous review item
      this.learn.reviewItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.learn.previousReviewItem);
      this.learn.reviewItem.rowIndexes.forEach(function (rowIndex) {
        var row = _this41.rows[rowIndex];
        var questionId = _this41.learn.reviewItem.questionId;
        var question = row.data.questions[questionId];
        // Revert the previous item's reviewAfter and reviewCycle
        question.reviewAfter = _this41.learn.previousReviewAfter;
        question.reviewCycle = _this41.learn.previousReviewCycle;
        // Update Firestore update object
        _this41.learn.firestoreUpdate[row.docId][row.rowId + '.questions.' + questionId] = {
          reviewAfter: question.reviewAfter,
          reviewCycle: question.reviewCycle
          // Update activeQuestions array
        };var questionIndex = _this41.activeQuestions.findIndex(function (e) {
          return e.rowIndex === rowIndex && e.questionId === questionId;
        });
        var questionObj = _this41.activeQuestions[questionIndex];
        questionObj.reviewAfter = question.reviewAfter;
        questionObj.reviewCycle = question.reviewCycle;
      });
      // Show answer
      this.learn.answerVisible = true;
    },
    optionsClick: function optionsClick(option) {
      // Blur checkbox
      document.activeElement.blur();
      this.options[option] = !this.options[option];
      // If using background photos, must also be using summary images
      if (this.options.useBackgroundPhotos) {
        this.options.useSummaryImages = true;
      }
      // Update Firestore
      db.doc('memoSets/' + this.memoSetId).update({
        options: this.options
      }).catch(function (error) {
        logError('MemoSet_optionsClick', error);
      });
      // Refresh search if review groups option changed
      if (option === 'useReviewGroups') {
        this.initSearch();
      }
    },
    overlappingObjects: function overlappingObjects() {
      var _this42 = this;

      return this.objects.some(function (obj) {
        return _this42.objects.some(function (obj2) {
          // Ignore the same object
          if (obj.sequence === obj2.sequence) return false;
          // Return true if the objects overlap
          return !(obj.left + obj.width < obj2.left || obj.left > obj2.left + obj2.width || obj.top + obj.height < obj2.top || obj.top > obj2.top + obj2.height);
        });
      });
    },
    panLockClick: function panLockClick() {
      // Blur button
      document.getElementById('panLockButton').blur();
      this.panLock = !this.panLock;
    },
    photoLoad: function photoLoad() {
      this.addPhoto.loading = false;
      window.URL.revokeObjectURL(this.addPhoto.url);
    },
    photoPaste: function photoPaste(event) {
      var i = void 0,
          items = void 0;
      if (event.clipboardData) {
        items = event.clipboardData.items;
        if (items) {
          for (i = 0; i < items.length; i++) {
            if (items[i].type.substring(0, 6) === 'image/') {
              this.addPhoto.loading = true;
              this.addPhoto.fileType = items[i].type;
              this.addPhoto.file = items[i].getAsFile();
              this.addPhoto.url = window.URL.createObjectURL(this.addPhoto.file);
              break;
            }
          }
        }
      }
    },
    populateColumnClick: function populateColumnClick() {
      var _this43 = this;

      var fieldIndex = void 0;
      // Hide Actions popup
      $('.actionsButton').popup('hide');
      // Set column to the last column touched, if there was one
      fieldIndex = this.fields.findIndex(function (e) {
        return e.fieldId === _this43.lastFieldId;
      });
      if (fieldIndex !== -1) {
        this.populateColumn.column = fieldIndex.toString();
      } else {
        // If only one column, use that
        if (this.fields.length === 1) {
          this.populateColumn.column = '0';
        }
      }
      // Prepare dropdowns
      $('.populateColumnColumn').dropdown({
        onChange: function onChange(value) {
          _this43.populateColumn.column = value;
        },
        showOnFocus: false
      }).dropdown('set selected', this.populateColumn.column);
      $('.populateColumnDataSet').dropdown({
        onChange: function onChange(value) {
          _this43.populateColumn.dataSet = value;
          _this43.populateColumnInit();
        },
        showOnFocus: false
      });
      $('.populateColumnSuits').dropdown({
        onChange: function onChange(value) {
          _this43.populateColumn.suits = value;
        },
        showOnFocus: false
      });
      $('.populateColumnValues').dropdown({
        onChange: function onChange(value) {
          _this43.populateColumn.values = value;
        },
        showOnFocus: false
      });
      $('.populateColumnSignificantCard').dropdown({
        onChange: function onChange(value) {
          _this43.populateColumn.significantCard = value;
        },
        showOnFocus: false
      });
      $('.populateColumnIncludeRepeated').dropdown({
        onChange: function onChange(value) {
          _this43.populateColumn.includeRepeated = value;
        },
        showOnFocus: false
      });
      $('.ui.modal.populateColumn').modal({
        autofocus: false,
        onApprove: this.populateColumnSubmit,
        onHidden: this.revertPreventBackHistory,
        onVisible: this.prepareModalHistory
      }).modal('show');
    },
    populateColumnEnter: function populateColumnEnter() {
      // Exit if form is incomplete or invalid
      if (this.populateColumn.column === '' || this.populateColumn.dataSet === '' || this.populateColumn.dataSet === 'n' && !this.populateColumnPreviewHtml) return;
      // Hide modal
      $('.ui.modal.populateColumn').modal('hide');
      // Submit form
      this.populateColumnSubmit();
    },
    populateColumnInit: function populateColumnInit() {
      // If numbers, reset default first and last values
      // Note that the value contenteditable divs are refreshed by v-if
      if (this.populateColumn.dataSet.substring(0, 1) === 'n') {
        this.$set(this.populateColumn.numValues, 0, this.populateColumn.originalNumValues[0]);
        this.$set(this.populateColumn.numValues, 1, this.populateColumn.originalNumValues[1]);
      }
    },
    populateColumnSubmit: function populateColumnSubmit() {
      var _this44 = this;

      var self = this;
      var base = void 0,
          columnData = void 0,
          fieldId = void 0,
          firestoreNewDocs = void 0,
          firestoreUpdateDocs = void 0,
          firstDigits = void 0,
          firstFormat = void 0,
          formattedValue = void 0,
          increment = void 0,
          lastDigits = void 0,
          numberOfValues = void 0,
          rowsAdded = void 0,
          suits = void 0,
          values = void 0;
      columnData = [];
      if (this.populateColumn.dataSet.substring(0, 1) === 'c') {
        suits = this.populateColumn.suits.split('');
        switch (this.populateColumn.values) {
          case 'A-K':
            values = ['A', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K'];
            break;
          case 'K-A':
            values = ['K', 'Q', 'J', '10', '9', '8', '7', '6', '5', '4', '3', '2', 'A'];
            break;
          case '2-A':
            values = ['2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K', 'A'];
            break;
          case 'A-2':
            values = ['A', 'K', 'Q', 'J', '10', '9', '8', '7', '6', '5', '4', '3', '2'];
            break;
        }
      }
      if (this.populateColumn.dataSet === 'c1') {
        suits.forEach(function (suit) {
          values.forEach(function (value) {
            columnData.push('(' + value + suit + ')');
          });
        });
      }
      if (this.populateColumn.dataSet === 'c2') {
        suits.forEach(function (suit1) {
          values.forEach(function (value1) {
            suits.forEach(function (suit2) {
              values.forEach(function (value2) {
                if (value1 + suit1 !== value2 + suit2 || self.populateColumn.includeRepeated === 'Y') {
                  if (self.populateColumn.significantCard === 'L') {
                    columnData.push('(' + value1 + suit1 + ' ' + value2 + suit2 + ')');
                  } else {
                    columnData.push('(' + value2 + suit2 + ' ' + value1 + suit1 + ')');
                  }
                }
              });
            });
          });
        });
      }
      if (this.populateColumn.dataSet === 'n') {
        // For convenience
        var first = this.populateColumn.numValues[0];
        var last = this.populateColumn.numValues[1];
        // Handle simple numbers
        if (first === parseInt(first, 10).toString() && last === parseInt(last, 10).toString()) {
          numberOfValues = Math.abs(parseInt(last, 10) - parseInt(first, 10)) + 1;
          // Set increment to 1 if increasing, -1 if decreasing
          increment = parseInt(last, 10) > parseInt(first, 10) ? 1 : -1;
          for (var i = 0; i < numberOfValues; i++) {
            var thisValue = (parseInt(first, 10) + i * increment).toString();
            columnData.push(thisValue);
          }
        } else {
          // Handle formatted numbers
          firstFormat = first.replace(/\d/g, '<digit>');
          // Extract the digits only
          firstDigits = first.replace(/\D/g, '');
          lastDigits = last.replace(/\D/g, '');
          // Set base to 2 (binary) if all digits are 0 or 1
          base = (firstDigits + lastDigits).replace(/0/g, '').replace(/1/g, '') === '' ? 2 : 10;
          numberOfValues = Math.abs(parseInt(lastDigits, base) - parseInt(firstDigits, base)) + 1;
          // Set increment to 1 if increasing, -1 if decreasing
          increment = parseInt(lastDigits, base) > parseInt(firstDigits, base) ? 1 : -1;
          for (var _i6 = 0; _i6 < numberOfValues; _i6++) {
            var _thisValue2 = (parseInt(firstDigits, base) + _i6 * increment).toString(base);
            // Left pad with zeros
            _thisValue2 = ('0'.repeat(firstDigits.length) + _thisValue2).slice(-firstDigits.length);
            // Add non-numeric formatting
            formattedValue = firstFormat;
            for (var d = 0; d < firstDigits.length; d++) {
              formattedValue = formattedValue.replace('<digit>', _thisValue2.substring(d, d + 1));
            }
            columnData.push(formattedValue);
          }
        }
      }
      // Insert rows at the bottom if required
      if (columnData.length > this.rows.length) {
        this.addRows.addBelowRow = this.rows.length.toString();
        this.addRows.numberOfRows = columnData.length - this.rows.length;
        // Add rows without updating Firestore
        this.addRowsAddRows(false);
        rowsAdded = true;
        // For convenience
        firestoreNewDocs = this.addRows.firestoreNewDocs;
        firestoreUpdateDocs = this.addRows.firestoreUpdateDocs;
      } else {
        // No rows to add
        firestoreNewDocs = {};
        firestoreUpdateDocs = {};
      }
      // Update the column data
      fieldId = this.fields[parseInt(this.populateColumn.column, 10)].fieldId;
      for (var _i7 = 0; _i7 < columnData.length; _i7++) {
        var row = this.rows[_i7];
        this.$set(row.data, fieldId, columnData[_i7]);
        // Update Firestore object
        if (firestoreNewDocs[row.docId]) {
          firestoreNewDocs[row.docId][row.rowId][fieldId] = columnData[_i7];
        } else {
          if (!firestoreUpdateDocs[row.docId]) firestoreUpdateDocs[row.docId] = {};
          firestoreUpdateDocs[row.docId][row.rowId + '.' + fieldId] = columnData[_i7];
        }
      }
      // Update Firestore
      var batch = db.batch();
      // Write new docs
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(firestoreNewDocs).forEach(function (docId) {
        batch.set(db.doc('memoSets/' + _this44.memoSetId + '/rows/' + docId), firestoreNewDocs[docId]);
      });
      // Write update docs
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(firestoreUpdateDocs).forEach(function (docId) {
        batch.update(db.doc('memoSets/' + _this44.memoSetId + '/rows/' + docId), firestoreUpdateDocs[docId]);
      });
      if (rowsAdded) {
        this.writeRowCount(batch);
      }
      this.updateKnownData(batch, this.memoSetId);
      batch.commit().catch(function (error) {
        logError('MemoSet_populateColumnSubmit', error);
      });
      this.initSearch();
    },
    populateColumnValueInput: function populateColumnValueInput(event, valueIndex) {
      this.$set(this.populateColumn.numValues, valueIndex, event.target.innerHTML);
    },
    prepareActiveQuestions: function prepareActiveQuestions() {
      var _this45 = this;

      var reviewGroupIndex = void 0,
          selectedQuestions = void 0,
          selectedReviewGroupNames = void 0;
      this.activeQuestions = [];
      // If review groups are used, prepare array of selected review group names
      if (this.options.useReviewGroups) {
        selectedReviewGroupNames = [];
        this.learn.reviewGroupIds.forEach(function (reviewGroupIndexString) {
          reviewGroupIndex = parseInt(reviewGroupIndexString, 10);
          selectedReviewGroupNames.push(_this45.reviewGroupsList[reviewGroupIndex]);
        });
      }
      // For each selected question
      selectedQuestions = this.questions.filter(function (question) {
        return _this45.learn.questionIds.includes(question.questionId);
      });
      selectedQuestions.forEach(function (question) {
        _this45.rows.forEach(function (row, rowIndex) {
          // If review groups not used, or row is in selected review groups
          if (!_this45.options.useReviewGroups || selectedReviewGroupNames.includes(row.data.reviewGroup || '')) {
            if (_this45.rowHasData(row, question.fromFieldId, question.toFieldId)) {
              _this45.activeQuestions.push({
                questionId: question.questionId,
                reviewAfter: row.data.questions && row.data.questions[question.questionId] ? row.data.questions[question.questionId].reviewAfter : 0,
                reviewCycle: row.data.questions && row.data.questions[question.questionId] ? row.data.questions[question.questionId].reviewCycle : 0,
                rowIndex: rowIndex
              });
            }
          }
        });
      });
    },
    prepareAlternatives: function prepareAlternatives() {
      var _this46 = this;

      this.alternatives = {};
      // Loop through private alternatives
      if (this.privateAlternatives) {
        var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.privateAlternatives);
        keys.forEach(function (key) {
          // Add private alternatives to the alternatives object
          if (!_this46.alternatives[key]) _this46.alternatives[key] = [];
          var values = _this46.privateAlternatives[key];
          values.forEach(function (value) {
            _this46.alternatives[key].push({
              author: _this46.user.displayName,
              authorId: _this46.user.id,
              public: false,
              value: value
            });
          });
        });
      }
      // Loop through public alternatives
      if (this.publicAlternatives) {
        this.publicAlternatives.forEach(function (doc) {
          var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(doc.data());
          keys.forEach(function (key) {
            // Add public alternatives to the alternatives object
            if (!_this46.alternatives[key]) _this46.alternatives[key] = [];
            var alternativesForKey = doc.data()[key];
            alternativesForKey.forEach(function (alternativeForKey) {
              alternativeForKey.authorId = doc.id;
              alternativeForKey.public = true;
              _this46.alternatives[key].push(alternativeForKey);
            });
          });
        });
      }
    },
    prepareModalHistory: function prepareModalHistory() {
      this.backCloses = 'modal';
      this.preventBack();
    },
    prepareObjects: function prepareObjects() {
      var _this47 = this;

      this.objects = [];
      this.photoRowIndexes = [];
      if (this.photo.id) {
        // Loop through memo set rows
        // Note - this loop is faster than using array filter and forEach
        this.rows.forEach(function (row, rowIndex) {
          if (row.data.photoId === _this47.photo.id) {
            _this47.addObjectsForRow(row, rowIndex);
            _this47.photoRowIndexes.push(rowIndex);
          }
        });
      } else {
        this.addObjectsForRow(this.rows[this.rowIndex], this.rowIndex);
      }
      // Sort objects by sequence
      this.objects.sort(function (a, b) {
        if (a.sequence < b.sequence) return -1;
        return 1;
      });
    },
    prepareVisibleRows: function prepareVisibleRows() {
      this.checkVisibleThumbnails();
      this.applyMathjax();
    },
    prepareWalkThroughStep: function prepareWalkThroughStep(options) {
      var step = void 0;
      step = this.walkThrough.steps[this.walkThrough.stepNum];
      // If there is a background photo
      if (step.photoId) {
        this.photo = this.photos.find(function (photo) {
          return photo.id === step.photoId;
        });
        this.locationRect = {
          height: step.location.height,
          left: step.location.left,
          top: step.location.top,
          width: step.location.width
        };
        this.showRect = {
          left: this.walkThroughLocationRectWithMargin.left,
          top: this.walkThroughLocationRectWithMargin.top,
          width: this.walkThroughLocationRectWithMargin.width,
          height: this.walkThroughLocationRectWithMargin.height
        };
      } else {
        // No background photo
        this.photo = {
          height: noPhotoSize,
          width: noPhotoSize
        };
        this.locationRect = {
          height: noPhotoSize,
          left: 0,
          top: 0,
          width: noPhotoSize
          // Show the entire dummy photo
        };this.showRect = {
          left: 0,
          top: 0,
          width: this.photo.width,
          height: this.photo.height
        };
      }
      this.photoTransition = options.photoChange;
      this.setDataHeight();
      // Apply Mathjax
      this.$nextTick(function () {
        if (window.MathJax) {
          window.MathJax.typeset(['.walkThroughDataTable']);
        }
      });
    },
    preventBack: function preventBack() {
      var _this48 = this;

      // Push to history to prevent back button going back
      window.history.pushState({ preventBack: true }, '', window.location.href);
      // Hide modal on history entry change
      window.onpopstate = function () {
        switch (_this48.backCloses) {
          case 'modal':
            // Hide modals
            $('.ui.modal').modal('hide');
            break;
          case 'popup':
            // Hide Actions menu
            $('.actionsButton').popup('hide');
            break;
        }
        _this48.backCloses = '';
      };
    },
    previousRowsClick: function previousRowsClick(event) {
      // Blur button
      event.target.blur();
      // Show previous rows
      this.firstVisibleRow -= this.visibleRowsCount;
      if (this.firstVisibleRow < 1) this.firstVisibleRow = 1;
      this.goToRowVal = this.firstVisibleRow.toString();
      // Check/update thumbnails and Mathjax
      this.prepareVisibleRows();
      this.scrollToTopLeft();
    },
    printMemoSetClick: function printMemoSetClick() {
      var _this49 = this;

      var self = this;
      var firstVisibleRow = void 0,
          imageUrls = void 0,
          remaining = void 0;
      function imageLoaded() {
        remaining--;
        if (!remaining) {
          self.$nextTick(function () {
            window.print();
            // Revert first visible row number and printing flag
            self.firstVisibleRow = firstVisibleRow;
            self.printing = false;
          });
        }
      }
      document.getElementById('printMemoSetButton').blur();
      // Save first visible row number
      firstVisibleRow = this.firstVisibleRow;
      this.firstVisibleRow = 1;
      // Set printing flag - this makes all rows visible
      this.printing = true;
      // Check/update thumbnails and Mathjax
      this.prepareVisibleRows();
      // Prepare array of images that need to be loaded
      imageUrls = [];
      // Add card images
      for (var i = 0; i < 52; i++) {
        imageUrls.push(this.appPathPrefix + '/static/cards/english/card' + i + '.svg');
      }
      // Add images in columns
      var cellHtml = void 0,
          imgPos = void 0,
          quotePos = void 0;
      this.fields.forEach(function (field) {
        _this49.rows.forEach(function (row) {
          cellHtml = row.data[field.fieldId];
          if (cellHtml) {
            while (true) {
              imgPos = cellHtml.indexOf('<img src="');
              if (imgPos === -1) break;
              quotePos = cellHtml.indexOf('"', imgPos + 10);
              imageUrls.push(cellHtml.substring(imgPos + 10, quotePos).replace(/&amp;/g, '&'));
              cellHtml = cellHtml.substring(quotePos);
              break;
            }
          }
        });
      });
      // TODO - Add images for background photos and summary images
      // Keep unique image URLs
      imageUrls = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(imageUrls)));
      // Check/load images
      remaining = imageUrls.length;
      imageUrls.forEach(function (imageUrl) {
        var img = new Image();
        img.onload = imageLoaded;
        img.onerror = imageLoaded;
        img.src = imageUrl;
      });
    },
    questionClick: function questionClick(mode, question, questionIndex) {
      var _this50 = this;

      this.question.mode = mode;
      if (this.question.mode === 'edit') {
        this.question.questionId = question.questionId;
        this.question.questionIndex = questionIndex;
        this.question.originalQuestionText = question.questionText;
        this.question.questionText = question.questionText;
        this.question.fromFieldId = question.fromFieldId;
        this.question.toFieldId = question.toFieldId;
      } else {
        this.question.questionId = '';
        this.question.originalQuestionText = '';
        this.question.questionText = '';
        this.question.fromFieldId = '';
        this.question.toFieldId = '';
      }
      this.question.pendingDelete = false;
      // Prepare From Column dropdown
      $('.questionFromFieldId').dropdown({
        onChange: function onChange(value) {
          _this50.question.fromFieldId = value;
          _this50.defaultQuestionText();
        },
        showOnFocus: false
      });
      // Prepare To Column dropdown
      $('.questionToFieldId').dropdown({
        onChange: function onChange(value) {
          _this50.question.toFieldId = value;
          _this50.defaultQuestionText();
        },
        showOnFocus: false
      });
      // Default dropdown values
      if (this.question.mode === 'edit') {
        $('.questionFromFieldId').dropdown('set selected', this.question.fromFieldId);
        $('.questionToFieldId').dropdown('set selected', this.question.toFieldId);
      } else {
        $('.questionFromFieldId').dropdown('clear');
        $('.questionToFieldId').dropdown('clear');
      }
      // Show modal
      this.modal = 'question';
      $('.ui.modal.question').modal({
        autofocus: false,
        onApprove: this.questionSubmit,
        onHidden: function onHidden() {
          _this50.modal = '';
          _this50.revertPreventBackHistory();
        },
        onVisible: this.prepareModalHistory
      }).modal('show');
    },
    questionEnter: function questionEnter() {
      // Do nothing if there's an error or the question is pending deletion
      if (this.questionStatus !== 'ok' || this.question.pendingDelete) return;
      // Submit form
      this.questionSubmit();
      // Hide modal
      $('.ui.modal.question').modal('hide');
    },
    questionInput: function questionInput(event) {
      this.question.questionText = event.target.innerHTML;
    },
    questionSubmit: function questionSubmit() {
      var questionId = void 0;
      if (this.question.pendingDelete) {
        this.deleteFieldOrQuestion('', this.question.questionId);
      } else {
        if (this.question.mode === 'add') {
          var questionIndex = void 0;
          // Get next available question ID
          questionIndex = 0;
          while (true) {
            questionIndex++;
            questionId = 'q' + questionIndex.toString();
            if (!this.questions.filter(function (question) {
              return question.questionId === questionId;
            }).length) break;
          }
          this.questions.push({
            fromFieldId: this.question.fromFieldId,
            questionId: questionId,
            questionText: this.question.questionText,
            toFieldId: this.question.toFieldId
          });
        } else {
          var question = this.questions[this.question.questionIndex];
          question.fromFieldId = this.question.fromFieldId;
          question.toFieldId = this.question.toFieldId;
          question.questionText = this.question.questionText;
          questionId = this.question.questionId;
        }
        this.sortQuestions();
        // Reset questions selected for learning
        this.learn.questionIds = [];
        this.$nextTick(function () {
          // Highlight the new question
          $('#question_' + questionId).transition({
            animation: 'questionGlow',
            duration: '3s'
          });
        });
        // Update Firestore
        this.writeQuestions();
      }
    },
    questionTextBlur: function questionTextBlur(questionIndex) {
      // Trim trailing whitespace
      this.questions[questionIndex].questionText = this.questions[questionIndex].questionText.replace(/\s+$/, '');
      if (this.questions[questionIndex].questionText !== this.questionText) {
        // Update Firestore
        this.writeQuestions();
      }
    },
    randomId: function randomId() {
      return db.collection('dummy').doc().id;
    },
    readMemoSet: function readMemoSet() {
      var _this51 = this;

      var self = this;
      var headerDataLoaded = void 0,
          privateAlternativesLoaded = void 0,
          publicAlternativesLoaded = void 0,
          rowsDataLoaded = void 0,
          rowsRef = void 0;
      if (this.memoSetType === 'public' && this.user.id !== this.ownerId || this.memoSetType === 'regular' && !this.selfOwned) {
        db.doc('memoSets/' + this.originalMemoSetId + '/userRatings/' + this.user.id).get().then(function (doc) {
          if (doc.exists) {
            _this51.myRating = doc.data().rating;
          } else {
            _this51.myRating = 0;
          }
          self.$nextTick(function () {
            // Initialize rating
            $('.ui.rating.myRating').rating({
              clearable: true,
              onRate: function onRate(value) {
                var previousRating = _this51.myRating;
                _this51.myRating = value;
                if (value) {
                  // Write rating to Firestore
                  db.doc('memoSets/' + self.originalMemoSetId + '/userRatings/' + self.user.id).set({
                    rating: value
                  }).then(function () {
                    // Write request for server to update memo set rating
                    db.collection('userRatingChange').add({
                      memoSetId: self.memoSetId,
                      newRating: value,
                      oldRating: previousRating,
                      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                      userId: self.user.id
                    }).catch(function (error) {
                      logError('MemoSet_readMemoSet_1', error);
                    });
                  }).catch(function (error) {
                    logError('MemoSet_readMemoSet_2', error);
                  });
                } else {
                  // Rating has been removed
                  db.doc('memoSets/' + self.originalMemoSetId + '/userRatings/' + self.user.id).delete().then(function () {
                    // Write request for server to update memo set rating
                    db.collection('userRatingChange').add({
                      memoSetId: self.originalMemoSetId,
                      newRating: value,
                      oldRating: previousRating,
                      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                      userId: self.user.id
                    }).catch(function (error) {
                      logError('MemoSet_readMemoSet_3', error);
                    });
                  }).catch(function (error) {
                    logError('MemoSet_readMemoSet_4', error);
                  });
                }
              }
            });
          });
        }).catch(function (error) {
          logError('MemoSet_readMemoSet_5', error);
        });
      }
      // Listen to memo set header data
      this.detachMemoSetListener = db.collection('memoSets').doc(this.memoSetId).onSnapshot(function (doc) {
        // If memo set has been deleted
        if (doc.exists && doc.data().deleted) {
          // Redirect to Memo Sets page
          self.$router.push('/memo-sets');
        }
        if (!headerDataLoaded || !doc.metadata.hasPendingWrites) {
          if (doc.exists) {
            // NOTE - could maybe use https://stackoverflow.com/a/39333479 to copy multiple properties at once
            self.authorName = doc.data().authorName || null;
            self.createdAt = doc.data().createdAt;
            self.description = doc.data().description || _this51.text.memoSetDefaultDescription;
            self.descriptionPlaceholder = self.description === self.text.memoSetDefaultDescription;
            self.fields = doc.data().fields;
            self.learn.maxResponseTime = doc.data().maxResponseTime || '';
            self.learn.questionIds = doc.data().selectedQuestionIds || [];
            self.learn.reviewGroupIds = doc.data().selectedReviewGroupIds || [];
            self.options = doc.data().options;
            self.photos = doc.data().photos;
            self.questions = doc.data().questions;
            self.sharing = doc.data().sharing || {};
            self.sortQuestions();
            self.learn.useMaxResponseTime = !!self.learn.maxResponseTime;
            headerDataLoaded = true;
            if (rowsDataLoaded) self.memoSetLoaded();
          } else {
            // Redirect to Memo Sets page
            self.$router.push('/memo-sets');
          }
        }
      }, function (error) {
        logError('MemoSet_readMemoSet_6', error);
      });
      // Listen to memo set rows data
      if (this.memoSetType === 'regular') rowsRef = db.collection('memoSets/' + this.memoSetId + '/rows').where('userId', '==', this.user.id);
      if (this.memoSetType === 'public') rowsRef = db.collection('memoSets/' + this.memoSetId + '/rows').where('sharing.public', '==', true);
      if (this.memoSetType === 'shared') rowsRef = db.collection('memoSets/' + this.memoSetId + '/rows').where('sharing.' + this.user.id, '==', this.user.displayName);
      this.detachDataListener = rowsRef.onSnapshot(function (snapshot) {
        var pendingWrites = false;
        snapshot.docChanges().forEach(function (change) {
          if (change.doc.metadata.hasPendingWrites) {
            pendingWrites = true;
          }
        });
        if (!rowsDataLoaded || !pendingWrites) {
          self.rows = [];
          snapshot.forEach(function (doc) {
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(doc.data()).forEach(function (rowId) {
              // Ignore userId and sharing fields
              if (rowId !== 'userId' && rowId !== 'sharing') {
                self.rows.push({
                  data: doc.data()[rowId],
                  docId: doc.id,
                  rowId: rowId
                });
              }
            });
          });
          // Sort rows by seq
          self.rows.sort(function (a, b) {
            if (a.data.seq < b.data.seq) return -1;
            return 1;
          });
          rowsDataLoaded = true;
          if (headerDataLoaded) self.memoSetLoaded();
          self.initSearch();
        }
      }, function (error) {
        logError('MemoSet_readMemoSet_7', error);
      });
      // Read private alternatives
      this.detachPrivateListener = db.doc('memoSets/' + this.memoSetId + '/private/' + this.user.id).onSnapshot(function (doc) {
        self.privateAlternatives = doc.data();
        privateAlternativesLoaded = true;
        if (publicAlternativesLoaded) self.prepareAlternatives();
      }, function (error) {
        logError('MemoSet_readMemoSet_8', error);
      });
      // Read public alternatives
      this.detachPublicListener = db.collection('memoSets').doc(this.memoSetId).collection('public').onSnapshot(function (snapshot) {
        self.publicAlternatives = snapshot;
        publicAlternativesLoaded = true;
        if (privateAlternativesLoaded) self.prepareAlternatives();
      }, function (error) {
        logError('MemoSet_readMemoSet_9', error);
      });
    },
    rectangleHandleMouseDown: function rectangleHandleMouseDown(event, handle) {
      this.rectangleResizeStart(event, handle);
    },
    rectangleHandleTouchStart: function rectangleHandleTouchStart(event, handle) {
      // If this is the first touch
      if (event.touches.length === 1) {
        this.rectangleResizeStart(event.touches[0], handle);
        event.stopPropagation();
      }
    },
    rectangleResizeStart: function rectangleResizeStart(pointer, handle) {
      // Save before state for undo array
      this.summaryImage.before = {
        height: this.locationRect.height,
        left: this.locationRect.left,
        top: this.locationRect.top,
        width: this.locationRect.width
      };
      this.pointerPosX = pointer.clientX;
      this.pointerPosY = pointer.clientY;
      this.resizingRectangle = true;
      this.rectangleResizeHandle = handle;
      this.animateTransition = false;
    },
    rectangleMouseDown: function rectangleMouseDown(event) {
      if (this.mode === 'select' && !this.panLock) {
        this.rectanglePointerDown(event);
        // Prevent panning
        event.stopPropagation();
      }
    },
    rectanglePointerDown: function rectanglePointerDown(pointer) {
      // Save before state for undo array
      this.summaryImage.before = {
        left: this.locationRect.left,
        top: this.locationRect.top
      };
      this.activeObject = -1;
      this.rectangleActive = true;
      this.pointerPosX = pointer.clientX;
      this.pointerPosY = pointer.clientY;
      this.movingRectangle = true;
      this.animateTransition = false;
    },
    rectangleTouchStart: function rectangleTouchStart(event) {
      if (event.touches.length === 1) {
        if (this.mode === 'select' && !this.panLock) {
          this.summaryImage.firstTouchActiveObject = this.activeObject;
          this.summaryImage.firstTouchRectangleActive = this.rectangleActive;
          this.summaryImage.firstTouchTimestamp = event.timeStamp;
          this.rectanglePointerDown(event.touches[0]);
          // Prevent panning
          event.stopPropagation();
        }
      }
    },
    removeClippingPathUndoEntries: function removeClippingPathUndoEntries() {
      for (var i = this.summaryImage.undoArrayIndex - 1; i >= 0; i--) {
        if (this.summaryImage.undoArray[i].changeType === 'clippingPath') {
          this.summaryImage.undoArray.splice(i, 1);
          this.summaryImage.undoArrayIndex--;
        }
      }
    },

    removeColor: function removeColor() {
      var ctx = void 0,
          imgData = void 0,
          undoEntry = void 0;
      var mask = this.removeMask;
      ctx = this.editCanvas.getContext('2d');
      imgData = ctx.getImageData(0, 0, this.editCanvas.width, this.editCanvas.height);
      // Make pixels within the mask transparent
      for (var y = mask.bounds.minY; y <= mask.bounds.maxY; y++) {
        for (var x = mask.bounds.minX; x <= mask.bounds.maxX; x++) {
          if (mask.data[y * mask.width + x] === 0) continue;
          var k = (y * this.editCanvas.width + x) * 4;
          imgData.data[k] = 0;
          imgData.data[k + 1] = 0;
          imgData.data[k + 2] = 0;
          imgData.data[k + 3] = 0;
        }
      }
      ctx.putImageData(imgData, 0, 0);
      this.drawObjectCanvas();
      undoEntry = {
        after: {
          canvas: this.copyOfCanvas(document.getElementById('objectCanvas'))
        },
        before: {
          canvas: this.copyOfCanvas(this.summaryImage.before.canvas)
        },
        changeType: 'remove',
        objIndex: this.activeObject
      };
      if (this.summaryImage.before.url) {
        undoEntry.before.url = this.summaryImage.before.url;
        this.summaryImage.before = {};
      }
      this.addSummaryImageUndoEntry(undoEntry);
      this.removing = false;
    },
    removeColorClick: function removeColorClick() {
      var _this52 = this;

      var ctx = void 0,
          img = void 0;
      // Blur button
      document.getElementById('removeColorButton').blur();
      var obj = this.objects[this.activeObject];
      if (this.mode === 'clip') this.endClipMode();
      if (this.mode === 'draw') this.endDrawMode();
      if (this.mode === 'remove') {
        this.endRemoveMode();
      } else {
        // Save the object's URL
        this.summaryImage.before = {
          url: obj.url
          // Initialize editCanvas with the object image
        };img = new Image();
        img.crossOrigin = 'Anonymous';
        img.onload = function () {
          _this52.editCanvas = document.createElement('canvas');
          _this52.editCanvas.width = img.naturalWidth;
          _this52.editCanvas.height = img.naturalHeight;
          ctx = _this52.editCanvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          _this52.drawObjectCanvas();
          _this52.removeImageData = ctx.getImageData(0, 0, _this52.editCanvas.width, _this52.editCanvas.height);
          _this52.mode = 'remove';
          _this52.removing = false;
          _this52.panLock = false;
        };
        img.src = obj.url;
      }
    },
    removeDrawPath: function removeDrawPath() {
      var image = void 0;
      var canvas = document.getElementById('objectCanvas');
      var ctx = canvas.getContext('2d');
      // Draw image from master canvas
      this.drawObjectCanvas();
      // Use Magic Wand to create mask
      image = {
        data: this.removeImageData.data,
        width: canvas.width,
        height: canvas.height,
        bytes: 4
      };
      this.removeMask = MagicWand.floodFill(image, this.removeDownPoint.x, this.removeDownPoint.y, this.removeThreshold, null, true);
      this.removeContours = MagicWand.traceContours(this.removeMask);
      // Draw path
      ctx.lineWidth = this.editCanvas.width / this.objects[this.activeObject].width;
      ctx.beginPath();
      this.removeContours.forEach(function (contour) {
        ctx.moveTo(contour.points[0].x, contour.points[0].y);
        contour.points.forEach(function (point) {
          ctx.lineTo(point.x, point.y);
        });
      });
      ctx.strokeStyle = 'red';
      ctx.stroke();
      ctx.lineWidth = 1;
    },
    removePointerDown: function removePointerDown(pointer) {
      var ctx = void 0,
          pixel = void 0;
      // Save mouse position
      this.pointerPosX = pointer.clientX;
      this.pointerPosY = pointer.clientY;
      // Determine pointer down point on the canvas - rounded to integer coordinates
      this.removeDownPoint = this.getCanvasCoords(this.pointerPosX, this.pointerPosY);
      this.removeDownPoint.x = Math.round(this.removeDownPoint.x);
      this.removeDownPoint.y = Math.round(this.removeDownPoint.y);
      ctx = this.editCanvas.getContext('2d');
      pixel = ctx.getImageData(this.removeDownPoint.x, this.removeDownPoint.y, 1, 1);
      // If the point clicked is not transparent
      if (pixel.data[3]) {
        // Save intial canvas
        this.summaryImage.before.canvas = this.copyOfCanvas(this.editCanvas);
        this.removeThreshold = this.removeDefaultThreshold;
        this.removing = true;
        this.removeDrawPath();
      }
    },
    removePointerMove: function removePointerMove(pointer) {
      var deltaY = void 0;
      deltaY = pointer.clientY - this.pointerPosY;
      if (deltaY < 0) {
        deltaY /= 5;
      } else {
        deltaY /= 3;
      }
      this.removeThreshold = this.removeDefaultThreshold + deltaY;
      // Constrain threshold between 1 and 255
      this.removeThreshold = Math.max(Math.min(this.removeThreshold, 255), 1);
      this.removeDrawPath();
    },
    resetLearningClick: function resetLearningClick() {
      var textKey = void 0;
      // Prepare text key depending on plurality of questions and groups
      textKey = 'memoSetReset';
      if (this.learn.questionIds.length !== this.questions.length) {
        textKey += 'Question';
        if (this.learn.questionIds.length > 1) textKey += 's';
      }
      if (this.options.useReviewGroups && this.learn.reviewGroupIds.length !== this.reviewGroupsList.length) {
        textKey += 'Group';
        if (this.learn.reviewGroupIds.length > 1) textKey += 's';
      }
      this.resetLearningMessage = this.text[textKey];
      $('.ui.modal.resetLearning').modal({
        onApprove: this.resetLearningSubmit,
        onHidden: this.revertPreventBackHistory,
        onVisible: this.prepareModalHistory
      }).modal('show');
    },
    resetLearningSubmit: function resetLearningSubmit() {
      var _this53 = this;

      var firestoreUpdate = void 0,
          questionsToReset = void 0;
      firestoreUpdate = {};
      questionsToReset = this.activeQuestions.filter(function (question) {
        return question.reviewCycle || question.reviewAfter;
      });
      questionsToReset.forEach(function (question) {
        var row = _this53.rows[question.rowIndex];
        _this53.$delete(row.data.questions, question.questionId);
        // Update Firestore update object
        if (!firestoreUpdate[row.docId]) firestoreUpdate[row.docId] = {};
        firestoreUpdate[row.docId][row.rowId + '.questions.' + question.questionId] = firebase.firestore.FieldValue.delete();
      });
      // Update Firestore
      var batch = db.batch();
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(firestoreUpdate).forEach(function (docId) {
        batch.update(db.doc('memoSets/' + _this53.memoSetId + '/rows/' + docId), firestoreUpdate[docId]);
      });
      this.updateKnownData(batch, this.memoSetId);
      batch.commit().catch(function (error) {
        logError('MemoSet_resetLearningSubmit', error);
      });
      this.prepareActiveQuestions();
      this.setStatuses('slow');
    },
    resizeObject: function resizeObject(event) {
      // minObjectSize is the minimum size of the object, in screen pixels
      var minObjectSize = 40;
      // adjustX, adjustY, handlePosAfterResize, handlePosBeforeResize, rotatedAdjustX, rotatedAdjustY are relative to the photo
      // diagonalDistance, moveX, moveY, rotatedMoveX, rotatedMoveY, this.pointerPosX, this.pointerPosY are relative to the screen
      var adjustX = void 0,
          adjustY = void 0,
          angleInRadians = void 0,
          angleToHandleInRadians = void 0,
          aspect = void 0,
          diagonalDistance = void 0,
          fixedHandle = void 0,
          handlePosAfterResize = void 0,
          handlePosBeforeResize = void 0,
          moveX = void 0,
          moveY = void 0,
          obj = void 0,
          rotatedAdjustX = void 0,
          rotatedAdjustY = void 0,
          rotatedMoveX = void 0,
          rotatedMoveY = void 0;
      obj = this.objects[this.activeObject];
      moveX = event.clientX - this.pointerPosX;
      moveY = event.clientY - this.pointerPosY;
      // Rotate movement anticlockwise by the object's angle
      angleInRadians = obj.angle * Math.PI / 180;
      rotatedMoveX = moveX * Math.cos(angleInRadians) + moveY * Math.sin(angleInRadians);
      rotatedMoveY = -moveX * Math.sin(angleInRadians) + moveY * Math.cos(angleInRadians);
      adjustX = 0;
      adjustY = 0;
      // Determine a fixed handle based on which handle is dragged
      switch (this.objectResizeHandle) {
        case 'right middle':
        case 'right bottom':
        case 'center bottom':
          fixedHandle = 'left top';
          break;
        case 'left middle':
        case 'left top':
        case 'center top':
          fixedHandle = 'right bottom';
          break;
        case 'left bottom':
          fixedHandle = 'right top';
          break;
        case 'right top':
          fixedHandle = 'left bottom';
      }
      // Get position of fixed handle before resize
      handlePosBeforeResize = this.handlePosition(obj, fixedHandle);
      switch (this.objectResizeHandle) {
        case 'center top':
          obj.height -= rotatedMoveY / this.photoTransform.scale;
          // If the object is too short, adjust it
          if (obj.height < minObjectSize / this.photoTransform.scale) {
            adjustY = obj.height - minObjectSize / this.photoTransform.scale;
            obj.height = minObjectSize / this.photoTransform.scale;
          }
          break;
        case 'right middle':
          obj.width += rotatedMoveX / this.photoTransform.scale;
          // If the object is too narrow, adjust it
          if (obj.width < minObjectSize / this.photoTransform.scale) {
            adjustX = minObjectSize / this.photoTransform.scale - obj.width;
            obj.width = minObjectSize / this.photoTransform.scale;
          }
          break;
        case 'center bottom':
          obj.height += rotatedMoveY / this.photoTransform.scale;
          // If the object is too short, adjust it
          if (obj.height < minObjectSize / this.photoTransform.scale) {
            adjustY = minObjectSize / this.photoTransform.scale - obj.height;
            obj.height = minObjectSize / this.photoTransform.scale;
          }
          break;
        case 'left middle':
          obj.width -= rotatedMoveX / this.photoTransform.scale;
          // If the object is too narrow, adjust it
          if (obj.width < minObjectSize / this.photoTransform.scale) {
            adjustX = obj.width - minObjectSize / this.photoTransform.scale;
            obj.width = minObjectSize / this.photoTransform.scale;
          }
          break;
        case 'right top':
          // angleToHandleInRadians is the angle from the center of the object to the handle, measured clockwise from the y-axis
          angleToHandleInRadians = Math.atan(obj.width / obj.height);
          // Get component of movement along the direction from the center to the handle
          diagonalDistance = rotatedMoveX * Math.sin(angleToHandleInRadians) - rotatedMoveY * Math.cos(angleToHandleInRadians);
          obj.width += diagonalDistance * Math.sin(angleToHandleInRadians) / this.photoTransform.scale;
          obj.height += diagonalDistance * Math.cos(angleToHandleInRadians) / this.photoTransform.scale;
          // Adjust object if too small
          aspect = obj.width / obj.height;
          if (aspect < 1) {
            // If the object is too narrow, adjust it
            if (obj.width < minObjectSize / this.photoTransform.scale) {
              adjustX = minObjectSize / this.photoTransform.scale - obj.width;
              adjustY = -adjustX / aspect;
              obj.width = minObjectSize / this.photoTransform.scale;
              obj.height = obj.width / aspect;
            }
          } else {
            // If the object is too short, adjust it
            if (obj.height < minObjectSize / this.photoTransform.scale) {
              adjustY = obj.height - minObjectSize / this.photoTransform.scale;
              adjustX = -adjustY * aspect;
              obj.height = minObjectSize / this.photoTransform.scale;
              obj.width = obj.height * aspect;
            }
          }
          break;
        case 'right bottom':
          // angleToHandleInRadians is the angle from the center of the object to the handle, measured clockwise from the x-axis
          angleToHandleInRadians = Math.atan(obj.height / obj.width);
          // Get component of movement along the direction from the center to the handle
          diagonalDistance = rotatedMoveX * Math.cos(angleToHandleInRadians) + rotatedMoveY * Math.sin(angleToHandleInRadians);
          obj.width += diagonalDistance * Math.cos(angleToHandleInRadians) / this.photoTransform.scale;
          obj.height += diagonalDistance * Math.sin(angleToHandleInRadians) / this.photoTransform.scale;
          // Adjust object if too small
          aspect = obj.width / obj.height;
          if (aspect < 1) {
            // If the object is too narrow, adjust it
            if (obj.width < minObjectSize / this.photoTransform.scale) {
              adjustX = minObjectSize / this.photoTransform.scale - obj.width;
              adjustY = adjustX / aspect;
              obj.width = minObjectSize / this.photoTransform.scale;
              obj.height = obj.width / aspect;
            }
          } else {
            // If the object is too short, adjust it
            if (obj.height < minObjectSize / this.photoTransform.scale) {
              adjustY = minObjectSize / this.photoTransform.scale - obj.height;
              adjustX = adjustY * aspect;
              obj.height = minObjectSize / this.photoTransform.scale;
              obj.width = obj.height * aspect;
            }
          }
          break;
        case 'left bottom':
          // angleToHandleInRadians is the angle from the center of the object to the handle, measured clockwise from the negative y-axis
          angleToHandleInRadians = Math.atan(obj.width / obj.height);
          // Get component of movement along the direction from the center to the handle
          diagonalDistance = -rotatedMoveX * Math.sin(angleToHandleInRadians) + rotatedMoveY * Math.cos(angleToHandleInRadians);
          obj.width += diagonalDistance * Math.sin(angleToHandleInRadians) / this.photoTransform.scale;
          obj.height += diagonalDistance * Math.cos(angleToHandleInRadians) / this.photoTransform.scale;
          // Adjust object if too small
          aspect = obj.width / obj.height;
          if (aspect < 1) {
            // If the object is too narrow, adjust it
            if (obj.width < minObjectSize / this.photoTransform.scale) {
              adjustX = obj.width - minObjectSize / this.photoTransform.scale;
              adjustY = -adjustX / aspect;
              obj.width = minObjectSize / this.photoTransform.scale;
              obj.height = obj.width / aspect;
            }
          } else {
            // If the object is too short, adjust it
            if (obj.height < minObjectSize / this.photoTransform.scale) {
              adjustY = minObjectSize / this.photoTransform.scale - obj.height;
              adjustX = -adjustY * aspect;
              obj.height = minObjectSize / this.photoTransform.scale;
              obj.width = obj.height * aspect;
            }
          }
          break;
        case 'left top':
          // angleToHandleInRadians is the angle from the center of the object to the handle, measured clockwise from the negaive x-axis
          angleToHandleInRadians = Math.atan(obj.height / obj.width);
          // Get component of movement along the direction from the center to the handle
          diagonalDistance = -rotatedMoveX * Math.cos(angleToHandleInRadians) - rotatedMoveY * Math.sin(angleToHandleInRadians);
          obj.width += diagonalDistance * Math.cos(angleToHandleInRadians) / this.photoTransform.scale;
          obj.height += diagonalDistance * Math.sin(angleToHandleInRadians) / this.photoTransform.scale;
          // Adjust object if too small
          aspect = obj.width / obj.height;
          if (aspect < 1) {
            // If the object is too narrow, adjust it
            if (obj.width < minObjectSize / this.photoTransform.scale) {
              adjustX = obj.width - minObjectSize / this.photoTransform.scale;
              adjustY = adjustX / aspect;
              obj.width = minObjectSize / this.photoTransform.scale;
              obj.height = obj.width / aspect;
            }
          } else {
            // If the object is too short, adjust it
            if (obj.height < minObjectSize / this.photoTransform.scale) {
              adjustY = obj.height - minObjectSize / this.photoTransform.scale;
              adjustX = adjustY * aspect;
              obj.height = minObjectSize / this.photoTransform.scale;
              obj.width = obj.height * aspect;
            }
          }
          break;
      }
      handlePosAfterResize = this.handlePosition(obj, fixedHandle);
      // Adjust left and top to keep fixed handle in position
      obj.left += handlePosBeforeResize.x - handlePosAfterResize.x;
      obj.top += handlePosBeforeResize.y - handlePosAfterResize.y;
      // Rotate adjustments clockwise by the object's angle
      rotatedAdjustX = adjustX * Math.cos(angleInRadians) - adjustY * Math.sin(angleInRadians);
      rotatedAdjustY = adjustX * Math.sin(angleInRadians) + adjustY * Math.cos(angleInRadians);
      // Set mouse position ready for next mousemove, but adjust if attempting to make object too small
      this.pointerPosX = event.clientX + rotatedAdjustX * this.photoTransform.scale;
      this.pointerPosY = event.clientY + rotatedAdjustY * this.photoTransform.scale;
    },
    resizeRectangle: function resizeRectangle(event) {
      // minRectangleSize is the minimum size of the location rectangle, in screen pixels
      var minRectangleSize = 40;
      // adjustX, adjustY are relative to the photo
      // moveX, moveY, this.pointerPosX, this.pointerPosY are relative to the screen
      var adjustX = void 0,
          adjustY = void 0,
          moveX = void 0,
          moveY = void 0,
          previousValue = void 0;
      moveX = event.clientX - this.pointerPosX;
      moveY = event.clientY - this.pointerPosY;
      adjustX = 0;
      adjustY = 0;
      if (this.rectangleResizeHandle.indexOf('left') !== -1) {
        // Set previousValue to the rectangle's right position
        previousValue = this.locationRect.left + this.locationRect.width;
        this.locationRect.left += moveX / this.photoTransform.scale;
        this.locationRect.width -= moveX / this.photoTransform.scale;
        // If the rectangle is too narrow, adjust it
        if (this.locationRect.width < minRectangleSize / this.photoTransform.scale) {
          this.locationRect.width = minRectangleSize / this.photoTransform.scale;
          adjustX = previousValue - this.locationRect.width - this.locationRect.left;
          this.locationRect.left = previousValue - this.locationRect.width;
        }
      }
      if (this.rectangleResizeHandle.indexOf('top') !== -1) {
        // Set previousValue to the rectangle's bottom position
        previousValue = this.locationRect.top + this.locationRect.height;
        this.locationRect.top += moveY / this.photoTransform.scale;
        this.locationRect.height -= moveY / this.photoTransform.scale;
        // If the rectangle is too short, adjust it
        if (this.locationRect.height < minRectangleSize / this.photoTransform.scale) {
          this.locationRect.height = minRectangleSize / this.photoTransform.scale;
          adjustY = previousValue - this.locationRect.height - this.locationRect.top;
          this.locationRect.top = previousValue - this.locationRect.height;
        }
      }
      if (this.rectangleResizeHandle.indexOf('right') !== -1) {
        this.locationRect.width += moveX / this.photoTransform.scale;
        // If the rectangle is too narrow, adjust it
        if (this.locationRect.width < minRectangleSize / this.photoTransform.scale) {
          adjustX = minRectangleSize / this.photoTransform.scale - this.locationRect.width;
          this.locationRect.width = minRectangleSize / this.photoTransform.scale;
        }
      }
      if (this.rectangleResizeHandle.indexOf('bottom') !== -1) {
        this.locationRect.height += moveY / this.photoTransform.scale;
        // If the rectangle is too short, adjust it
        if (this.locationRect.height < minRectangleSize / this.photoTransform.scale) {
          adjustY = minRectangleSize / this.photoTransform.scale - this.locationRect.height;
          this.locationRect.height = minRectangleSize / this.photoTransform.scale;
        }
      }
      // Set pointer position ready for next move, but adjust if attempting to make rectangle too small
      this.pointerPosX = event.clientX + adjustX * this.photoTransform.scale;
      this.pointerPosY = event.clientY + adjustY * this.photoTransform.scale;
    },
    revertPreventBackHistory: function revertPreventBackHistory() {
      // Revert history if not already done
      if (window.history.state && window.history.state.preventBack) {
        window.history.back();
      }
    },
    revertTableWrapperScrollPos: function revertTableWrapperScrollPos() {
      var _this54 = this;

      this.$nextTick(function () {
        var tableWrapper = document.getElementById('tableWrapper');
        if (tableWrapper) {
          tableWrapper.scrollLeft = _this54.saveTableWrapperScrollLeft;
          tableWrapper.scrollTop = _this54.saveTableWrapperScrollTop;
        }
      });
    },
    reviewGroupBlur: function reviewGroupBlur(event, rowIndex) {
      var _this55 = this;

      var oldValue = void 0,
          selectedGroupNames = void 0,
          updateObj = void 0;
      var row = this.rows[rowIndex];
      var enteredValue = event.target.textContent.trim();
      var allGroupsSelected = this.learn.reviewGroupIds.length === this.reviewGroupsList.length;
      // If there was any previous value or a value has been entered
      if (row.data.reviewGroup !== undefined || enteredValue !== '') {
        if (enteredValue !== row.data.reviewGroup) {
          selectedGroupNames = this.learn.reviewGroupIds.map(function (groupId) {
            return _this55.reviewGroupsList[parseInt(groupId, 10)];
          });
          oldValue = row.data.reviewGroup || '';
          this.$set(row.data, 'reviewGroup', enteredValue);
          // If all groups were selected
          if (allGroupsSelected) {
            // Reset selected groups - all groups will be selected when the Learn tab is activated
            this.learn.reviewGroupIds = [];
          } else {
            // If the old group no longer exists
            if (!this.reviewGroupsList.includes(oldValue)) {
              // Remove old value from selected groups
              selectedGroupNames = selectedGroupNames.filter(function (groupName) {
                return groupName !== oldValue;
              });
            }
            this.learn.reviewGroupIds = selectedGroupNames.map(function (groupName) {
              return _this55.reviewGroupsList.indexOf(groupName).toString();
            });
          }
          // Update Firestore
          updateObj = {};
          updateObj[row.rowId + '.reviewGroup'] = row.data.reviewGroup;
          db.doc('memoSets/' + this.memoSetId + '/rows/' + row.docId).update(updateObj).catch(function (error) {
            logError('MemoSet_reviewGroupBlur', error);
          });
          this.initSearch();
        }
      }
      // Update reviewGroup element to remove any pasted HTML formatting
      event.target.textContent = row.data.reviewGroup;
    },
    rotateObject: function rotateObject(event) {
      var centerX = void 0,
          centerY = void 0,
          img = void 0;
      img = document.querySelector('.objectActive');
      centerX = (img.getBoundingClientRect().left + img.getBoundingClientRect().right) / 2;
      centerY = (img.getBoundingClientRect().top + img.getBoundingClientRect().bottom) / 2;
      // Calculate angle in degrees between vertical and line from center of object to mouse position
      this.objects[this.activeObject].angle = Math.atan((event.clientX - centerX) / (centerY - event.clientY)) * 180 / Math.PI;
      // Add 180 degrees if mouse position is below center of object
      if (event.clientY > centerY) {
        this.objects[this.activeObject].angle += 180;
      }
    },
    rowFieldBlur: function rowFieldBlur(event, fieldId, rowIndex) {
      var updateObj = void 0,
          valueAdded = void 0,
          valueDeleted = void 0;
      var row = this.rows[rowIndex];
      var enteredValue = this.sanitize(event.target.innerHTML);
      var previousValue = row.data[fieldId] === undefined ? '' : row.data[fieldId];
      if (enteredValue !== '' || previousValue !== '') {
        if (enteredValue !== previousValue) {
          var batch = db.batch();
          updateObj = {};
          valueAdded = previousValue === '';
          valueDeleted = enteredValue === '';
          if (valueDeleted) {
            this.$delete(row.data, fieldId);
            updateObj[row.rowId + '.' + fieldId] = firebase.firestore.FieldValue.delete();
            // Delete row questions using the field
            if (this.checkRowQuestions(rowIndex)) {
              updateObj[row.rowId + '.questions'] = row.data.questions;
            }
          } else {
            this.$set(row.data, fieldId, enteredValue);
            updateObj[row.rowId + '.' + fieldId] = row.data[fieldId];
          }
          // Update Firestore
          batch.update(db.doc('memoSets/' + this.memoSetId + '/rows/' + row.docId), updateObj);
          // If value has been added or deleted, update known data
          if (valueAdded || valueDeleted) {
            this.updateKnownData(batch, this.memoSetId);
          }
          batch.commit().catch(function (error) {
            logError('MemoSet_rowFieldBlur', error);
          });
          this.initSearch();
        }
        // Apply Mathjax if required
        var hasMath = /\$.*\$/.test(this.rows[rowIndex].data[fieldId]);
        if (hasMath) {
          this.$nextTick(function () {
            if (window.MathJax) {
              window.MathJax.typeset([event.target]);
            }
          });
        }
      }
      // Update element to remove any pasted HTML formatting or trailing whitespace
      event.target.innerHTML = enteredValue;
      // Reset currentFieldId and currentRow to hide the toolbar
      this.currentFieldId = '';
      this.currentRow = -1;
      // Reset editingCell flag
      this.editingCell = false;
    },
    rowFieldEnter: function rowFieldEnter(event, fieldId, rowIndex) {
      // If Shift or Ctrl is pressed, and field is not Review Group
      if ((event.ctrlKey || event.shiftKey) && fieldId !== 'reviewGroup') {
        // Add a <br> tag if Ctrl is pressed (the default action adds it if Shift is pressed)
        if (event.ctrlKey) {
          // Need to use 2 <br> tags if the cursor is at the end and the field does not already end in <br>
          if (isCaretAtEnd() && event.target.innerHTML.slice(-4) !== '<br>' && event.target.innerHTML.slice(-6) !== '<br />') {
            pasteHtmlAtCaret('<br><br>');
          } else {
            pasteHtmlAtCaret('<br>');
          }
        }
      } else {
        event.preventDefault();
        // If the next row's cell is blank
        if (rowIndex !== this.rows.length - 1 && !this.rows[rowIndex + 1].data[fieldId]) {
          // If we're on the last visible row, move down
          if (rowIndex === this.firstVisibleRow + this.visibleRowsCount - 2) {
            this.firstVisibleRow++;
            this.goToRowVal = this.firstVisibleRow.toString();
          }
          // Focus on the next value
          this.$nextTick(function () {
            var nextCell = document.getElementById(fieldId + '_' + (rowIndex + 1));
            nextCell.focus();
            moveCursorToEndOfContentEditable(nextCell);
          });
        } else {
          // Blur cell
          event.target.blur();
          this.currentFieldId = '';
          this.currentRow = -1;
        }
      }
    },
    rowFieldFocus: function rowFieldFocus(event, fieldId, rowIndex) {
      this.currentFieldId = fieldId;
      this.currentRow = rowIndex;
      this.lastFieldId = fieldId;
      // Refresh value for Mathjaxed cells
      if (this.rows[rowIndex].data[fieldId] && event.target.innerHTML !== this.rows[rowIndex].data[fieldId]) {
        event.target.innerHTML = this.rows[rowIndex].data[fieldId];
        // If the user has clicked on a MathJax element, move cursor position to the end
        // Notes: window.getSelection().rangeCount is occasionally 0 - see https://stackoverflow.com/q/22935320
        // If the rangeCount is 1, window.getSelection().getRangeAt(0).startOffset is the caret position
        // For some reason, if the user clicks on the row number, then a MathJax element, startOffset is 3, so move the cursor to the end in that case too
        if (!window.getSelection().rangeCount || !window.getSelection().getRangeAt(0).startOffset || window.getSelection().getRangeAt(0).startOffset === 3) {
          moveCursorToEndOfContentEditable(event.target);
        }
      }
    },
    rowFieldPaste: function rowFieldPaste(event, source, fieldIndex, rowIndex) {
      var cells = void 0,
          columnsAvailable = void 0,
          columnsPasted = void 0,
          pasteLines = void 0,
          pasteText = void 0;
      pasteText = event.clipboardData.getData('text');
      // If multiple cells have been pasted
      if (pasteText.indexOf('\n') !== -1 || pasteText.indexOf('\t') !== -1) {
        // Prevent default paste operation
        event.preventDefault();
        // Determine equivalent fieldIndex for Group and Notes columns
        if (source === 'group') {
          fieldIndex = this.fields.length;
        }
        if (source === 'notes') {
          fieldIndex = this.fields.length;
          if (this.options.useReviewGroups) fieldIndex++;
        }
        // Determine columns available for pasting
        columnsAvailable = this.fields.length - fieldIndex;
        // Add one for Group column if used
        if (this.options.useReviewGroups) columnsAvailable++;
        // Add one for Notes column if no Background Photo, Summary Image columns
        if (!this.options.useBackgroundPhotos && !this.options.useSummaryImages) columnsAvailable++;
        // Split pasted text by line
        if (pasteText.indexOf('\r\n') !== -1) {
          pasteLines = pasteText.split('\r\n');
        } else {
          pasteLines = pasteText.split('\n');
        }
        // Ignore blank last line
        if (pasteLines[pasteLines.length - 1] === '') {
          pasteLines.length--;
        }
        // Determine number of columns pasted
        this.pasteCells.pasteData = [];
        columnsPasted = 0;
        // Loop through pasted lines
        for (var i = 0; i < pasteLines.length; i++) {
          cells = pasteLines[i].split('\t');
          // Handle images copied from Systems module
          cells = this.convertSystemImages(cells);
          cells = cells.map(function (cell) {
            // Remove initial and final quotes, if present (spreadsheets add quotes with multi)
            if (cell.substring(0, 1) === '"' && cell.slice(-1) === '"') {
              cell = cell.slice(1, -1);
            }
            // Replace any remaining line breaks with <br> tags
            return cell.replace(/\n/g, '<br>');
          });
          if (cells.length > columnsPasted) {
            columnsPasted = cells.length;
          }
          this.pasteCells.pasteData.push(cells);
        }
        this.pasteCells.columns = Math.min(columnsPasted, columnsAvailable);
        this.pasteCells.rows = pasteLines.length;
        // Blur field pasted into
        event.target.blur();
        this.pasteCells.fieldIndex = fieldIndex;
        this.pasteCells.rowIndex = rowIndex;
        // Show paste confirmation modal
        $('.ui.modal.rowFieldPasteConfirm').modal({
          onApprove: this.rowFieldPasteSubmit
        }).modal('show');
      }
    },
    rowFieldPasteSubmit: function rowFieldPasteSubmit() {
      var _this56 = this;

      var fieldId = void 0,
          firestoreNewDocs = void 0,
          firestoreUpdateDocs = void 0,
          firestoreValue = void 0,
          rowsAdded = void 0,
          rowsAvailable = void 0,
          valueDeleted = void 0;
      var batch = db.batch();
      // Add rows at the bottom if required
      rowsAvailable = this.rows.length - this.pasteCells.rowIndex;
      if (this.pasteCells.rows > rowsAvailable) {
        this.addRows.addBelowRow = this.rows.length.toString();
        this.addRows.numberOfRows = this.pasteCells.rows - rowsAvailable;
        // Add rows without updating Firestore
        this.addRowsAddRows(false);
        rowsAdded = true;
        // For convenience
        firestoreNewDocs = this.addRows.firestoreNewDocs;
        firestoreUpdateDocs = this.addRows.firestoreUpdateDocs;
      } else {
        // No rows to add
        firestoreNewDocs = {};
        firestoreUpdateDocs = {};
      }
      for (var i = 0; i < this.pasteCells.rows; i++) {
        var row = this.rows[this.pasteCells.rowIndex + i];
        for (var j = 0; j < this.pasteCells.columns; j++) {
          if (this.pasteCells.fieldIndex + j < this.fields.length) {
            fieldId = this.fields[this.pasteCells.fieldIndex + j].fieldId;
          } else {
            if (this.pasteCells.fieldIndex + j === this.fields.length && this.options.useReviewGroups) {
              fieldId = 'reviewGroup';
            } else {
              fieldId = 'notes';
            }
          }
          var cellValue = this.sanitize(this.pasteCells.pasteData[i][j]);
          var previousValue = row.data[fieldId] === undefined ? '' : row.data[fieldId];
          if (cellValue !== previousValue) {
            valueDeleted = cellValue === '';
            if (valueDeleted) {
              this.$delete(row.data, fieldId);
              firestoreValue = firebase.firestore.FieldValue.delete();
            } else {
              this.$set(row.data, fieldId, cellValue);
              firestoreValue = cellValue;
            }
            // Update Firestore object
            if (firestoreNewDocs[row.docId]) {
              firestoreNewDocs[row.docId][row.rowId][fieldId] = firestoreValue;
            } else {
              if (!firestoreUpdateDocs[row.docId]) firestoreUpdateDocs[row.docId] = {};
              firestoreUpdateDocs[row.docId][row.rowId + '.' + fieldId] = firestoreValue;
            }
          }
        }
        // Delete any row questions with missing field values
        if (this.checkRowQuestions(this.pasteCells.rowIndex + i)) {
          // Apply questions data to firestoreNewDocs or firestoreUpdateDocs
          if (firestoreNewDocs[row.docId]) {
            firestoreNewDocs[row.docId][row.rowId + '.questions'] = row.data.questions;
          } else {
            if (!firestoreUpdateDocs[row.docId]) firestoreUpdateDocs[row.docId] = {};
            firestoreUpdateDocs[row.docId][row.rowId + '.questions'] = row.data.questions;
          }
        }
      }
      // Write new docs
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(firestoreNewDocs).forEach(function (docId) {
        batch.set(db.doc('memoSets/' + _this56.memoSetId + '/rows/' + docId), firestoreNewDocs[docId]);
      });
      // Write update docs
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(firestoreUpdateDocs).forEach(function (docId) {
        batch.update(db.doc('memoSets/' + _this56.memoSetId + '/rows/' + docId), firestoreUpdateDocs[docId]);
      });
      if (rowsAdded) {
        this.writeRowCount(batch);
      }
      this.updateKnownData(batch, this.memoSetId);
      batch.commit().catch(function (error) {
        logError('MemoSet_rowFieldPasteSubmit', error);
      });
      // Apply Mathjax to pasted data
      this.applyMathjax();
      // Update search data
      this.initSearch();
    },
    rowHasData: function rowHasData(row, fromFieldId, toFieldId) {
      // Return boolean indicating whether the row has data for the fieldIds provided
      var rowHasData = true;
      if (fromFieldId === 's') {
        if (!row.data.photoId && (!row.data.objects || !row.data.objects.length)) rowHasData = false;
      } else {
        if (!row.data[fromFieldId] || !row.data[fromFieldId].replace(/<br ?\/?>/g, '')) rowHasData = false;
      }
      if (toFieldId === 's') {
        if (!row.data.photoId && (!row.data.objects || !row.data.objects.length)) rowHasData = false;
      } else {
        if (!row.data[toFieldId] || !row.data[toFieldId].replace(/<br ?\/?>/g, '')) rowHasData = false;
      }
      return rowHasData;
    },
    sanitize: function sanitize(html) {
      if (!html) return '';
      // Return cached value if present
      if (this.cachedSanitize[html]) return this.cachedSanitize[html];
      var sanitizedHtml = void 0;
      sanitizedHtml = this.$sanitize(html, {
        allowedAttributes: {
          audio: ['id', 'src'],
          button: ['class', 'contenteditable', 'id'],
          i: ['class'],
          img: ['class', 'src']
        },
        allowedTags: ['audio', 'b', 'br', 'button', 'div', 'i', 'img', 'strong'],
        allowedSchemesByTag: {
          img: ['data', 'http', 'https']
        }
      });
      // Remove empty divs
      sanitizedHtml = sanitizedHtml.replace(/<div><\/div>/g, '');
      // Remove trailing <br> or <br /> tags
      sanitizedHtml = sanitizedHtml.replace(/<br \/>/g, '<br>').replace(/(<br>\s*)+$/, '');
      // Remove trailing whitespace
      sanitizedHtml = sanitizedHtml.replace(/\s+$/, '');
      // Enable audio play buttons
      sanitizedHtml = this.enableAudio(sanitizedHtml);
      this.cachedSanitize[html] = sanitizedHtml;
      return sanitizedHtml;
    },
    sanitizeWithStyle: function sanitizeWithStyle(html) {
      // Return cached value if present
      if (this.cachedSanitizeWithStyle[html]) return this.cachedSanitizeWithStyle[html];
      var sanitizedHtml = void 0;
      if (!html) return '';
      sanitizedHtml = this.$sanitize(html, {
        allowedAttributes: {
          audio: ['autoplay', 'id', 'src'],
          button: ['class', 'contenteditable', 'id'],
          div: ['class', 'style'],
          i: ['class'],
          img: ['class', 'src'],
          span: ['class', 'style']
        },
        allowedTags: ['audio', 'b', 'br', 'button', 'div', 'i', 'img', 'span', 'strong'],
        allowedSchemesByTag: {
          img: ['data', 'http', 'https']
        }
      });
      // Remove empty divs
      sanitizedHtml = sanitizedHtml.replace(/<div><\/div>/g, '');
      // Remove trailing <br> or <br /> tags
      sanitizedHtml = sanitizedHtml.replace(/<br \/>/g, '<br>').replace(/(<br>\s*)+$/, '');
      // Remove trailing whitespace
      sanitizedHtml = sanitizedHtml.replace(/\s+$/, '');
      // Enable audio play buttons
      sanitizedHtml = this.enableAudio(sanitizedHtml);
      this.cachedSanitizeWithStyle[html] = sanitizedHtml;
      return sanitizedHtml;
    },
    saveLearnOptions: function saveLearnOptions() {
      db.doc('memoSets/' + this.memoSetId).update({
        maxResponseTime: this.learn.maxResponseTime,
        selectedQuestionIds: this.learn.questionIds,
        selectedReviewGroupIds: this.learn.reviewGroupIds
      }).catch(function (error) {
        logError('MemoSet_saveLearnOptions', error);
      });
    },
    saveTableWrapperScrollPos: function saveTableWrapperScrollPos() {
      var tableWrapper = document.getElementById('tableWrapper');
      if (tableWrapper) {
        this.saveTableWrapperScrollLeft = tableWrapper.scrollLeft;
        this.saveTableWrapperScrollTop = tableWrapper.scrollTop;
      }
    },
    scrollToTopLeft: function scrollToTopLeft() {
      var tableWrapper = document.getElementById('tableWrapper');
      tableWrapper.scrollLeft = 0;
      tableWrapper.scrollTop = 0;
    },
    selectAllQuestions: function selectAllQuestions(select) {
      var checkboxAction = select ? 'set checked' : 'set unchecked';
      this.questions.forEach(function (question) {
        $('#learnQuestion_' + question.questionId).checkbox(checkboxAction);
      });
      this.setSelectedQuestions();
    },
    selectAllReviewGroups: function selectAllReviewGroups(select) {
      var checkboxAction = select ? 'set checked' : 'set unchecked';
      this.reviewGroupsList.forEach(function (reviewGroup, reviewGroupIndex) {
        $('#learnReviewGroup_' + reviewGroupIndex).checkbox(checkboxAction);
      });
      this.setSelectedReviewGroups();
    },
    sendToBackClick: function sendToBackClick(event) {
      var obj = void 0,
          undoEntry = void 0;
      // Blur button
      event.target.blur();
      if (this.mode === 'clip') this.endClipMode();
      if (this.mode === 'draw') this.endDrawMode();
      if (this.mode === 'remove') this.endRemoveMode();
      // Prepare undo entry
      obj = this.objects[this.activeObject];
      undoEntry = {
        before: { sequence: this.activeObject },
        changeType: 'send to back'
      };
      this.addSummaryImageUndoEntry(undoEntry);
      // Move active object to bottom
      obj = this.objects.splice(this.activeObject, 1)[0];
      this.objects.unshift(obj);
      this.activeObject = -1;
      this.setLocationZIndex();
    },
    setActiveObjectOverlap: function setActiveObjectOverlap() {
      var _this57 = this;

      // Allow time for DOM to render
      this.$nextTick(function () {
        var obj1 = void 0,
            objRect1 = void 0,
            objRect2 = void 0;
        obj1 = document.getElementById('summaryImageObj_' + _this57.activeObject);
        if (obj1) {
          objRect1 = document.getElementById('summaryImageObj_' + _this57.activeObject).getBoundingClientRect();
          // Return true if any other objects overlap the active object
          _this57.activeObjectOverlap = _this57.objects.some(function (obj, objIndex) {
            objRect2 = document.getElementById('summaryImageObj_' + objIndex).getBoundingClientRect();
            return objIndex !== _this57.activeObject && !(objRect2.right < objRect1.left || objRect2.left > objRect1.right || objRect2.bottom < objRect1.top || objRect2.top > objRect1.bottom);
          });
        }
      });
    },
    setCongratsMessage: function setCongratsMessage() {
      var textKey = void 0;
      // Prepare text key based on plurality of questions and groups
      textKey = 'memoSetCongrats';
      if (this.learn.questionIds.length !== this.questions.length) {
        textKey += 'Question';
        if (this.learn.questionIds.length > 1) textKey += 's';
      }
      if (this.options.useReviewGroups && this.learn.reviewGroupIds.length !== this.reviewGroupsList.length) {
        textKey += 'Group';
        if (this.learn.reviewGroupIds.length > 1) textKey += 's';
      }
      this.learn.congratsMessage = this.text[textKey];
    },
    setCoverImageFileChange: function setCoverImageFileChange(file) {
      if (file) {
        // Check that file is an image
        if (file.type.substring(0, 6) === 'image/') {
          // Show image in the modal
          this.setCoverImage.url = window.URL.createObjectURL(file);
          this.setCoverImage.file = file;
        } else {
          this.initSetCoverImage();
          alert('Please select an image file.');
        }
      }
    },
    setCoverImagePhotoClick: function setCoverImagePhotoClick(photoIndex) {
      this.setCoverImage.url = this.photos[photoIndex].url;
    },
    setDataHeight: function setDataHeight() {
      if (this.walkThrough.steps[this.walkThrough.stepNum].summary) {
        this.dataHeight = 0;
      } else {
        this.dataHeight = document.getElementById('walkThroughData').offsetHeight;
      }
    },
    setHideTopElements: function setHideTopElements() {
      var _this58 = this;

      if (this.activeTab !== 'data') return;
      // Delay updating hideTopElements to handle case where user clicks from one cell to another
      if (this.timeouts.hideTopElements) {
        clearTimeout(this.timeouts.hideTopElements);
        this.timeouts.hideTopElements = null;
      }
      this.timeouts.hideTopElements = setTimeout(function () {
        _this58.timeouts.hideTopElements = null;
        var prevHideTopElements = _this58.hideTopElements;
        _this58.hideTopElements = _this58.window.height < 400 && _this58.currentRow !== -1;
        // Refresh table height if hideTopElements has changed
        if (_this58.hideTopElements !== prevHideTopElements) {
          _this58.setTableWrapperHeight();
        }
        // Scroll down to make active cell visible on mobile
        if (_this58.currentFieldId && _this58.currentRow !== -1) {
          _this58.$nextTick(function () {
            if (document.getElementById('tableWrapper')) {
              document.getElementById('tableWrapper').scrollTop -= 70;
            }
          });
        }
      }, 400);
    },
    setImageDataUrlForBlob: function setImageDataUrlForBlob(blob) {
      var _this59 = this;

      // NOTE: THIS FUNCTION IS NOT CURRENTLY USED, BUT IT CONTAINS THE CODE REQUIRED TO CONVERT A BLOB/FILE IMAGE INTO A DATA URL.
      var blobUrl = void 0,
          img = void 0;
      blobUrl = window.URL.createObjectURL(blob);
      // Convert the image being added (which uses a blob URL) to a data URL via canvas
      img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = function () {
        var canvas = void 0,
            ctx = void 0,
            scaleFactor = void 0;
        canvas = document.createElement('canvas');
        // Scale image down if required
        scaleFactor = Math.min(maxImageSize / img.naturalWidth, maxImageSize / img.naturalHeight, 1);
        canvas.height = img.naturalHeight * scaleFactor;
        canvas.width = img.naturalWidth * scaleFactor;
        ctx = canvas.getContext('2d');
        // Fill with white in case of transparent images
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        _this59.addImage.url = canvas.toDataURL('image/jpeg');
        // Revoke the blob URL
        window.URL.revokeObjectURL(blobUrl);
      };
      img.src = blobUrl;
    },
    setInfoWrapperHeight: function setInfoWrapperHeight() {
      var _this60 = this;

      this.$nextTick(function () {
        var height = void 0;
        height = _this60.window.height - 155;
        // Increase height slightly if mobile
        if (_this60.mobile) height += 17;
        // Ensure table height is not negative
        if (height < 0) height = 0;
        _this60.infoWrapperMaxHeight = height;
      });
    },
    setLearnWrapperHeights: function setLearnWrapperHeights() {
      var _this61 = this;

      this.$nextTick(function () {
        var questionsHeight = void 0,
            reviewGroupsHeight = void 0,
            totalHeight = void 0;
        totalHeight = _this61.window.height - 320;
        // Reduce height slightly if mobile
        if (_this61.mobile) totalHeight -= 40;
        // Ensure total height is not negative
        if (totalHeight < 0) totalHeight = 0;
        if (_this61.mobile) {
          questionsHeight = totalHeight;
          // If using review groups
          if (_this61.options.useReviewGroups) {
            // Allocate height between questions and review groups
            questionsHeight = totalHeight * (_this61.questions.length / (_this61.questions.length + _this61.reviewGroupsList.length));
            if (questionsHeight < totalHeight * 0.35) questionsHeight = totalHeight * 0.35;
            if (questionsHeight > totalHeight * 0.65) questionsHeight = totalHeight * 0.65;
            questionsHeight = Math.round(questionsHeight);
          }
          reviewGroupsHeight = totalHeight - questionsHeight;
        } else {
          questionsHeight = totalHeight;
          reviewGroupsHeight = totalHeight;
        }
        _this61.learnWrapperMaxHeights = [questionsHeight, reviewGroupsHeight];
      });
    },
    setLocationZIndex: function setLocationZIndex() {
      var _this62 = this;

      // Wait for objects and location to render, then trigger locationZIndex computed function
      this.$nextTick(function () {
        _this62.locationZIndexTrigger++;
      });
    },
    setPageTitle: function setPageTitle() {
      document.title = this.title + ' - MemQ';
    },
    setQuestionsWrapperHeight: function setQuestionsWrapperHeight() {
      var _this63 = this;

      this.$nextTick(function () {
        var height = void 0;
        height = _this63.window.height - 230;
        // Increase height slightly if mobile
        if (_this63.mobile) height += 17;
        // Ensure table height is not negative
        if (height < 0) height = 0;
        _this63.questionsWrapperMaxHeight = height;
      });
    },
    setSelectedQuestions: function setSelectedQuestions() {
      var _this64 = this;

      this.learn.questionIds = [];
      this.questions.forEach(function (question) {
        if ($('#learnQuestion_' + question.questionId).checkbox('is checked')) {
          _this64.learn.questionIds.push(question.questionId);
        }
      });
      this.prepareActiveQuestions();
      this.setStatuses('fast');
      this.learn.saveOptions = true;
    },
    setSelectedReviewGroups: function setSelectedReviewGroups() {
      var _this65 = this;

      this.learn.reviewGroupIds = [];
      this.reviewGroupsList.forEach(function (reviewGroup, reviewGroupIndex) {
        if ($('#learnReviewGroup_' + reviewGroupIndex).checkbox('is checked')) {
          _this65.learn.reviewGroupIds.push(reviewGroupIndex.toString());
        }
      });
      this.prepareActiveQuestions();
      this.setStatuses('fast');
      this.learn.saveOptions = true;
    },
    setStatuses: function setStatuses(speed) {
      var due = void 0,
          known = void 0,
          unknown = void 0;
      var now = Date.now();
      known = this.activeQuestions.filter(function (question) {
        return question.reviewCycle && question.reviewAfter > now;
      }).length;
      due = this.activeQuestions.filter(function (question) {
        return question.reviewCycle && question.reviewAfter <= now;
      }).length;
      unknown = this.activeQuestions.filter(function (question) {
        return !question.reviewCycle;
      }).length;
      this.statuses = {
        due: due,
        known: known,
        unknown: unknown,
        speed: speed
      };
    },
    setTableWrapperHeight: function setTableWrapperHeight() {
      var _this66 = this;

      this.$nextTick(function () {
        var height = void 0,
            tableTop = void 0;
        var tableWrapper = document.getElementById('tableWrapper');
        if (tableWrapper) {
          tableTop = tableWrapper.getBoundingClientRect().top;
          height = _this66.window.height - tableTop - 4;
          // Reduce height slightly if not mobile
          if (!_this66.mobile) height -= 12;
          // Ensure table height is not negative
          if (height < 0) height = 0;
          _this66.tableWrapperMaxHeight = height;
        }
      });
    },
    setTableWrapperScrollLeft: function setTableWrapperScrollLeft() {
      if (document.getElementById('tableWrapper')) {
        this.tableWrapperScrollLeft = document.getElementById('tableWrapper').scrollLeft;
      }
    },
    shareMemoSetClick: function shareMemoSetClick() {
      document.getElementById('shareMemoSetButton').blur();
      // Reset form fields
      this.share.public = false;
      $('#sharePublic').checkbox('uncheck');
      this.share.specific = false;
      $('#shareSpecific').checkbox('uncheck');
      this.share.username = '';
      this.share.noUser = false;
      this.share.shareSelf = false;
      this.share.showPublicCheckbox = !this.sharing.public;
      // Show modal
      $('.ui.modal.shareMemoSet').modal({
        onApprove: this.shareMemoSetSubmit
      }).modal('show');
    },
    shareMemoSetEnter: function shareMemoSetEnter() {
      // Exit if form is incomplete
      if (!(this.share.showPublicCheckbox && this.share.public) && !(this.share.specific && this.share.username)) return;
      // Submit form
      this.shareMemoSetSubmit();
    },
    shareMemoSetSpecificClick: function shareMemoSetSpecificClick() {
      this.share.specific = !this.share.specific;
      if (!this.share.specific) {
        this.share.username = '';
      }
    },
    shareMemoSetSubmit: function shareMemoSetSubmit() {
      var _this67 = this;

      var self = this;
      var removeGetUserListener = void 0,
          shareUserId = void 0;
      if (this.share.specific && this.share.username) {
        // Write a request to get user details
        db.collection('getUser').add({
          searchFor: this.share.username,
          timestamp: firebase.firestore.FieldValue.serverTimestamp(),
          userId: this.user.id
        }).then(function (docRef) {
          // Listen for the results
          removeGetUserListener = docRef.onSnapshot(function (doc) {
            if (doc.exists && doc.data().done) {
              // Remove the listener
              removeGetUserListener();
              // Delete the getUser document
              docRef.delete();
              self.share.checkingUser = false;
              shareUserId = doc.data().returnUserId;
              if (shareUserId) {
                if (shareUserId === _this67.user.id) {
                  self.share.shareSelf = true;
                } else {
                  var batch = db.batch();
                  self.$set(self.sharing, shareUserId, doc.data().returnDisplayName);
                  self.writeSharedSummary(batch, shareUserId);
                  if (_this67.share.showPublicCheckbox && _this67.share.public) {
                    _this67.$set(_this67.sharing, 'public', true);
                    _this67.writeSharedSummary(batch, 'public');
                  }
                  // Update sharing on memoSets document
                  batch.update(db.doc('memoSets/' + _this67.memoSetId), {
                    sharing: _this67.sharing
                  });
                  // Update sharing on rows documents
                  var uniqueDocIds = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(_this67.rows.map(function (row) {
                    return row.docId;
                  }))));
                  uniqueDocIds.forEach(function (docId) {
                    batch.update(db.doc('memoSets/' + _this67.memoSetId + '/rows/' + docId), {
                      sharing: _this67.sharing
                    });
                  });
                  batch.commit().catch(function (error) {
                    logError('MemoSet_shareMemoSetSubmit_1', error);
                  });
                  // Hide modal
                  $('.ui.modal.shareMemoSet').modal('hide');
                }
              } else {
                self.share.noUser = true;
              }
            }
          });
        }).catch(function (error) {
          logError('MemoSet_shareMemoSetSubmit_2', error);
        });
        // Set flag to indicate that we're waiting
        this.share.checkingUser = true;
        // Return false to prevent the modal from automatically closing
        // The modal is closed manually above once we have received the getUser response
        return false;
      } else {
        if (this.share.showPublicCheckbox && this.share.public) {
          var batch = db.batch();
          this.$set(this.sharing, 'public', true);
          this.writeSharedSummary(batch, 'public');
          // Update sharing on memoSets document
          batch.update(db.doc('memoSets/' + this.memoSetId), {
            sharing: this.sharing
          });
          // Update sharing on rows documents
          var uniqueDocIds = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(this.rows.map(function (row) {
            return row.docId;
          }))));
          uniqueDocIds.forEach(function (docId) {
            batch.update(db.doc('memoSets/' + _this67.memoSetId + '/rows/' + docId), {
              sharing: _this67.sharing
            });
          });
          batch.commit().catch(function (error) {
            logError('MemoSet_shareMemoSetSubmit_3', error);
          });
        }
      }
      // Hide modal manually - needed when the user pressed Enter to submit
      $('.ui.modal.shareMemoSet').modal('hide');
    },
    shareMemoSetUsernameFocus: function shareMemoSetUsernameFocus() {
      $('#shareSpecific').checkbox('check');
      this.share.specific = true;
    },
    showAnswerClick: function showAnswerClick() {
      var row = void 0,
          rowQuestion = void 0;
      this.learn.answerVisible = true;
      this.learn.responseTime = Date.now() - this.learn.timestamp;
      this.learn.reviewItem.answerHtml = this.learn.reviewItem.answerHtml.replace('<audio', '<audio autoplay');
      if (this.learn.maxResponseTime && this.learn.responseTime > parseFloat(this.learn.maxResponseTime.replace(',', '.')) * 1000) {
        this.learn.tooSlow = true;
        this.learn.previousReviewItem = null;
      } else {
        this.learn.tooSlow = false;
        this.learn.previousReviewItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.learn.reviewItem);
        row = this.rows[this.learn.reviewItem.rowIndex];
        this.learn.previousReviewAfter = 0;
        this.learn.previousReviewCycle = 0;
        if (row.data.questions && row.data.questions[this.learn.reviewItem.questionId]) {
          rowQuestion = row.data.questions[this.learn.reviewItem.questionId];
          this.learn.previousReviewAfter = rowQuestion.reviewAfter;
          this.learn.previousReviewCycle = rowQuestion.reviewCycle;
        }
      }
      this.justAllKnown = false;
      // Scroll to answer
      this.$nextTick(function () {
        var learnContent = document.querySelector('.learnContent');
        learnContent.scroll({
          behavior: 'smooth',
          top: learnContent.scrollHeight
        });
      });
    },
    showDataClick: function showDataClick(event) {
      // Blur button
      event.target.blur();
      // Toggle data visibility
      this.dataVisible = !this.dataVisible;
      this.setDataHeight();
      this.animateTransition = !this.walkThrough.steps[this.walkThrough.stepNum].summary;
      this.photoTransition = false;
    },
    showObjectsClick: function showObjectsClick(event) {
      // Blur button
      if (event) event.target.blur();
      // Toggle objects visibility
      this.objectsVisible = !this.objectsVisible;
    },
    sortPhotos: function sortPhotos() {
      var _this68 = this;

      var aFirstRow = void 0,
          bFirstRow = void 0;
      // Sort the photos array according to order used within the memo set
      this.photos.sort(function (a, b) {
        aFirstRow = _this68.photoUsage[a.id] ? _this68.photoUsage[a.id].firstRowIndex : 999999;
        bFirstRow = _this68.photoUsage[b.id] ? _this68.photoUsage[b.id].firstRowIndex : 999999;
        return aFirstRow - bFirstRow;
      });
    },
    sortQuestions: function sortQuestions() {
      var _this69 = this;

      // Sort questions by from column index, to column index
      this.questions.sort(function (a, b) {
        if (_this69.fieldsById[a.fromFieldId].fieldIndex < _this69.fieldsById[b.fromFieldId].fieldIndex) return -1;
        if (_this69.fieldsById[a.fromFieldId].fieldIndex > _this69.fieldsById[b.fromFieldId].fieldIndex) return 1;
        if (_this69.fieldsById[a.toFieldId].fieldIndex < _this69.fieldsById[b.toFieldId].fieldIndex) return -1;
        if (_this69.fieldsById[a.toFieldId].fieldIndex > _this69.fieldsById[b.toFieldId].fieldIndex) return 1;
        return 1;
      });
    },
    sortRowsClick: function sortRowsClick() {
      var _this70 = this;

      // Hide Actions popup
      $('.actionsButton').popup('hide');
      this.$nextTick(function () {
        // Prepare Sort By Column dropdown
        _this70.sortRows.sortByColumn = '-1';
        $('.sortRowsSortByColumn').dropdown({
          onChange: function onChange(value) {
            _this70.sortRows.sortByColumn = value;
          },
          showOnFocus: false
        }).dropdown('clear');
        $('.ui.modal.sortRows').modal({
          onApprove: _this70.sortRowsSubmit,
          onHidden: _this70.revertPreventBackHistory,
          onVisible: _this70.prepareModalHistory
        }).modal('show');
      });
    },
    sortRowsEnter: function sortRowsEnter() {
      // Exit if form is incomplete
      if (this.sortRows.sortByColumn === '-1') return;
      // Hide modal
      $('.ui.modal.sortRows').modal('hide');
      // Submit form
      this.sortRowsSubmit();
    },
    sortRowsSubmit: function sortRowsSubmit() {
      var _this71 = this;

      var fieldId = void 0,
          firestoreUpdateDocs = void 0,
          sortMode = void 0;
      fieldId = this.fields[parseInt(this.sortRows.sortByColumn, 10)].fieldId;
      // Determine whether data is numeric
      sortMode = 'Num';
      for (var i = 0; i < this.rows.length; i++) {
        if (this.rows[i].data[fieldId] && !$.isNumeric(this.rows[i].data[fieldId].replace(/<br ?\/?>/g, ''))) {
          sortMode = 'Text';
          break;
        }
      }
      if (sortMode === 'Num') {
        this.rows.sort(function (a, b) {
          var aVal = a.data[fieldId] ? a.data[fieldId].replace(/<br ?\/?>/g, '') : '';
          var bVal = b.data[fieldId] ? b.data[fieldId].replace(/<br ?\/?>/g, '') : '';
          if (aVal === '' && bVal === '') return 0;
          if (aVal !== '' && bVal === '') return -1;
          if (aVal === '' && bVal !== '') return 1;
          if (parseFloat(aVal) === parseFloat(bVal)) return 0;
          if (parseFloat(aVal) > parseFloat(bVal)) return 1;
          return -1;
        });
      } else {
        this.rows.sort(function (a, b) {
          var aVal = a.data[fieldId] ? a.data[fieldId].replace(/<br ?\/?>/g, '') : '';
          var bVal = b.data[fieldId] ? b.data[fieldId].replace(/<br ?\/?>/g, '') : '';
          if (!aVal && !bVal) return 0;
          if (aVal && !bVal) return -1;
          if (!aVal && bVal) return 1;
          if (aVal === bVal) return 0;
          if (aVal > bVal) return 1;
          return -1;
        });
      }
      this.sortThumbnails();
      // Update Firestore
      firestoreUpdateDocs = {};
      this.rows.forEach(function (row, rowIndex) {
        // If seq has changed
        if (row.data.seq !== rowIndex) {
          _this71.$set(row.data, 'seq', rowIndex);
          // Create update object for the document if necessary
          if (!firestoreUpdateDocs[row.docId]) firestoreUpdateDocs[row.docId] = {};
          firestoreUpdateDocs[row.docId][row.rowId + '.seq'] = rowIndex;
        }
      });
      var batch = db.batch();
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(firestoreUpdateDocs).forEach(function (docId) {
        batch.update(db.doc('memoSets/' + _this71.memoSetId + '/rows/' + docId), firestoreUpdateDocs[docId]);
      });
      batch.commit().catch(function (error) {
        logError('MemoSet_sortRowsSubmit', error);
      });
      // Check/update thumbnails and Mathjax
      this.prepareVisibleRows();
      this.scrollToTopLeft();
      this.initSearch();
    },
    sortThumbnails: function sortThumbnails() {
      var _this72 = this;

      // Create a working array of objects with sequence number
      var workingArray = [];
      this.rows.forEach(function (row, rowIndex) {
        workingArray[rowIndex] = {
          seq: rowIndex,
          thumbnail: null
        };
      });
      // Add thumbnails to the working array
      this.thumbnails.forEach(function (thumbnail, index) {
        workingArray[index].thumbnail = thumbnail;
      });
      // Add newSeq to the working array - the index of the corresponding row
      this.rows.forEach(function (row, rowIndex) {
        workingArray[row.data.seq].newSeq = rowIndex;
      });
      // Sort the working array by newSeq
      workingArray.sort(function (a, b) {
        return a.newSeq - b.newSeq;
      });
      // Update thumbnails array
      workingArray.forEach(function (item, index) {
        _this72.$set(_this72.thumbnails, index, item.thumbnail);
      });
    },
    startDrawing: function startDrawing(pointer) {
      var canvasCoords = void 0,
          ctx = void 0,
          obj = void 0,
          radiusX = void 0,
          radiusY = void 0;
      obj = this.objects[this.activeObject];
      // Save intial canvas
      this.summaryImage.before.canvas = this.copyOfCanvas(this.editCanvas);
      ctx = this.editCanvas.getContext('2d');
      // Draw transparent hole at cursor position
      canvasCoords = this.getCanvasCoords(pointer.clientX, pointer.clientY);
      radiusX = drawTransparentRadius / this.photoTransform.scale * this.editCanvas.width / obj.width;
      radiusY = drawTransparentRadius / this.photoTransform.scale * this.editCanvas.height / obj.height;
      ctx.beginPath();
      ctx.ellipse(canvasCoords.x, canvasCoords.y, radiusX, radiusY, 0, 0, 2 * Math.PI);
      ctx.globalCompositeOperation = 'destination-out';
      ctx.fill();
      this.drawObjectCanvas();
      ctx.globalCompositeOperation = 'source-over';
      // Save mouse position
      this.pointerPosX = pointer.clientX;
      this.pointerPosY = pointer.clientY;
      this.drawing = true;
    },
    startRecording: function startRecording(stream) {
      var _this73 = this;

      var self = this;
      var blob = void 0,
          now = void 0;
      this.addCellAudio.stream = stream;
      this.audioRecorder = new MediaRecorder(stream, { mimeType: 'audio/webm' });
      this.audioRecorder.addEventListener('dataavailable', function (event) {
        if (event.data.size) {
          blob = new Blob([event.data]);
          now = Date.now();
          self.addCellAudio.url = window.URL.createObjectURL(blob);
          self.addCellAudio.file = new File([blob], _this73.user.id + '_' + now + '.webm', {
            lastModified: now,
            type: 'audio/webm'
          });
        }
        self.addCellAudio.recording = false;
      });
      this.audioRecorder.start();
      this.addCellAudio.recording = true;
      this.timeouts.audioRecorder = setTimeout(this.stopRecordingClick, maxAudioDuration);
    },
    startRecordingClick: function startRecordingClick() {
      function handleError() {
        console.log('Error');
      }
      window.navigator.mediaDevices.getUserMedia({ audio: true, video: false }).then(this.startRecording).catch(handleError);
    },
    startTimerOnNextTick: function startTimerOnNextTick() {
      var _this74 = this;

      this.$nextTick(function () {
        _this74.learn.timestamp = Date.now();
      });
    },
    stopRecordingClick: function stopRecordingClick() {
      this.audioRecorder.stop();
      // Stop the track to remove recording indicator from browser tab
      this.addCellAudio.stream.getTracks()[0].stop();
      // Clear audio recorder timeout
      if (this.timeouts.audioRecorder) {
        clearTimeout(this.timeouts.audioRecorder);
        this.timeouts.audioRecorder = null;
      }
    },
    summaryImageClick: function summaryImageClick(rowIndex) {
      var _this75 = this;

      if (this.memoSetType !== 'regular') return;
      var photoId = void 0,
          row = void 0;
      this.saveTableWrapperScrollPos();
      this.rowIndex = rowIndex;
      row = this.rows[rowIndex];
      photoId = row.data.photoId;
      if (photoId) {
        this.photoIndex = this.photos.findIndex(function (photo) {
          return photo.id === photoId;
        });
        this.photo = this.photos[this.photoIndex];
        this.locationRect = {
          height: row.data.location.height,
          left: row.data.location.left,
          top: row.data.location.top,
          width: row.data.location.width
        };
      } else {
        this.photoIndex = -1;
        this.photo = {
          height: noPhotoSize,
          width: noPhotoSize
        };
        this.locationRect = {
          height: noPhotoSize,
          left: 0,
          top: 0,
          width: noPhotoSize
        };
      }
      // If there is a photo and any objects, start zoomed to the location
      if (photoId && row.data.objects && row.data.objects.length) {
        this.showRect = {
          left: this.summaryImageLocationRectWithMargin.left,
          top: this.summaryImageLocationRectWithMargin.top,
          width: this.summaryImageLocationRectWithMargin.width,
          height: this.summaryImageLocationRectWithMargin.height
        };
      } else {
        // Show the entire photo
        this.showRect = {
          left: 0,
          top: 0,
          width: this.photo.width,
          height: this.photo.height
        };
      }
      this.prepareObjects();
      this.summaryImage.page = 'summary';
      this.summaryImage.createdObjectUrls = [];
      this.summaryImage.neededObjectUrls = [];
      // Initialize mode
      this.mode = 'select';
      this.movingRectangle = false;
      this.panning = false;
      this.rectangleActive = false;
      this.resizingRectangle = false;
      this.activeObject = -1;
      this.movingObject = false;
      this.resizingObject = false;
      this.rotatingObject = false;
      this.summaryImage.undoArray = [];
      this.summaryImage.undoArrayIndex = 0;
      this.summaryImage.undoArrayIndexMax = 0;
      // Wrap in nextTick to avoid flashing previous summary image
      this.$nextTick(function () {
        _this75.modal = 'summaryImage';
        $('.ui.modal.summaryImage').modal({
          autofocus: false,
          centered: false,
          closable: false,
          onApprove: _this75.summaryImageSubmit,
          onDeny: _this75.summaryImageDeny,
          onHidden: _this75.revertPreventBackHistory,
          onHide: function onHide() {
            // Workaround for onHide firing when other modals are closed
            if ($('.ui.modal.summaryImage').modal('is active')) {
              // Revoke any object URLs we don't need to keep
              _this75.summaryImage.createdObjectUrls.filter(function (url) {
                return !_this75.summaryImage.neededObjectUrls.includes(url);
              }).forEach(function (url) {
                window.URL.revokeObjectURL(url);
              });
              // Show data table
              _this75.modal = '';
              _this75.prepareVisibleRows();
              _this75.setTableWrapperHeight();
              _this75.revertTableWrapperScrollPos();
            }
          },
          onVisible: _this75.prepareModalHistory
        }).modal('show');
        _this75.setLocationZIndex();
        _this75.animateTransition = false;
      });
    },
    summaryImageDeny: function summaryImageDeny() {
      // If on Add Image page, return to Summary page
      if (this.summaryImage.page === 'add') {
        this.summaryImage.page = 'summary';
        return false;
      }
    },
    summaryImageMouseDown: function summaryImageMouseDown(event) {
      this.pointerPosX = event.clientX;
      this.pointerPosY = event.clientY;
      this.panning = true;
      this.summaryImage.backgroundPointerDownTimestamp = event.timeStamp;
    },
    summaryImageMouseMove: function summaryImageMouseMove(event) {
      if (this.panning) this.summaryImagePanPhoto(event);
      if (this.movingRectangle) this.moveRectangle(event);
      if (this.resizingRectangle) this.resizeRectangle(event);
      if (this.movingObject) this.moveObject(event);
      if (this.resizingObject) this.resizeObject(event);
      if (this.rotatingObject) this.rotateObject(event);
      if (this.removing) this.removePointerMove(event);
    },
    summaryImagePanPhoto: function summaryImagePanPhoto(event) {
      // centerX, centerY are relative to the photo
      // moveX, moveY, this.pointerPosX, this.pointerPosY are relative to the screen
      var centerX = void 0,
          centerY = void 0,
          moveX = void 0,
          moveY = void 0;
      // Move showRect to the center of the visible part of the photo - this makes pan work properly for the non-limiting dimension
      centerX = -this.photoTransform.translateX + 0.5 * this.photoTransform.visibleWidth / this.photoTransform.scale;
      centerY = -this.photoTransform.translateY + 0.5 * this.photoTransform.visibleHeight / this.photoTransform.scale;
      this.showRect.left = centerX - this.showRect.width / 2;
      this.showRect.top = centerY - this.showRect.height / 2;
      // Move showRect by the amount the pointer has moved
      moveX = event.clientX - this.pointerPosX;
      moveY = event.clientY - this.pointerPosY;
      this.showRect.left -= moveX / this.photoTransform.scale;
      this.showRect.top -= moveY / this.photoTransform.scale;
      // Prevent pan from going too far up
      if (this.showRect.top < 0) {
        this.showRect.top = 0;
      }
      // Prevent pan from going too far left
      if (this.showRect.left < 0) {
        this.showRect.left = 0;
      }
      // Prevent pan from going too far down
      if (this.showRect.top + this.showRect.height > this.photo.height) {
        this.showRect.top = this.photo.height - this.showRect.height;
      }
      // Prevent pan from going too far right
      if (this.showRect.left + this.showRect.width > this.photo.width) {
        this.showRect.left = this.photo.width - this.showRect.width;
      }
      this.pointerPosX = event.clientX;
      this.pointerPosY = event.clientY;
      this.animateTransition = false;
    },
    summaryImageRedoClick: function summaryImageRedoClick(event) {
      var obj = void 0,
          tempObj = void 0,
          undoEntry = void 0;
      // Blur button
      document.getElementById('redoButton').blur();
      undoEntry = this.summaryImage.undoArray[this.summaryImage.undoArrayIndex];
      switch (undoEntry.changeType) {
        case 'clip':
          obj = this.objects[undoEntry.objIndex];
          obj.url = undoEntry.after.url;
          break;
        case 'clippingPath':
          this.clippingPath = undoEntry.after;
          this.drawObjectCanvas();
          this.drawClippingPath(false);
          break;
        case 'draw':
          obj = this.objects[undoEntry.objIndex];
          // If redoing during drawing
          if (this.mode === 'draw') {
            // Update the object canvas
            this.editCanvas = undoEntry.after.canvas;
            this.drawObjectCanvas();
          } else {
            // Update the object's URL
            obj.url = undoEntry.after.canvas.toDataURL();
          }
          break;
        case 'object add':
          this.objects.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, undoEntry.obj));
          break;
        case 'object flip':
          obj = this.objects[undoEntry.objIndex];
          obj[undoEntry.flipField] = !obj[undoEntry.flipField];
          // Deselect any location or objects
          this.activeObject = -1;
          this.rectangleActive = false;
          break;
        case 'object delete':
          this.objects.splice(undoEntry.objIndex, 1);
          // Deselect any location or objects
          this.activeObject = -1;
          this.rectangleActive = false;
          break;
        case 'object move':
          obj = this.objects[undoEntry.before.sequence];
          obj.left = undoEntry.after.left;
          obj.top = undoEntry.after.top;
          tempObj = this.objects.splice(undoEntry.before.sequence, 1)[0];
          this.objects.push(tempObj);
          // Deselect any location or objects
          this.activeObject = -1;
          this.rectangleActive = false;
          this.setLocationZIndex();
          break;
        case 'object resize':
          obj = this.objects[undoEntry.objIndex];
          obj.height = undoEntry.after.height;
          obj.left = undoEntry.after.left;
          obj.top = undoEntry.after.top;
          obj.width = undoEntry.after.width;
          // Deselect any location or objects
          this.activeObject = -1;
          this.rectangleActive = false;
          this.setLocationZIndex();
          break;
        case 'object rotate':
          obj = this.objects[undoEntry.objIndex];
          obj.angle = undoEntry.after.angle;
          // Deselect any location or objects
          this.activeObject = -1;
          this.rectangleActive = false;
          this.setLocationZIndex();
          break;
        case 'rectangle move':
          this.locationRect.left = undoEntry.after.left;
          this.locationRect.top = undoEntry.after.top;
          // Deselect any location or objects
          this.activeObject = -1;
          this.rectangleActive = false;
          this.setLocationZIndex();
          break;
        case 'rectangle resize':
          this.locationRect.height = undoEntry.after.height;
          this.locationRect.left = undoEntry.after.left;
          this.locationRect.top = undoEntry.after.top;
          this.locationRect.width = undoEntry.after.width;
          // Deselect any location or objects
          this.activeObject = -1;
          this.rectangleActive = false;
          this.setLocationZIndex();
          break;
        case 'remove':
          obj = this.objects[undoEntry.objIndex];
          // If redoing in remove mode
          if (this.mode === 'remove') {
            // Update the object canvas
            this.editCanvas = undoEntry.after.canvas;
            this.drawObjectCanvas();
          } else {
            // Update the object's URL
            obj.url = undoEntry.after.canvas.toDataURL();
          }
          break;
        case 'send to back':
          tempObj = this.objects.splice(undoEntry.before.sequence, 1)[0];
          this.objects.unshift(tempObj);
          // Deselect any location or objects
          this.activeObject = -1;
          this.rectangleActive = false;
          this.setLocationZIndex();
          break;
      }
      this.summaryImage.undoArrayIndex++;
      // Disable animation
      this.animateTransition = false;
    },
    summaryImageSubmit: function summaryImageSubmit() {
      var _this76 = this;

      var backgroundHeight = void 0,
          backgroundWidth = void 0,
          imageElement = void 0,
          imageHeight = void 0,
          imageWidth = void 0,
          newObj = void 0,
          objHeight = void 0,
          objWidth = void 0,
          otherLocation = void 0,
          rowLocation = void 0,
          undoEntry = void 0;
      switch (this.summaryImage.page) {
        case 'add':
          // Calculate dimensions of the object to be added, at 50% of the limiting dimension
          backgroundWidth = this.rows[this.rowIndex].data.photoId ? this.locationRect.width : noPhotoSize;
          backgroundHeight = this.rows[this.rowIndex].data.photoId ? this.locationRect.height : noPhotoSize;
          imageElement = document.getElementById('addImageImage');
          imageWidth = imageElement.naturalWidth;
          imageHeight = imageElement.naturalHeight;
          if (imageWidth / imageHeight > backgroundWidth / backgroundHeight) {
            // Width is the limiting dimension
            objWidth = backgroundWidth * 0.5;
            objHeight = objWidth * imageHeight / imageWidth;
          } else {
            // Height is the limiting dimension
            objHeight = backgroundHeight * 0.5;
            objWidth = objHeight * imageWidth / imageHeight;
          }
          this.lastObjectKey++;
          newObj = {
            angle: 0,
            file: this.addImage.file,
            flipX: false,
            flipY: false,
            height: objHeight,
            imageElement: imageElement.cloneNode(false),
            key: this.lastObjectKey,
            left: this.rows[this.rowIndex].data.photoId ? this.locationRect.left : 0,
            naturalHeight: imageElement.naturalHeight,
            naturalWidth: imageElement.naturalWidth,
            rowIndex: this.rowIndex,
            top: this.rows[this.rowIndex].data.photoId ? this.locationRect.top : 0,
            url: this.addImage.url,
            width: objWidth
          };
          this.objects.push(newObj);
          this.summaryImage.page = 'summary';
          // Zoom to the location
          this.rectangleActive = true;
          this.zoomToSelected();
          // Select new object
          this.mode = 'select';
          this.rectangleActive = false;
          this.hoverObject = -1;
          this.activeObject = this.objects.length - 1;
          // Prepare undo entry
          undoEntry = {
            changeType: 'object add',
            obj: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, newObj)
          };
          this.addSummaryImageUndoEntry(undoEntry);
          // Return false to prevent closing the modal
          return false;
        case 'summary':
          // End editing
          if (this.mode === 'clip') this.endClipMode();
          if (this.mode === 'draw') this.endDrawMode();
          if (this.mode === 'remove') this.endRemoveMode();
          // Deselect objects and location
          this.activeObject = -1;
          this.rectangleActive = false;
          // Update object sequences
          this.objects.forEach(function (obj, objIndex) {
            obj.sequence = objIndex;
          });
          // Move objects to their containing location, if appropriate
          if (this.photo.id) {
            this.objects.forEach(function (obj, objIndex) {
              rowLocation = _this76.rows[obj.rowIndex].data.location;
              // If the object is outside its row's location
              if (obj.left + obj.width < rowLocation.left || obj.left > rowLocation.left + rowLocation.width || obj.top + obj.height < rowLocation.top || obj.top > rowLocation.top + rowLocation.height) {
                // Look for another row whose location includes the object
                _this76.photoRowIndexes.forEach(function (rowIndex) {
                  otherLocation = _this76.rows[rowIndex].data.location;
                  if (!(obj.left + obj.width < otherLocation.left || obj.left > otherLocation.left + otherLocation.width || obj.top + obj.height < otherLocation.top || obj.top > otherLocation.top + otherLocation.height)) {
                    // Note: an object may overlap multiple other locations, in which case it will just be moved to the last one
                    obj.rowIndex = rowIndex;
                  }
                });
              } else {
                // Look for a smaller location that the object is completely inside
                // Loop through locations on the photo, skipping the object's current location
                _this76.photoRowIndexes.forEach(function (rowIndex) {
                  if (rowIndex !== obj.rowIndex) {
                    otherLocation = _this76.rows[rowIndex].data.location;
                    // Refresh rowLocation in case it has changed during the loop
                    rowLocation = _this76.rows[obj.rowIndex].data.location;
                    // If the location is smaller than the object's current location
                    if (otherLocation.height * otherLocation.width < rowLocation.height * rowLocation.width) {
                      // If the object is completely inside the location
                      if (obj.left >= otherLocation.left && obj.left + obj.width <= otherLocation.left + otherLocation.width && obj.top >= otherLocation.top && obj.top + obj.height <= otherLocation.top + otherLocation.height) {
                        obj.rowIndex = rowIndex;
                      }
                    }
                  }
                });
              }
            });
          }
          // Check for new or edited objects - new object URLs start with 'blob:', and edited object URLs start with 'data:'
          this.summaryImage.imagesRemaining = 0;
          this.objects.filter(function (obj) {
            return obj.url.substring(0, 5) !== 'https';
          }).forEach(function (obj) {
            _this76.summaryImage.imagesRemaining++;
            _this76.summaryImageUploadImage(obj);
          });
          // If there are images to upload
          if (this.summaryImage.imagesRemaining) {
            this.summaryImage.uploading = true;
            // Prevent modal closing
            return false;
          } else {
            this.summaryImageUpdateRows();
          }
          break;
      }
    },
    summaryImageTouchMove: function summaryImageTouchMove(event) {
      var centerXRelativeToScreen = void 0,
          centerYRelativeToScreen = void 0,
          distance = void 0,
          touch0 = void 0,
          touch1 = void 0;
      if (event.touches.length === 1) {
        touch0 = event.touches[0];
        if (this.panning) this.summaryImagePanPhoto(touch0);
        if (this.movingRectangle) this.moveRectangle(touch0);
        if (this.movingObject) this.moveObject(touch0);
        if (this.resizingObject) this.resizeObject(touch0);
        if (this.resizingRectangle) this.resizeRectangle(touch0);
        if (this.rotatingObject) this.rotateObject(touch0);
      }
      if (event.touches.length === 2) {
        touch0 = event.touches[0];
        touch1 = event.touches[1];
        if (this.pinching) {
          distance = Math.sqrt(Math.pow(touch0.clientX - touch1.clientX, 2) + Math.pow(touch0.clientY - touch1.clientY, 2));
          var zoomFactor = distance / this.pinchData.distance;
          if (zoomFactor > 1) {
            this.zoomIn(zoomFactor, null, { x: this.pinchData.centerXRelativeToPhoto, y: this.pinchData.centerYRelativeToPhoto }, false);
          }
          if (zoomFactor < 1) {
            this.zoomOut(1 / zoomFactor, null, { x: this.pinchData.centerXRelativeToPhoto, y: this.pinchData.centerYRelativeToPhoto }, false);
          }
          centerXRelativeToScreen = (touch0.clientX + touch1.clientX) / 2;
          centerYRelativeToScreen = (touch0.clientY + touch1.clientY) / 2;
          this.summaryImagePanPhoto({ clientX: centerXRelativeToScreen, clientY: centerYRelativeToScreen });
          this.pinchData.distance = distance;
        }
      }
    },
    summaryImageTouchStart: function summaryImageTouchStart(event) {
      var centerXRelativeToPhoto = void 0,
          centerXRelativeToScreen = void 0,
          centerXRelativeToVisiblePhoto = void 0,
          centerYRelativeToPhoto = void 0,
          centerYRelativeToScreen = void 0,
          centerYRelativeToVisiblePhoto = void 0,
          obj = void 0,
          summaryImageRect = void 0,
          tempObj = void 0,
          touch0 = void 0,
          touch1 = void 0;
      if (event.touches.length === 1) {
        touch0 = event.touches[0];
        this.pointerPosX = touch0.clientX;
        this.pointerPosY = touch0.clientY;
        this.panning = true;
        this.animateTransition = false;
        this.summaryImage.backgroundPointerDownTimestamp = event.timeStamp;
      }
      if (event.touches.length === 2) {
        if (event.timeStamp - this.summaryImage.firstTouchTimestamp < 300) {
          // Revert any object selection/move
          if (this.movingObject) {
            obj = this.objects[this.activeObject];
            obj.left = this.summaryImage.before.left;
            obj.top = this.summaryImage.before.top;
            tempObj = this.objects.pop();
            this.objects.splice(this.summaryImage.before.sequence, 0, tempObj);
            this.setLocationZIndex();
            this.movingObject = false;
          }
          // Revert any rectangle move
          if (this.movingRectangle) {
            this.locationRect.left = this.summaryImage.before.left;
            this.locationRect.top = this.summaryImage.before.top;
            this.setLocationZIndex();
            this.movingRectangle = false;
          }
          // Revert any object editing
          if (this.mode === 'clip') {
            // Remove the last touch point from the clipping path
            this.clippingPath = this.firstTouchClippingPath.slice();
            this.drawObjectCanvas();
            this.drawClippingPath(false);
            this.clipping = false;
          }
          if (this.mode === 'draw') {
            this.editCanvas = this.copyOfCanvas(this.summaryImage.before.canvas);
            this.drawObjectCanvas();
            this.drawing = false;
          }
          if (this.mode === 'remove') {
            this.editCanvas = this.copyOfCanvas(this.summaryImage.before.canvas);
            this.drawObjectCanvas();
            this.removing = false;
          }
          this.rectangleActive = this.summaryImage.firstTouchRectangleActive;
          this.activeObject = this.summaryImage.firstTouchActiveObject;
        }
        touch0 = event.touches[0];
        touch1 = event.touches[1];
        this.panning = false;
        this.pinching = true;
        this.animateTransition = false;
        centerXRelativeToScreen = (touch0.clientX + touch1.clientX) / 2;
        centerYRelativeToScreen = (touch0.clientY + touch1.clientY) / 2;
        this.pointerPosX = centerXRelativeToScreen;
        this.pointerPosY = centerYRelativeToScreen;
        // Get center of touches relative to the visible photo
        summaryImageRect = $('.summaryImageWrapper')[0].getBoundingClientRect();
        centerXRelativeToVisiblePhoto = (touch0.clientX + touch1.clientX) / 2 - summaryImageRect.left;
        centerYRelativeToVisiblePhoto = (touch0.clientY + touch1.clientY) / 2 - summaryImageRect.top;
        // Calculate position of mouse relative to the photo
        centerXRelativeToPhoto = -this.photoTransform.translateX + centerXRelativeToVisiblePhoto / this.photoTransform.scale;
        centerYRelativeToPhoto = -this.photoTransform.translateY + centerYRelativeToVisiblePhoto / this.photoTransform.scale;
        this.pinchData = {
          centerXRelativeToPhoto: centerXRelativeToPhoto,
          centerYRelativeToPhoto: centerYRelativeToPhoto,
          distance: Math.sqrt(Math.pow(touch0.clientX - touch1.clientX, 2) + Math.pow(touch0.clientY - touch1.clientY, 2))
        };
      }
    },
    summaryImageUndoClick: function summaryImageUndoClick(event) {
      var obj = void 0,
          tempObj = void 0,
          undoEntry = void 0;
      // Blur button
      document.getElementById('undoButton').blur();
      this.summaryImage.undoArrayIndex--;
      undoEntry = this.summaryImage.undoArray[this.summaryImage.undoArrayIndex];
      // Exit clip mode if undoing a non-clippingPath change
      if (this.mode === 'clip' && undoEntry.changeType !== 'clippingPath') {
        this.mode = 'select';
        // Don't allow the clippingPath changes to be redone
        this.summaryImage.undoArrayIndexMax = this.summaryImage.undoArrayIndex + 1;
      }
      // Exit draw mode if undoing a non-draw change
      if (this.mode === 'draw' && undoEntry.changeType !== 'draw') {
        this.mode = 'select';
      }
      // Exit remove mode if undoing a non-remove change
      if (this.mode === 'remove' && undoEntry.changeType !== 'remove') {
        this.mode = 'select';
      }
      switch (undoEntry.changeType) {
        case 'clip':
          obj = this.objects[undoEntry.objIndex];
          obj.url = undoEntry.before.url;
          break;
        case 'clippingPath':
          if (this.summaryImage.undoArray[this.summaryImage.undoArrayIndex - 1] && this.summaryImage.undoArray[this.summaryImage.undoArrayIndex - 1].changeType === 'clippingPath') {
            this.clippingPath = this.summaryImage.undoArray[this.summaryImage.undoArrayIndex - 1].after;
          } else {
            this.clippingPath = [];
          }
          this.drawObjectCanvas();
          this.drawClippingPath(false);
          break;
        case 'draw':
          obj = this.objects[undoEntry.objIndex];
          // If undoing during drawing
          if (this.mode === 'draw') {
            // Update the object canvas
            this.editCanvas = undoEntry.before.canvas;
            this.drawObjectCanvas();
          } else {
            // Update the object's URL
            if (undoEntry.before.url) {
              obj.url = undoEntry.before.url;
            } else {
              obj.url = undoEntry.before.canvas.toDataURL();
            }
          }
          break;
        case 'object add':
          this.objects.pop();
          // Deselect any location or objects
          this.activeObject = -1;
          this.rectangleActive = false;
          this.setLocationZIndex();
          break;
        case 'object flip':
          obj = this.objects[undoEntry.objIndex];
          obj[undoEntry.flipField] = !obj[undoEntry.flipField];
          // Deselect any location or objects
          this.activeObject = -1;
          this.rectangleActive = false;
          break;
        case 'object delete':
          obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, undoEntry.obj);
          this.objects.splice(undoEntry.objIndex, 0, obj);
          // Deselect any location or objects
          this.activeObject = -1;
          this.rectangleActive = false;
          this.setLocationZIndex();
          break;
        case 'object move':
          obj = this.objects[undoEntry.after.sequence];
          obj.left = undoEntry.before.left;
          obj.top = undoEntry.before.top;
          tempObj = this.objects.pop();
          this.objects.splice(undoEntry.before.sequence, 0, tempObj);
          // Deselect any location or objects
          this.activeObject = -1;
          this.rectangleActive = false;
          this.setLocationZIndex();
          break;
        case 'object resize':
          obj = this.objects[undoEntry.objIndex];
          obj.height = undoEntry.before.height;
          obj.left = undoEntry.before.left;
          obj.top = undoEntry.before.top;
          obj.width = undoEntry.before.width;
          // Deselect any location or objects
          this.activeObject = -1;
          this.rectangleActive = false;
          this.setLocationZIndex();
          break;
        case 'object rotate':
          obj = this.objects[undoEntry.objIndex];
          obj.angle = undoEntry.before.angle;
          // Deselect any location or objects
          this.activeObject = -1;
          this.rectangleActive = false;
          this.setLocationZIndex();
          break;
        case 'rectangle move':
          this.locationRect.left = undoEntry.before.left;
          this.locationRect.top = undoEntry.before.top;
          // Deselect any location or objects
          this.activeObject = -1;
          this.rectangleActive = false;
          this.setLocationZIndex();
          break;
        case 'rectangle resize':
          this.locationRect.height = undoEntry.before.height;
          this.locationRect.left = undoEntry.before.left;
          this.locationRect.top = undoEntry.before.top;
          this.locationRect.width = undoEntry.before.width;
          // Deselect any location or objects
          this.activeObject = -1;
          this.rectangleActive = false;
          this.setLocationZIndex();
          break;
        case 'remove':
          obj = this.objects[undoEntry.objIndex];
          // If undoing in remove mode
          if (this.mode === 'remove') {
            // Update the object canvas
            this.editCanvas = undoEntry.before.canvas;
            this.drawObjectCanvas();
          } else {
            // Update the object's URL
            if (undoEntry.before.url) {
              obj.url = undoEntry.before.url;
            } else {
              obj.url = undoEntry.before.canvas.toDataURL();
            }
          }
          break;
        case 'send to back':
          tempObj = this.objects.shift();
          this.objects.splice(undoEntry.before.sequence, 0, tempObj);
          // Deselect any location or objects
          this.activeObject = -1;
          this.rectangleActive = false;
          this.setLocationZIndex();
          break;
      }
      // Disable animation
      this.animateTransition = false;
    },
    summaryImageUpdateRows: function summaryImageUpdateRows() {
      var _this77 = this;

      var self = this;
      var allCurrentObjects = void 0,
          currentObjectsForRow = void 0,
          docId = void 0,
          firestoreObjectsForRow = void 0,
          location = void 0,
          rowId = void 0,
          rowUpdateObjs = void 0;
      function handleRowObjectChanges(rowIndex, currentObjects) {
        var originalObjects = void 0;
        // Check whether any objects have changed on the row
        originalObjects = self.rows[rowIndex].data.objects || [];
        if (self.objectsChanged(originalObjects, currentObjects)) {
          // Update objects for the row
          self.rows[rowIndex].data.objects = currentObjects;
          // Prepare for Firestore update
          docId = self.rows[rowIndex].docId;
          rowId = self.rows[rowIndex].rowId;
          // We don't want to write rowIndex or tempUrl to Firestore
          firestoreObjectsForRow = currentObjects.map(function (obj) {
            return {
              angle: obj.angle,
              flipX: obj.flipX,
              flipY: obj.flipY,
              height: obj.height,
              left: obj.left,
              sequence: obj.sequence,
              top: obj.top,
              url: obj.url,
              width: obj.width
            };
          });
          if (!rowUpdateObjs[docId]) rowUpdateObjs[docId] = {};
          rowUpdateObjs[docId][rowId + '.objects'] = firestoreObjectsForRow;
        }
      }
      rowUpdateObjs = {};
      // Update location rectangle
      location = this.rows[this.rowIndex].data.location;
      if (location) {
        if (location.left !== this.locationRect.left || location.top !== this.locationRect.top || location.width !== this.locationRect.width || location.height !== this.locationRect.height) {
          location.left = this.locationRect.left;
          location.top = this.locationRect.top;
          location.width = this.locationRect.width;
          location.height = this.locationRect.height;
          docId = this.rows[this.rowIndex].docId;
          rowId = this.rows[this.rowIndex].rowId;
          rowUpdateObjs[docId] = {};
          rowUpdateObjs[docId][rowId + '.location'] = this.locationRect;
        }
      }
      // Create array of objects containing only properties used in the rows data
      allCurrentObjects = this.objects.map(function (obj) {
        return {
          angle: obj.angle,
          flipX: obj.flipX,
          flipY: obj.flipY,
          height: obj.height,
          left: obj.left,
          rowIndex: obj.rowIndex,
          sequence: obj.sequence,
          tempUrl: obj.tempUrl || '',
          top: obj.top,
          url: obj.pendingUrl || obj.url,
          width: obj.width
        };
      });
      if (this.photo.id) {
        // Loop through all rows using the photo
        this.photoRowIndexes.forEach(function (rowIndex) {
          currentObjectsForRow = allCurrentObjects.filter(function (obj) {
            return obj.rowIndex === rowIndex;
          });
          handleRowObjectChanges(rowIndex, currentObjectsForRow);
        });
        // Update thumbnails for all rows using the photo
        this.photoRowIndexes.forEach(function (rowIndex) {
          _this77.createThumbnail(rowIndex);
        });
      } else {
        handleRowObjectChanges(this.rowIndex, allCurrentObjects);
        // Update thumbnail for the row
        this.createThumbnail(this.rowIndex);
      }
      // Update row documents
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(rowUpdateObjs)) {
        var batch = db.batch();
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(rowUpdateObjs).forEach(function (docId) {
          batch.update(db.doc('memoSets/' + _this77.memoSetId + '/rows/' + docId), rowUpdateObjs[docId]);
        });
        batch.commit().then(function () {
          if (_this77.summaryImage.uploading) {
            _this77.summaryImage.uploading = false;
            // Close modal
            $('.ui.modal.summaryImage').modal('hide');
          }
        }).catch(function (error) {
          logError('MemoSet_summaryImageSubmit', error);
        });
      }
    },
    summaryImageUploadImage: function summaryImageUploadImage(obj) {
      var _this78 = this;

      var canvas = void 0,
          ctx = void 0,
          height = void 0,
          imageDataUrl = void 0,
          imageKey = void 0,
          img = void 0,
          scaleFactor = void 0,
          tempCanvas = void 0,
          tempCtx = void 0,
          width = void 0;
      // If the user has uploaded or pasted an image with no edits, the URL is a blob, and we have the file in obj.file
      // If the user has edited a file, the URL is a data URL
      // Get a random key for the image
      imageKey = this.getImageKey();
      // If we have a new, unedited image file
      if (obj.url.substring(0, 5) === 'blob:') {
        // We need to keep the object URL until the image has been uploaded and downloaded from Firebase storage
        this.summaryImage.neededObjectUrls.push(obj.url);
        // If image isn't too large
        if (obj.naturalHeight <= maxImageSize && obj.naturalWidth <= maxImageSize) {
          // Upload the image to Firebase Storage
          firebase.storage().ref('userImages/' + this.user.id + '/' + imageKey).put(obj.file, { cacheControl: 'max-age=2592000' }).then(function (snapshot) {
            return snapshot.ref.getDownloadURL();
          }).then(function (downloadUrl) {
            // Put the blob URL into tempUrl, so we can use it for the thumbnail until the image has been downloaded
            obj.tempUrl = obj.url;
            obj.url = downloadUrl;
            // Download image
            img = new Image();
            img.onload = function () {
              // Find the row object
              _this78.rows.forEach(function (row, rowIndex) {
                if (row.data.objects) {
                  row.data.objects.forEach(function (rowObj) {
                    if (rowObj.tempUrl === obj.tempUrl) {
                      // Update the row object's URL to the download URL, and remove the temp URL
                      rowObj.url = downloadUrl;
                      rowObj.tempUrl = '';
                      window.URL.revokeObjectURL(obj.tempUrl);
                    }
                  });
                }
              });
            };
            img.src = downloadUrl;
            _this78.summaryImage.imagesRemaining--;
            if (!_this78.summaryImage.imagesRemaining) _this78.summaryImageUpdateRows();
          });
        } else {
          // Large image - reduce size via canvas
          img = obj.imageElement;
          scaleFactor = Math.min(maxImageSize / img.naturalWidth, maxImageSize / img.naturalHeight);
          scaleFactor = Math.min(scaleFactor, 1);
          // Limit scale down to half to preserve image quality
          scaleFactor = Math.max(scaleFactor, 0.5);
          tempCanvas = document.createElement('canvas');
          tempCanvas.width = img.naturalWidth * scaleFactor;
          tempCanvas.height = img.naturalHeight * scaleFactor;
          tempCtx = tempCanvas.getContext('2d');
          // Fill with white in case of transparent images
          tempCtx.fillStyle = 'white';
          tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);
          tempCtx.drawImage(img, 0, 0, tempCanvas.width, tempCanvas.height);
          width = tempCanvas.width;
          height = tempCanvas.height;
          while (scaleFactor === 0.5) {
            scaleFactor = Math.min(maxImageSize / width, maxImageSize / height);
            scaleFactor = Math.max(scaleFactor, 0.5);
            tempCtx.drawImage(tempCanvas, 0, 0, width, height, 0, 0, width * scaleFactor, height * scaleFactor);
            width = width * scaleFactor;
            height = height * scaleFactor;
          }
          // Draw section of tempCanvas onto canvas
          canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          ctx = canvas.getContext('2d');
          ctx.drawImage(tempCanvas, 0, 0, width, height, 0, 0, width, height);
          imageDataUrl = canvas.toDataURL('image/jpeg');
        }
      } else {
        imageDataUrl = imageDataUrl = obj.url;
      }
      if (imageDataUrl) {
        // Upload the image to Firebase Storage
        firebase.storage().ref('userImages/' + this.user.id + '/' + imageKey).putString(imageDataUrl, 'data_url', { cacheControl: 'max-age=2592000' }).then(function (snapshot) {
          return snapshot.ref.getDownloadURL();
        }).then(function (downloadUrl) {
          // Put the data URL into tempUrl, so we can use it for the thumbnail until the image has been downloaded
          obj.tempUrl = obj.url;
          obj.url = downloadUrl;
          // Download image
          img = new Image();
          img.onload = function () {
            // Find the row object
            _this78.rows.forEach(function (row, rowIndex) {
              if (row.data.objects) {
                row.data.objects.forEach(function (rowObj) {
                  if (rowObj.tempUrl === obj.tempUrl) {
                    // Update the row object's URL to the download URL, and remove the temp URL
                    rowObj.url = downloadUrl;
                    rowObj.tempUrl = '';
                  }
                });
              }
            });
          };
          img.src = downloadUrl;
          _this78.summaryImage.imagesRemaining--;
          if (!_this78.summaryImage.imagesRemaining) _this78.summaryImageUpdateRows();
        });
      }
    },
    tableWrapperScroll: function tableWrapperScroll() {
      if (this.timeouts.setTableWrapperScrollLeft) {
        clearTimeout(this.timeouts.setTableWrapperScrollLeft);
        this.timeouts.setTableWrapperScrollLeft = null;
      }
      this.timeouts.setTableWrapperScrollLeft = setTimeout(this.setTableWrapperScrollLeft, 100);
    },
    textOnly: function textOnly(html) {
      var text = void 0;
      if (!html) return '';
      // Replace line break with space
      text = html.replace(/<br ?\/?>/g, ' ');
      // Remove all HTML tags
      text = this.$sanitize(text, {
        allowedAttributes: [],
        allowedTags: []
      });
      return text;
    },
    titleBlur: function titleBlur(event) {
      var slug = void 0,
          updateObj = void 0;
      // If no title, revert to previous value
      if (!event.target.textContent.trim()) {
        event.target.textContent = this.title;
        return;
      }
      // If title has changed
      if (event.target.textContent.trim() !== this.title) {
        this.title = event.target.textContent.trim();
        this.setPageTitle();
        slug = this.createMemoSetSlug(this.title);
        // Update Firestore
        updateObj = {};
        updateObj[this.memoSetId + '.slug'] = slug;
        updateObj[this.memoSetId + '.title'] = this.title;
        var batch = db.batch();
        batch.update(db.doc('users/' + this.user.id + '/memoSets/' + this.docId), updateObj);
        this.updateSharedSummaries(batch, {
          slug: slug,
          title: this.title
        });
        batch.commit().catch(function (error) {
          logError('MemoSet_titleBlur', error);
        });
      }
      // Remove any non-text content
      event.target.textContent = event.target.textContent;
    },
    titleFocus: function titleFocus(event) {
      // If the title is the default title
      var defaultTitleLength = this.text.memoSetsDefaultTitle.length;
      if (this.title.substring(0, defaultTitleLength) === this.text.memoSetsDefaultTitle && (this.title.length === defaultTitleLength || this.title.substring(defaultTitleLength + 1, defaultTitleLength + 2) === '(')) {
        // Select the entire title
        selectElementContents(event.target);
      }
    },
    unshareMemoSet: function unshareMemoSet(shareUserId) {
      var _this79 = this;

      var batch = db.batch();
      // Remove property from sharing object
      this.$delete(this.sharing, shareUserId);
      // Update sharing on memoSets document
      batch.update(db.doc('memoSets/' + this.memoSetId), {
        sharing: this.sharing
      });
      // Update sharing on rows documents
      var uniqueDocIds = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(this.rows.map(function (row) {
        return row.docId;
      }))));
      uniqueDocIds.forEach(function (docId) {
        batch.update(db.doc('memoSets/' + _this79.memoSetId + '/rows/' + docId), {
          sharing: _this79.sharing
        });
      });
      if (shareUserId === 'public') {
        // Remove memo set from publicMemoSets
        batch.delete(db.doc('publicMemoSets/' + this.memoSetId));
      } else {
        // Remove memo set from share user's sharedWithMe data
        batch.delete(db.doc('users/' + shareUserId + '/sharedWithMe/' + this.memoSetId));
      }
      batch.commit().catch(function (error) {
        logError('MemoSet_unshareMemoSet', error);
      });
    },
    updateKnownData: function updateKnownData(batch, memoSetId) {
      var _this80 = this;

      var adjustedDueTimes = void 0,
          dueQuestions = void 0,
          knownData = void 0,
          knownQuestions = void 0,
          setObj = void 0,
          unknownQuestions = void 0;
      var now = Date.now();
      // Prepare array of all question instances
      var allQuestions = [];
      this.questions.forEach(function (question) {
        _this80.rows.forEach(function (row, rowIndex) {
          if (_this80.rowHasData(row, question.fromFieldId, question.toFieldId)) {
            allQuestions.push({
              reviewAfter: row.data.questions && row.data.questions[question.questionId] ? row.data.questions[question.questionId].reviewAfter : 0,
              reviewCycle: row.data.questions && row.data.questions[question.questionId] ? row.data.questions[question.questionId].reviewCycle : 0
            });
          }
        });
      });
      knownQuestions = allQuestions.filter(function (question) {
        return question.reviewCycle && question.reviewAfter > now;
      });
      dueQuestions = allQuestions.filter(function (question) {
        return question.reviewCycle && question.reviewAfter <= now;
      });
      unknownQuestions = allQuestions.filter(function (question) {
        return !question.reviewCycle;
      });
      // If nothing is known or due
      if (!knownQuestions.length && !dueQuestions.length) {
        this.deleteKnownData(batch, memoSetId);
      } else {
        knownData = [unknownQuestions.length, dueQuestions.length, Math.round(now / 10000)];
        // Concatenate array of due times
        adjustedDueTimes = knownQuestions.map(function (question) {
          return Math.round((question.reviewAfter - now) / 10000);
        });
        // Sort numerically, ascending
        adjustedDueTimes.sort(function (a, b) {
          return a - b;
        });
        knownData = knownData.concat(adjustedDueTimes);
        setObj = {};
        setObj[memoSetId] = knownData;
        batch.set(db.doc('users/' + this.user.id + '/knownData/doc'), setObj, { merge: true });
      }
    },
    updateLearningInFirestore: function updateLearningInFirestore(batch) {
      var _this81 = this;

      // If there are Firestore updates
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.learn.firestoreUpdate).length) {
        // Update Firestore based on learn.firestoreUpdate
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.learn.firestoreUpdate).forEach(function (docId) {
          batch.update(db.doc('memoSets/' + _this81.memoSetId + '/rows/' + docId), _this81.learn.firestoreUpdate[docId]);
        });
        // Reset Firestore update data
        this.learn.firestoreUpdate = {};
      }
    },
    updateSharedSummaries: function updateSharedSummaries(batch, updateObj) {
      var _this82 = this;

      var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.sharing);
      keys.forEach(function (shareUserId) {
        if (shareUserId === 'public') {
          batch.update(db.doc('publicMemoSets/' + _this82.memoSetId), updateObj);
        } else {
          batch.update(db.doc('users/' + shareUserId + '/sharedWithMe/' + _this82.memoSetId), updateObj);
        }
      });
    },
    viewAlternativesClick: function viewAlternativesClick(rowIndex, fieldId) {
      var _this83 = this;

      var currentValueDone = false;
      // Save row index and field ID
      this.rowIndex = rowIndex;
      this.fieldId = fieldId;
      var currentValue = this.rows[rowIndex].data[fieldId];
      // Populate cellAlternatives
      this.cellAlternatives = [];
      this.alternatives[this.rows[rowIndex].rowId + '|' + fieldId].forEach(function (alternative) {
        _this83.cellAlternatives.push({
          author: alternative.author,
          authorId: alternative.authorId,
          public: alternative.public,
          value: alternative.value
        });
        if (alternative.value === currentValue) {
          currentValueDone = true;
        }
      });
      if (!currentValueDone) {
        this.cellAlternatives.push({
          author: this.user.displayName,
          authorId: this.user.id,
          new: true,
          public: false,
          value: currentValue
        });
      }
      // Sort by public/private, then alphabetically
      this.cellAlternatives.sort(function (a, b) {
        if (a.public && !b.public) return -1;
        if (!a.public && b.public) return 1;
        if (a.value < b.value) return -1;
        return 1;
      });
      // Add index and originalPublic properties
      this.cellAlternatives.forEach(function (alternative, index) {
        alternative.index = index;
        alternative.originalPublic = alternative.public;
      });
      this.selectedAlternativeIndex = this.cellAlternatives.findIndex(function (alternative) {
        return alternative.value === currentValue;
      });
      this.originalAlternativeIndex = this.selectedAlternativeIndex;
      $('.ui.modal.viewAlternatives').modal({
        autofocus: false,
        onApprove: this.viewAlternativesSubmit,
        onHidden: this.revertPreventBackHistory,
        onVisible: this.prepareModalHistory
      }).modal('show');
    },
    viewAlternativesEnter: function viewAlternativesEnter() {
      // Hide modal
      $('.ui.modal.viewAlternatives').modal('hide');
      // Submit form
      this.viewAlternativesSubmit();
    },
    viewAlternativesSubmit: function viewAlternativesSubmit() {
      var _this84 = this;

      var commitRequired = void 0,
          privateChanges = void 0,
          publicChanges = void 0,
          updateObj = void 0;
      var row = this.rows[this.rowIndex];
      var cellKey = row.rowId + '|' + this.fieldId;
      var privateAlternatives = [];
      var userPublicAlternatives = [];
      var alternativeChanged = this.selectedAlternativeIndex !== this.originalAlternativeIndex;
      this.cellAlternatives.forEach(function (alternative) {
        if (alternative.authorId === _this84.user.id) {
          if (alternative.originalPublic && !alternative.public || !alternative.originalPublic && alternative.public) {
            publicChanges = true;
          }
          if (!alternative.originalPublic && (alternative.public || alternative.deleted) || alternative.originalPublic && !alternative.public && !alternative.deleted || alternative.new && alternativeChanged && !alternative.deleted) {
            privateChanges = true;
          }
          if (!alternative.deleted) {
            if (alternative.public) {
              userPublicAlternatives.push({
                author: _this84.user.displayName,
                value: alternative.value
              });
            } else {
              // Exclude the original alternative if still selected
              if (!alternative.new || alternativeChanged) {
                privateAlternatives.push(alternative.value);
              }
            }
          }
        }
      });
      var batch = db.batch();
      if (privateChanges) {
        // Write private alternatives to Firestore
        updateObj = {};
        updateObj[cellKey] = privateAlternatives;
        batch.update(db.doc('memoSets/' + this.memoSetId + '/private/' + this.user.id), updateObj);
        commitRequired = true;
      }
      if (publicChanges) {
        // Write user's public alternatives to Firestore
        updateObj = {};
        updateObj[cellKey] = userPublicAlternatives;
        batch.update(db.doc('memoSets/' + this.memoSetId + '/public/' + this.user.id), updateObj);
        commitRequired = true;
      }
      if (alternativeChanged) {
        this.$set(row.data, this.fieldId, this.cellAlternatives[this.selectedAlternativeIndex].value);
        // TODO - Update questions?
        // Update Firestore
        updateObj = {};
        updateObj[row.rowId + '.' + this.fieldId] = row.data[this.fieldId];
        batch.update(db.doc('memoSets/' + this.memoSetId + '/rows/' + row.docId), updateObj);
        commitRequired = true;
        this.initSearch();
      }
      if (commitRequired) {
        batch.commit().catch(function (error) {
          logError('MemoSet_viewAlternativesSubmit', error);
        });
      }
    },
    walkThroughClick: function walkThroughClick(event) {
      var _this85 = this;

      var objects = void 0,
          photoId = void 0,
          photos = void 0,
          photosIndex = void 0,
          previousPhotoId = void 0,
          steps = void 0;
      // Blur button
      event.target.blur();
      this.saveTableWrapperScrollPos();
      this.walkThrough.photos = [];
      this.walkThrough.steps = [];
      // For convenience
      photos = this.walkThrough.photos;
      steps = this.walkThrough.steps;
      // Loop through memo set rows
      this.rows.forEach(function (row, rowIndex) {
        photoId = row.data.photoId;
        // If there is a summary image
        if (photoId || row.data.objects && row.data.objects.length) {
          // If there is a background photo
          if (photoId) {
            // If photo changed, add step for the entire photo
            if (photoId !== previousPhotoId) {
              steps.push({
                location: {
                  height: _this85.photos[_this85.photoIndexes[rowIndex]].height,
                  left: 0,
                  top: 0,
                  width: _this85.photos[_this85.photoIndexes[rowIndex]].width
                },
                photo: _this85.photos[_this85.photoIndexes[rowIndex]],
                photoId: photoId,
                rowIndex: rowIndex,
                summary: true
              });
            }
            steps.push({
              location: row.data.location,
              photo: _this85.photos[_this85.photoIndexes[rowIndex]],
              photoId: photoId,
              rowIndex: rowIndex
            });
            // Look for the photo in walkThrough.photos
            photosIndex = photos.findIndex(function (photo) {
              return photo.id === photoId;
            });
            // Add the photo if not found
            if (photosIndex === -1) {
              photos.push({
                id: photoId,
                locations: [],
                objects: [],
                url: _this85.photos[_this85.photoIndexes[rowIndex]].url
              });
              photosIndex = photos.length - 1;
            }
            // Add the row's location
            photos[photosIndex].locations.push({
              height: row.data.location.height,
              left: row.data.location.left,
              rowIndex: rowIndex,
              top: row.data.location.top,
              width: row.data.location.width
            });
            // Add the row's objects
            if (row.data.objects) {
              row.data.objects.forEach(function (obj) {
                _this85.lastObjectKey++;
                photos[photosIndex].objects.push({
                  angle: obj.angle,
                  flipX: obj.flipX,
                  flipY: obj.flipY,
                  height: obj.height,
                  key: _this85.lastObjectKey,
                  left: obj.left,
                  sequence: obj.sequence,
                  top: obj.top,
                  url: obj.url,
                  width: obj.width
                });
              });
            }
          } else {
            // No background photo, only objects
            objects = [];
            row.data.objects.forEach(function (obj) {
              _this85.lastObjectKey++;
              objects.push({
                angle: obj.angle,
                flipX: obj.flipX,
                flipY: obj.flipY,
                height: obj.height,
                key: _this85.lastObjectKey,
                left: obj.left,
                sequence: obj.sequence,
                top: obj.top,
                url: obj.url,
                width: obj.width
              });
            });
            steps.push({
              objects: objects,
              rowIndex: rowIndex
            });
          }
        }
        previousPhotoId = photoId;
        _this85.animateTransition = false;
        // Set initial data height if data is visible
        if (_this85.dataVisible) {
          _this85.$nextTick(_this85.setDataHeight);
        }
      });
      // Sort objects within photos
      photos.forEach(function (photo) {
        photo.objects.sort(function (a, b) {
          if (a.sequence < b.sequence) return -1;
          return 1;
        });
      });
      // Remove photo step if only one location for the photo
      this.walkThrough.steps = steps.filter(function (step, stepIndex) {
        return !step.summary || steps[stepIndex + 2] && steps[stepIndex + 2].photoId === step.photoId;
      });
      this.walkThrough.stepNum = 0;
      // Prepare slider
      $('#walkThroughSlider').slider({
        min: 0,
        max: this.walkThrough.steps.length - 1,
        onMove: function onMove(value) {
          if (value !== _this85.walkThrough.stepNum) {
            _this85.walkThroughMove(value - _this85.walkThrough.stepNum, 'slider');
          }
        }
      });
      this.prepareWalkThroughStep({});
      this.modal = 'walkThrough';
      $('.ui.modal.walkThrough').modal({
        autofocus: false,
        centered: false,
        onHidden: this.revertPreventBackHistory,
        onHide: function onHide() {
          // Workaround for onHide firing when other modals are closed
          if ($('.ui.modal.walkThrough').modal('is active')) {
            // Show data table
            _this85.modal = '';
            _this85.prepareVisibleRows();
            _this85.setTableWrapperHeight();
            if (!_this85.walkThrough.rowClicked) {
              _this85.revertTableWrapperScrollPos();
            }
            _this85.walkThrough.rowClicked = false;
          }
        },
        onVisible: this.prepareModalHistory
      }).modal('show');
    },
    walkThroughGoToRowClick: function walkThroughGoToRowClick() {
      this.firstVisibleRow = this.walkThrough.steps[this.walkThrough.stepNum].rowIndex + 1;
      this.goToRowVal = this.firstVisibleRow.toString();
      this.walkThrough.rowClicked = true;
      this.closeWalkThrough();
    },
    walkThroughMove: function walkThroughMove(delta, source, event) {
      var _this86 = this;

      var photoChange = void 0,
          step = void 0;
      // Blur button
      if (event) event.target.blur();
      // Exit if no available step
      if (this.walkThrough.stepNum + delta < 0 || this.walkThrough.stepNum + delta > this.walkThrough.steps.length - 1) return;
      this.walkThrough.stepNum += delta;
      step = this.walkThrough.steps[this.walkThrough.stepNum];
      photoChange = !step.photoId || step.photoId !== this.walkThrough.steps[this.walkThrough.stepNum - delta].photoId;
      if (photoChange) {
        this.photoOpacity = 0;
        this.animateTransition = false;
      }
      this.$nextTick(function () {
        _this86.animateTransition = true;
        _this86.photoOpacity = 1;
        _this86.prepareWalkThroughStep({
          photoChange: photoChange
        });
      });
      // Update slider
      if (source === 'button' || source === 'key') {
        $('.ui.slider').slider('set value', this.walkThrough.stepNum);
      }
    },
    windowKeyDown: function windowKeyDown(event) {
      // Learn tab
      if (this.activeTab === 'learn') {
        // If not in Learn modal or max response time field
        if (this.modal !== 'learn' && document.activeElement !== document.getElementById('maxResponseTime')) {
          // Handle right arrow
          if (event.keyCode === 39) {
            this.learnClick();
          }
        }
        // If in max response time field
        if (document.activeElement === document.getElementById('maxResponseTime')) {
          // Handle enter key
          if (event.keyCode === 13) {
            document.getElementById('maxResponseTime').blur();
          }
        }
      }
      // Add Cell Image modal
      if ($('.ui.modal.addCellImage').modal('is active')) {
        // Handle Enter key
        if (event.keyCode === 13) {
          this.addCellImageEnter();
        }
      }
      // Add Column modal
      if ($('.ui.modal.addColumn').modal('is active')) {
        // Handle Enter key
        if (event.keyCode === 13) {
          this.addColumnEnter();
        }
      }
      // Add Rows modal
      if ($('.ui.modal.addRows').modal('is active')) {
        // Handle Enter key
        if (event.keyCode === 13) {
          this.addRowsEnter();
        }
      }
      // Background Photo modal
      if ($('.ui.modal.backgroundPhoto').modal('is active')) {
        // Handle Enter key
        if (event.keyCode === 13) {
          this.backgroundPhotoEnter();
        }
      }
      // Copied Memo Set modal
      if ($('.ui.modal.copiedMemoSet').modal('is active')) {
        // Handle Enter key
        if (event.keyCode === 13) {
          this.copiedMemoSetEnter();
        }
      }
      // Copy Memo Set modal
      if ($('.ui.modal.copyMemoSet').modal('is active')) {
        // Handle Enter key
        if (event.keyCode === 13) {
          this.copyMemoSetEnter();
        }
      }
      // Delete Column modal
      if ($('.ui.modal.deleteColumn').modal('is active')) {
        // Handle Enter key
        if (event.keyCode === 13) {
          this.deleteColumnEnter();
        }
      }
      // Delete Memo Set modal
      if ($('.ui.modal.deleteMemoSet').modal('is active')) {
        // Handle Enter key
        if (event.keyCode === 13) {
          this.deleteMemoSetEnter();
        }
      }
      // Delete Rows modal
      if ($('.ui.modal.deleteRows').modal('is active')) {
        // Handle Enter key
        if (event.keyCode === 13) {
          this.deleteRowsEnter();
        }
      }
      // Export Data modal
      if ($('.ui.modal.exportData').modal('is active')) {
        // Handle Enter key
        if (event.keyCode === 13) {
          this.exportDataEnter();
        }
      }
      // Invalid Row Number modal
      if ($('.ui.modal.invalidRowNumber').modal('is active')) {
        // Handle Enter key
        if (event.keyCode === 13) {
          $('.ui.modal.invalidRowNumber').modal('hide');
        }
      }
      // Learn modal
      if ($('.ui.modal.learn').modal('is active')) {
        // Handle right arrow, D keys
        if (event.keyCode === 39 || event.keyCode === 68) {
          if (!this.learn.answerVisible) {
            this.showAnswerClick();
            event.preventDefault();
          }
        }
        // Handle left arrow, A keys
        if (event.keyCode === 37 || event.keyCode === 65) {
          if (!this.learn.answerVisible && this.learn.previousReviewItem) {
            this.oopsClick();
            event.preventDefault();
          }
        }
        // Handle up arrow, W keys
        if (event.keyCode === 38 || event.keyCode === 87) {
          if (this.learn.answerVisible) {
            this.answerClick('correct');
            event.preventDefault();
          }
        }
        // Handle down arrow, S keys
        if (event.keyCode === 40 || event.keyCode === 83) {
          if (this.learn.answerVisible) {
            this.answerClick('incorrect');
            event.preventDefault();
          }
        }
      }
      // Move Columns modal
      if ($('.ui.modal.moveColumn').modal('is active')) {
        // Handle Enter key
        if (event.keyCode === 13) {
          this.moveColumnEnter();
        }
      }
      // Move Rows modal
      if ($('.ui.modal.moveRows').modal('is active')) {
        // Handle Enter key
        if (event.keyCode === 13) {
          this.moveRowsEnter();
        }
      }
      // Populate Column modal
      if ($('.ui.modal.populateColumn').modal('is active')) {
        // Handle Enter key
        if (event.keyCode === 13) {
          this.populateColumnEnter();
        }
      }
      // Question modal
      if ($('.ui.modal.question').modal('is active')) {
        // Handle Enter key
        if (event.keyCode === 13) {
          this.questionEnter();
        }
        // Handle Escape key
        if (event.keyCode === 27) {
          $('.ui.modal.question').modal('hide');
        }
      }
      // Set Cover Image modal
      if ($('.ui.modal.setCoverImage').modal('is active')) {
        // Handle Enter key
        if (event.keyCode === 13) {
          this.coverImageEnter();
        }
      }
      // Share Memo Set modal
      if ($('.ui.modal.shareMemoSet').modal('is active')) {
        // Handle Enter key
        if (event.keyCode === 13) {
          this.shareMemoSetEnter();
        }
      }
      // Sort Rows modal
      if ($('.ui.modal.sortRows').modal('is active')) {
        // Handle Enter key
        if (event.keyCode === 13) {
          this.sortRowsEnter();
        }
      }
      // Summary Image modal
      if ($('.ui.modal.summaryImage').modal('is active')) {
        // If Escape pressed
        if (event.keyCode === 27) {
          if (this.summaryImage.page === 'summary') {
            $('.ui.modal.summaryImage').modal('hide');
          } else {
            this.summaryImage.page = 'summary';
          }
        }
        // If Delete pressed
        if (event.keyCode === 46) {
          if (this.summaryImage.page === 'summary' && this.mode === 'select' && this.activeObject !== -1) {
            this.deleteImageClick();
          }
        }
        // If Ctrl-Z pressed
        if (event.keyCode === 90 && this.ctrlDown && this.summaryImage.undoArrayIndex) {
          this.summaryImageUndoClick();
        }
        // If Ctrl-Y pressed
        if (event.keyCode === 89 && this.ctrlDown && this.summaryImage.undoArrayIndex < this.summaryImage.undoArrayIndexMax) {
          this.summaryImageRedoClick();
        }
      }
      // Walk Through modal
      if ($('.ui.modal.walkThrough').modal('is active')) {
        // If Enter or Escape pressed
        if (event.keyCode === 13 || event.keyCode === 27) {
          this.closeWalkThrough();
          event.preventDefault();
        }
        // If right arrow or D pressed
        if (event.keyCode === 39 || event.keyCode === 68) {
          // Move through the walk through, unless the focus is on the slider, in which case the slider has already handled it
          if (document.activeElement.id !== 'walkThroughSlider') {
            this.walkThroughMove(1, 'key');
          }
        }
        // Left arrow, A
        if (event.keyCode === 37 || event.keyCode === 65) {
          // Move through the walk through, unless the focus is on the slider, in which case the slider has already handled it
          if (document.activeElement.id !== 'walkThroughSlider') {
            this.walkThroughMove(-1, 'key');
          }
        }
        // Space
        if (event.keyCode === 32) {
          this.showObjectsClick();
          event.preventDefault();
        }
      }
      // View Alternatives modal
      if ($('.ui.modal.viewAlternatives').modal('is active')) {
        // Handle Enter key
        if (event.keyCode === 13) {
          this.viewAlternativesEnter();
        }
      }
      // If Ctrl pressed
      if (event.keyCode === 17) {
        this.ctrlDown = true;
      }
    },
    windowKeyUp: function windowKeyUp(event) {
      // If Ctrl unpressed
      if (event.keyCode === 17) {
        this.ctrlDown = false;
      }
    },
    windowPointerUp: function windowPointerUp(event) {
      // If the user clicked briefly on the summary image background
      if (this.mode === 'select' && !this.panLock && this.summaryImage.backgroundPointerDownTimestamp && event.timeStamp - this.summaryImage.backgroundPointerDownTimestamp < 300) {
        // Deselect all objects
        this.rectangleActive = false;
        this.activeObject = -1;
      }
      this.summaryImage.backgroundPointerDownTimestamp = 0;
      this.panning = false;
      if (this.clipping) this.clippingPointerUp();
      if (this.drawing) this.endDrawing();
      if (this.removing) this.removeColor();
      if (this.movingRectangle) this.endMovingRectangle();
      if (this.movingObject) this.endMovingObject();
      if (this.resizingObject) this.endResizingObject();
      if (this.resizingRectangle) this.endResizingRectangle();
      if (this.rotatingObject) this.endRotatingObject();
    },
    windowWheel: function windowWheel(event) {
      var mouseX = void 0,
          mouseXRelativeToVisiblePhoto = void 0,
          mouseY = void 0,
          mouseYRelativeToVisiblePhoto = void 0,
          summaryImageRect = void 0,
          summaryImageWrapper = void 0;
      if ($('.ui.modal.summaryImage').modal('is active')) {
        // Get mouse position relative to the visible photo
        summaryImageWrapper = $('.summaryImageWrapper')[0];
        if (summaryImageWrapper) {
          summaryImageRect = summaryImageWrapper.getBoundingClientRect();
          mouseXRelativeToVisiblePhoto = event.clientX - summaryImageRect.left;
          mouseYRelativeToVisiblePhoto = event.clientY - summaryImageRect.top;
          // Calculate position of mouse relative to the photo
          mouseX = -this.photoTransform.translateX + mouseXRelativeToVisiblePhoto / this.photoTransform.scale;
          mouseY = -this.photoTransform.translateY + mouseYRelativeToVisiblePhoto / this.photoTransform.scale;
          if (event.deltaY < 0) {
            this.zoomIn(1.2, null, { x: mouseX, y: mouseY }, true);
          }
          if (event.deltaY > 0) {
            this.zoomOut(1.2, null, { x: mouseX, y: mouseY }, true);
          }
          event.preventDefault();
        }
      }
    },
    writeFields: function writeFields() {
      db.doc('memoSets/' + this.memoSetId).update({
        fields: this.fields
      }).catch(function (error) {
        logError('MemoSet_writeFields', error);
      });
    },
    writeQuestions: function writeQuestions() {
      db.doc('memoSets/' + this.memoSetId).update({
        questions: this.questions
      }).catch(function (error) {
        logError('MemoSet_writeQuestions', error);
      });
    },
    writeRowCount: function writeRowCount(batch) {
      var updateObj = {};
      updateObj[this.memoSetId + '.rowCount'] = this.rows.length;
      batch.update(db.doc('users/' + this.user.id + '/memoSets/' + this.docId), updateObj);
      this.updateSharedSummaries(batch, {
        rowCount: this.rows.length
      });
    },
    writeSelectedQuestions: function writeSelectedQuestions(batch) {
      batch.update(db.doc('memoSets/' + this.memoSetId), {
        selectedQuestionIds: this.learn.questionIds
      });
    },
    writeSharedSummary: function writeSharedSummary(batch, shareUserId) {
      var summary = {
        coverImage: this.coverImage,
        description: this.databaseDescription,
        rowCount: this.rows.length,
        ownerId: this.user.id,
        ownerName: this.user.displayName,
        slug: this.slug,
        title: this.title
      };
      if (shareUserId === 'public') {
        batch.set(db.doc('publicMemoSets/' + this.memoSetId), summary);
      } else {
        batch.set(db.doc('users/' + shareUserId + '/sharedWithMe/' + this.memoSetId), summary);
      }
    },
    zoomIn: function zoomIn(zoomFactor, event, mousePos, animate) {
      // centerX, centerY, mousePos are relative to the photo
      var centerX = void 0,
          centerY = void 0;
      // Blur button
      if (event) event.target.blur();
      // Calculate center of showRect relative to the photo
      centerX = -this.photoTransform.translateX + 0.5 * this.photoTransform.visibleWidth / this.photoTransform.scale;
      centerY = -this.photoTransform.translateY + 0.5 * this.photoTransform.visibleHeight / this.photoTransform.scale;
      this.showRect.width /= zoomFactor;
      this.showRect.height /= zoomFactor;
      this.showRect.left = centerX - this.showRect.width / 2;
      this.showRect.top = centerY - this.showRect.height / 2;
      // If zooming with mouse wheel, adjust to maintain section of photo under cursor
      if (mousePos) {
        this.showRect.left += (mousePos.x - centerX) * (zoomFactor - 1) / zoomFactor;
        this.showRect.top += (mousePos.y - centerY) * (zoomFactor - 1) / zoomFactor;
        // Keep showRect within bounds
        if (this.showRect.left < 0) this.showRect.left = 0;
        if (this.showRect.top < 0) this.showRect.top = 0;
        if (this.showRect.left + this.showRect.width > this.photo.width) this.showRect.left = this.photo.width - this.showRect.width;
        if (this.showRect.top + this.showRect.height > this.photo.height) this.showRect.top = this.photo.height - this.showRect.height;
      }
      this.animateTransition = animate;
    },
    zoomOut: function zoomOut(zoomFactor, event, mousePos, animate) {
      // centerX, centerY, mousePos are relative to the photo
      var centerX = void 0,
          centerY = void 0,
          previousHeight = void 0,
          previousWidth = void 0;
      // Blur button
      if (event) event.target.blur();
      // Calculate center of showRect relative to the photo
      centerX = -this.photoTransform.translateX + 0.5 * this.photoTransform.visibleWidth / this.photoTransform.scale;
      centerY = -this.photoTransform.translateY + 0.5 * this.photoTransform.visibleHeight / this.photoTransform.scale;
      previousWidth = this.showRect.width;
      previousHeight = this.showRect.height;
      this.showRect.width *= zoomFactor;
      this.showRect.height *= zoomFactor;
      this.showRect.left -= (this.showRect.width - previousWidth) / 2;
      this.showRect.top -= (this.showRect.height - previousHeight) / 2;
      // If zooming with mouse wheel, adjust to maintain section of photo under cursor
      if (mousePos) {
        this.showRect.left -= (mousePos.x - centerX) * (zoomFactor - 1);
        this.showRect.top -= (mousePos.y - centerY) * (zoomFactor - 1);
      }
      // Adjust showRect if it is beyond the left side of the photo
      if (this.showRect.left < 0) {
        // Reduce width
        this.showRect.width += this.showRect.left;
        this.showRect.left = 0;
      }
      // Adjust showRect if it is beyond the top of the photo
      if (this.showRect.top < 0) {
        // Reduce height
        this.showRect.height += this.showRect.top;
        this.showRect.top = 0;
      }
      // Adjust showRect if it is beyond the right side of the photo
      if (this.showRect.left + this.showRect.width > this.photo.width) {
        this.showRect.width = this.photo.width - this.showRect.left;
      }
      // Adjust showRect if it is beyond the bottom of the photo
      if (this.showRect.top + this.showRect.height > this.photo.height) {
        this.showRect.height = this.photo.height - this.showRect.top;
      }
      this.animateTransition = animate;
    },
    zoomToSelected: function zoomToSelected() {
      // Blur button
      document.getElementById('zoomToSelectedButton').blur();
      this.animateTransition = true;
      if (this.rectangleActive) {
        var objRect = this.objectRectWithMargin(this.activeObject, 0.1);
        this.showRect = {
          left: objRect.left,
          top: objRect.top,
          width: objRect.width,
          height: objRect.height
        };
      } else if (this.activeObject !== -1) {
        var _objRect = this.objectRectWithMargin(this.activeObject, 0.1);
        this.showRect = {
          left: _objRect.left,
          top: _objRect.top,
          width: _objRect.width,
          height: _objRect.height
        };
      } else {
        // Show entire photo
        this.showRect = {
          left: 0,
          top: 0,
          width: this.photo.width,
          height: this.photo.height
        };
      }
    }
  },
  mounted: function mounted() {
    var _this87 = this;

    this.setInfoWrapperHeight();
    // Initialize main tabs
    $('.menu.mainTabs .item').tab({
      onVisible: function onVisible(tabPath) {
        _this87.activeTab = tabPath;
        if (tabPath === 'info') {
          _this87.setInfoWrapperHeight();
        }
        if (tabPath === 'data') {
          // Initialize visible summary image thumbnails and Mathjax
          _this87.prepareVisibleRows();
          _this87.setTableWrapperHeight();
        }
        if (tabPath === 'questions') {
          _this87.setQuestionsWrapperHeight();
        }
        if (tabPath === 'learn' && _this87.ready) {
          _this87.setLearnWrapperHeights();
          _this87.initLearn();
        }
      }
    });
    // Initialize tabs on backgroundPhoto modal
    $('.menu.backgroundPhotoTabs .item').tab({
      onVisible: function onVisible(tabPath) {
        _this87.backgroundPhotoTab = tabPath;
      }
    });
    this.$nextTick(function () {
      var _this88 = this;

      $('.actionsButton').popup({
        delay: {
          hide: 1000000
        },
        inline: true,
        hoverable: true,
        on: 'click',
        onHidden: function onHidden() {
          _this88.revertPreventBackHistory();
        },
        onVisible: function onVisible() {
          _this88.backCloses = 'popup';
          _this88.preventBack();
        },
        position: 'bottom right'
      });
    });
    // Add event listeners
    window.addEventListener('mouseup', this.windowPointerUp);
    window.addEventListener('touchend', this.windowPointerUp);
    window.addEventListener('keydown', this.windowKeyDown);
    window.addEventListener('keyup', this.windowKeyUp);
    window.addEventListener('wheel', this.windowWheel, { passive: false });
  },
  props: ['memoSets', 'mobile', 'text', 'touch', 'user', 'window'],
  watch: {
    memoSets: function memoSets(newMemoSets) {
      if (newMemoSets) {
        this.initMemoSet();
      }
    },
    'window.height': function windowHeight(newHeight, oldHeight) {
      this.animateTransition = false;
      if (this.modal === 'walkThrough') {
        this.setDataHeight();
      }
      this.setInfoWrapperHeight();
      this.setTableWrapperHeight();
      if (this.mobile) {
        this.setHideTopElements();
        // Blur active element if virtual keyboard closed
        if (this.touch && newHeight - oldHeight > 100) {
          document.activeElement.blur();
        }
      }
      this.setQuestionsWrapperHeight();
      this.setLearnWrapperHeights();
    },
    'window.width': function windowWidth(newWidth) {
      this.animateTransition = false;
      if (this.modal === 'walkThrough') {
        this.setDataHeight();
      }
      // Note - changing width may change mobile value
      this.setInfoWrapperHeight();
      this.setTableWrapperHeight();
      this.setQuestionsWrapperHeight();
      this.setLearnWrapperHeights();
    }
  }
});

/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemoSetMethods_vue__ = __webpack_require__(88);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemoSetMethods_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);



var firebase = window.firebase;
var db = firebase.firestore();
var memoSetsPerDoc = 1000;

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    createMemoSetSlug: function createMemoSetSlug(title) {
      // Note: a dot in the slug causes a "Cannot GET ..." error if a memo set page is refreshed
      var slug = void 0;
      // If the title is all dots
      if (title.replace(/\./g, '') === '') {
        // Replace dots with hyphens
        slug = title.replace(/\./g, '-');
      } else {
        // Remove dots, replace whitespace with -, and encode the rest
        // Note that browsers generally show the decoded characters in the URL as per https://stackoverflow.com/a/2742985
        slug = encodeURI(title.toLowerCase().replace(/\./g, '').replace(/\s+/g, '-'));
      }
      return slug;
    },
    firstAvailableDocId: function firstAvailableDocId() {
      // Returns the first available doc ID for a new memo set
      var docId = void 0,
          docIds = void 0,
          found = void 0;
      // Create an array of all docIds used so far
      docIds = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(this.memoSets.map(function (memoSet) {
        return memoSet.docId;
      }))));
      for (var i = 0; i < docIds.length; i++) {
        docId = docIds[i];
        if (this.memoSets.filter(function (memoSet) {
          return memoSet.docId === docId;
        }).length < memoSetsPerDoc) {
          found = true;
          break;
        }
      }
      if (!found) {
        // Get a new random doc ID
        docId = this.randomId();
      }
      return docId;
    },
    nextFolderId: function nextFolderId() {
      var folderId = void 0,
          folderIndex = void 0;
      // Get next available folder ID
      folderIndex = 0;
      while (true) {
        folderIndex++;
        folderId = 'f' + folderIndex.toString();
        if (!this.user.folders.filter(function (folder) {
          return folder.folderId === folderId;
        }).length) break;
      }
      return folderId;
    },
    newMemoSetTitle: function newMemoSetTitle() {
      var title = void 0,
          titleWithVersion = void 0,
          version = void 0;
      title = this.text.memoSetsDefaultTitle;
      // Check whether there is a memo set with the desired title
      if (this.memoSets.filter(function (memoSet) {
        return memoSet.title === title;
      }).length) {
        // Append the next unused version number (starting at 2) in parentheses to construct the title
        version = 1;
        while (true) {
          version++;
          titleWithVersion = title + ' (' + version + ')';
          if (!this.memoSets.filter(function (memoSet) {
            return memoSet.title === titleWithVersion;
          }).length) {
            title = titleWithVersion;
            break;
          }
        }
      }
      return title;
    },
    randomId: function randomId() {
      return db.collection('dummy').doc().id;
    }
  }
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Breadcrumbs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_StatusBar__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_MemoSetMethods__ = __webpack_require__(87);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var $ = window.$;
var firebase = window.firebase;
var db = firebase.firestore();

function logError(errorCode, error) {
  console.log(errorCode);
  console.log(error);
}

// Function from https://stackoverflow.com/questions/6139107/programmatically-select-text-in-a-contenteditable-html-element
function selectElementContents(el) {
  var range = document.createRange();
  range.selectNodeContents(el);
  var sel = window.getSelection();
  sel.removeAllRanges();
  sel.addRange(range);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'memo-sets',
  components: {
    Breadcrumbs: __WEBPACK_IMPORTED_MODULE_3__components_Breadcrumbs__["a" /* default */],
    StatusBar: __WEBPACK_IMPORTED_MODULE_4__components_StatusBar__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_MemoSetMethods__["a" /* default */]],
  data: function data() {
    return {
      accordionState: [],
      addingMemoSetId: '',
      draggingFolder: false,
      draggingMemoSet: false,
      folderDragEnters: 0,
      folderTouchInitialTimeout: null,
      fromFolderIndex: -1,
      fromMemoSetIndex: -1,
      memoSetDragFolderTimeout: null,
      memoSetDragEnters: 0,
      memoSetTouchFolderTimeout: null,
      memoSetTouchInitialTimeout: null,
      newFolder: false,
      pendingFolder: -1,
      ready: false,
      renamingFolder: -1,
      toFolderIndex: -1,
      toMemoSetIndex: -1,
      touchMovingFolder: false,
      touchMovingMemoSet: false,
      touchScrollTimeout: null,
      touchY: 0
    };
  },

  computed: {
    breadcrumbs: function breadcrumbs() {
      return [{ label: this.text.navHome, to: '/' }, { label: this.text.navMemoSets }];
    },
    folders: function folders() {
      var _this = this;

      var folders = void 0,
          memoSetsForFolder = void 0;
      if (!this.user.folders || !this.memoSets) return [];
      // Create array of folders with memo sets
      folders = [];
      this.user.folders.forEach(function (folder, folderIndex) {
        memoSetsForFolder = _this.memoSets.filter(function (memoSet) {
          return memoSet.folderId === folder.folderId;
        });
        // Sort by sequence
        memoSetsForFolder.sort(function (a, b) {
          if (a.seq < b.seq) return -1;
          return 1;
        });
        folders.push({
          folderId: folder.folderId,
          folderName: folder.folderName,
          memoSets: memoSetsForFolder,
          seq: folderIndex
        });
      });
      return folders;
    },
    statusesWithSpeed: function statusesWithSpeed() {
      var statusesWithSpeed = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.statuses);
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(statusesWithSpeed).forEach(function (memoSetId) {
        statusesWithSpeed[memoSetId].speed = 'slow';
      });
      return statusesWithSpeed;
    }
  },
  created: function created() {
    // TEMP - for debugging
    window.vm = this;
    // Set memo set source - used by the MemoSet component
    window.aoms = window.aoms || {};
    window.aoms.memoSetSource = 'MemoSets';
    this.checkReady();
    this.setPageTitle();
  },
  mounted: function mounted() {
    var accordionContents = void 0,
        accordionTitles = void 0,
        i = void 0,
        self = void 0;
    self = this;
    // Initialize accordion
    $('.ui.accordion').accordion({
      exclusive: false,
      onClosing: function onClosing() {
        self.$set(self.accordionState, this.index('.content'), false);
        window.aoms = window.aoms || {};
        window.aoms.accordionState = self.accordionState.slice();
      },
      onOpen: function onOpen() {
        if (self.newFolder) {
          self.newFolder = false;
          window.scrollTo({
            left: 0,
            top: document.body.scrollHeight,
            behavior: 'smooth'
          });
        }
      },
      onOpening: function onOpening() {
        self.$set(self.accordionState, this.index('.content'), true);
        window.aoms = window.aoms || {};
        window.aoms.accordionState = self.accordionState.slice();
      }
    });
    // If we have a saved accordion state, open sections appropriately
    if (window.aoms && window.aoms.accordionState) {
      accordionContents = document.querySelectorAll('.ui.accordion .content');
      accordionTitles = document.querySelectorAll('.ui.accordion .title');
      for (i = 0; i < this.folders.length; i++) {
        if (window.aoms.accordionState[i]) {
          accordionContents[i].classList.add('active');
          accordionTitles[i].classList.add('active');
        }
      }
    }
    // Initialize search
    this.initSearch();
  },
  methods: {
    addFolderClick: function addFolderClick(event) {
      var _this2 = this;

      this.folders.push({
        folderId: this.nextFolderId(),
        folderName: this.text.memoSetsNewFolder,
        memoSets: [],
        seq: this.folders.length
      });
      this.writeFolders();
      this.renamingFolder = this.folders.length - 1;
      // Open the new folder
      this.$nextTick(function () {
        _this2.$nextTick(function () {
          _this2.newFolder = true;
          $('.ui.accordion').accordion('open', _this2.folders.length - 1);
          _this2.$nextTick(function () {
            var folderName = void 0;
            folderName = document.getElementById('folder' + _this2.renamingFolder);
            folderName.focus();
            selectElementContents(folderName);
          });
        });
      });
    },
    addMemoSetClick: function addMemoSetClick(folderIndex) {
      var _this3 = this;

      var blankRows = void 0,
          updateObj = void 0;
      var docId = this.firstAvailableDocId();
      var folder = this.folders[folderIndex];
      var folderId = folder.folderId;
      // Set seq to 1 more than the highest seq in the folder
      var seq = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(folder.memoSets.map(function (memoSet) {
        return memoSet.seq;
      })).concat([-1])) + 1;
      var memoSetRef = db.collection('memoSets').doc();
      var memoSetId = memoSetRef.id;
      var title = this.newMemoSetTitle();
      var slug = this.createMemoSetSlug(title);
      // Start batched write
      var batch = db.batch();
      batch.set(memoSetRef, {
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        description: '',
        fields: [{
          fieldId: 'f1',
          heading: this.text.memoSetDefaultColumn1
        }, {
          fieldId: 'f2',
          heading: this.text.memoSetDefaultColumn2
        }],
        options: {
          useBackgroundPhotos: false,
          useReviewGroups: false,
          useSummaryImages: false
        },
        photos: [],
        sharing: {},
        questions: [],
        userId: this.user.id
      });
      updateObj = {};
      updateObj[memoSetId] = {
        coverImage: 'https://firebasestorage.googleapis.com/v0/b/art-of-memory.appspot.com/o/common%2Fdodec.png?alt=media&token=e4181cb6-dcd4-4964-b857-cd8723fdec09',
        folderId: folderId,
        rowCount: 3,
        seq: seq,
        slug: slug,
        title: title
      };
      batch.update(db.doc('users/' + this.user.id + '/memoSets/' + docId), updateObj);
      // Write 3 blank rows, plus userId for security rules
      blankRows = { userId: this.user.id };
      for (var i = 0; i < 3; i++) {
        blankRows[this.randomId()] = {
          seq: i
        };
      }
      batch.set(db.doc('memoSets/' + memoSetId + '/rows/' + this.randomId()), blankRows);
      this.addingMemoSetId = memoSetId;
      batch.commit().then(function () {
        // Route to the new memo set
        _this3.$router.push('memo-sets/' + memoSetId + '/' + slug);
      }).catch(function (error) {
        _this3.addingMemoSetId = '';
        logError('MemoSets_addMemoSetClick', error);
      });
    },
    addMemoSetWrapperDragEnter: function addMemoSetWrapperDragEnter(folderIndex) {
      if (this.draggingMemoSet) {
        this.memoSetDragEnters++;
        this.toFolderIndex = folderIndex;
        if (this.folders[folderIndex].memoSets) {
          this.toMemoSetIndex = this.folders[folderIndex].memoSets.length;
        } else {
          this.toMemoSetIndex = 0;
        }
      }
    },
    addMemoSetWrapperDragLeave: function addMemoSetWrapperDragLeave() {
      if (this.draggingMemoSet) {
        this.memoSetDragEnters--;
        if (!this.memoSetDragEnters) {
          this.toMemoSetIndex = -1;
        }
      }
    },
    checkReady: function checkReady() {
      // Redirect to Home page if the user data has loaded but the user isn't signed in
      if (this.user.uiLanguage && !this.user.folders) {
        this.$router.push('/');
      }
      if (this.user.folders && this.memoSets) {
        // If we have a saved accordion state with the same number of folders, use it
        if (window.aoms && window.aoms.accordionState && window.aoms.accordionState.length === this.user.folders.length) {
          this.accordionState = window.aoms.accordionState.slice();
        } else {
          // Initialize accordion state
          this.closeAll();
          this.accordionState = this.folders.map(function (folder) {
            return false;
          });
          window.aoms = window.aoms || {};
          window.aoms.accordionState = this.accordionState.slice();
        }
        // Initialize search
        this.initSearch();
        this.ready = true;
      }
    },
    closeAll: function closeAll() {
      var i = void 0;
      // Close all accordion sections
      for (i = 0; i < this.folders.length; i++) {
        if (this.accordionState[i]) {
          $('.ui.accordion').accordion('close', i);
        }
      }
    },
    deleteFolderClick: function deleteFolderClick(index) {
      $('.ui.accordion').accordion('close', index);
      this.folders.splice(index, 1);
      this.writeFolders();
    },
    disableMenuForTouch: function disableMenuForTouch(event) {
      if (this.touch) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    },
    folderDragEnd: function folderDragEnd() {
      this.draggingFolder = false;
    },
    folderDragEnter: function folderDragEnter(folderIndex) {
      var _this4 = this;

      if (this.draggingFolder) {
        this.folderDragEnters++;
        this.toFolderIndex = folderIndex;
      }
      if (this.draggingMemoSet) {
        this.memoSetDragEnters++;
        if (this.pendingFolder !== -1 && folderIndex !== this.pendingFolder) {
          // Cancel timeout if there is one already
          if (this.memoSetDragFolderTimeout !== null) {
            clearTimeout(this.memoSetDragFolderTimeout);
            this.memoSetDragFolderTimeout = null;
            this.pendingFolder = -1;
          }
        }
        // If the folder is closed and not pending open
        if (!this.accordionState[folderIndex] && folderIndex !== this.pendingFolder) {
          this.memoSetDragFolderTimeout = setTimeout(function () {
            _this4.memoSetDragFolderTimeout = null;
            $('.ui.accordion').accordion('open', folderIndex);
            _this4.pendingFolder = -1;
          }, 500);
          this.pendingFolder = folderIndex;
        }
        this.toFolderIndex = folderIndex;
        this.toMemoSetIndex = 0;
      }
    },
    folderDragLeave: function folderDragLeave() {
      if (this.draggingFolder) {
        this.folderDragEnters--;
        // If we haven't entered another folder, we've left all folders
        if (!this.folderDragEnters) {
          this.toFolderIndex = -1;
        }
      }
      if (this.draggingMemoSet) {
        this.memoSetDragEnters--;
        // If we haven't entered another folder, we've left all folders
        if (!this.memoSetDragEnters) {
          // Cancel timeout if there is one
          if (this.memoSetDragFolderTimeout !== null) {
            clearTimeout(this.memoSetDragFolderTimeout);
            this.memoSetDragFolderTimeout = null;
            this.pendingFolder = -1;
          }
        }
      }
    },
    folderDragStart: function folderDragStart(folderIndex) {
      // Ignore dragstart if touching the screen
      if (this.folderTouchInitialTimeout || this.touchMovingFolder) return;
      // Close all accordion sections
      this.closeAll();
      this.draggingFolder = true;
      this.fromFolderIndex = folderIndex;
      this.folderDragEnters = 0;
    },
    folderDrop: function folderDrop() {
      var folder = void 0;
      if (this.draggingFolder) {
        if (this.fromFolderIndex !== this.toFolderIndex) {
          // Move folder
          folder = this.folders.splice(this.fromFolderIndex, 1)[0];
          this.folders.splice(this.toFolderIndex, 0, folder);
          this.writeFolders();
        }
      }
      if (this.draggingMemoSet) {
        // Move memo set to the start of the folder
        this.moveMemoSet();
      }
    },
    folderNameBlur: function folderNameBlur(event) {
      // If no folder name, revert to previous value
      if (!event.target.textContent.trim()) {
        event.target.textContent = this.folders[this.renamingFolder].folderName;
        this.renamingFolder = -1;
        return;
      }
      // If folder name has changed
      if (event.target.textContent.trim() !== this.folders[this.renamingFolder].folderName) {
        this.folders[this.renamingFolder].folderName = event.target.textContent.trim();
        this.writeFolders();
        // Update search data
        this.initSearch();
      }
      this.renamingFolder = -1;
    },
    folderTitleClick: function folderTitleClick(event, folderIndex) {
      if (folderIndex === this.renamingFolder) {
        event.stopPropagation();
      }
    },
    folderTouchEnd: function folderTouchEnd() {
      var folder = void 0;
      if (this.folderTouchInitialTimeout !== null) {
        clearTimeout(this.folderTouchInitialTimeout);
        this.folderTouchInitialTimeout = null;
      }
      if (this.touchMovingFolder) {
        if (this.fromFolderIndex !== this.toFolderIndex) {
          // Move folder
          folder = this.folders.splice(this.fromFolderIndex, 1)[0];
          this.folders.splice(this.toFolderIndex, 0, folder);
          this.writeFolders();
        }
      }
      this.touchMovingFolder = false;
    },
    folderTouchMove: function folderTouchMove(event) {
      var folders = void 0,
          i = void 0,
          touchLocation = void 0,
          touchTarget = void 0;
      if (this.folderTouchInitialTimeout !== null) {
        clearTimeout(this.folderTouchInitialTimeout);
        this.folderTouchInitialTimeout = null;
      }
      if (this.touchMovingFolder) {
        // Determine touch target
        touchLocation = event.changedTouches[0];
        touchTarget = document.elementFromPoint(touchLocation.clientX, touchLocation.clientY);
        // Handle page scrolling
        this.touchY = touchLocation.clientY;
        if (!this.touchScrollTimeout) {
          this.touchScroll();
        }
        // Check whether the touch is over a folder
        folders = document.querySelectorAll('.ui.accordion .title');
        for (i = 0; i < folders.length; i++) {
          if (folders[i].contains(touchTarget)) {
            this.toFolderIndex = i;
            break;
          }
        }
        event.preventDefault();
      }
    },
    folderTouchStart: function folderTouchStart(index, event) {
      var _this5 = this;

      this.touchMovingFolder = false;
      this.folderTouchInitialTimeout = setTimeout(function () {
        _this5.folderTouchInitialTimeout = null;
        _this5.touchMovingFolder = true;
        // Close all accordion sections
        _this5.closeAll();
        _this5.fromFolderIndex = index;
        _this5.toFolderIndex = index;
        _this5.touchY = event.clientY;
      }, 500);
    },
    initSearch: function initSearch() {
      var _this6 = this;

      var searchData = void 0;
      // Exit if search box not mounted yet
      if (!$('.ui.search').length) return;
      searchData = [];
      this.folders.forEach(function (folder, folderIndex) {
        folder.memoSets.forEach(function (memoSet) {
          searchData.push({
            category: folder.folderName,
            folderIndex: folderIndex,
            memoSetId: memoSet.memoSetId,
            slug: memoSet.slug,
            title: memoSet.title
          });
        });
      });
      $('.ui.search').search({
        cache: false,
        onSelect: function onSelect(result, response) {
          // Save the accordion state with only the selected folder open
          window.aoms.accordionState = _this6.folders.map(function (folder, folderIndex) {
            return folderIndex === result.folderIndex;
          });
          _this6.$router.push('memo-sets/' + result.memoSetId + '/' + result.slug);
        },
        showNoResults: false,
        source: searchData,
        type: 'category'
      });
    },
    memoSetDragEnd: function memoSetDragEnd() {
      this.draggingMemoSet = false;
    },
    memoSetDragEnter: function memoSetDragEnter(folderIndex, memoSetIndex) {
      this.memoSetDragEnters++;
      this.toFolderIndex = folderIndex;
      this.toMemoSetIndex = memoSetIndex;
    },
    memoSetDragLeave: function memoSetDragLeave() {
      this.memoSetDragEnters--;
      if (!this.memoSetDragEnters) {
        this.toMemoSetIndex = -1;
      }
    },
    memoSetDragStart: function memoSetDragStart(folderIndex, memoSetIndex) {
      // Ignore dragstart if touching the screen
      if (this.memoSetTouchInitialTimeout || this.touchMovingMemoSet) return;
      this.draggingMemoSet = true;
      this.fromFolderIndex = folderIndex;
      this.fromMemoSetIndex = memoSetIndex;
      this.toFolderIndex = folderIndex;
      this.toMemoSetIndex = memoSetIndex;
      this.memoSetDragEnters = 0;
    },
    memoSetDrop: function memoSetDrop() {
      this.moveMemoSet();
    },
    memoSetTouchEnd: function memoSetTouchEnd() {
      if (this.memoSetTouchInitialTimeout !== null) {
        clearTimeout(this.memoSetTouchInitialTimeout);
        this.memoSetTouchInitialTimeout = null;
      }
      if (this.touchMovingMemoSet) {
        // Move memo set
        this.moveMemoSet();
      }
      this.touchMovingMemoSet = false;
    },
    memoSetTouchMove: function memoSetTouchMove(event) {
      var _this7 = this;

      var addMemoSetWrappers = void 0,
          folders = void 0,
          i = void 0,
          memoSetNum = void 0,
          memoSets = void 0,
          touchingFolder = void 0,
          touchingMemoSet = void 0,
          touchLocation = void 0,
          touchTarget = void 0;
      // Clear initial timeout if there is one
      if (this.memoSetTouchInitialTimeout !== null) {
        clearTimeout(this.memoSetTouchInitialTimeout);
        this.memoSetTouchInitialTimeout = null;
      }
      if (this.touchMovingMemoSet) {
        touchLocation = event.changedTouches[0];
        touchTarget = document.elementFromPoint(touchLocation.clientX, touchLocation.clientY);
        // Handle page scrolling
        this.touchY = touchLocation.clientY;
        if (!this.touchScrollTimeout) {
          this.touchScroll();
        }
        // Check whether the touch is over a memo set
        memoSets = document.querySelectorAll('.ui.accordion tbody tr');
        for (i = 0; i < memoSets.length; i++) {
          if (memoSets[i].contains(touchTarget)) {
            touchingMemoSet = true;
            memoSetNum = i;
            break;
          }
        }
        if (touchingMemoSet) {
          // Figure out which folder and memo set we are on
          for (i = 0; i < this.folders.length; i++) {
            if (memoSetNum < (this.folders[i].memoSets || []).length) {
              this.toFolderIndex = i;
              this.toMemoSetIndex = memoSetNum;
              break;
            }
            memoSetNum -= (this.folders[i].memoSets || []).length;
          }
        }
        if (!touchingMemoSet) {
          // Check whether the touch is over the add memo set wrapper
          addMemoSetWrappers = document.querySelectorAll('.addMemoSetWrapper');
          for (i = 0; i < addMemoSetWrappers.length; i++) {
            if (addMemoSetWrappers[i].contains(touchTarget)) {
              touchingMemoSet = true;
              this.toFolderIndex = i;
              this.toMemoSetIndex = (this.folders[i].memoSets || []).length;
            }
          }
        }
        if (!touchingMemoSet) {
          // Check whether the touch is over a folder
          folders = document.querySelectorAll('.ui.accordion .title');
          for (i = 0; i < folders.length; i++) {
            if (folders[i].contains(touchTarget)) {
              touchingFolder = true;
              // If this is a new folder, cancel the previous timeout
              if (this.memoSetTouchFolderTimeout && i !== this.pendingFolder) {
                clearTimeout(this.memoSetTouchFolderTimeout);
                this.memoSetTouchFolderTimeout = null;
                this.pendingFolder = -1;
              }
              // If the folder is closed
              if (!this.accordionState[i]) {
                // Set timeout if not already set
                if (!this.memoSetTouchFolderTimeout) {
                  this.memoSetTouchFolderTimeout = setTimeout(function () {
                    _this7.memoSetTouchFolderTimeout = null;
                    $('.ui.accordion').accordion('open', i);
                    _this7.pendingFolder = -1;
                  }, 500);
                  this.pendingFolder = i;
                }
              }
              this.toFolderIndex = i;
              this.toMemoSetIndex = 0;
              break;
            }
          }
        }
        if (!touchingFolder && !touchingMemoSet && this.memoSetTouchFolderTimeout) {
          clearTimeout(this.memoSetTouchFolderTimeout);
          this.memoSetTouchFolderTimeout = null;
          this.pendingFolder = -1;
        }
        event.preventDefault();
      }
    },
    memoSetTouchStart: function memoSetTouchStart(folderIndex, memoSetIndex, event) {
      var _this8 = this;

      this.touchMovingMemoSet = false;
      this.memoSetTouchInitialTimeout = setTimeout(function () {
        _this8.memoSetTouchInitialTimeout = null;
        _this8.touchMovingMemoSet = true;
        _this8.fromFolderIndex = folderIndex;
        _this8.fromMemoSetIndex = memoSetIndex;
        _this8.toFolderIndex = folderIndex;
        _this8.toMemoSetIndex = memoSetIndex;
        _this8.touchY = event.clientY;
      }, 500);
    },
    moveMemoSet: function moveMemoSet() {
      var fromFolder = void 0,
          memoSet = void 0,
          toFolder = void 0;
      fromFolder = this.folders[this.fromFolderIndex];
      toFolder = this.folders[this.toFolderIndex];
      // Cut memo set from orginal position
      memoSet = fromFolder.memoSets.splice([this.fromMemoSetIndex], 1)[0];
      // Create memoSets array for toFolder if none
      toFolder.memoSets = toFolder.memoSets || [];
      // Paste memo set into new position
      toFolder.memoSets.splice(this.toMemoSetIndex, 0, memoSet);
      this.writeMemoSets();
      // Update search data
      this.initSearch();
    },
    renameFolderClick: function renameFolderClick(index) {
      this.renamingFolder = index;
      this.$nextTick(function () {
        var folderTitle = document.getElementById('folder' + index);
        folderTitle.focus();
        selectElementContents(folderTitle);
      });
    },
    scrollPage: function scrollPage(position) {
      if (position < 150) {
        window.scrollBy({
          left: 0,
          top: position - 150,
          behavior: 'smooth'
        });
      }
      if (position > this.window.height - 100) {
        window.scrollBy({
          left: 0,
          top: position - (this.window.height - 100),
          behavior: 'smooth'
        });
      }
    },
    setPageTitle: function setPageTitle() {
      if (this.text && this.text.navMemoSets) {
        document.title = this.text.navMemoSets + ' - MemQ';
      }
    },
    tableHeadDragEnter: function tableHeadDragEnter(folderIndex) {
      if (this.draggingMemoSet) {
        this.memoSetDragEnters++;
        this.toFolderIndex = folderIndex;
        this.toMemoSetIndex = 0;
      }
    },
    tableHeadDragLeave: function tableHeadDragLeave() {
      if (this.draggingMemoSet) {
        this.memoSetDragEnters--;
        if (!this.memoSetDragEnters) {
          this.toMemoSetIndex = -1;
        }
      }
    },
    tableHeadDrop: function tableHeadDrop() {
      if (this.draggingMemoSet) {
        // Move memo set to the start of the folder
        this.moveMemoSet();
      }
    },
    touchScroll: function touchScroll() {
      this.touchScrollTimeout = null;
      if (this.touchMovingFolder || this.touchMovingMemoSet) {
        if (this.touchY < 150) {
          window.scrollBy({
            left: 0,
            top: (this.touchY - 150) / 8
          });
          // For some mobile browsers, the scrollbar is on the pusher instead of the window
          document.querySelector('.pusher').scrollTop += this.touchY - 150;
        }
        if (this.touchY > this.window.height - 100) {
          window.scrollBy({
            left: 0,
            top: (this.touchY - (this.window.height - 100)) / 8
          });
          // For some mobile browsers, the scrollbar is on the pusher instead of the window
          document.querySelector('.pusher').scrollTop += this.touchY - (this.window.height - 100);
        }
        this.touchScrollTimeout = setTimeout(this.touchScroll, 15);
      }
    },
    writeFolders: function writeFolders() {
      var folders = void 0;
      // Prepare array of folders with no memo sets
      folders = [];
      this.folders.forEach(function (folder) {
        folders.push({
          folderId: folder.folderId,
          folderName: folder.folderName
        });
      });
      db.doc('users/' + this.user.id).update({
        folders: folders
      }).catch(function (error) {
        logError('MemoSets_writeFolders', error);
      });
    },
    writeMemoSets: function writeMemoSets() {
      var _this9 = this;

      var docIds = void 0,
          updateObj = void 0;
      updateObj = {};
      this.folders.forEach(function (folder) {
        folder.memoSets.forEach(function (memoSet, memoSetIndex) {
          if (!updateObj[memoSet.docId]) updateObj[memoSet.docId] = {};
          updateObj[memoSet.docId][memoSet.memoSetId + '.folderId'] = folder.folderId;
          updateObj[memoSet.docId][memoSet.memoSetId + '.seq'] = memoSetIndex;
        });
      });
      docIds = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(updateObj);
      docIds.forEach(function (docId) {
        db.doc('users/' + _this9.user.id + '/memoSets/' + docId).update(updateObj[docId]).catch(function (error) {
          logError('MemoSets_writeMemoSets', error);
        });
      });
    }
  },
  props: ['memoSets', 'mobile', 'text', 'statuses', 'touch', 'user', 'window'],
  watch: {
    memoSets: function memoSets(newMemoSets) {
      this.checkReady();
    },
    text: function text(newText) {
      this.setPageTitle();
    },
    user: function user(newUser) {
      this.checkReady();
    }
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Breadcrumbs__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var firebase = window.firebase;
var db = firebase.firestore();

function logError(errorCode, error) {
  console.log(errorCode);
  console.log(error);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'public-memo-sets',
  components: {
    Breadcrumbs: __WEBPACK_IMPORTED_MODULE_0__components_Breadcrumbs__["a" /* default */]
  },
  data: function data() {
    return {
      lastSearchText: '',
      ratingsSummary: {},
      searching: false,
      searchResults: [],
      searchText: '',
      searchTimeout: null,
      topMemoSets: [],
      unsubscribeTop: null,
      userReady: false
    };
  },

  computed: {
    breadcrumbs: function breadcrumbs() {
      return [{ label: this.text.navHome, to: '/' }, { label: this.text.navPublicMemoSets }];
    }
  },
  created: function created() {
    var self = this;
    // TEMP - for debugging
    window.vm = this;
    window.aoms = window.aoms || {};
    // Set memo set source - used by the MemoSet component
    window.aoms.memoSetSource = 'PublicMemoSets';
    this.checkUserReady();
    // Set previous search text and results if available
    if (window.aoms.memoSetSearchText) {
      this.searchText = window.aoms.memoSetSearchText;
      this.searchResults = window.aoms.memoSetSearchResults;
    } else {
      this.searching = true;
    }
    // Listen to default memo sets
    this.unsubscribeTop = db.doc('topMemoSets/top').onSnapshot(function (snapshot) {
      self.topMemoSets = snapshot.data().memoSets;
      if (self.searching && !self.searchText) {
        self.searchResults = self.topMemoSets;
        self.searching = false;
      }
    }, function (error) {
      logError('PublicMemoSets_1', error);
    });
    this.setPageTitle();
  },
  mounted: function mounted() {},
  methods: {
    cancelSearchTimeout: function cancelSearchTimeout() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = null;
      }
    },
    checkUserReady: function checkUserReady() {
      // Redirect to Home page if the user data has loaded but the user isn't signed in
      if (this.user.uiLanguage && !this.user.folders) {
        this.$router.push('/');
      }
      if (this.user.folders) {
        this.userReady = true;
      }
    },
    sanitize: function sanitize(html) {
      var sanitizedHtml = void 0;
      if (!html) return '';
      sanitizedHtml = this.$sanitize(html, {
        allowedAttributes: {
          img: ['class', 'src']
        },
        allowedTags: ['b', 'br', 'i', 'img'],
        allowedSchemesByTag: {
          img: ['data', 'http', 'https']
        }
      });
      return sanitizedHtml;
    },
    search: function search() {
      var self = this;
      this.cancelSearchTimeout();
      if (this.searchText) {
        if (this.searchText.trim() !== this.lastSearchText) {
          this.lastSearchText = this.searchText.trim();
          db.collection('memoSetSearch').add({
            searchText: this.searchText,
            timestamp: firebase.firestore.FieldValue.serverTimestamp(),
            userId: this.user.id
          }).then(function (docRef) {
            // Listen to the memoSetSearch document
            var detachListener = db.doc('memoSetSearch/' + docRef.id).onSnapshot(function (snapshot) {
              if (snapshot.data().done) {
                detachListener();
                if (!self.searchTimeout) {
                  self.searchResults = snapshot.data().memoSets;
                  self.searching = false;
                  // Save search and search results
                  window.aoms.memoSetSearchText = self.searchText;
                  window.aoms.memoSetSearchResults = self.searchResults;
                }
                // Delete the memoSetSearch document
                db.doc('memoSetSearch/' + docRef.id).delete().catch(function (error) {
                  logError('PublicMemoSets_2', error);
                });
              }
            }, function (error) {
              logError('PublicMemoSets_3', error);
            });
          }).catch(function (error) {
            logError('PublicMemoSets_4', error);
          });
        } else {
          // No real change to search text - show previous results
          this.searching = false;
        }
      } else {
        this.searchResults = this.topMemoSets;
        this.searching = false;
        this.lastSearchText = '';
        window.aoms.memoSetSearchText = '';
      }
    },
    searchEnter: function searchEnter() {
      // If there's a search timeout, just search now
      this.cancelSearchTimeout();
      this.search();
    },
    searchInput: function searchInput() {
      // Update this.searchText if not updated - needed on mobile, where value doesn't change with each keystroke
      if (this.searchText !== document.getElementById('searchText').value) {
        this.searchText = document.getElementById('searchText').value;
      }
      this.cancelSearchTimeout();
      this.searchTimeout = setTimeout(this.search, 600);
      this.searching = true;
    },
    setPageTitle: function setPageTitle() {
      if (this.text && this.text.navPublicMemoSets) {
        document.title = this.text.navPublicMemoSets + ' - MemQ';
      }
    }
  },
  props: ['mobile', 'text', 'touch', 'user', 'window'],
  watch: {
    text: function text(newText) {
      this.setPageTitle();
    },
    user: function user(newUser) {
      this.checkUserReady();
    }
  }
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Breadcrumbs__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'shared-memo-sets',
  components: {
    Breadcrumbs: __WEBPACK_IMPORTED_MODULE_0__components_Breadcrumbs__["a" /* default */]
  },
  data: function data() {
    return {
      ratingsSummary: {},
      userReady: false
    };
  },

  computed: {
    breadcrumbs: function breadcrumbs() {
      return [{ label: this.text.navHome, to: '/' }, { label: this.text.navSharedMemoSets }];
    }
  },
  created: function created() {
    // TEMP - for debugging
    window.vm = this;
    window.aoms = window.aoms || {};
    this.checkUserReady();
    this.setPageTitle();
  },
  mounted: function mounted() {},
  methods: {
    checkUserReady: function checkUserReady() {
      // Redirect to Home page if the user data has loaded but the user isn't signed in
      if (this.user.uiLanguage && !this.user.folders) {
        this.$router.push('/');
      }
      if (this.user.folders) {
        this.userReady = true;
      }
    },
    sanitize: function sanitize(html) {
      var sanitizedHtml = void 0;
      if (!html) return '';
      sanitizedHtml = this.$sanitize(html, {
        allowedAttributes: {
          img: ['class', 'src']
        },
        allowedTags: ['b', 'br', 'i', 'img'],
        allowedSchemesByTag: {
          img: ['data', 'http', 'https']
        }
      });
      return sanitizedHtml;
    },
    setPageTitle: function setPageTitle() {
      if (this.text && this.text.navSharedMemoSets) {
        document.title = this.text.navSharedMemoSets + ' - MemQ';
      }
    }
  },
  props: ['mobile', 'sharedMemoSets', 'text', 'touch', 'user', 'window'],
  watch: {
    text: function text(newText) {
      this.setPageTitle();
    },
    user: function user(newUser) {
      this.checkUserReady();
    }
  }
});

/***/ }),
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Acirc":"Â","acirc":"â","acute":"´","AElig":"Æ","aelig":"æ","Agrave":"À","agrave":"à","amp":"&","AMP":"&","Aring":"Å","aring":"å","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","brvbar":"¦","Ccedil":"Ç","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","COPY":"©","curren":"¤","deg":"°","divide":"÷","Eacute":"É","eacute":"é","Ecirc":"Ê","ecirc":"ê","Egrave":"È","egrave":"è","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","GT":">","Iacute":"Í","iacute":"í","Icirc":"Î","icirc":"î","iexcl":"¡","Igrave":"Ì","igrave":"ì","iquest":"¿","Iuml":"Ï","iuml":"ï","laquo":"«","lt":"<","LT":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","Ntilde":"Ñ","ntilde":"ñ","Oacute":"Ó","oacute":"ó","Ocirc":"Ô","ocirc":"ô","Ograve":"Ò","ograve":"ò","ordf":"ª","ordm":"º","Oslash":"Ø","oslash":"ø","Otilde":"Õ","otilde":"õ","Ouml":"Ö","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","QUOT":"\"","raquo":"»","reg":"®","REG":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","THORN":"Þ","thorn":"þ","times":"×","Uacute":"Ú","uacute":"ú","Ucirc":"Û","ucirc":"û","Ugrave":"Ù","ugrave":"ù","uml":"¨","Uuml":"Ü","uuml":"ü","Yacute":"Ý","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_sanitize__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_sanitize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_sanitize__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_sanitize___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 117 */,
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(63);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea3f2098_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(138);
function injectStyle (ssrContext) {
  __webpack_require__(119)
  __webpack_require__(121)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ea3f2098"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea3f2098_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 120 */,
/* 121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signin_vue__ = __webpack_require__(69);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04b9531f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signin_vue__ = __webpack_require__(137);
function injectStyle (ssrContext) {
  __webpack_require__(136)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04b9531f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04b9531f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"innerWrapper"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.userStatus === 'unknown' || !_vm.emailLinkChecked),expression:"userStatus === 'unknown' || !emailLinkChecked"}],staticClass:"ui active inline loader"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.userStatus === 'not signed in' && _vm.emailLinkChecked),expression:"userStatus === 'not signed in' && emailLinkChecked"}]},[_c('h3',[_vm._v("Welcome to the Art of Memory software!")]),_vm._v(" "),_c('img',{staticClass:"ui large image",attrs:{"src":_vm.appPathPrefix + '/static/img/aom.png'}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("If you have a subscription to the Art of Memory software, enter your email address to sign in.")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"ui fluid input",class:{disabled: _vm.emailStatus === 'sending'}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"id":"email","autocomplete":"off","placeholder":"you@example.com","spellcheck":"false","type":"email"},domProps:{"value":(_vm.email)},on:{"focus":function($event){_vm.emailStatus = 'initial'},"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.signInClick()},"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"ui primary button signIn",class:{disabled: !_vm.email || _vm.email.indexOf('@') == -1 || _vm.emailStatus !== 'initial'},on:{"click":function($event){_vm.signInClick()}}},[_vm._v("Sign In")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.emailStatus === 'sending'),expression:"emailStatus === 'sending'"}],staticClass:"ui active inline loader"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.emailStatus === 'sent'),expression:"emailStatus === 'sent'"}],staticClass:"ui success message"},[_c('div',{staticClass:"header"},[_vm._v("\n        Email Sent\n      ")]),_vm._v(" "),_c('p',[_vm._v("We’ve sent you an email containing a sign-in link. Please open the email and click the link to sign in.")]),_vm._v(" "),_c('p',[_vm._v("Please contact us at support@artofmemory.com if you have any issues signing in.")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.emailStatus === 'no access'),expression:"emailStatus === 'no access'"}],staticClass:"ui error message"},[_c('div',{staticClass:"header"},[_vm._v("\n        Email Address Not Found\n      ")]),_vm._v(" "),_c('p',[_vm._v("We can’t find a subscription for that email address. Please email us at support@artofmemory.com if you believe this is an error.")])])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('br')])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("If you don’t have a subscription, you can "),_c('a',{attrs:{"href":"https://artofmemory.com/preorder"}},[_vm._v("learn more about the software here")]),_vm._v(".")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tex2jax_ignore",attrs:{"id":"app"}},[_c('div',{staticClass:"ui vertical inverted sidebar menu"},[_c('a',{staticClass:"item",on:{"click":function($event){_vm.hideSidebar()}}},[_vm._v(" "),_c('i',{staticClass:"close icon"})]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready),expression:"ready"}],staticClass:"item",class:{active: _vm.$route.path === '/'},on:{"click":function($event){_vm.sidebarGo('/')}}},[_vm._v(_vm._s(_vm.text.navHome))]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready && _vm.user.id),expression:"ready && user.id"}],staticClass:"item",class:{active: _vm.$route.path.substr(0, 10) === '/memo-sets'},on:{"click":function($event){_vm.sidebarGo('/memo-sets')}}},[_vm._v(_vm._s(_vm.text.navMemoSets))]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready && _vm.user.id),expression:"ready && user.id"}],staticClass:"item",class:{active: _vm.$route.path.substr(0, 17) === '/shared-memo-sets'},on:{"click":function($event){_vm.sidebarGo('/shared-memo-sets')}}},[_vm._v(_vm._s(_vm.text.navSharedMemoSets))]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready && _vm.user.id),expression:"ready && user.id"}],staticClass:"item",class:{active: _vm.$route.path.substr(0, 17) === '/public-memo-sets'},on:{"click":function($event){_vm.clearSearch(); _vm.sidebarGo('/public-memo-sets')}}},[_vm._v(_vm._s(_vm.text.navPublicMemoSets))]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready),expression:"ready"}],staticClass:"item",attrs:{"href":"https://forum.artofmemory.com","target":"_blank","rel":"noopener"}},[_vm._v(_vm._s(_vm.text.navForum)),_c('i',{staticClass:"external icon"})]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready),expression:"ready"}],staticClass:"item",attrs:{"href":"https://memoryleague.com","target":"_blank","rel":"noopener"}},[_vm._v("Memory League"),_c('i',{staticClass:"external icon"})]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready),expression:"ready"}],staticClass:"item",attrs:{"href":"https://artofmemory.com/app","target":"_blank","rel":"noopener"}},[_vm._v(_vm._s(_vm.text.navTutorials)),_c('i',{staticClass:"external icon"})]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready),expression:"ready"}],staticClass:"item",attrs:{"href":"https://artofmemory.com/wiki","target":"_blank","rel":"noopener"}},[_vm._v("Wiki"),_c('i',{staticClass:"external icon"})])]),_vm._v(" "),_c('div',{staticClass:"pusher"},[_c('div',{staticClass:"ui fixed inverted menu noPrint"},[_c('div',{staticClass:"ui fluid container"},[_c('router-link',{staticClass:"header item memQ",class:{'mobile': _vm.mobile},attrs:{"to":"/","active-class":"none","exact":""}},[_c('div',{staticClass:"memQ1"},[_vm._v("Mem")]),_c('div',{staticClass:"memQ2"},[_vm._v("Q")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.mobile),expression:"mobile"}],staticClass:"item",on:{"click":_vm.showSidebar}},[_c('i',{staticClass:"sidebar icon"})]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready && !_vm.mobile),expression:"ready && !mobile"}],staticClass:"item main",attrs:{"to":"/","exact":""}},[_vm._v(_vm._s(_vm.text.navHome))]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready && !_vm.mobile && _vm.user.id),expression:"ready && !mobile && user.id"}],staticClass:"item main",attrs:{"to":"/memo-sets"}},[_vm._v(_vm._s(_vm.text.navMemoSets))]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready && !_vm.mobile && _vm.user.id),expression:"ready && !mobile && user.id"}],staticClass:"item main",attrs:{"to":"/shared-memo-sets"}},[_vm._v(_vm._s(_vm.text.navSharedMemoSets))]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready && !_vm.mobile),expression:"ready && !mobile"}],staticClass:"item main",attrs:{"to":"/public-memo-sets"},nativeOn:{"click":function($event){_vm.clearSearch()}}},[_vm._v(_vm._s(_vm.text.navPublicMemoSets))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready && !_vm.mobile),expression:"ready && !mobile"}],staticClass:"ui simple dropdown item"},[_c('i',{staticClass:"ellipsis vertical icon"}),_vm._v(" "),_c('div',{staticClass:"menu"},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready && !_vm.mobile),expression:"ready && !mobile"}],staticClass:"item",attrs:{"href":"https://forum.artofmemory.com","target":"_blank","rel":"noopener"}},[_c('span',{staticClass:"moreOptionsItem"},[_vm._v(_vm._s(_vm.text.navForum))]),_vm._v(" "),_c('i',{staticClass:"external icon"})]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready && !_vm.mobile),expression:"ready && !mobile"}],staticClass:"item",attrs:{"href":"https://app.memoryleague.com","target":"_blank","rel":"noopener"}},[_c('span',{staticClass:"moreOptionsItem"},[_vm._v("Memory League")]),_vm._v(" "),_c('i',{staticClass:"external icon"})]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready && !_vm.mobile),expression:"ready && !mobile"}],staticClass:"item",attrs:{"href":"https://artofmemory.com/app","target":"_blank","rel":"noopener"}},[_c('span',{staticClass:"moreOptionsItem"},[_vm._v(_vm._s(_vm.text.navTutorials))]),_vm._v(" "),_c('i',{staticClass:"external icon"})]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready && !_vm.mobile),expression:"ready && !mobile"}],staticClass:"item",attrs:{"href":"https://artofmemory.com/wiki","target":"_blank","rel":"noopener"}},[_c('span',{staticClass:"moreOptionsItem"},[_vm._v("Wiki")]),_vm._v(" "),_c('i',{staticClass:"external icon"})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready),expression:"ready"}],staticClass:"right menu"},[_c('div',{staticClass:"ui dropdown item narrow"},[_c('i',{staticClass:"info circle icon"}),_vm._v(" "),_c('div',{staticClass:"ui menu"},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.text.navInfoTitle))]),_vm._v(" "),_c('div',{staticClass:"divider"}),_vm._v(" "),_c('router-link',{staticClass:"item notActive",attrs:{"to":'/guide',"target":"_blank","rel":"noopener"}},[_vm._v(_vm._s(_vm.text.navInfoGuide))]),_vm._v(" "),_c('router-link',{staticClass:"item",attrs:{"to":"/contact-us"}},[_vm._v(_vm._s(_vm.text.navInfoContactUs))]),_vm._v(" "),_c('a',{staticClass:"item notActive",attrs:{"href":"https://artofmemory.com/legal/terms","target":"_blank","rel":"noopener"}},[_vm._v(_vm._s(_vm.text.navInfoTerms))]),_vm._v(" "),_c('a',{staticClass:"item notActive",attrs:{"href":"https://artofmemory.com/legal/privacy","target":"_blank","rel":"noopener"}},[_vm._v(_vm._s(_vm.text.navInfoPrivacy))])],1)]),_vm._v(" "),_c('div',{staticClass:"ui dropdown item narrow"},[_c('i',{staticClass:"flag noRightMargin",class:_vm.user.uiLanguage || 'us'}),_vm._v(" "),_c('div',{staticClass:"ui menu"},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.text.navLanguageTitle))]),_vm._v(" "),_c('div',{staticClass:"divider"}),_vm._v(" "),_vm._l((_vm.languages),function(language){return _c('div',{key:language.countryCode,staticClass:"item",on:{"click":function($event){_vm.setLanguage(language.countryCode)}}},[_c('i',{staticClass:"flag",class:language.countryCode}),_vm._v(" "+_vm._s(language.name)+"\n              ")])})],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.user.id),expression:"user.id"}],staticClass:"ui dropdown item narrow",class:{'desktopMenuRightMargin': !_vm.mobile}},[_c('i',{staticClass:"user icon"}),_vm._v(" "),_c('div',{staticClass:"ui menu userMenu"},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.user.displayName))]),_vm._v(" "),_c('div',{staticClass:"divider"}),_vm._v(" "),_c('a',{staticClass:"item notActive",attrs:{"href":"https://artofmemory.com/user","target":"_blank","rel":"noopener"}},[_vm._v(_vm._s(_vm.text.navUserMyAccount))]),_vm._v(" "),_c('div',{staticClass:"item",on:{"click":function($event){_vm.signOutClick()}}},[_vm._v(_vm._s(_vm.text.navUserSignOut))])])])])],1)]),_vm._v(" "),_c('div',{staticClass:"ui fluid wrapper",on:{"touchstart":function($event){_vm.touch = true}}},[(!_vm.user.id)?_c('signin'):_vm._e(),_vm._v(" "),_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(_vm.user.id),expression:"user.id"}],key:_vm.$route.fullPath,attrs:{"memo-sets":_vm.memoSets,"mobile":_vm.mobile,"shared-memo-sets":_vm.sharedMemoSets,"statuses":_vm.statuses,"text":_vm.text,"touch":_vm.touch,"user":_vm.user,"window":_vm.window}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AdminSignin__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_MemoSet__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_MemoSets__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PublicMemoSets__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SharedMemoSets__ = __webpack_require__(195);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */]
  }, {
    path: '/index.html',
    name: 'HomeIndex',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */]
  }, {
    path: '/admin-signin',
    name: 'AdminSignin',
    component: __WEBPACK_IMPORTED_MODULE_2__components_AdminSignin__["a" /* default */]
  }, {
    path: '/memo-sets/:memoSetId/:slug',
    name: 'MemoSet',
    component: __WEBPACK_IMPORTED_MODULE_4__components_MemoSet__["a" /* default */]
  }, {
    path: '/memo-sets',
    name: 'MemoSets',
    component: __WEBPACK_IMPORTED_MODULE_5__components_MemoSets__["a" /* default */]
  }, {
    path: '/public-memo-sets/:memoSetId/:slug',
    name: 'PublicMemoSet',
    component: __WEBPACK_IMPORTED_MODULE_4__components_MemoSet__["a" /* default */]
  }, {
    path: '/public-memo-sets',
    name: 'PublicMemoSets',
    component: __WEBPACK_IMPORTED_MODULE_6__components_PublicMemoSets__["a" /* default */]
  }, {
    path: '/shared-memo-sets/:memoSetId/:slug',
    name: 'SharedMemoSet',
    component: __WEBPACK_IMPORTED_MODULE_4__components_MemoSet__["a" /* default */]
  }, {
    path: '/shared-memo-sets',
    name: 'SharedMemoSets',
    component: __WEBPACK_IMPORTED_MODULE_7__components_SharedMemoSets__["a" /* default */]
  }]
}));

/***/ }),
/* 140 */,
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminSignin_vue__ = __webpack_require__(70);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0140e1f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminSignin_vue__ = __webpack_require__(145);
function injectStyle (ssrContext) {
  __webpack_require__(142)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0140e1f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminSignin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0140e1f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminSignin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumbWrapper"},[_c('div',{staticClass:"ui breadcrumb"},[_vm._l((_vm.breadcrumbs),function(breadcrumb,index){return [(breadcrumb.to)?_c('router-link',{key:'bcLink' + index,attrs:{"to":breadcrumb.to,"exact":""}},[_vm._v(_vm._s(breadcrumb.label))]):_vm._e(),_vm._v(" "),(breadcrumb.to)?_c('i',{key:'bcDivider' + index,staticClass:"right chevron icon divider"}):_vm._e(),_vm._v(" "),(!breadcrumb.to)?_c('div',{key:'bcLabel' + index,staticClass:"active section"},[_vm._v(_vm._s(breadcrumb.label))]):_vm._e()]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_vm._v(" "),_c('div',{staticClass:"innerWrapper"},[_c('h1',[_vm._v("Admin Sign-in")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.signingIn),expression:"signingIn"}],staticClass:"ui active inline loader"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.signingIn),expression:"!signingIn"}],staticClass:"ui input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userId),expression:"userId"}],attrs:{"type":"text","placeholder":"User ID"},domProps:{"value":(_vm.userId)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.signIn()},"input":function($event){if($event.target.composing){ return; }_vm.userId=$event.target.value}}})])]),_vm._v(" "),_c('br')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(72);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cbe7f0a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(153);
function injectStyle (ssrContext) {
  __webpack_require__(147)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0cbe7f0a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cbe7f0a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:{invisible: !_vm.total}},[_c('div',{staticClass:"known bar left",class:{
      fast: _vm.statuses.speed === 'fast',
      slow: _vm.statuses.speed === 'slow',
      right: !_vm.statuses.due && !_vm.statuses.unknown
    },style:({width: _vm.percents.known + '%'})},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.display.known),expression:"display.known"}],staticClass:"text"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.showIcon.known),expression:"showIcon.known"}],staticClass:"check icon"}),_vm._v(_vm._s(_vm.display.known)+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"due bar",class:{
      fast: _vm.statuses.speed === 'fast',
      slow: _vm.statuses.speed === 'slow',
      left: !_vm.statuses.known,
      right: !_vm.statuses.unknown
    },style:({width: _vm.percents.due + '%'})},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.display.due),expression:"display.due"}],staticClass:"text"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.showIcon.due),expression:"showIcon.due"}],staticClass:"calendar outline icon"}),_vm._v(_vm._s(_vm.display.due)+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"unknown bar right",class:{
      fast: _vm.statuses.speed === 'fast',
      slow: _vm.statuses.speed === 'slow',
      left: !_vm.statuses.known && !_vm.statuses.due
    },style:({width: _vm.percents.unknown + '%'})},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.display.unknown),expression:"display.unknown"}],staticClass:"text"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.showIcon.unknown),expression:"showIcon.unknown"}],staticClass:"x icon"}),_vm._v(_vm._s(_vm.display.unknown)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_vm._v(" "),_c('div',{staticClass:"innerWrapper",class:{'mobile': _vm.mobile}},[(_vm.mobile)?_c('div',{staticClass:"navigation"},[_c('div',{staticClass:"ui menu",class:{'three item': _vm.sharedMemoSets && _vm.sharedMemoSets.length, 'two item': !_vm.sharedMemoSets || !_vm.sharedMemoSets.length},staticStyle:{"background-color":"#f0f1f2"}},[_c('router-link',{staticClass:"item noBorderRadius",attrs:{"to":"memo-sets"}},[_vm._v("My Memo Sets")]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.sharedMemoSets && _vm.sharedMemoSets.length),expression:"sharedMemoSets && sharedMemoSets.length"}],staticClass:"item noBorderRadius",attrs:{"to":"shared-memo-sets"}},[_vm._v("Shared With Me")]),_vm._v(" "),_c('router-link',{staticClass:"item noBorderRadius",attrs:{"to":"public-memo-sets"}},[_vm._v("Public Memo Sets")])],1)]):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"ui header summaryHeader"},[_vm._v("Summary")]),_vm._v(" "),_c('div',{staticClass:"ui center aligned segment statisticsWrapper",class:{'mobile': _vm.mobile}},[_c('div',{staticClass:"ui statistics",class:{'small': !_vm.mobile, 'tiny mobile': _vm.mobile},staticStyle:{"display":"block"}},[_c('div',{staticClass:"purple statistic"},[_c('div',{staticClass:"value"},[_c('i',{staticClass:"table icon"}),_vm._v("\n            "+_vm._s(_vm.summary.activeMemoSets)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("\n            Active memo sets\n          ")])]),_vm._v(" "),_c('div',{staticClass:"green statistic"},[_c('div',{staticClass:"value"},[_c('i',{staticClass:"check icon"}),_vm._v("\n            "+_vm._s(_vm.summary.itemsKnown)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("\n            Items known\n          ")])]),_vm._v(" "),_c('div',{staticClass:"orange statistic"},[_c('div',{staticClass:"value"},[_c('i',{staticClass:"calendar outline icon"}),_vm._v("\n            "+_vm._s(_vm.summary.itemsDue)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("\n            Items due for review\n          ")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.reviewMemoSets.length),expression:"!reviewMemoSets.length"}],staticClass:"ui center aligned segment congratulations"},[_vm._m(0),_vm._v(" "),_c('div',[_vm._v("Everything is up to date. Congratulations!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reviewMemoSets.length),expression:"reviewMemoSets.length"}]},[_c('h3',{staticClass:"ui header reviewMemoSetsHeader"},[_vm._v("Ready for Review")]),_vm._v(" "),_c('div',{staticClass:"tableWrapper",class:{'mobile': _vm.mobile}},[_c('table',{staticClass:"ui selectable unstackable table",class:{'compact': _vm.mobile}},[_c('thead',[_c('tr',[_c('th',{staticClass:"two wide"},[_vm._v(_vm._s(_vm.text.memoSetsColumnImage))]),_vm._v(" "),_c('th',{staticClass:"six wide"},[_vm._v(_vm._s(_vm.text.memoSetsColumnMemoSet))]),_vm._v(" "),_c('th',{staticClass:"two wide"},[_vm._v("Due")]),_vm._v(" "),_c('th',{staticClass:"four wide"},[_vm._v(_vm._s(_vm.text.commonStatus))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.reviewMemoSets),function(memoSet){return _c('tr',{key:memoSet.memoSetId},[_c('td',{staticClass:"imgCell"},[_c('router-link',{attrs:{"to":'memo-sets/' + memoSet.memoSetId + '/' + memoSet.slug}},[_c('div',{staticClass:"coverImageWrapper"},[_c('img',{staticClass:"ui centered rounded image",attrs:{"src":memoSet.coverImage}})])])],1),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":'memo-sets/' + memoSet.memoSetId + '/' + memoSet.slug}},[_vm._v("\n                  "+_vm._s(memoSet.title)+"\n                ")])],1),_vm._v(" "),_c('td',{staticClass:"locationNum"},[_c('router-link',{attrs:{"to":'memo-sets/' + memoSet.memoSetId + '/' + memoSet.slug}},[_c('span',{class:{'indent1': memoSet.statuses.due < 1000, 'indent2': memoSet.statuses.due < 100, 'indent3': memoSet.statuses.due < 10}},[_vm._v(_vm._s(memoSet.statuses.due))])])],1),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":'memo-sets/' + memoSet.memoSetId + '/' + memoSet.slug}},[_c('status-bar',{directives:[{name:"show",rawName:"v-show",value:(memoSet.statuses),expression:"memoSet.statuses"}],attrs:{"mobile":_vm.mobile,"page":"Home","statuses":memoSet.statuses,"window":_vm.window}})],1)],1)])}))])])]),_vm._v(" "),_c('br')])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"large green checkmark box icon"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemoSet_vue__ = __webpack_require__(74);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5b70482_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemoSet_vue__ = __webpack_require__(188);
function injectStyle (ssrContext) {
  __webpack_require__(155)
  __webpack_require__(156)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e5b70482"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemoSet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5b70482_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemoSet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('breadcrumbs',{staticClass:"noPrint",attrs:{"breadcrumbs":_vm.breadcrumbs}}),_vm._v(" "),_c('div',{staticClass:"innerWrapper",class:{'mobile': _vm.mobile}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.ready),expression:"!ready"}],staticClass:"ui small active inline loader memoSetLoader"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready),expression:"ready"}]},[(_vm.memoSetType !== 'regular')?_c('div',{class:{'mobile': _vm.mobile, 'publicHeaderWrapper': _vm.memoSetType === 'public', 'sharedHeaderWrapper': _vm.memoSetType === 'shared'}},[_c('h4',{staticClass:"rightLabel noBottomMargin"},[_vm._v(_vm._s(_vm.text.memoSetAuthor)+":")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.ownerName))]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.memoSetType === 'public' && _vm.user.id !== _vm.ownerId)?_c('div',{staticStyle:{"display":"inline-block","margin-top":"0.6rem"}},[_c('h4',{staticClass:"rightLabel"},[_vm._v(_vm._s(_vm.text.memoSetMyRating)+":")]),_vm._v(" "),_c('div',{staticClass:"ui yellow star rating myRating",attrs:{"data-rating":_vm.myRating,"data-max-rating":"5"}})]):_vm._e(),_vm._v(" "),(_vm.memoSetType === 'public' && _vm.user.id === _vm.ownerId)?_c('div',{staticStyle:{"display":"inline-block","margin-top":"0.6rem"}},[_c('h4',{staticClass:"rightLabel"},[_vm._v(_vm._s(_vm.text.publicRating)+":")]),_vm._v(" "),_c('div',{staticClass:"ui yellow star rating",staticStyle:{"position":"relative","width":"7rem"}},[_vm._m(0),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"-1rem","position":"absolute","overflow-x":"hidden"},style:({width: _vm.ratingsData.width + 'rem'})},[_c('i',{staticClass:"star active icon"}),_vm._v(" "),_c('i',{staticClass:"star active icon"}),_vm._v(" "),_c('i',{staticClass:"star active icon"}),_vm._v(" "),_c('i',{staticClass:"star active icon"}),_vm._v(" "),_c('i',{staticClass:"star active icon"})])]),_vm._v(" "),_c('span',{staticClass:"ratingsCount"},[_vm._v("("+_vm._s(_vm.ratingsData.count)+")")])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hideTopElements),expression:"!hideTopElements"}],staticClass:"rightButtonWrapper",class:{'mobile': _vm.mobile, 'noTabsText': !_vm.tabsText, 'publicRightButtonWrapper': _vm.memoSetType === 'public', 'sharedRightButtonWrapper': _vm.memoSetType === 'shared'}},[_c('div',{staticClass:"ui one item menu multiLine"},[(_vm.user.id !== _vm.ownerId && !_vm.memoSetAdded)?_c('a',{staticClass:"item addItem",on:{"click":function($event){_vm.addToMyMemoSetsClick($event)}}},[_c('i',{staticClass:"large plus icon",class:{'compactTabsIcon': _vm.mobile, 'noRightMargin': !_vm.tabsText}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabsText),expression:"tabsText"}],class:{'compactTabsText': _vm.mobile}},[_vm._v(" Add")])]):_vm._e(),_vm._v(" "),(_vm.user.id === _vm.ownerId || _vm.memoSetAdded)?_c('router-link',{staticClass:"item addItem",attrs:{"to":_vm.user.id === _vm.ownerId ? ('/memo-sets/' + _vm.memoSetId + '/' + _vm.slug) : ('/memo-sets/' + _vm.memoSetId + '_' + _vm.user.id + '/' + _vm.slug)}},[_c('i',{staticClass:"large open folder icon",class:{'compactTabsIcon': _vm.mobile, 'noRightMargin': !_vm.tabsText}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabsText),expression:"tabsText"}],class:{'compactTabsText': _vm.mobile}},[_vm._v(" Open")])]):_vm._e()],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"tabsAndButtonWrapper noPrint",class:{'mobile': _vm.mobile}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hideTopElements),expression:"!hideTopElements"}],staticClass:"tabsWrapper",class:{'mobile': _vm.mobile, 'noTabsText': !_vm.tabsText, 'threeTabs': _vm.memoSetType !== 'regular'}},[_c('div',{staticClass:"ui menu mainTabs multiLine",class:{'four item': _vm.memoSetType === 'regular', 'three item': _vm.memoSetType !== 'regular', 'mobile': _vm.mobile}},[_c('a',{staticClass:"active item",attrs:{"data-tab":"info"}},[_c('i',{staticClass:"large info circle icon",class:{'compactTabsIcon': _vm.mobile, 'noRightMargin': !_vm.tabsText}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabsText),expression:"tabsText"}],class:{'compactTabsText': _vm.mobile}},[_vm._v(_vm._s(_vm.text.memoSetTabInfo))])]),_vm._v(" "),_c('a',{staticClass:"item",attrs:{"data-tab":"data"}},[_c('i',{staticClass:"large table icon",class:{'compactTabsIcon': _vm.mobile, 'noRightMargin': !_vm.tabsText}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabsText),expression:"tabsText"}],class:{'compactTabsText': _vm.mobile}},[_vm._v(_vm._s(_vm.text.memoSetTabData))])]),_vm._v(" "),_c('a',{staticClass:"item",attrs:{"data-tab":"questions"}},[_c('i',{staticClass:"large question icon",class:{'compactTabsIcon': _vm.mobile, 'noRightMargin': !_vm.tabsText}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabsText),expression:"tabsText"}],class:{'compactTabsText': _vm.mobile}},[_vm._v(_vm._s(_vm.text.memoSetTabQuestions))])]),_vm._v(" "),(_vm.memoSetType === 'regular')?_c('a',{staticClass:"item",attrs:{"data-tab":"learn"}},[_c('i',{staticClass:"large graduation cap icon",class:{'compactTabsIcon': _vm.mobile, 'noRightMargin': !_vm.tabsText}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabsText),expression:"tabsText"}],class:{'compactTabsText': _vm.mobile}},[_vm._v(_vm._s(_vm.text.memoSetTabLearn))])]):_vm._e()])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hideTopElements),expression:"!hideTopElements"}],staticClass:"rightButtonWrapper",class:{'mobile': _vm.mobile, 'noTabsText': !_vm.tabsText}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:((_vm.activeTab === 'learn' && _vm.questions.length) || (_vm.activeTab !== 'learn' && _vm.walkThroughEnabled)),expression:"(activeTab === 'learn' && questions.length) || (activeTab !== 'learn' && walkThroughEnabled)"}],staticClass:"ui one item menu multiLine"},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab !== 'learn' && _vm.walkThroughEnabled),expression:"activeTab !== 'learn' && walkThroughEnabled"}],staticClass:"item walkThroughItem",on:{"click":function($event){_vm.walkThroughClick($event)}}},[_c('i',{staticClass:"large walking icon",class:{'compactTabsIcon': _vm.mobile, 'noRightMargin': !_vm.tabsText}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabsText),expression:"tabsText"}],class:{'compactTabsText': _vm.mobile}},[_vm._v(_vm._s(_vm.text.memoSetWalkThrough))])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab === 'learn' && _vm.questions.length),expression:"activeTab === 'learn' && questions.length"}],staticClass:"item learnItem",class:{disabled: !_vm.activeQuestions.length},on:{"click":function($event){_vm.learnClick($event)}}},[_c('i',{staticClass:"large arrow right icon",class:{'compactTabsIcon': _vm.mobile, 'noRightMargin': !_vm.tabsText}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabsText),expression:"tabsText"}],class:{'compactTabsText': _vm.mobile}},[_vm._v(_vm._s(_vm.text.memoSetLearn))])])])])]),_vm._v(" "),_c('div',{staticClass:"ui active tab basic segment noBottomMargin noBottomPadding noTopMargin",attrs:{"data-tab":"info"}},[_c('div',{staticClass:"infoWrapper",class:{'mobile': _vm.mobile, 'thinScroll': _vm.mobile && _vm.touch},style:({maxHeight: _vm.infoWrapperMaxHeight + 'px'}),attrs:{"id":"infoWrapper"}},[_c('div',{staticClass:"ui grid infoGrid",class:{'mobile': _vm.mobile}},[(_vm.memoSetType === 'regular')?_c('div',{staticClass:"noTopMargin noTopPadding",class:{'one wide column labelColumn': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('h4',{staticClass:"noTopMargin noTopPadding"},[_vm._v(_vm._s(_vm.text.memoSetTitle)),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.mobile),expression:"!mobile"}]},[_vm._v(":")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"noTopPadding",class:{'fifteen wide column mainColumn': !_vm.mobile && _vm.memoSetType === 'regular', 'sixteen wide column': _vm.mobile || _vm.memoSetType !== 'regular'}},[(_vm.memoSetType !== 'regular')?_c('h4',{staticClass:"noTopMargin"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),(_vm.memoSetType === 'regular')?_c('div',{staticClass:"editable inlineEditable",attrs:{"id":"title","contenteditable":"","tabindex":"0"},on:{"blur":function($event){_vm.titleBlur($event)},"focus":function($event){_vm.titleFocus($event)},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();$event.target.blur()},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }$event.target.blur()}]}},[_vm._v(_vm._s(_vm.title))]):_vm._e()]),_vm._v(" "),(_vm.memoSetType === 'regular')?_c('div',{staticClass:"noTopMargin noTopPadding",class:{'one wide column labelColumn': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('h4',{staticClass:"noTopMargin noTopPadding"},[_vm._v(_vm._s(_vm.text.memoSetCoverImage)),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.mobile),expression:"!mobile"}]},[_vm._v(":")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"noTopPadding",class:{'fifteen wide column mainColumn': !_vm.mobile && _vm.memoSetType === 'regular', 'sixteen wide column': _vm.mobile || _vm.memoSetType !== 'regular'}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.coverImageLoaded),expression:"!coverImageLoaded"}],staticClass:"ui small active inline loader"}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.coverImageLoaded),expression:"coverImageLoaded"}],staticClass:"ui rounded image coverImage",class:{coverImageEditable: _vm.memoSetType === 'regular'},attrs:{"src":_vm.coverImage},on:{"click":function($event){_vm.coverImageClick()},"load":function($event){_vm.coverImageLoaded = true}}})]),_vm._v(" "),(_vm.memoSetType === 'regular')?_c('div',{staticClass:"noTopMargin noTopPadding",class:{'one wide column labelColumn': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('h4',{staticClass:"noTopMargin noTopPadding"},[_vm._v(_vm._s(_vm.text.memoSetDescription)),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.mobile),expression:"!mobile"}]},[_vm._v(":")])])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.memoSetType === 'regular' || _vm.description !== _vm.text.memoSetDefaultDescription),expression:"memoSetType === 'regular' || description !== text.memoSetDefaultDescription"}],staticClass:"noTopMargin noTopPadding",class:{'fifteen wide column mainColumn': !_vm.mobile && _vm.memoSetType === 'regular', 'sixteen wide column': _vm.mobile || _vm.memoSetType !== 'regular'}},[(_vm.memoSetType !== 'regular')?_c('div',{domProps:{"innerHTML":_vm._s(_vm.sanitize(_vm.description))}}):_vm._e(),_vm._v(" "),(_vm.memoSetType === 'regular')?_c('div',{staticClass:"editable inlineEditable",class:{descriptionPlaceholder: _vm.descriptionPlaceholder},attrs:{"contenteditable":""},domProps:{"innerHTML":_vm._s(_vm.sanitize(_vm.description))},on:{"blur":function($event){_vm.descriptionBlur($event)},"focus":function($event){_vm.descriptionFocus($event)},"input":function($event){_vm.descriptionPlaceholder = false},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.descriptionEnter($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }$event.target.blur()}]}}):_vm._e()]),_vm._v(" "),(_vm.selfOwned && _vm.sharingArray.length)?_c('div',{staticClass:"noPrint noTopMargin noTopPadding",class:{'one wide column labelColumn': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('h4',{staticClass:"noTopMargin noTopPadding"},[_vm._v(_vm._s(_vm.text.memoSetSharedWith)),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.mobile),expression:"!mobile"}]},[_vm._v(":")])])]):_vm._e(),_vm._v(" "),(_vm.selfOwned && _vm.sharingArray.length)?_c('div',{staticClass:"noPrint noTopMargin noTopPadding",class:{'fifteen wide column mainColumn': !_vm.mobile, 'sixteen wide column': _vm.mobile}},_vm._l((_vm.sharingArray),function(share){return _c('div',{key:share.userId,staticClass:"ui label moveUp",class:{green: share.userId === 'public'}},[(share.userId === 'public')?_c('span',[_vm._v(_vm._s(_vm.text.memoSetPublic))]):_vm._e(),_vm._v(" "),(share.userId !== 'public')?_c('span',[_vm._v(_vm._s(share.displayName))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"delete icon",on:{"click":function($event){_vm.unshareMemoSet(share.userId)}}})])})):_vm._e(),_vm._v(" "),(_vm.memoSetType === 'regular' && !_vm.selfOwned)?_c('div',{staticClass:"noTopMargin noTopPadding",class:{'one wide column labelColumn': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('h4',{staticClass:"noTopMargin noTopPadding"},[_vm._v(_vm._s(_vm.text.memoSetOriginalAuthor)),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.mobile),expression:"!mobile"}]},[_vm._v(":")])])]):_vm._e(),_vm._v(" "),(_vm.memoSetType === 'regular' && !_vm.selfOwned)?_c('div',{staticClass:"noTopMargin noTopPadding",class:{'fifteen wide column mainColumn': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_vm._v("\n              "+_vm._s(_vm.authorName)+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.memoSetType === 'regular' && !_vm.selfOwned)?_c('div',{staticClass:"noTopMargin noTopPadding",class:{'one wide column labelColumn': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('h4',{staticClass:"noTopMargin noTopPadding"},[_vm._v(_vm._s(_vm.text.memoSetMyRating)),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.mobile),expression:"!mobile"}]},[_vm._v(":")])])]):_vm._e(),_vm._v(" "),(_vm.memoSetType === 'regular' && !_vm.selfOwned)?_c('div',{staticClass:"noTopMargin noTopPadding",class:{'fifteen wide column mainColumn': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"ui yellow star rating myRating",attrs:{"data-rating":_vm.myRating,"data-max-rating":"5"}})]):_vm._e()]),_vm._v(" "),(_vm.memoSetType === 'regular')?_c('div',{staticClass:"actionButtonsWrapper noPrint"},[_c('button',{staticClass:"ui button actionButton",attrs:{"id":"copyMemoSetButton"},on:{"click":function($event){_vm.copyMemoSetClick()}}},[_c('i',{staticClass:"copy icon"}),_vm._v(_vm._s(_vm.text.memoSetCopy))]),_vm._v(" "),_c('button',{staticClass:"ui button actionButton",class:{'disabled loading': _vm.printing},attrs:{"id":"printMemoSetButton"},on:{"click":function($event){_vm.printMemoSetClick()}}},[_c('i',{staticClass:"print icon"}),_vm._v(_vm._s(_vm.text.memoSetPrint))]),_vm._v(" "),(_vm.selfOwned)?_c('button',{staticClass:"ui button actionButton",attrs:{"id":"shareMemoSetButton"},on:{"click":function($event){_vm.shareMemoSetClick()}}},[_c('i',{staticClass:"share icon"}),_vm._v(_vm._s(_vm.text.memoSetShare))]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"ui button actionButton",attrs:{"id":"deleteMemoSetButton"},on:{"click":function($event){_vm.deleteMemoSetClick()}}},[_c('i',{staticClass:"trash alternate icon"}),_vm._v(_vm._s(_vm.text.memoSetDelete))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"ui tab basic segment noBottomMargin noBottomPadding noTopPadding dataTab",class:{dataTabPrinting: _vm.printing},attrs:{"data-tab":"data"}},[(_vm.memoSetType === 'regular')?_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hideTopElements),expression:"!hideTopElements"}],staticClass:"searchRowWrapper noPrint",class:{'mobile': _vm.mobile}},[_c('div',{staticClass:"searchWrapper",class:{'mobile': _vm.mobile, 'noTabsText': !_vm.tabsText}},[_c('div',{staticClass:"ui fluid search"},[_c('div',{staticClass:"ui fluid icon input"},[_c('input',{staticClass:"prompt",attrs:{"id":"search","type":"text","placeholder":_vm.text.commonSearchPlaceholder}}),_vm._v(" "),_c('i',{staticClass:"search icon"})]),_vm._v(" "),_c('div',{staticClass:"results",class:{'mobile': _vm.mobile, 'noTabsText': !_vm.tabsText}})])]),_vm._v(" "),_c('div',{staticClass:"navigationWrapper",class:{'mobile': _vm.mobile, 'noTabsText': !_vm.tabsText}},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabsText),expression:"tabsText"}],staticClass:"ui icon button goToRowButton",class:{disabled: _vm.firstVisibleRow === 1},on:{"click":function($event){_vm.firstRowsClick($event)}}},[_c('i',{staticClass:"large double angle left icon largeIconInButton"})]),_vm._v(" "),_c('button',{staticClass:"ui icon button goToRowButton",class:{disabled: _vm.firstVisibleRow === 1},on:{"click":function($event){_vm.previousRowsClick($event)}}},[_c('i',{staticClass:"large angle left icon largeIconInButton"})]),_vm._v(" "),_c('div',{staticClass:"ui input goToRowInput"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.goToRowVal),expression:"goToRowVal"}],attrs:{"id":"goToRow","type":"text"},domProps:{"value":(_vm.goToRowVal)},on:{"change":function($event){_vm.goToRow()},"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.target.blur()},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }$event.target.blur()}],"input":function($event){if($event.target.composing){ return; }_vm.goToRowVal=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"ui icon button goToRowButton",class:{disabled: _vm.rows.length < _vm.firstVisibleRow + _vm.visibleRowsCount},on:{"click":function($event){_vm.nextRowsClick($event)}}},[_c('i',{staticClass:"large angle right icon largeIconInButton"})]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabsText),expression:"tabsText"}],staticClass:"ui icon button goToRowButton",class:{disabled: _vm.rows.length < _vm.firstVisibleRow + _vm.visibleRowsCount},on:{"click":function($event){_vm.lastRowsClick($event)}}},[_c('i',{staticClass:"large double angle right icon largeIconInButton"})])]),_vm._v(" "),_c('div',{staticClass:"actionsButtonWrapper",class:{'mobile': _vm.mobile, 'noTabsText': !_vm.tabsText}},[_c('div',{staticClass:"ui one item menu multiLine actionsButton"},[_c('a',{staticClass:"item"},[_c('i',{staticClass:"large bars icon",class:{'compactTabsIcon': _vm.mobile, 'noRightMargin': !_vm.tabsText}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabsText),expression:"tabsText"}],class:{'compactTabsText': _vm.mobile}},[_vm._v(_vm._s(_vm.text.memoSetActions))])])]),_vm._v(" "),_c('div',{staticClass:"ui popup top transition hidden"},[_c('div',{staticClass:"ui divided three column grid",class:{desktopActionsWidth: !_vm.mobile, mobileActionsWidth: _vm.mobile}},[_c('div',{staticClass:"column actionsWidth1"},[_c('h4',{staticClass:"ui header"},[_vm._v(_vm._s(_vm.text.memoSetOptions))]),_vm._v(" "),_c('div',{staticClass:"ui link list"},[_c('div',{staticClass:"item",on:{"click":function($event){_vm.optionsClick('useReviewGroups')}}},[_c('div',{staticClass:"ui checkbox"},[_c('input',{staticClass:"hidden",attrs:{"type":"checkbox","tabindex":"0"},domProps:{"checked":_vm.options.useReviewGroups}}),_vm._v(" "),_c('label',{staticClass:"checkboxLabel"},[_vm._v(_vm._s(_vm.text.memoSetUseGroups))])])]),_vm._v(" "),_c('div',{staticClass:"item",staticStyle:{"margin-top":"-2px"},on:{"click":function($event){_vm.optionsClick('useBackgroundPhotos')}}},[_c('div',{staticClass:"ui checkbox"},[_c('input',{staticClass:"hidden",attrs:{"type":"checkbox","tabindex":"0"},domProps:{"checked":_vm.options.useBackgroundPhotos}}),_vm._v(" "),_c('label',{staticClass:"checkboxLabel"},[_vm._v(_vm._s(_vm.text.memoSetUseBackgroundPhotos))])])]),_vm._v(" "),_c('div',{staticClass:"item",class:{disabled: _vm.options.useBackgroundPhotos},staticStyle:{"margin-top":"-2px"},on:{"click":function($event){_vm.optionsClick('useSummaryImages')}}},[_c('div',{staticClass:"ui checkbox"},[_c('input',{staticClass:"hidden",attrs:{"type":"checkbox","tabindex":"0","disabled":_vm.options.useBackgroundPhotos},domProps:{"checked":_vm.options.useSummaryImages}}),_vm._v(" "),_c('label',{staticClass:"checkboxLabel"},[_vm._v(_vm._s(_vm.text.memoSetUseSummaryImages))])])]),_vm._v(" "),_c('div',{staticClass:"ui divider"}),_vm._v(" "),_c('div',{staticClass:"ui basic compact button",on:{"click":function($event){_vm.exportDataClick()}}},[_c('i',{staticClass:"copy icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.text.memoSetExportData))])])])]),_vm._v(" "),_c('div',{staticClass:"column actionsWidth2"},[_c('h4',{staticClass:"ui header"},[_vm._v(_vm._s(_vm.text.memoSetColumns)),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.mobile),expression:"!mobile"}],staticClass:"disabled grey clockwise rotated content icon actionsIcon"})]),_vm._v(" "),_c('div',{staticClass:"ui link list"},[_c('a',{staticClass:"item",on:{"click":function($event){_vm.addColumnClick()}}},[_vm._v(_vm._s(_vm.text.memoSetAddColumn))]),_vm._v(" "),_c('a',{staticClass:"item",class:{disabled: !_vm.fields.length},on:{"click":function($event){_vm.deleteColumnClick()}}},[_vm._v(_vm._s(_vm.text.memoSetDeleteColumn))]),_vm._v(" "),_c('a',{staticClass:"item",class:{disabled: _vm.fields.length < 2},on:{"click":function($event){_vm.moveColumnClick()}}},[_vm._v(_vm._s(_vm.text.memoSetMoveColumn))]),_vm._v(" "),_c('a',{staticClass:"item",class:{disabled: !_vm.fields.length},on:{"click":function($event){_vm.populateColumnClick()}}},[_vm._v(_vm._s(_vm.text.memoSetPopulateColumn))])])]),_vm._v(" "),_c('div',{staticClass:"column actionsWidth3"},[_c('h4',{staticClass:"ui header"},[_vm._v(_vm._s(_vm.text.commonRows)),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.mobile),expression:"!mobile"}],staticClass:"disabled grey content icon actionsIcon"})]),_vm._v(" "),_c('div',{staticClass:"ui link list"},[_c('a',{staticClass:"item",on:{"click":function($event){_vm.addRowsClick()}}},[_vm._v(_vm._s(_vm.text.memoSetAddRows))]),_vm._v(" "),_c('a',{staticClass:"item",class:{disabled: !_vm.rows.length},on:{"click":function($event){_vm.deleteRowsClick()}}},[_vm._v(_vm._s(_vm.text.memoSetDeleteRows))]),_vm._v(" "),_c('a',{staticClass:"item",class:{disabled: _vm.rows.length < 2},on:{"click":function($event){_vm.moveRowsClick()}}},[_vm._v(_vm._s(_vm.text.memoSetMoveRows))]),_vm._v(" "),_c('a',{staticClass:"item",class:{disabled: _vm.rows.length < 2},on:{"click":function($event){_vm.sortRowsClick()}}},[_vm._v(_vm._s(_vm.text.memoSetSortRows))])])])])])])]):_vm._e(),_vm._v(" "),(_vm.printing || (_vm.activeTab === 'data' && _vm.modal !== 'summaryImage' && _vm.modal !== 'walkThrough'))?_c('div',{staticClass:"tableWrapper",class:{mobile: _vm.mobile, readOnly: _vm.memoSetType !== 'regular', thinScroll: _vm.mobile && _vm.touch},style:({maxHeight: _vm.tableWrapperMaxHeight + 'px'}),attrs:{"id":"tableWrapper"},on:{"&scroll":function($event){_vm.tableWrapperScroll()}}},[(_vm.fields)?_c('table',{staticClass:"ui celled unstackable table memoSetTable"},[_c('thead',[_c('tr',{staticClass:"middle aligned"},[_c('th',{staticClass:"one wide disabled"},[_vm._v(_vm._s(_vm.text.memoSetRow))]),_vm._v(" "),_vm._l((_vm.fields),function(field,fieldIndex){return _c('th',{key:field.fieldId,staticClass:"two wide noPadding dummyHeight outlineOnFocus",class:{disabled: _vm.memoSetType !== 'regular'}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentRow === 0 && field.fieldId === _vm.currentFieldId),expression:"currentRow === 0 && field.fieldId === currentFieldId"}],staticClass:"headingCellButtons"},[_c('div',{staticClass:"ui mini compact icon button",attrs:{"data-position":"bottom center","data-tooltip":"Add an image"},on:{"mousedown":function($event){_vm.addCellImageClick(0, field.fieldId)}}},[_c('i',{staticClass:"image icon"})]),_vm._v(" "),_c('div',{staticClass:"ui mini compact icon button",attrs:{"data-position":"bottom center","data-tooltip":"Add audio"},on:{"mousedown":function($event){_vm.addCellAudioClick(0, field.fieldId)}}},[_c('i',{staticClass:"volume up icon"})])]),_vm._v(" "),_c('div',{staticClass:"aligner",on:{"click":function($event){_vm.cellClick($event)}}},[_c('div',{staticClass:"contenteditableHeading",attrs:{"contenteditable":_vm.memoSetType === 'regular',"spellcheck":"false"},on:{"blur":function($event){_vm.headingBlur($event, field, fieldIndex)},"focus":function($event){_vm.headingFocus(field.fieldId)},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();$event.target.blur()},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }$event.target.blur()}]}},[_vm._v(_vm._s(field.heading))])])])}),_vm._v(" "),_c('th',{directives:[{name:"show",rawName:"v-show",value:(_vm.options.useReviewGroups),expression:"options.useReviewGroups"}],staticClass:"two wide disabled"},[_vm._v(_vm._s(_vm.text.memoSetGroup))]),_vm._v(" "),_c('th',{directives:[{name:"show",rawName:"v-show",value:(_vm.options.useBackgroundPhotos),expression:"options.useBackgroundPhotos"}],staticClass:"one wide disabled photo"},[_vm._v(_vm._s(_vm.text.memoSetBackgroundPhoto))]),_vm._v(" "),_c('th',{directives:[{name:"show",rawName:"v-show",value:(_vm.options.useSummaryImages),expression:"options.useSummaryImages"}],staticClass:"one wide disabled photo"},[_vm._v(_vm._s(_vm.text.memoSetSummaryImage))]),_vm._v(" "),_c('th',{staticClass:"four wide disabled"},[_vm._v(_vm._s(_vm.text.memoSetNotes))])],2)]),_vm._v(" "),_c('tbody',[_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.firstVisibleRow > 1),expression:"firstVisibleRow > 1"}]},[_c('td',{staticClass:"noPadding",attrs:{"colspan":_vm.fields.length + 2 + (_vm.options.useBackgroundPhotos ? 1 : 0) + (_vm.options.useReviewGroups ? 1 : 0) + (_vm.options.useSummaryImages ? 1 : 0)}},[_c('div',{staticClass:"ui fluid button barButton",on:{"click":function($event){_vm.previousRowsClick($event)}}},[_c('span',{style:({marginLeft: _vm.barButtonMargin + 'px'})},[_vm._v(_vm._s(_vm.text.memoSetPreviousRows))])])])]),_vm._v(" "),_vm._l((_vm.visibleRows),function(row,visibleRowsIndex){return _c('tr',{key:row.rowId,staticClass:"top aligned"},[_c('td',{staticClass:"disabled middle aligned"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(visibleRowsIndex + _vm.visibleRowsOffset + 1 < 10),expression:"visibleRowsIndex + visibleRowsOffset + 1 < 10"}]},[_vm._v(" ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(visibleRowsIndex + _vm.visibleRowsOffset + 1 < 100),expression:"visibleRowsIndex + visibleRowsOffset + 1 < 100"}]},[_vm._v(" ")]),_vm._v("\n                  "+_vm._s(visibleRowsIndex + _vm.visibleRowsOffset + 1)+"\n                ")]),_vm._v(" "),_vm._l((_vm.fields),function(field,fieldIndex){return _c('td',{key:field.fieldId,staticClass:"cellTd outlineOnFocus",class:{cardsCell: _vm.cardStyle(row.data[field.fieldId])},style:(_vm.cardStyle(row.data[field.fieldId]))},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentRow && visibleRowsIndex + _vm.visibleRowsOffset === _vm.currentRow && field.fieldId === _vm.currentFieldId),expression:"currentRow && visibleRowsIndex + visibleRowsOffset === currentRow && field.fieldId === currentFieldId"}],staticClass:"cellButtons",class:{lightBackground: !visibleRowsIndex}},[_c('div',{staticClass:"ui mini compact icon button",attrs:{"data-position":"bottom center","data-tooltip":"Add an image"},on:{"mousedown":function($event){_vm.addCellImageClick(visibleRowsIndex + _vm.visibleRowsOffset, field.fieldId)}}},[_c('i',{staticClass:"image icon"})]),_vm._v(" "),_c('div',{staticClass:"ui mini compact icon button",attrs:{"data-position":"bottom center","data-tooltip":"Add audio"},on:{"mousedown":function($event){_vm.addCellAudioClick(visibleRowsIndex + _vm.visibleRowsOffset, field.fieldId)}}},[_c('i',{staticClass:"volume up icon"})])]),_vm._v(" "),(visibleRowsIndex + _vm.visibleRowsOffset === _vm.currentRow && field.fieldId === _vm.currentFieldId && row.data[field.fieldId] && !_vm.editingCell && !_vm.alternatives[row.rowId + '|' + field.fieldId])?_c('div',{staticClass:"alternativesWrapper"},[_c('div',{staticClass:"mini compact basic ui icon button addAlternative",attrs:{"data-position":"right center","data-tooltip":"Add alternative"},on:{"click":function($event){_vm.addAlternativeClick(visibleRowsIndex + _vm.visibleRowsOffset, field.fieldId)}}},[_c('i',{staticClass:"plus icon"})])]):_vm._e(),_vm._v(" "),(_vm.alternatives[row.rowId + '|' + field.fieldId] && !(visibleRowsIndex + _vm.visibleRowsOffset === _vm.currentRow && field.fieldId === _vm.currentFieldId && _vm.editingCell))?_c('div',{staticClass:"alternativesWrapper"},[_c('div',{staticClass:"mini compact basic ui icon button viewAlternatives",attrs:{"data-position":"right center","data-tooltip":"View alternatives"},on:{"click":function($event){_vm.viewAlternativesClick(visibleRowsIndex + _vm.visibleRowsOffset, field.fieldId)}}},[_c('i',{staticClass:"large dropdown icon"})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"aligner",on:{"click":function($event){_vm.cellClick($event)}}},[_c('div',{staticClass:"contenteditableCell tex2jax_process",attrs:{"contenteditable":_vm.memoSetType === 'regular',"id":field.fieldId + '_' + (visibleRowsIndex + _vm.visibleRowsOffset),"spellcheck":_vm.cardStyle(row.data[field.fieldId]) ? false : true},domProps:{"innerHTML":_vm._s(_vm.sanitize(row.data[field.fieldId]))},on:{"blur":function($event){_vm.rowFieldBlur($event, field.fieldId, visibleRowsIndex + _vm.visibleRowsOffset)},"focus":function($event){_vm.rowFieldFocus($event, field.fieldId, visibleRowsIndex + _vm.visibleRowsOffset)},"input":function($event){_vm.editingCell = true},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.rowFieldEnter($event, field.fieldId, visibleRowsIndex + _vm.visibleRowsOffset)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }$event.target.blur()}],"paste":function($event){_vm.rowFieldPaste($event, 'field', fieldIndex, visibleRowsIndex + _vm.visibleRowsOffset)}}})])])}),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.options.useReviewGroups),expression:"options.useReviewGroups"}],staticClass:"one wide noPadding dummyHeight outlineOnFocus"},[_c('div',{staticClass:"aligner",on:{"click":function($event){_vm.cellClick($event)}}},[_c('div',{staticClass:"ui label reviewGroup",class:_vm.reviewGroupColors[row.data.reviewGroup || ''],attrs:{"contenteditable":_vm.memoSetType === 'regular',"id":'reviewGroup_' + (visibleRowsIndex + _vm.visibleRowsOffset),"spellcheck":"false"},on:{"blur":function($event){_vm.reviewGroupBlur($event, visibleRowsIndex + _vm.visibleRowsOffset)},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.rowFieldEnter($event, 'reviewGroup', visibleRowsIndex + _vm.visibleRowsOffset)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }$event.target.blur()}],"paste":function($event){_vm.rowFieldPaste($event, 'group', -1, visibleRowsIndex + _vm.visibleRowsOffset)}}},[_vm._v(_vm._s(row.data.reviewGroup || ''))])])]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.options.useBackgroundPhotos),expression:"options.useBackgroundPhotos"}],staticClass:"center aligned middle aligned"},[_c('div',{staticClass:"ui centered grid"},[_c('div',{staticClass:"row noBottomPadding noTopPadding"},[(row.data.photoId && (visibleRowsIndex + _vm.visibleRowsOffset === 0 || row.data.photoId !== _vm.rows[visibleRowsIndex + _vm.visibleRowsOffset - 1].data.photoId))?_c('img',{staticClass:"photoThumbnail",class:{clickable: _vm.memoSetType === 'regular'},style:({
                          height: _vm.photoThumbnailDimensions[_vm.photoIndexes[visibleRowsIndex + _vm.visibleRowsOffset]].height + 'px',
                          minWidth: _vm.photoThumbnailDimensions[_vm.photoIndexes[visibleRowsIndex + _vm.visibleRowsOffset]].width + 'px',
                          width: _vm.photoThumbnailDimensions[_vm.photoIndexes[visibleRowsIndex + _vm.visibleRowsOffset]].width + 'px'
                        }),attrs:{"src":_vm.photos[_vm.photoIndexes[visibleRowsIndex + _vm.visibleRowsOffset]].url},on:{"click":function($event){_vm.backgroundPhotoClick(visibleRowsIndex + _vm.visibleRowsOffset)}}}):_vm._e(),_vm._v(" "),(_vm.memoSetType === 'regular' && visibleRowsIndex + _vm.visibleRowsOffset && row.data.photoId && row.data.photoId === _vm.rows[visibleRowsIndex + _vm.visibleRowsOffset - 1].data.photoId)?_c('span',{staticClass:"asAbove asAboveLink",on:{"click":function($event){_vm.backgroundPhotoClick(visibleRowsIndex + _vm.visibleRowsOffset)}}},[_vm._v(_vm._s(_vm.text.memoSetAsAbove))]):_vm._e(),_vm._v(" "),(_vm.memoSetType !== 'regular' && visibleRowsIndex + _vm.visibleRowsOffset && row.data.photoId && row.data.photoId === _vm.rows[visibleRowsIndex + _vm.visibleRowsOffset - 1].data.photoId)?_c('span',{staticClass:"asAbove"},[_vm._v("\n                        "+_vm._s(_vm.text.memoSetAsAbove)+"\n                      ")]):_vm._e(),_vm._v(" "),(_vm.memoSetType === 'regular' && !row.data.photoId)?_c('div',{staticClass:"ui large icon button noPrint",on:{"click":function($event){_vm.backgroundPhotoClick(visibleRowsIndex + _vm.visibleRowsOffset)}}},[_c('i',{staticClass:"plus icon"})]):_vm._e()])])]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.options.useSummaryImages),expression:"options.useSummaryImages"}],staticClass:"center aligned middle aligned"},[_c('div',{staticClass:"ui centered grid"},[_c('div',{staticClass:"row noBottomPadding noTopPadding"},[(_vm.thumbnails[visibleRowsIndex + _vm.visibleRowsOffset])?_c('img',{staticClass:"summaryImageThumbnail",class:{clickable: _vm.memoSetType === 'regular', summaryImageThumbnailBorder: !row.data.photoId},attrs:{"src":_vm.thumbnails[visibleRowsIndex + _vm.visibleRowsOffset]},on:{"click":function($event){_vm.summaryImageClick(visibleRowsIndex + _vm.visibleRowsOffset)}}}):_vm._e(),_vm._v(" "),(_vm.memoSetType === 'regular' && _vm.thumbnails[visibleRowsIndex + _vm.visibleRowsOffset] === null)?_c('div',{staticClass:"ui large icon button noPrint",attrs:{"data-content":"Add a summary image"},on:{"click":function($event){_vm.summaryImageClick(visibleRowsIndex + _vm.visibleRowsOffset)}}},[_c('i',{staticClass:"plus icon"})]):_vm._e()])])]),_vm._v(" "),_c('td',{staticClass:"cellTd outlineOnFocus"},[_c('div',{staticClass:"aligner",on:{"click":function($event){_vm.cellClick($event)}}},[_c('div',{staticClass:"contenteditableCell tex2jax_process",attrs:{"contenteditable":_vm.memoSetType === 'regular',"id":'notes_' + (visibleRowsIndex + _vm.visibleRowsOffset)},domProps:{"innerHTML":_vm._s(_vm.sanitize(row.data.notes || ''))},on:{"blur":function($event){_vm.rowFieldBlur($event, 'notes', visibleRowsIndex + _vm.visibleRowsOffset)},"focus":function($event){_vm.rowFieldFocus($event, 'notes', visibleRowsIndex + _vm.visibleRowsOffset)},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }$event.target.blur()},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.rowFieldEnter($event, 'notes', visibleRowsIndex + _vm.visibleRowsOffset)}],"paste":function($event){_vm.rowFieldPaste($event, 'notes', -1, visibleRowsIndex + _vm.visibleRowsOffset)}}})])])],2)}),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.rows.length > _vm.firstVisibleRow + _vm.visibleRowsCount - 1),expression:"rows.length > firstVisibleRow + visibleRowsCount - 1"}]},[_c('td',{staticClass:"noPadding",attrs:{"colspan":_vm.fields.length + 2 + (_vm.options.useBackgroundPhotos ? 1 : 0) + (_vm.options.useReviewGroups ? 1 : 0) + (_vm.options.useSummaryImages ? 1 : 0)}},[_c('div',{staticClass:"ui fluid button barButton",on:{"click":function($event){_vm.nextRowsClick($event)}}},[_c('span',{style:({marginLeft: _vm.barButtonMargin + 'px'})},[_vm._v(_vm._s(_vm.text.memoSetNextRows))])])])])],2)]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"ui tab basic segment noBottomMargin noBottomPadding noTopMargin",attrs:{"data-tab":"questions"}},[(_vm.activeTab === 'questions')?_c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.questions.length),expression:"questions.length"}],staticClass:"questionsWrapper",class:{'mobile': _vm.mobile, 'thinScroll': _vm.mobile && _vm.touch},style:({maxHeight: _vm.questionsWrapperMaxHeight + 'px'}),attrs:{"id":"questionsWrapper"}},[_c('div',{staticClass:"ui segments"},_vm._l((_vm.questions),function(question,questionIndex){return _c('div',{key:'question_' + question.questionId,staticClass:"ui segment questionSegment",attrs:{"id":'question_' + question.questionId},on:{"click":function($event){_vm.questionClick('edit', question, questionIndex)}}},[_vm._v("\n                "+_vm._s(_vm.fieldsById[question.fromFieldId].heading)+"\n                "),_c('span',{staticStyle:{"margin":"0 0.8rem"}},[_vm._v("⟶")]),_vm._v("\n                "+_vm._s(_vm.fieldsById[question.toFieldId].heading)+"\n              ")])}))]),_vm._v(" "),(_vm.memoSetType === 'regular' && _vm.addQuestionEnabled)?_c('button',{staticClass:"ui primary button addQuestionButton",on:{"click":function($event){_vm.questionClick('add')}}},[_c('i',{staticClass:"plus icon"}),_vm._v("\n            "+_vm._s(_vm.text.memoSetAddQuestion)+"\n          ")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"ui tab basic segment learnMain",attrs:{"data-tab":"learn"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.ready),expression:"!ready"}],staticClass:"ui small active inline loader"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready),expression:"ready"}],staticStyle:{"margin-top":"0.4rem"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.questions.length),expression:"!questions.length"}],staticClass:"ui warning message"},[_c('div',{staticClass:"header"},[_vm._v("\n              "+_vm._s(_vm.text.memoSetNoQuestionsDefinedHdr)+"\n            ")]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"1rem"}},[_vm._v(_vm._s(_vm.text.memoSetNoQuestionsDefined))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.questions.length),expression:"questions.length"}]},[_c('div',{staticClass:"resetWrapper",class:{resetWrapperMobile: _vm.mobile}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.statuses.known || _vm.statuses.due),expression:"statuses.known || statuses.due"}],staticClass:"ui right floated icon button",class:{tiny: _vm.mobile},on:{"click":function($event){_vm.resetLearningClick()}}},[_c('i',{staticClass:"undo alternate icon"})])]),_vm._v(" "),_c('status-bar',{staticClass:"statusBar",attrs:{"mobile":_vm.mobile,"page":"MemoSet","statuses":_vm.statuses,"window":_vm.window}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.noStatusBarText),expression:"noStatusBarText"}],staticClass:"ui warning message noStatusBar"},[_c('span',[_vm._v(_vm._s(_vm.noStatusBarText))])]),_vm._v(" "),_c('div',{staticClass:"ui grid learnGrid",class:{'mobile': _vm.mobile}},[_c('div',{staticClass:"noRightPadding noTopPadding",class:{'eight wide column': !_vm.mobile && _vm.options.useReviewGroups, 'sixteen wide column': _vm.mobile || !_vm.options.useReviewGroups}},[_c('div',{staticClass:"ui segment learnSegment"},[_c('h4',{staticClass:"ui block header segmentHeader"},[_vm._v(_vm._s(_vm.text.memoSetQuestions)+"\n                    "),_c('div',{staticClass:"ui compact right floated button learnSelectAllButton",class:{disabled: !_vm.learn.questionIds.length},on:{"click":function($event){_vm.selectAllQuestions(false)}}},[_vm._v(_vm._s(_vm.text.memoSetNone))]),_vm._v(" "),_c('div',{staticClass:"ui compact right floated button learnSelectAllButton",class:{disabled: _vm.learn.questionIds.length === _vm.questions.length},on:{"click":function($event){_vm.selectAllQuestions(true)}}},[_vm._v(_vm._s(_vm.text.memoSetAll))])]),_vm._v(" "),_c('div',{staticClass:"ui form learnQuestionsWrapper",class:{'thinScroll': _vm.mobile && _vm.touch},style:({maxHeight: _vm.learnWrapperMaxHeights[0] + 'px'})},[_c('div',{staticClass:"inline fields"},[_c('div',{staticClass:"grouped fields"},_vm._l((_vm.questions),function(question){return _c('div',{key:'learnQuestion_' + question.questionId,staticClass:"field"},[_c('div',{staticClass:"ui checkbox learnQuestion",attrs:{"id":'learnQuestion_' + question.questionId}},[_c('input',{staticClass:"hidden",attrs:{"type":"checkbox","name":"learnQuestions","tabindex":"0"}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.fieldsById[question.fromFieldId].heading)),_c('span',{staticStyle:{"margin":"0 0.4rem"}},[_vm._v("⟶")]),_vm._v(_vm._s(_vm.fieldsById[question.toFieldId].heading))])])])}))])])])]),_vm._v(" "),(_vm.options.useReviewGroups)?_c('div',{staticClass:"noRightPadding noTopPadding",class:{'eight wide column rightShift': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"ui segment learnSegment"},[_c('h4',{staticClass:"ui block header segmentHeader"},[_vm._v(_vm._s(_vm.text.memoSetGroups)+"\n                    "),_c('div',{staticClass:"ui compact right floated button learnSelectAllButton",class:{disabled: !_vm.learn.reviewGroupIds.length},on:{"click":function($event){_vm.selectAllReviewGroups(false)}}},[_vm._v(_vm._s(_vm.text.memoSetNone))]),_vm._v(" "),_c('div',{staticClass:"ui compact right floated button learnSelectAllButton",class:{disabled: _vm.learn.reviewGroupIds.length === _vm.reviewGroupsList.length},on:{"click":function($event){_vm.selectAllReviewGroups(true)}}},[_vm._v(_vm._s(_vm.text.memoSetAll))])]),_vm._v(" "),_c('div',{staticClass:"ui form learnReviewGroupsWrapper",class:{'thinScroll': _vm.mobile && _vm.touch},style:({maxHeight: _vm.learnWrapperMaxHeights[1] + 'px'})},[_c('div',{staticClass:"inline fields"},[_c('div',{staticClass:"grouped fields"},_vm._l((_vm.reviewGroupsList),function(reviewGroup,reviewGroupIndex){return _c('div',{key:'learnReviewGroup_' + reviewGroupIndex,staticClass:"field"},[_c('div',{staticClass:"ui checkbox learnReviewGroup",attrs:{"id":'learnReviewGroup_' + reviewGroupIndex}},[_c('input',{staticClass:"hidden",attrs:{"type":"checkbox","name":"learnReviewGroups","tabindex":"0"},domProps:{"value":_vm.question.questionId}}),_vm._v(" "),_c('label',[_c('div',{staticClass:"ui label learnReviewGroupLabel",class:reviewGroup ? _vm.reviewGroupColors[reviewGroup] : 'noGroup'},[_vm._v("\n                          "+_vm._s(reviewGroup || 'No Group'))])])])])}))])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"ui checkbox useMaxResponseTime",on:{"mousedown":function($event){_vm.useMaxResponseTimeMouseDown = true}}},[_c('input',{staticClass:"hidden",attrs:{"type":"checkbox","tabindex":"0"},domProps:{"checked":_vm.learn.useMaxResponseTime}}),_vm._v(" "),_c('label',[_c('strong',[_vm._v("Time Limit"),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.learn.useMaxResponseTime),expression:"learn.useMaxResponseTime"}]},[_vm._v(":")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.learn.useMaxResponseTime),expression:"learn.useMaxResponseTime"}],staticClass:"ui right labeled input",staticStyle:{"margin-left":"1rem"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.learn.maxResponseTime),expression:"learn.maxResponseTime"}],staticClass:"maxResponseTime",attrs:{"id":"maxResponseTime","type":"text"},domProps:{"value":(_vm.learn.maxResponseTime)},on:{"blur":function($event){_vm.maxResponseTimeBlur()},"focus":function($event){_vm.useMaxResponseTimeMouseDown = false},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.learn, "maxResponseTime", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"ui basic label maxResponseTimeLabel"},[_vm._v("\n                seconds\n              ")])])],1)])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"ui modal addCellAudio",class:_vm.modalClass},[_c('div',{staticClass:"ui header"},[_vm._v("\n      "+_vm._s(_vm.text.memoSetAddAudio)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.addCellAudio.loading),expression:"addCellAudio.loading"}],staticClass:"ui small active inline loader modalLoader"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.addCellAudio.loading),expression:"!addCellAudio.loading"}]},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.addCellAudio.url),expression:"addCellAudio.url"}]},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.addCellAudio.uploading),expression:"addCellAudio.uploading"}],staticClass:"ui active dimmer"},[_c('div',{staticClass:"ui text loader"},[_vm._v("Uploading audio")])]),_vm._v(" "),_c('audio',{staticStyle:{"outline":"none"},attrs:{"id":"addCellAudio","controls":"","src":_vm.addCellAudio.url}}),_vm._v(" "),_c('button',{staticClass:"ui red button resetAudioButton",on:{"click":function($event){_vm.initAddCellAudio()}}},[_vm._v("Reset")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.addCellAudio.url),expression:"!addCellAudio.url"}]},[_vm._m(1),_vm._v(" "),_c('input',{attrs:{"type":"file","accept":"audio/*","id":"cellAudioFile"},on:{"change":function($event){_vm.cellAudioFileChange($event.target.files[0])}}}),_vm._v(" "),_c('div',{staticClass:"ui horizontal divider"},[_vm._v("\n            Or\n          ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.addCellAudio.recording),expression:"!addCellAudio.recording"}],staticClass:"ui button",on:{"click":function($event){_vm.startRecordingClick()}}},[_c('i',{staticClass:"large microphone icon"}),_vm._v("\n            Start Recording\n          ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.addCellAudio.recording),expression:"addCellAudio.recording"}],staticClass:"ui blue button",on:{"click":function($event){_vm.stopRecordingClick()}}},[_c('i',{staticClass:"large microphone slash icon"}),_vm._v("\n            Stop Recording\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"ui primary ok button",class:{disabled: !_vm.addCellAudio.url}},[_vm._v("OK")]),_vm._v(" "),_c('div',{staticClass:"ui cancel button"},[_vm._v("Cancel")])])]),_vm._v(" "),_c('div',{staticClass:"ui modal addCellImage",class:_vm.modalClass},[_c('div',{staticClass:"ui header"},[_vm._v("\n      "+_vm._s(_vm.text.memoSetAddImage)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.addCellImage.loading),expression:"addCellImage.loading"}],staticClass:"ui small active inline loader modalLoader"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.addCellImage.loading),expression:"!addCellImage.loading"}]},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.addCellImage.url),expression:"addCellImage.url"}]},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.addCellImage.uploading),expression:"addCellImage.uploading"}],staticClass:"ui active dimmer"},[_c('div',{staticClass:"ui text loader"},[_vm._v("Uploading image")])]),_vm._v(" "),_c('img',{staticClass:"ui bordered rounded image",staticStyle:{"height":"56vh","object-fit":"contain","width":"100%"},attrs:{"id":"addCellImage","src":_vm.addCellImage.url},on:{"load":function($event){_vm.cellImageLoad()}}}),_vm._v(" "),_c('button',{staticClass:"ui red button resetImageButton",on:{"click":function($event){_vm.initAddCellImage()}}},[_vm._v("Reset")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.addCellImage.url),expression:"!addCellImage.url"}]},[_vm._m(2),_vm._v(" "),_c('input',{attrs:{"type":"file","accept":"image/*","id":"cellImageFile"},on:{"change":function($event){_vm.cellImageFileChange($event.target.files[0])}}}),_vm._v(" "),_c('div',{staticClass:"ui horizontal divider"},[_vm._v("\n            Or\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Copy any image you find on the web by right-clicking on the image and choosing 'Copy image'.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Then paste the image into the box below.\n          ")]),_vm._v(" "),_c('textarea',{staticClass:"pasteImageHere",attrs:{"placeholder":_vm.text.memoSetPasteImageHere,"tabindex":"0"},on:{"keypress":function($event){$event.preventDefault();},"paste":function($event){$event.preventDefault();_vm.cellImagePaste($event)}}})])])]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"ui primary ok button",class:{disabled: !_vm.addCellImage.url}},[_vm._v("OK")]),_vm._v(" "),_c('div',{staticClass:"ui cancel button"},[_vm._v("Cancel")])])]),_vm._v(" "),_c('div',{staticClass:"ui modal addColumn",class:_vm.modalClass},[_c('div',{staticClass:"ui header"},[_vm._v("\n      "+_vm._s(_vm.text.memoSetAddColumn)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"ui grid",class:{'mobile': _vm.mobile}},[_c('div',{staticClass:"modalLabel modalLabelPadding",class:{'four wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('span',[_vm._v("Column Heading")])]),_vm._v(" "),_c('div',{staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"ui fluid input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addColumn.columnHeading),expression:"addColumn.columnHeading"}],attrs:{"type":"text","placeholder":"Enter the new column heading..."},domProps:{"value":(_vm.addColumn.columnHeading)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.addColumn, "columnHeading", $event.target.value)}}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fields.length),expression:"fields.length"}],staticClass:"modalLabel modalLabelPadding",class:{'four wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('span',[_vm._v("Add After")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fields.length),expression:"fields.length"}],staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"ui fluid selection dropdown addColumnAddAfterColumn"},[_c('input',{attrs:{"type":"hidden"},domProps:{"value":_vm.addColumn.addAfterColumn}}),_vm._v(" "),_c('i',{staticClass:"dropdown icon"}),_vm._v(" "),_c('div',{staticClass:"default text"}),_vm._v(" "),_c('div',{staticClass:"menu"},[_c('div',{staticClass:"item",attrs:{"data-value":"-1"}},[_vm._v("(First)")]),_vm._v(" "),_vm._l((_vm.fields),function(field,index){return _c('div',{key:index,staticClass:"item",attrs:{"data-value":index}},[_vm._v("\n                "+_vm._s(field.heading)+"\n              ")])})],2)])])])]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"ui primary ok button",class:{disabled: !_vm.addColumn.columnHeading}},[_vm._v(_vm._s(_vm.text.commonAdd))]),_vm._v(" "),_c('button',{staticClass:"ui cancel button"},[_vm._v(_vm._s(_vm.text.commonCancel))])])]),_vm._v(" "),_c('div',{staticClass:"ui modal addRows",class:[_vm.modalClass, {fullHeight: _vm.verticallyChallenged}]},[_c('div',{staticClass:"ui header"},[_vm._v("\n      "+_vm._s(_vm.text.memoSetAddRows)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"ui grid",class:{'mobile': _vm.mobile}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.rows.length),expression:"rows.length"}],staticClass:"modalLabel modalLabelPadding",class:{'four wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('span',[_vm._v("Add Below Row")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.rows.length),expression:"rows.length"}],staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"ui fluid input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addRows.addBelowRow),expression:"addRows.addBelowRow"}],attrs:{"type":"text","placeholder":'Enter row number between ' + '0 and ' + _vm.rows.length + '...'},domProps:{"value":(_vm.addRows.addBelowRow)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.addRows, "addBelowRow", $event.target.value)},function($event){_vm.applyMathjaxToRowDataTables()}]}})])]),_vm._v(" "),(!_vm.mobile && parseInt(_vm.addRows.addBelowRow, 10) > 0 && parseInt(_vm.addRows.addBelowRow, 10) <= _vm.rows.length)?_c('div',{staticClass:"four wide column"}):_vm._e(),_vm._v(" "),(parseInt(_vm.addRows.addBelowRow, 10) > 0 && parseInt(_vm.addRows.addBelowRow, 10) <= _vm.rows.length)?_c('div',{staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"row noBottomPadding rowDataTableWrapper",class:{'noTopPadding': _vm.mobile, 'thinScroll': _vm.mobile && _vm.touch}},[(_vm.fields)?_c('table',{staticClass:"ui celled unstackable table rowDataTable"},[_c('thead',[_c('tr',{staticClass:"middle aligned"},[_vm._l((_vm.fields),function(field){return _c('th',{key:field.fieldId,staticClass:"two wide"},[_vm._v("\n                    "+_vm._s(field.heading)+"\n                  ")])}),_vm._v(" "),_c('th',{staticClass:"three wide"},[_vm._v(_vm._s(_vm.text.memoSetNotes))])],2)]),_vm._v(" "),_c('tbody',[_c('tr',{staticClass:"middle aligned"},[_vm._l((_vm.fields),function(field){return _c('td',{key:field.fieldId,class:{cardsCell: _vm.cardStyle(_vm.rows[parseInt(_vm.addRows.addBelowRow, 10) - 1].data[field.fieldId])},style:(_vm.cardStyle(_vm.rows[parseInt(_vm.addRows.addBelowRow, 10) - 1].data[field.fieldId]))},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.sanitize(_vm.rows[parseInt(_vm.addRows.addBelowRow, 10) - 1].data[field.fieldId]))}})])}),_vm._v(" "),_c('td',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.sanitize(_vm.rows[parseInt(_vm.addRows.addBelowRow, 10) - 1].data.notes))}})])],2)])]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modalLabel modalLabelPadding",class:{'four wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('span',[_vm._v("Number of Rows")])]),_vm._v(" "),_c('div',{staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"ui fluid input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addRows.numberOfRows),expression:"addRows.numberOfRows"}],attrs:{"type":"text","autocomplete":"off","placeholder":"Enter the number of rows to be added..."},domProps:{"value":(_vm.addRows.numberOfRows)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.addRows, "numberOfRows", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"ui primary ok button",class:{disabled: !(parseInt(_vm.addRows.addBelowRow, 10) >= 0) || !(parseInt(_vm.addRows.numberOfRows, 10) > 0)}},[_vm._v(_vm._s(_vm.text.commonAdd))]),_vm._v(" "),_c('button',{staticClass:"ui cancel button"},[_vm._v(_vm._s(_vm.text.commonCancel))])])]),_vm._v(" "),_c('div',{staticClass:"ui modal backgroundPhoto",class:_vm.modalClass},[_c('div',{staticClass:"ui header noBottomBorder"},[_vm._v("\n      Background Photo\n      "),_c('div',{staticClass:"ui secondary pointing menu backgroundPhotoTabs"},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.modalPhotos.length),expression:"modalPhotos.length"}],staticClass:"header item",attrs:{"data-tab":"backgroundPhotoSelect"}},[_vm._v("Select Photo")]),_vm._v(" "),_c('a',{staticClass:"header item",attrs:{"data-tab":"backgroundPhotoAdd"}},[_vm._v("Add Photo")])])]),_vm._v(" "),_c('div',{staticClass:"scrolling content backgroundPhotoContent",class:{'thinScroll': _vm.mobile && _vm.touch}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.addPhoto.uploading),expression:"addPhoto.uploading"}],staticClass:"ui dimmer",class:{active: _vm.addPhoto.uploading}},[_c('div',{staticClass:"ui text loader"},[_vm._v("Uploading image")])]),_vm._v(" "),_c('div',{staticClass:"ui tab basic segment noTopPadding",attrs:{"data-tab":"backgroundPhotoSelect"}},[_c('table',{staticClass:"ui selectable unstackable basic table"},[_c('tbody',[_c('tr',{staticClass:"backgroundPhotoNoneRow",class:{positive: _vm.selectedPhotoIndex === -1},on:{"click":function($event){_vm.selectedPhotoIndex = -1}}},[_c('td',{staticClass:"two wide center aligned"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedPhotoIndex === -1),expression:"selectedPhotoIndex === -1"}],staticClass:"tick"},[_vm._v("✓")])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('td')]),_vm._v(" "),_vm._l((_vm.modalPhotos),function(photo,photoIndex){return _c('tr',{key:photo.id,class:{positive: photoIndex === _vm.selectedPhotoIndex},on:{"click":function($event){_vm.selectedPhotoIndex = photoIndex}}},[_c('td',{staticClass:"two wide center aligned"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(photoIndex === _vm.selectedPhotoIndex),expression:"photoIndex === selectedPhotoIndex"}],staticClass:"tick"},[_vm._v("✓")])]),_vm._v(" "),_c('td',{staticClass:"six wide center aligned"},[_c('img',{staticStyle:{"border-radius":".3125em"},style:({
                    height: _vm.photoThumbnailDimensions[photoIndex].height + 'px',
                    minWidth: _vm.photoThumbnailDimensions[photoIndex].width + 'px',
                    width: _vm.photoThumbnailDimensions[photoIndex].width + 'px'
                  }),attrs:{"src":photo.url}})]),_vm._v(" "),_c('td',{staticClass:"right aligned"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:((!_vm.photoUsage[photo.id] || (_vm.photoUsage[photo.id].firstRowIndex === _vm.rowIndex && _vm.photoUsage[photo.id].lastRowIndex === _vm.rowIndex)) && _vm.selectedPhotoIndex !== photoIndex),expression:"(!photoUsage[photo.id] || (photoUsage[photo.id].firstRowIndex === rowIndex && photoUsage[photo.id].lastRowIndex === rowIndex)) && selectedPhotoIndex !== photoIndex"}],staticClass:"ui icon button",staticStyle:{"margin-right":"1rem"},on:{"click":function($event){$event.stopPropagation();_vm.deletePhotoClick(photoIndex)}}},[_c('i',{staticClass:"trash alternate icon"})])])])})],2)])]),_vm._v(" "),_c('div',{staticClass:"ui tab basic segment noTopPadding noTopMargin",attrs:{"data-tab":"backgroundPhotoAdd"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.addPhoto.loading),expression:"addPhoto.loading"}],staticClass:"ui small active inline loader modalLoader"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.addPhoto.loading),expression:"!addPhoto.loading"}]},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.addPhoto.url),expression:"addPhoto.url"}]},[_c('img',{staticClass:"ui bordered rounded image",staticStyle:{"height":"56vh","object-fit":"contain","width":"100%"},attrs:{"id":"addPhotoImage","src":_vm.addPhoto.url},on:{"load":function($event){_vm.photoLoad()}}}),_vm._v(" "),_c('button',{staticClass:"ui red button resetImageButton",on:{"click":function($event){_vm.initAddPhoto()}}},[_vm._v("Reset")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.addPhoto.url),expression:"!addPhoto.url"}]},[_vm._m(4),_vm._v(" "),_c('input',{attrs:{"type":"file","accept":"image/*","id":"photoFile"},on:{"change":function($event){_vm.addPhotoFileChange($event.target.files[0])}}}),_vm._v(" "),_c('div',{staticClass:"ui horizontal divider"},[_vm._v("\n              Or\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              Copy any image you find on the web by right-clicking on the image and choosing 'Copy image'.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              Then paste the image into the box below.\n            ")]),_vm._v(" "),_c('textarea',{staticClass:"pasteImageHere",attrs:{"placeholder":_vm.text.memoSetPasteImageHere,"tabindex":"0"},on:{"keypress":function($event){$event.preventDefault();},"paste":function($event){$event.preventDefault();_vm.photoPaste($event)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"subsequentRowsWrapper"},[_c('span',[_vm._v(_vm._s(_vm.text.memoSetApplyToSubsequentRowsLeft))]),_vm._v(" "),_c('div',{staticClass:"ui input subsequentRowsInput"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.applyToRows),expression:"applyToRows"}],attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.applyToRows)},on:{"input":function($event){if($event.target.composing){ return; }_vm.applyToRows=$event.target.value}}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.text.memoSetApplyToSubsequentRowsRight))])]),_vm._v(" "),_c('div',{staticClass:"ui primary ok button",class:{disabled: _vm.backgroundPhotoTab === 'backgroundPhotoAdd' && !_vm.addPhoto.url}},[_vm._v(_vm._s(_vm.text.commonOK))]),_vm._v(" "),_c('button',{staticClass:"ui cancel button"},[_vm._v(_vm._s(_vm.text.commonCancel))])])]),_vm._v(" "),_c('div',{staticClass:"ui modal copiedMemoSet",class:_vm.modalClass},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"content"},[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.copyMemoSet.newTitle))]),_vm._v(" has been created in folder "),_c('strong',[_vm._v(_vm._s(_vm.copyMemoSet.newFolderName))]),_vm._v(".")])]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"ui primary ok button",class:{disabled: _vm.backgroundPhotoTab === 'backgroundPhotoAdd' && !_vm.addPhoto.url}},[_vm._v("Go to New Copy")]),_vm._v(" "),_c('button',{staticClass:"ui cancel button"},[_vm._v("Stay with the Original")])])]),_vm._v(" "),_c('div',{staticClass:"ui modal copyMemoSet",class:_vm.modalClass},[_c('div',{staticClass:"ui header"},[(_vm.memoSetType === 'regular')?_c('span',[_vm._v(_vm._s(_vm.text.memoSetCopyMemoSet))]):_vm._e(),_vm._v(" "),(_vm.memoSetType !== 'regular')?_c('span',[_vm._v(_vm._s(_vm.text.memoSetAddToMyMemoSets))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"ui grid",class:{'mobile': _vm.mobile}},[_c('div',{staticClass:"modalLabel modalLabelPadding",class:{'four wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('span',[_vm._v(_vm._s(_vm.text.memoSetTitle))])]),_vm._v(" "),_c('div',{staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"ui fluid input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.copyMemoSet.newTitle),expression:"copyMemoSet.newTitle"}],attrs:{"type":"text","autocomplete":"off","placeholder":"Enter the new memo set title..."},domProps:{"value":(_vm.copyMemoSet.newTitle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.copyMemoSet, "newTitle", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"modalLabel modalLabelPadding",class:{'four wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('span',[_vm._v(_vm._s(_vm.text.memoSetFolder))])]),_vm._v(" "),_c('div',{staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"ui fluid selection dropdown copyMemoSetFolderId"},[_c('input',{attrs:{"type":"hidden"}}),_vm._v(" "),_c('i',{staticClass:"dropdown icon"}),_vm._v(" "),_c('div',{staticClass:"default text"},[_vm._v("Select a folder for the memo set...")]),_vm._v(" "),_c('div',{staticClass:"menu"},[_vm._l((_vm.user.folders),function(folder){return _c('div',{key:folder.folderId,staticClass:"item",attrs:{"data-value":folder.folderId}},[_vm._v("\n                "+_vm._s(folder.folderName)+"\n              ")])}),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"new"}},[_c('span',[_vm._v(_vm._s(_vm.text.memoSetNewFolderItem))])])],2)])]),_vm._v(" "),_c('div',{staticClass:"modalLabel modalLabelPadding",class:{'four wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile, visibilityHidden: _vm.copyMemoSet.folderId !== 'new'}},[_c('span',[_vm._v(_vm._s(_vm.text.memoSetNewFolderLabel))])]),_vm._v(" "),_c('div',{staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile, visibilityHidden: _vm.copyMemoSet.folderId !== 'new'}},[_c('div',{staticClass:"ui fluid input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.copyMemoSet.newFolderName),expression:"copyMemoSet.newFolderName"}],attrs:{"id":"newFolderName","type":"text","autocomplete":"off","placeholder":"Enter the new folder name..."},domProps:{"value":(_vm.copyMemoSet.newFolderName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.copyMemoSet, "newFolderName", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"ui primary ok button",class:{disabled: !_vm.copyMemoSet.newTitle || _vm.copyMemoSet.folderId === '' || (_vm.copyMemoSet.folderId === 'new' && !_vm.copyMemoSet.newFolderName)}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.memoSetType === 'regular'),expression:"memoSetType === 'regular'"}]},[_vm._v("Copy")]),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.memoSetType !== 'regular'),expression:"memoSetType !== 'regular'"}]},[_vm._v("Add")])]),_vm._v(" "),_c('div',{staticClass:"ui cancel button"},[_vm._v("Cancel")])])]),_vm._v(" "),_c('div',{staticClass:"ui modal deleteColumn",class:_vm.modalClass},[_c('div',{staticClass:"ui header"},[_vm._v("\n      "+_vm._s(_vm.text.memoSetDeleteColumn)+"\n    ")]),_vm._v(" "),(_vm.fields)?_c('div',{staticClass:"content"},[_c('div',{staticClass:"ui grid",class:{'mobile': _vm.mobile}},[_c('div',{staticClass:"modalLabel modalLabelPadding",class:{'four wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('span',[_vm._v("Delete Column")])]),_vm._v(" "),_c('div',{staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"ui fluid selection dropdown deleteColumnDeleteColumn"},[_c('input',{attrs:{"type":"hidden"}}),_vm._v(" "),_c('i',{staticClass:"dropdown icon"}),_vm._v(" "),_c('div',{staticClass:"default text"},[_vm._v("Select the column to be deleted...")]),_vm._v(" "),_c('div',{staticClass:"menu"},_vm._l((_vm.fields),function(field,index){return _c('div',{key:index,staticClass:"item",attrs:{"data-value":index}},[_vm._v("\n                "+_vm._s(field.heading)+"\n              ")])}))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"ui red ok button",class:{disabled: _vm.deleteColumn.deleteColumn === '-1'}},[_vm._v(_vm._s(_vm.text.commonDelete))]),_vm._v(" "),_c('button',{staticClass:"ui cancel button"},[_vm._v(_vm._s(_vm.text.commonCancel))])])]),_vm._v(" "),_c('div',{staticClass:"ui modal deleteMemoSet",class:_vm.modalClass},[_c('div',{staticClass:"ui header"},[_vm._v("\n      "+_vm._s(_vm.text.memoSetDeleteMemoSet)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.modalHtml)}})]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"ui red ok button"},[_vm._v(_vm._s(_vm.text.commonDelete))]),_vm._v(" "),_c('button',{staticClass:"ui cancel button"},[_vm._v(_vm._s(_vm.text.commonCancel))])])]),_vm._v(" "),_c('div',{staticClass:"ui modal deleteRows",class:[_vm.modalClass, {fullHeight: _vm.verticallyChallenged}]},[_c('div',{staticClass:"ui header"},[_vm._v("\n      "+_vm._s(_vm.text.memoSetDeleteRows)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"ui grid",class:{'mobile': _vm.mobile}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.rows.length),expression:"rows.length"}],staticClass:"modalLabel modalLabelPadding",class:{'four wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('span',[_vm._v("Delete From Row")])]),_vm._v(" "),_c('div',{staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"ui fluid input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.deleteRows.deleteFromRow),expression:"deleteRows.deleteFromRow"}],attrs:{"type":"text","placeholder":'Enter row number between 1 and ' + _vm.rows.length + '...'},domProps:{"value":(_vm.deleteRows.deleteFromRow)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.deleteRows, "deleteFromRow", $event.target.value)},function($event){_vm.applyMathjaxToRowDataTables()}]}})])]),_vm._v(" "),(!_vm.mobile && parseInt(_vm.deleteRows.deleteFromRow, 10) > 0 && parseInt(_vm.deleteRows.deleteFromRow, 10) <= _vm.rows.length)?_c('div',{staticClass:"four wide column"}):_vm._e(),_vm._v(" "),(parseInt(_vm.deleteRows.deleteFromRow, 10) > 0 && parseInt(_vm.deleteRows.deleteFromRow, 10) <= _vm.rows.length)?_c('div',{staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"row noBottomPadding rowDataTableWrapper",class:{'noTopPadding': _vm.mobile, 'thinScroll': _vm.mobile && _vm.touch}},[(_vm.fields)?_c('table',{staticClass:"ui celled unstackable table rowDataTable"},[_c('thead',[_c('tr',{staticClass:"middle aligned"},[_vm._l((_vm.fields),function(field){return _c('th',{key:field.fieldId,staticClass:"two wide"},[_vm._v("\n                    "+_vm._s(field.heading)+"\n                  ")])}),_vm._v(" "),_c('th',{staticClass:"three wide"},[_vm._v(_vm._s(_vm.text.memoSetNotes))])],2)]),_vm._v(" "),_c('tbody',[_c('tr',{staticClass:"middle aligned"},[_vm._l((_vm.fields),function(field){return _c('td',{key:field.fieldId,class:{cardsCell: _vm.cardStyle(_vm.rows[parseInt(_vm.deleteRows.deleteFromRow, 10) - 1].data[field.fieldId])},style:(_vm.cardStyle(_vm.rows[parseInt(_vm.deleteRows.deleteFromRow, 10) - 1].data[field.fieldId]))},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.sanitize(_vm.rows[parseInt(_vm.deleteRows.deleteFromRow, 10) - 1].data[field.fieldId]))}})])}),_vm._v(" "),_c('td',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.sanitize(_vm.rows[parseInt(_vm.deleteRows.deleteFromRow, 10) - 1].data.notes))}})])],2)])]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.rows.length),expression:"rows.length"}],staticClass:"modalLabel modalLabelPadding",class:{'four wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('span',[_vm._v("Delete To Row")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.rows.length),expression:"rows.length"}],staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"ui fluid input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.deleteRows.deleteToRow),expression:"deleteRows.deleteToRow"}],attrs:{"type":"text","placeholder":'Enter row number between ' + (parseInt(_vm.deleteRows.deleteFromRow, 10) || '1') + ' and ' + _vm.rows.length + '...'},domProps:{"value":(_vm.deleteRows.deleteToRow)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.deleteRows, "deleteToRow", $event.target.value)}}})])]),_vm._v(" "),(!_vm.mobile && parseInt(_vm.deleteRows.deleteToRow, 10) > 0 && parseInt(_vm.deleteRows.deleteToRow, 10) <= _vm.rows.length)?_c('div',{staticClass:"four wide column"}):_vm._e(),_vm._v(" "),(parseInt(_vm.deleteRows.deleteToRow, 10) > 0 && parseInt(_vm.deleteRows.deleteToRow, 10) <= _vm.rows.length)?_c('div',{staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"row noBottomPadding rowDataTableWrapper",class:{'noTopPadding': _vm.mobile, 'thinScroll': _vm.mobile && _vm.touch}},[(_vm.fields)?_c('table',{staticClass:"ui celled unstackable table rowDataTable"},[_c('thead',[_c('tr',{staticClass:"middle aligned"},[_vm._l((_vm.fields),function(field){return _c('th',{key:field.fieldId,staticClass:"two wide"},[_vm._v("\n                    "+_vm._s(field.heading)+"\n                  ")])}),_vm._v(" "),_c('th',{staticClass:"three wide"},[_vm._v(_vm._s(_vm.text.memoSetNotes))])],2)]),_vm._v(" "),_c('tbody',[_c('tr',{staticClass:"middle aligned"},[_vm._l((_vm.fields),function(field){return _c('td',{key:field.fieldId,class:{cardsCell: _vm.cardStyle(_vm.rows[parseInt(_vm.deleteRows.deleteToRow, 10) - 1].data[field.fieldId])},style:(_vm.cardStyle(_vm.rows[parseInt(_vm.deleteRows.deleteToRow, 10) - 1].data[field.fieldId]))},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.sanitize(_vm.rows[parseInt(_vm.deleteRows.deleteToRow, 10) - 1].data[field.fieldId]))}})])}),_vm._v(" "),_c('td',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.sanitize(_vm.rows[parseInt(_vm.deleteRows.deleteToRow, 10) - 1].data.notes))}})])],2)])]):_vm._e()])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"ui red ok button",class:{disabled: !(parseInt(_vm.deleteRows.deleteFromRow, 10) > 0) || !(parseInt(_vm.deleteRows.deleteToRow, 10) > 0) || parseInt(_vm.deleteRows.deleteToRow, 10) < parseInt(_vm.deleteRows.deleteFromRow, 10)}},[_vm._v(_vm._s(_vm.text.commonDelete))]),_vm._v(" "),_c('button',{staticClass:"ui cancel button"},[_vm._v(_vm._s(_vm.text.commonCancel))])])]),_vm._v(" "),_c('div',{staticClass:"ui modal exportData",class:_vm.modalClass},[(_vm.exported)?_c('div',{staticClass:"ui header"},[_c('i',{staticClass:"green check icon"}),_vm._v(_vm._s(_vm.text.memoSetExportSuccessful)+"\n    ")]):_vm._e(),_vm._v(" "),(!_vm.exported)?_c('div',{staticClass:"ui header"},[_c('i',{staticClass:"red close icon"}),_vm._v(_vm._s(_vm.text.memoSetExportUnsuccessful)+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"content"},[(_vm.exported)?_c('p',[_vm._v(_vm._s(_vm.text.memoSetExportSuccessfulDetail))]):_vm._e(),_vm._v(" "),(!_vm.exported)?_c('p',[_vm._v(_vm._s(_vm.text.memoSetExportUnsuccessfulDetail))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"ui primary ok button"},[_vm._v(_vm._s(_vm.text.commonOK))])])]),_vm._v(" "),_c('div',{staticClass:"ui modal invalidRowNumber",class:_vm.modalClass},[_c('div',{staticClass:"ui header"},[_vm._v("\n      Invalid Row Number\n    ")]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v("\n      Please enter a number between 1 and "+_vm._s(_vm.rows.length)+".\n    ")]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"ui primary ok button"},[_vm._v(_vm._s(_vm.text.commonOK))])])]),_vm._v(" "),_c('div',{staticClass:"ui modal learn",class:[_vm.modalClass, {fullHeight: _vm.verticallyChallenged}]},[_c('div',{staticClass:"ui header"},[_c('span',[_vm._v("Learn")]),_vm._v(" "),_c('button',{staticClass:"ui compact icon button closeLearnButton",on:{"click":function($event){_vm.closeLearnModal()}}},[_c('i',{staticClass:"close icon"})])]),_vm._v(" "),_c('div',{staticClass:"content learnContent",class:{'thinScroll': _vm.mobile && _vm.touch},staticStyle:{"font-size":"120%"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.learn.contentVisible),expression:"!learn.contentVisible"}],staticClass:"ui small active inline loader learnMinHeight"}),_vm._v(" "),(_vm.learn.contentVisible && _vm.learn.reviewItem.questionId)?_c('div',{class:{learnMinHeight: !_vm.verticallyChallenged}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.learn.allKnown),expression:"learn.allKnown"}]},[_c('div',{staticClass:"ui green icon message congratulations"},[_c('i',{staticClass:"green checkmark box icon"}),_vm._v(" "),_c('i',{staticClass:"close icon",on:{"click":function($event){_vm.closeCongratsClick()}}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.learn.congratsMessage))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.text.memoSetCongratsContinue))])])])]),_vm._v(" "),_c('div',{staticClass:"learnQuestionHtml",domProps:{"innerHTML":_vm._s(_vm.learnQuestionHtml)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.learn.answerVisible),expression:"learn.answerVisible"}]},[_c('div',{staticClass:"ui divider",staticStyle:{"margin-bottom":"0"}}),_vm._v(" "),_c('div',{staticClass:"ui basic teal label answerMessage",staticStyle:{"float":"right"}},[_c('i',{staticClass:"clock outline icon"}),_vm._v("\n            "+_vm._s(_vm.responseTimeDisplay)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"ui compact green message answerMessage"},[_c('div',{staticClass:"learnAnswerHtml",domProps:{"innerHTML":_vm._s(_vm.learnAnswerHtml)}})])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"learnActions"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.learn.answerVisible),expression:"learn.answerVisible"}]},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.learn.tooSlow),expression:"learn.tooSlow"}],staticClass:"tooSlow"},[_c('i',{staticClass:"wait icon"}),_vm._v("Too slow!")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.learn.tooSlow),expression:"!learn.tooSlow"}],staticClass:"ui right labeled icon green button",on:{"click":function($event){_vm.answerClick('correct')}}},[_c('i',{staticClass:"up arrow icon"}),_vm._v("\n          Correct\n        ")]),_vm._v(" "),_c('button',{staticClass:"ui right labeled icon red button incorrectButton",on:{"click":function($event){_vm.answerClick('incorrect')}}},[_c('i',{staticClass:"down arrow icon"}),_vm._v("\n          Incorrect\n        ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.learn.contentVisible && !_vm.learn.answerVisible),expression:"learn.contentVisible && !learn.answerVisible"}]},[_c('button',{staticClass:"ui right labeled icon primary button",on:{"click":function($event){_vm.showAnswerClick()}}},[_c('i',{staticClass:"right arrow icon"}),_vm._v("\n          Show Answer\n        ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.learn.previousReviewItem),expression:"learn.previousReviewItem"}],staticClass:"ui left labeled icon button",staticStyle:{"float":"right"},on:{"click":function($event){_vm.oopsClick()}}},[_c('i',{staticClass:"left arrow icon"}),_vm._v("\n          Oops!\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"ui modal moveColumn",class:_vm.modalClass},[_c('div',{staticClass:"ui header"},[_vm._v("\n      "+_vm._s(_vm.text.memoSetMoveColumn)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"ui grid",class:{'mobile': _vm.mobile}},[_c('div',{staticClass:"modalLabel modalLabelPadding",class:{'four wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('span',[_vm._v("Column")])]),_vm._v(" "),_c('div',{staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"ui fluid selection dropdown moveColumnColumnSeq"},[_c('input',{attrs:{"type":"hidden"}}),_vm._v(" "),_c('i',{staticClass:"dropdown icon"}),_vm._v(" "),_c('div',{staticClass:"default text"},[_vm._v("Select the column to be moved...")]),_vm._v(" "),_c('div',{staticClass:"menu"},_vm._l((_vm.fields),function(field,index){return _c('div',{key:index,staticClass:"item",attrs:{"data-value":index}},[_vm._v("\n                "+_vm._s(field.heading)+"\n              ")])}))])]),_vm._v(" "),_c('div',{staticClass:"modalLabel modalLabelPadding",class:{'four wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('span',[_vm._v("Position")])]),_vm._v(" "),_c('div',{staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"ui fluid selection dropdown moveColumnPosition"},[_c('input',{attrs:{"type":"hidden"}}),_vm._v(" "),_c('i',{staticClass:"dropdown icon"}),_vm._v(" "),_c('div',{staticClass:"default text"},[_vm._v("Select the new position for the column...")]),_vm._v(" "),_c('div',{staticClass:"menu"},_vm._l((_vm.fields),function(field,index){return _c('div',{key:index,staticClass:"item",attrs:{"data-value":index + 1}},[_vm._v("\n                "+_vm._s(index + 1)),_c('span',{directives:[{name:"show",rawName:"v-show",value:(index === parseInt(_vm.moveColumn.columnSeq, 10)),expression:"index === parseInt(moveColumn.columnSeq, 10)"}],staticClass:"currentPosition"},[_vm._v("(current position)")])])}))])])])]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"ui primary ok button",class:{disabled: _vm.moveColumn.columnSeq === '-1' || _vm.moveColumn.position === '-1'}},[_vm._v("Move")]),_vm._v(" "),_c('div',{staticClass:"ui cancel button"},[_vm._v(_vm._s(_vm.text.commonCancel))])])]),_vm._v(" "),_c('div',{staticClass:"ui modal moveRows",class:[_vm.modalClass, {fullHeight: _vm.verticallyChallenged}]},[_c('div',{staticClass:"ui header"},[_vm._v("\n      "+_vm._s(_vm.text.memoSetMoveRows)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"content",class:{thinScroll: _vm.mobile && _vm.touch}},[_c('div',{staticClass:"ui grid",class:{'mobile': _vm.mobile}},[_c('div',{staticClass:"modalLabel modalLabelPadding",class:{'four wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('span',[_vm._v("First Row")])]),_vm._v(" "),_c('div',{staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"ui fluid input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.moveRows.firstRow),expression:"moveRows.firstRow"}],attrs:{"type":"text","placeholder":'Enter row number between 1 and ' + _vm.rows.length + '...'},domProps:{"value":(_vm.moveRows.firstRow)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.moveRows, "firstRow", $event.target.value)},function($event){_vm.applyMathjaxToRowDataTables()}]}})])]),_vm._v(" "),(!_vm.mobile && parseInt(_vm.moveRows.firstRow, 10) > 0 && parseInt(_vm.moveRows.firstRow, 10) <= _vm.rows.length)?_c('div',{staticClass:"four wide column"}):_vm._e(),_vm._v(" "),(parseInt(_vm.moveRows.firstRow, 10) > 0 && parseInt(_vm.moveRows.firstRow, 10) <= _vm.rows.length)?_c('div',{staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"row noBottomPadding rowDataTableWrapper",class:{'noTopPadding': _vm.mobile, 'thinScroll': _vm.mobile && _vm.touch}},[(_vm.fields)?_c('table',{staticClass:"ui celled unstackable table rowDataTable"},[_c('thead',[_c('tr',{staticClass:"middle aligned"},[_vm._l((_vm.fields),function(field){return _c('th',{key:field.fieldId,staticClass:"two wide"},[_vm._v("\n                    "+_vm._s(field.heading)+"\n                  ")])}),_vm._v(" "),_c('th',{staticClass:"three wide"},[_vm._v(_vm._s(_vm.text.memoSetNotes))])],2)]),_vm._v(" "),_c('tbody',[_c('tr',{staticClass:"middle aligned"},[_vm._l((_vm.fields),function(field){return _c('td',{key:field.fieldId,class:{cardsCell: _vm.cardStyle(_vm.rows[parseInt(_vm.moveRows.firstRow, 10) - 1].data[field.fieldId])},style:(_vm.cardStyle(_vm.rows[parseInt(_vm.moveRows.firstRow, 10) - 1].data[field.fieldId]))},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.sanitize(_vm.rows[parseInt(_vm.moveRows.firstRow, 10) - 1].data[field.fieldId]))}})])}),_vm._v(" "),_c('td',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.sanitize(_vm.rows[parseInt(_vm.moveRows.firstRow, 10) - 1].data.notes))}})])],2)])]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modalLabel modalLabelPadding",class:{'four wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('span',[_vm._v("Last Row")])]),_vm._v(" "),_c('div',{staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"ui fluid input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.moveRows.lastRow),expression:"moveRows.lastRow"}],attrs:{"type":"text","placeholder":'Enter row number between ' + (parseInt(_vm.moveRows.firstRow, 10) || '1') + ' and ' + _vm.rows.length + '...'},domProps:{"value":(_vm.moveRows.lastRow)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.moveRows, "lastRow", $event.target.value)},function($event){_vm.applyMathjaxToRowDataTables()}]}})])]),_vm._v(" "),(!_vm.mobile && parseInt(_vm.moveRows.lastRow, 10) > 0 && parseInt(_vm.moveRows.lastRow, 10) <= _vm.rows.length)?_c('div',{staticClass:"four wide column"}):_vm._e(),_vm._v(" "),(parseInt(_vm.moveRows.lastRow, 10) > 0 && parseInt(_vm.moveRows.lastRow, 10) <= _vm.rows.length)?_c('div',{staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"row noBottomPadding rowDataTableWrapper",class:{'noTopPadding': _vm.mobile, 'thinScroll': _vm.mobile && _vm.touch}},[(_vm.fields)?_c('table',{staticClass:"ui celled unstackable table rowDataTable"},[_c('thead',[_c('tr',{staticClass:"middle aligned"},[_vm._l((_vm.fields),function(field){return _c('th',{key:field.fieldId,staticClass:"two wide"},[_vm._v("\n                    "+_vm._s(field.heading)+"\n                  ")])}),_vm._v(" "),_c('th',{staticClass:"three wide"},[_vm._v(_vm._s(_vm.text.memoSetNotes))])],2)]),_vm._v(" "),_c('tbody',[_c('tr',{staticClass:"middle aligned"},[_vm._l((_vm.fields),function(field){return _c('td',{key:field.fieldId,class:{cardsCell: _vm.cardStyle(_vm.rows[parseInt(_vm.moveRows.lastRow, 10) - 1].data[field.fieldId])},style:(_vm.cardStyle(_vm.rows[parseInt(_vm.moveRows.lastRow, 10) - 1].data[field.fieldId]))},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.sanitize(_vm.rows[parseInt(_vm.moveRows.lastRow, 10) - 1].data[field.fieldId]))}})])}),_vm._v(" "),_c('td',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.sanitize(_vm.rows[parseInt(_vm.moveRows.lastRow, 10) - 1].data.notes))}})])],2)])]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modalLabel modalLabelPadding",class:{'four wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('span',[_vm._v("Move After Row")])]),_vm._v(" "),_c('div',{staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"ui fluid input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.moveRows.moveAfter),expression:"moveRows.moveAfter"}],attrs:{"type":"text","placeholder":'Enter row number between ' + '0 and ' + _vm.rows.length + '...'},domProps:{"value":(_vm.moveRows.moveAfter)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.moveRows, "moveAfter", $event.target.value)},function($event){_vm.applyMathjaxToRowDataTables()}]}})])]),_vm._v(" "),(!_vm.mobile && parseInt(_vm.moveRows.moveAfter, 10) > 0 && parseInt(_vm.moveRows.moveAfter, 10) <= _vm.rows.length)?_c('div',{staticClass:"four wide column"}):_vm._e(),_vm._v(" "),(parseInt(_vm.moveRows.moveAfter, 10) > 0 && parseInt(_vm.moveRows.moveAfter, 10) <= _vm.rows.length)?_c('div',{staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"row noBottomPadding rowDataTableWrapper",class:{'noTopPadding': _vm.mobile, 'thinScroll': _vm.mobile && _vm.touch}},[(_vm.fields)?_c('table',{staticClass:"ui celled unstackable table rowDataTable"},[_c('thead',[_c('tr',{staticClass:"middle aligned"},[_vm._l((_vm.fields),function(field){return _c('th',{key:field.fieldId,staticClass:"two wide"},[_vm._v("\n                    "+_vm._s(field.heading)+"\n                  ")])}),_vm._v(" "),_c('th',{staticClass:"three wide"},[_vm._v(_vm._s(_vm.text.memoSetNotes))])],2)]),_vm._v(" "),_c('tbody',[_c('tr',{staticClass:"middle aligned"},[_vm._l((_vm.fields),function(field){return _c('td',{key:field.fieldId,class:{cardsCell: _vm.cardStyle(_vm.rows[parseInt(_vm.moveRows.moveAfter, 10) - 1].data[field.fieldId])},style:(_vm.cardStyle(_vm.rows[parseInt(_vm.moveRows.moveAfter, 10) - 1].data[field.fieldId]))},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.sanitize(_vm.rows[parseInt(_vm.moveRows.moveAfter, 10) - 1].data[field.fieldId]))}})])}),_vm._v(" "),_c('td',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.sanitize(_vm.rows[parseInt(_vm.moveRows.moveAfter, 10) - 1].data.notes))}})])],2)])]):_vm._e()])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"ui primary ok button",class:{disabled: !(parseInt(_vm.moveRows.firstRow, 10) > 0 && parseInt(_vm.moveRows.firstRow, 10) <= parseInt(_vm.moveRows.lastRow, 10) && parseInt(_vm.moveRows.lastRow, 10) <= _vm.rows.length && parseInt(_vm.moveRows.moveAfter, 10) >= 0 && parseInt(_vm.moveRows.moveAfter, 10) <= _vm.rows.length) || (parseInt(_vm.moveRows.moveAfter, 10) >= parseInt(_vm.moveRows.firstRow, 10) - 1 && parseInt(_vm.moveRows.moveAfter, 10) <= parseInt(_vm.moveRows.lastRow))}},[_vm._v("Move")]),_vm._v(" "),_c('div',{staticClass:"ui cancel button"},[_vm._v(_vm._s(_vm.text.commonCancel))])])]),_vm._v(" "),_c('div',{staticClass:"ui modal populateColumn",class:[_vm.modalClass, {fullHeight: _vm.verticallyChallenged}]},[_c('div',{staticClass:"ui header"},[_vm._v("\n      "+_vm._s(_vm.text.memoSetPopulateColumn)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"content",class:{thinScroll: _vm.mobile && _vm.touch}},[_c('div',{staticClass:"ui grid",class:{'mobile': _vm.mobile}},[_c('div',{staticClass:"modalLabel modalLabelPadding",class:{'four wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('span',[_vm._v("Column")])]),_vm._v(" "),_c('div',{staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"ui fluid selection dropdown populateColumnColumn"},[_c('input',{attrs:{"type":"hidden"},domProps:{"value":_vm.populateColumn.column}}),_vm._v(" "),_c('i',{staticClass:"dropdown icon"}),_vm._v(" "),_c('div',{staticClass:"default text"},[_vm._v("Select the column to populate...")]),_vm._v(" "),_c('div',{staticClass:"menu"},_vm._l((_vm.fields),function(field,index){return _c('div',{key:index,staticClass:"item",attrs:{"data-value":index}},[_vm._v("\n                "+_vm._s(field.heading)+"\n              ")])}))])]),_vm._v(" "),(_vm.populateColumnDataExists)?_c('div',{staticClass:"ui red icon message populateColumnWarning"},[_c('i',{staticClass:"exclamation triangle icon"}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('p',[_vm._v("Data in the "),_c('strong',[_vm._v(_vm._s(_vm.fields[_vm.populateColumn.column].heading))]),_vm._v(" column will be deleted.")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modalLabel modalLabelPadding",class:{'four wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('span',[_vm._v("Data")])]),_vm._v(" "),_c('div',{staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_vm._m(6)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.populateColumn.dataSet.substring(0, 1) === 'c'),expression:"populateColumn.dataSet.substring(0, 1) === 'c'"}],staticClass:"modalLabel modalLabelPadding",class:{'four wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('span',[_vm._v("Order of Suits")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.populateColumn.dataSet.substring(0, 1) === 'c'),expression:"populateColumn.dataSet.substring(0, 1) === 'c'"}],staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"ui fluid selection dropdown populateColumnSuits"},[_c('input',{attrs:{"type":"hidden"},domProps:{"value":_vm.populateColumn.suits}}),_vm._v(" "),_c('i',{staticClass:"dropdown icon"}),_vm._v(" "),_c('div',{staticClass:"default text"}),_vm._v(" "),_vm._m(7)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.populateColumn.dataSet.substring(0, 1) === 'c'),expression:"populateColumn.dataSet.substring(0, 1) === 'c'"}],staticClass:"modalLabel modalLabelPadding",class:{'four wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('span',[_vm._v("Order of Values")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.populateColumn.dataSet.substring(0, 1) === 'c'),expression:"populateColumn.dataSet.substring(0, 1) === 'c'"}],staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"ui fluid selection dropdown populateColumnValues"},[_c('input',{attrs:{"type":"hidden"},domProps:{"value":_vm.populateColumn.values}}),_vm._v(" "),_c('i',{staticClass:"dropdown icon"}),_vm._v(" "),_c('div',{staticClass:"default text"}),_vm._v(" "),_vm._m(8)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.populateColumn.dataSet === 'c2'),expression:"populateColumn.dataSet === 'c2'"}],staticClass:"modalLabel modalLabelPadding",class:{'four wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('span',[_vm._v("Most Significant Card")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.populateColumn.dataSet === 'c2'),expression:"populateColumn.dataSet === 'c2'"}],staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"ui fluid selection dropdown populateColumnSignificantCard"},[_c('input',{attrs:{"type":"hidden"},domProps:{"value":_vm.populateColumn.significantCard}}),_vm._v(" "),_c('i',{staticClass:"dropdown icon"}),_vm._v(" "),_c('div',{staticClass:"default text"}),_vm._v(" "),_vm._m(9)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.populateColumn.dataSet === 'c2'),expression:"populateColumn.dataSet === 'c2'"}],staticClass:"modalLabel modalLabelPadding",class:{'four wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('span',[_vm._v("Include Repeated Cards")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.populateColumn.dataSet === 'c2'),expression:"populateColumn.dataSet === 'c2'"}],staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"ui fluid selection dropdown populateColumnIncludeRepeated"},[_c('input',{attrs:{"type":"hidden"},domProps:{"value":_vm.populateColumn.includeRepeated}}),_vm._v(" "),_c('i',{staticClass:"dropdown icon"}),_vm._v(" "),_c('div',{staticClass:"default text"}),_vm._v(" "),_vm._m(10)])]),_vm._v(" "),(_vm.populateColumn.dataSet === 'n')?_c('div',{staticClass:"modalLabel modalLabelPadding",class:{'four wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('span',[_vm._v("First Value")])]):_vm._e(),_vm._v(" "),(_vm.populateColumn.dataSet === 'n')?_c('div',{staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"populateColumnValue",attrs:{"contenteditable":""},domProps:{"innerHTML":_vm._s(_vm.populateColumn.originalNumValues[0])},on:{"input":function($event){_vm.populateColumnValueInput($event, 0)},"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.stopPropagation();}}})]):_vm._e(),_vm._v(" "),(_vm.populateColumn.dataSet === 'n')?_c('div',{staticClass:"modalLabel modalLabelPadding",class:{'four wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('span',[_vm._v("Last Value")])]):_vm._e(),_vm._v(" "),(_vm.populateColumn.dataSet === 'n')?_c('div',{staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"populateColumnValue",attrs:{"contenteditable":""},domProps:{"innerHTML":_vm._s(_vm.populateColumn.originalNumValues[1])},on:{"input":function($event){_vm.populateColumnValueInput($event, 1)},"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.stopPropagation();}}})]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.populateColumn.dataSet === 'n'),expression:"populateColumn.dataSet === 'n'"}],staticClass:"modalLabel modalLabelPadding",class:{'four wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('span',[_vm._v("Preview")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.populateColumn.dataSet === 'n'),expression:"populateColumn.dataSet === 'n'"}],staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"populateColumnPreview",domProps:{"innerHTML":_vm._s(_vm.populateColumnPreviewHtml)}})])])]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"ui primary ok button",class:{disabled: _vm.populateColumn.column === '' || _vm.populateColumn.dataSet === '' || (_vm.populateColumn.dataSet === 'n' && !_vm.populateColumnPreviewHtml)}},[_vm._v("Populate")]),_vm._v(" "),_c('button',{staticClass:"ui cancel button"},[_vm._v(_vm._s(_vm.text.commonCancel))])])]),_vm._v(" "),_c('div',{staticClass:"ui modal question",class:[_vm.modalClass, {fullHeight: _vm.verticallyChallenged}]},[_c('div',{staticClass:"ui header"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.deleteQuestionVisible),expression:"deleteQuestionVisible"}],staticClass:"ui right floated icon button deleteQuestionButton",on:{"click":function($event){_vm.deleteQuestionClick(_vm.question.questionIndex)}}},[_c('i',{staticClass:"trash alternate icon"})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.question.mode === 'add'),expression:"question.mode === 'add'"}]},[_vm._v(_vm._s(_vm.text.memoSetAddQuestion))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.question.mode === 'edit' && _vm.memoSetType === 'regular'),expression:"question.mode === 'edit' && memoSetType === 'regular'"}]},[_vm._v(_vm._s(_vm.text.memoSetEditQuestion))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.question.mode === 'edit' && _vm.memoSetType !== 'regular'),expression:"question.mode === 'edit' && memoSetType !== 'regular'"}]},[_vm._v(_vm._s(_vm.text.memoSetViewQuestion))])]),_vm._v(" "),_c('div',{staticClass:"content questionContent",class:{'thinScroll': _vm.mobile && _vm.touch}},[_c('div',{staticClass:"ui grid",class:{'mobile': _vm.mobile}},[_c('div',{staticClass:"modalLabel",class:{'four wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile, 'modalLabelPadding': _vm.memoSetType === 'regular'}},[_c('span',[_vm._v(_vm._s(_vm.text.memoSetFromColumn))])]),_vm._v(" "),_c('div',{class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile, 'noTopPadding': _vm.memoSetType === 'regular' || _vm.mobile}},[(_vm.memoSetType !== 'regular' && _vm.question.fromFieldId)?_c('div',[_vm._v(_vm._s(_vm.fieldsById[_vm.question.fromFieldId].heading))]):_vm._e(),_vm._v(" "),(_vm.memoSetType === 'regular')?_c('div',[_c('div',{staticClass:"ui fluid selection dropdown questionFromFieldId",class:{'noPointerEvents': _vm.question.pendingDelete}},[_c('input',{attrs:{"type":"hidden"},domProps:{"value":_vm.question.fromFieldId}}),_vm._v(" "),_c('i',{staticClass:"dropdown icon"}),_vm._v(" "),_c('div',{staticClass:"default text"},[_vm._v("Select the column to be used in the question...")]),_vm._v(" "),_c('div',{staticClass:"menu"},[_vm._l((_vm.fields),function(field){return _c('div',{key:field.fieldId,staticClass:"item",attrs:{"data-value":field.fieldId}},[_vm._v("\n                  "+_vm._s(field.heading)+"\n                ")])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.options.useSummaryImages),expression:"options.useSummaryImages"}],staticClass:"item",attrs:{"data-value":"s"}},[_vm._v("\n                  Summary Image\n                ")])],2)])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modalLabel",class:{'four wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile, 'modalLabelPadding': _vm.memoSetType === 'regular'}},[_c('span',[_vm._v(_vm._s(_vm.text.memoSetToColumn))])]),_vm._v(" "),_c('div',{class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile, 'noTopPadding': _vm.memoSetType === 'regular' || _vm.mobile}},[(_vm.memoSetType !== 'regular' && _vm.question.toFieldId)?_c('div',[_vm._v(_vm._s(_vm.fieldsById[_vm.question.toFieldId].heading))]):_vm._e(),_vm._v(" "),(_vm.memoSetType === 'regular')?_c('div',[_c('div',{staticClass:"ui fluid selection dropdown questionToFieldId",class:{'noPointerEvents': _vm.question.pendingDelete}},[_c('input',{attrs:{"type":"hidden"},domProps:{"value":_vm.question.toFieldId}}),_vm._v(" "),_c('i',{staticClass:"dropdown icon"}),_vm._v(" "),_c('div',{staticClass:"default text"},[_vm._v("Select the column that answers the question...")]),_vm._v(" "),_c('div',{staticClass:"menu"},[_vm._l((_vm.fields),function(field){return _c('div',{key:field.fieldId,staticClass:"item",attrs:{"data-value":field.fieldId}},[_vm._v("\n                  "+_vm._s(field.heading)+"\n                ")])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.options.useSummaryImages),expression:"options.useSummaryImages"}],staticClass:"item",attrs:{"data-value":"s"}},[_vm._v("\n                  Summary Image\n                ")])],2)])]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.questionStatus === 'ok'),expression:"questionStatus === 'ok'"}],staticClass:"modalLabel",class:{'four wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile, 'modalLabelPadding': _vm.memoSetType === 'regular'}},[_c('span',[_vm._v(_vm._s(_vm.text.memoSetQuestion))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.questionStatus === 'ok'),expression:"questionStatus === 'ok'"}],class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile, 'noTopPadding': _vm.memoSetType === 'regular' || _vm.mobile}},[(_vm.memoSetType !== 'regular' && _vm.question.originalQuestionText)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.question.originalQuestionText)}}):_vm._e(),_vm._v(" "),(_vm.modal === 'question' && _vm.memoSetType === 'regular')?_c('div',{staticClass:"questionText",attrs:{"contenteditable":!_vm.question.pendingDelete},domProps:{"innerHTML":_vm._s(_vm.question.originalQuestionText)},on:{"input":function($event){_vm.questionInput($event)},"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.stopPropagation();}}}):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.questionStatus === 'ok'),expression:"questionStatus === 'ok'"}],staticClass:"modalLabel modalLabelPadding",class:{'four wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('span',[_vm._v(_vm._s(_vm.text.memoSetExample))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.questionStatus === 'ok'),expression:"questionStatus === 'ok'"}],staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"questionPreview",class:{'questionPreviewShift': _vm.memoSetType !== 'regular' && !_vm.mobile},domProps:{"innerHTML":_vm._s(_vm.questionPreviewHtml)}})])]),_vm._v(" "),_c('transition',{attrs:{"name":"questionMessageFadeIn"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.questionStatus === 'exists' && !_vm.question.pendingDelete),expression:"questionStatus === 'exists' && !question.pendingDelete"}],staticClass:"ui error message"},[_vm._v("\n          There is already a question for those columns.\n        ")])]),_vm._v(" "),_c('transition',{attrs:{"name":"questionMessageFadeIn"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.questionStatus === 'same column' && !_vm.question.pendingDelete),expression:"questionStatus === 'same column' && !question.pendingDelete"}],staticClass:"ui error message"},[_vm._v("\n          The From Column and To Column must be different.\n        ")])]),_vm._v(" "),_c('transition',{attrs:{"name":"questionMessageFadeIn"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.question.pendingDelete),expression:"question.pendingDelete"}],staticClass:"ui red icon message"},[_c('i',{staticClass:"exclamation triangle icon"}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"header"},[_vm._v("\n              Are you sure you want to delete this question?\n            ")]),_vm._v(" "),_c('p',[_vm._v("Click "),_c('strong',[_vm._v("Delete")]),_vm._v(" to delete the question, or "),_c('strong',[_vm._v("Cancel")]),_vm._v(" to cancel.")])])])])],1),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.memoSetType === 'regular' && !_vm.question.pendingDelete),expression:"memoSetType === 'regular' && !question.pendingDelete"}],staticClass:"ui primary ok button",class:{disabled: _vm.questionStatus !== 'ok'}},[_vm._v("OK")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.memoSetType === 'regular' && _vm.question.pendingDelete),expression:"memoSetType === 'regular' && question.pendingDelete"}],staticClass:"ui red ok button"},[_vm._v("Delete")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.memoSetType === 'regular'),expression:"memoSetType === 'regular'"}],staticClass:"ui cancel button"},[_vm._v("Cancel")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.memoSetType !== 'regular'),expression:"memoSetType !== 'regular'"}],staticClass:"ui primary cancel button"},[_vm._v("OK")])])]),_vm._v(" "),_c('div',{staticClass:"ui modal resetLearning",class:_vm.modalClass},[_c('div',{staticClass:"ui header"},[_vm._v("\n      "+_vm._s(_vm.text.memoSetResetLearning)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v("\n      "+_vm._s(_vm.resetLearningMessage)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"ui red ok button"},[_vm._v("Reset")]),_vm._v(" "),_c('button',{staticClass:"ui cancel button"},[_vm._v(_vm._s(_vm.text.commonCancel))])])]),_vm._v(" "),_c('div',{staticClass:"ui modal rowFieldPasteConfirm",class:_vm.modalClass},[_c('div',{staticClass:"ui header"},[_vm._v("\n      Confirm Paste\n    ")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('p',[_vm._v("Are you sure you want to paste "+_vm._s(_vm.pasteCells.rows)+" row"),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.pasteCells.rows > 1),expression:"pasteCells.rows > 1"}]},[_vm._v("s")]),_vm._v(" and "+_vm._s(_vm.pasteCells.columns)+" column"),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.pasteCells.columns > 1),expression:"pasteCells.columns > 1"}]},[_vm._v("s")]),_vm._v("?")]),_vm._v(" "),_c('p',[_vm._v("Any data in those cells will be overwritten.")])]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"ui ok primary button"},[_vm._v(_vm._s(_vm.text.commonOK))]),_vm._v(" "),_c('div',{staticClass:"ui cancel button"},[_vm._v(_vm._s(_vm.text.commonCancel))])])]),_vm._v(" "),_c('div',{staticClass:"ui modal setCoverImage",class:_vm.modalClass},[_c('div',{staticClass:"ui header"},[_vm._v("\n      "+_vm._s(_vm.text.memoSetSetCoverImage)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.setCoverImage.loading),expression:"setCoverImage.loading"}],staticClass:"ui small active inline loader modalLoader"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.setCoverImage.loading),expression:"!setCoverImage.loading"}]},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.setCoverImage.url),expression:"setCoverImage.url"}]},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.setCoverImage.uploading),expression:"setCoverImage.uploading"}],staticClass:"ui active dimmer"},[_c('div',{staticClass:"ui text loader"},[_vm._v("Uploading image")])]),_vm._v(" "),_c('img',{staticClass:"ui bordered rounded image",staticStyle:{"height":"56vh","object-fit":"contain","width":"100%"},attrs:{"id":"setCoverImage","src":_vm.setCoverImage.url},on:{"load":function($event){_vm.coverImageLoad()}}}),_vm._v(" "),_c('button',{staticClass:"ui red button resetImageButton",on:{"click":function($event){_vm.initSetCoverImage()}}},[_vm._v("Reset")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.setCoverImage.url),expression:"!setCoverImage.url"}]},[_vm._m(11),_vm._v(" "),_c('input',{attrs:{"type":"file","accept":"image/*","id":"coverImageFile"},on:{"change":function($event){_vm.setCoverImageFileChange($event.target.files[0])}}}),_vm._v(" "),_c('div',{staticClass:"ui horizontal divider"},[_vm._v("\n            Or\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Copy any image you find on the web by right-clicking on the image and choosing 'Copy image'.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Then paste the image into the box below.\n          ")]),_vm._v(" "),_c('textarea',{staticClass:"pasteImageHere",attrs:{"placeholder":_vm.text.memoSetPasteImageHere,"tabindex":"0"},on:{"keypress":function($event){$event.preventDefault();},"paste":function($event){$event.preventDefault();_vm.coverImagePaste($event)}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.photos.length),expression:"photos.length"}]},[_c('div',{staticClass:"ui horizontal divider"},[_vm._v("\n              Or\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              Select a background photo:\n            ")]),_vm._v(" "),_c('div',{staticClass:"ui small images"},_vm._l((_vm.photos),function(photo,photoIndex){return _c('img',{key:photoIndex,staticClass:"coverImagePhoto",attrs:{"src":photo.url},on:{"click":function($event){_vm.setCoverImagePhotoClick(photoIndex)}}})}))])])])]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"ui primary ok button",class:{disabled: !_vm.setCoverImage.url}},[_vm._v("OK")]),_vm._v(" "),_c('div',{staticClass:"ui cancel button"},[_vm._v("Cancel")])])]),_vm._v(" "),_c('div',{staticClass:"ui modal shareMemoSet",class:_vm.modalClass},[_c('div',{staticClass:"ui header"},[_vm._v("\n      Share Memo Set\n    ")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"ui warning message"},[_vm._v("\n        "+_vm._s(_vm.text.memoSetSuitable)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"ui form",attrs:{"onsubmit":"return false"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.share.showPublicCheckbox),expression:"share.showPublicCheckbox"}],staticClass:"field"},[_c('div',{staticClass:"ui checkbox",attrs:{"id":"sharePublic"},on:{"click":function($event){_vm.share.public = !_vm.share.public}}},[_c('input',{staticClass:"hidden",attrs:{"type":"checkbox","tabindex":"0"}}),_vm._v(" "),_c('label',[_vm._v("Share publicly")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.share.showPublicCheckbox),expression:"!share.showPublicCheckbox"}],staticStyle:{"margin-bottom":"1.4rem"}},[_vm._v(_vm._s(_vm.text.memoSetAlreadyPublic))]),_vm._v(" "),_c('div',{staticClass:"inline fields"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"ui checkbox",attrs:{"id":"shareSpecific"},on:{"click":function($event){_vm.shareMemoSetSpecificClick()}}},[_c('input',{staticClass:"hidden",attrs:{"type":"checkbox","tabindex":"0"}}),_vm._v(" "),_c('label',[_vm._v("Share with specific user")])])]),_vm._v(" "),_c('div',{staticClass:"inline field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.share.username),expression:"share.username"}],staticStyle:{"width":"20em"},attrs:{"type":"text","placeholder":_vm.text.memoSetUsernameOrEmail,"autocomplete":"off"},domProps:{"value":(_vm.share.username)},on:{"focus":function($event){_vm.shareMemoSetUsernameFocus()},"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.share, "username", $event.target.value)},function($event){_vm.share.noUser = false; _vm.share.shareSelf = false}]}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.share.noUser),expression:"share.noUser"}],staticClass:"ui negative message"},[_c('div',{staticClass:"header"},[_vm._v("\n            User not found\n          ")]),_vm._v(" "),_c('p',[_vm._v("No user was found with that username or email address.")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.share.shareSelf),expression:"share.shareSelf"}],staticClass:"ui negative message"},[_c('div',{staticClass:"header"},[_vm._v("\n            Error\n          ")]),_vm._v(" "),_c('p',[_vm._v("You can't share the memo set with yourself!")])])])]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"ui green ok button",class:{disabled: !(_vm.share.showPublicCheckbox && _vm.share.public) && !(_vm.share.specific && _vm.share.username) || _vm.share.noUser || _vm.share.shareSelf, 'loading disabled': _vm.share.checkingUser}},[_vm._v("Share Memo Set")]),_vm._v(" "),_c('button',{staticClass:"ui cancel button"},[_vm._v("Cancel")])])]),_vm._v(" "),_c('div',{staticClass:"ui modal sortRows",class:_vm.modalClass},[_c('div',{staticClass:"ui header"},[_vm._v("\n      "+_vm._s(_vm.text.memoSetSortRows)+"\n    ")]),_vm._v(" "),(_vm.fields)?_c('div',{staticClass:"content"},[_c('div',{staticClass:"ui grid",class:{'mobile': _vm.mobile}},[_c('div',{staticClass:"modalLabel modalLabelPadding",class:{'four wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('span',[_vm._v("Sort By Column")])]),_vm._v(" "),_c('div',{staticClass:"noTopPadding",class:{'twelve wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"ui fluid selection dropdown sortRowsSortByColumn"},[_c('input',{attrs:{"type":"hidden"}}),_vm._v(" "),_c('i',{staticClass:"dropdown icon"}),_vm._v(" "),_c('div',{staticClass:"default text"},[_vm._v("Select the column to sort by...")]),_vm._v(" "),_c('div',{staticClass:"menu"},_vm._l((_vm.fields),function(field,index){return _c('div',{key:index,staticClass:"item",attrs:{"data-value":index}},[_vm._v("\n                "+_vm._s(field.heading)+"\n              ")])}))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"ui primary ok button",class:{disabled: _vm.sortRows.sortByColumn === '-1'}},[_vm._v("Sort")]),_vm._v(" "),_c('button',{staticClass:"ui cancel button"},[_vm._v(_vm._s(_vm.text.commonCancel))])])]),_vm._v(" "),_c('div',{staticClass:"ui fullscreen modal summaryImage fullHeight",class:[_vm.modalClass, {fullscreenMobileModal: _vm.mobile}]},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.summaryImage.page === 'add'),expression:"summaryImage.page === 'add'"}],staticClass:"ui header"},[_vm._v("\n      "+_vm._s(_vm.text.memoSetAddImage)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"content noBottomPadding"},[_c('div',{attrs:{"id":"summaryImageMaxWidth"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.summaryImage.page === 'summary'),expression:"summaryImage.page === 'summary'"}]},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.summaryImage.uploading),expression:"summaryImage.uploading"}],staticClass:"ui active dimmer"},[_c('div',{staticClass:"ui text loader"},[_vm._v(_vm._s(_vm.summaryImageUploadingMessage))])]),_vm._v(" "),_c('div',{staticClass:"summaryImageWrapper",style:({
            cursor: _vm.rotatingObject ? 'crosshair' : (_vm.panning ? 'grabbing' : 'grab'),
            height: _vm.availableHeight + 'px',
            width: _vm.availableWidth + 'px',
          }),on:{"mousedown":function($event){_vm.summaryImageMouseDown($event)},"mousemove":function($event){_vm.summaryImageMouseMove($event)},"touchstart":function($event){$event.preventDefault();_vm.summaryImageTouchStart($event)},"touchmove":function($event){$event.preventDefault();_vm.summaryImageTouchMove($event)}}},[_c('div',{staticClass:"summaryImageView",style:({
              height: (_vm.photo.height * _vm.photoTransform.scale) + 'px',
              marginLeft: (_vm.photoTransform.translateX * _vm.photoTransform.scale + ((_vm.availableWidth - _vm.photoTransform.visibleWidth) / 2)) + 'px',
              marginTop: (_vm.photoTransform.translateY * _vm.photoTransform.scale + ((_vm.availableHeight - _vm.photoTransform.visibleHeight) / 2)) + 'px',
              transition: _vm.animateTransition ? 'all 0.6s ease' : '',
              width: (_vm.photo.width * _vm.photoTransform.scale) + 'px'
            })},[(_vm.photo.url)?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.photo.url},on:{"dragstart":function($event){$event.preventDefault();}}}):_vm._e(),_vm._v(" "),(_vm.photo.url)?_c('div',{staticClass:"locationRectangle",style:({
                border: _vm.locationRectangleBorder,
                cursor: _vm.panLock || _vm.mode !== 'select' ? (_vm.panning ? 'grabbing' : 'grab') : (_vm.rotatingObject ? 'crosshair' : (_vm.rectangleActive ? 'move' : 'default')),
                height: (_vm.locationRect.height / _vm.photo.height * 100) + '%',
                left: (_vm.locationRect.left / _vm.photo.width * 100) + '%',
                top: (_vm.locationRect.top / _vm.photo.height * 100) + '%',
                width: (_vm.locationRect.width / _vm.photo.width * 100) + '%',
                zIndex: _vm.locationZIndex
              }),attrs:{"id":"locationRectangle"},on:{"dragstart":function($event){$event.preventDefault();},"mousedown":function($event){_vm.rectangleMouseDown($event)},"mouseenter":function($event){_vm.locationHover = true},"mouseleave":function($event){_vm.locationHover = false},"touchstart":function($event){$event.preventDefault();_vm.rectangleTouchStart($event)}}}):_vm._e(),_vm._v(" "),(!_vm.photo.url)?_c('div',{staticClass:"noPhotoRect",style:({
                height: (_vm.locationRect.height / _vm.photo.height * 100) + '%',
                left: (_vm.locationRect.left / _vm.photo.width * 100) + '%',
                top: (_vm.locationRect.top / _vm.photo.height * 100) + '%',
                width: (_vm.locationRect.width / _vm.photo.width * 100) + '%',
              })}):_vm._e(),_vm._v(" "),_vm._l((_vm.objects),function(obj,objectIndex){return _c('img',{directives:[{name:"show",rawName:"v-show",value:(objectIndex !== _vm.activeObject || _vm.mode === 'select'),expression:"objectIndex !== activeObject || mode === 'select'"}],key:'summaryImageObj_' + obj.key,class:{objectActive: objectIndex === _vm.activeObject},style:({
                cursor: _vm.panLock || _vm.mode !== 'select' ? (_vm.panning ? 'grabbing' : 'grab') : (_vm.rotatingObject ? 'crosshair' : (objectIndex === _vm.activeObject ? 'move' : 'default')),
                height: (obj.height / _vm.photo.height * 100) + '%',
                left: (obj.left / _vm.photo.width * 100) + '%',
                transform:
                  'rotate(' + obj.angle + 'deg)' +
                  (obj.flipX ? ' scaleX(-1)' : '') +
                  (obj.flipY ? ' scaleY(-1)' : ''),
                top: (obj.top / _vm.photo.height * 100) + '%',
                width: (obj.width / _vm.photo.width * 100) + '%',
                zIndex: (objectIndex + 1) * 2
              }),attrs:{"id":'summaryImageObj_' + objectIndex,"src":obj.url,"crossorigin":"anonymous"},on:{"dragstart":function($event){$event.preventDefault();},"mousedown":function($event){_vm.objectMouseDown(objectIndex, $event)},"mouseenter":function($event){_vm.objectMouseEnter(objectIndex)},"mouseleave":function($event){_vm.objectMouseLeave(objectIndex)},"touchstart":function($event){$event.preventDefault();_vm.objectTouchStart(objectIndex, $event)}}})}),_vm._v(" "),_c('canvas',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeObject !== -1 && (_vm.mode === 'clip' || _vm.mode === 'draw' || _vm.mode === 'remove')),expression:"activeObject !== -1 && (mode === 'clip' || mode === 'draw' || mode === 'remove')"}],staticStyle:{"z-index":"1000"},style:({
                cursor: _vm.panning ? 'grabbing' : (_vm.panLock ? 'grab' : (_vm.mode === 'clip' ? 'crosshair' : (_vm.mode === 'draw' ? 'url(' + _vm.appPathPrefix + '/static/editing/cursor60.png) 33 33, auto' : (_vm.mode === 'remove' ? (_vm.removing ? 'ns-resize' : 'crosshair') : '')))),
                height: _vm.activeObject === -1 ? '' : (((_vm.objects[_vm.activeObject].height + (2 * _vm.summaryImageObjectCanvasPadding / _vm.photoTransform.scale)) / _vm.photo.height * 100) + '%'),
                left: _vm.activeObject === -1 ? '' : (((_vm.objects[_vm.activeObject].left - (_vm.summaryImageObjectCanvasPadding / _vm.photoTransform.scale)) / _vm.photo.width * 100) + '%'),
                padding: _vm.summaryImageObjectCanvasPadding + 'px',
                top:  _vm.activeObject === -1 ? '' : (((_vm.objects[_vm.activeObject].top - (_vm.summaryImageObjectCanvasPadding / _vm.photoTransform.scale)) / _vm.photo.height * 100) + '%'),
                transform: _vm.activeObject === -1 ? '' :
                  'rotate(' + _vm.objects[_vm.activeObject].angle + 'deg)' +
                  (_vm.objects[_vm.activeObject].flipX ? ' scaleX(-1)' : '') +
                  (_vm.objects[_vm.activeObject].flipY ? ' scaleY(-1)' : ''),
                width: _vm.activeObject === -1 ? '' : (((_vm.objects[_vm.activeObject].width + (2 * _vm.summaryImageObjectCanvasPadding / _vm.photoTransform.scale)) / _vm.photo.width * 100) + '%'),
              }),attrs:{"id":"objectCanvas"},on:{"dragstart":function($event){$event.preventDefault();},"mousedown":function($event){$event.preventDefault();_vm.objectCanvasMouseDown($event)},"mouseleave":function($event){$event.preventDefault();_vm.objectCanvasMouseLeave()},"mousemove":function($event){$event.preventDefault();_vm.objectCanvasMouseMove($event)},"touchstart":function($event){$event.preventDefault();_vm.objectCanvasTouchStart($event)},"touchmove":function($event){$event.preventDefault();_vm.objectCanvasTouchMove($event)}}}),_vm._v(" "),(_vm.hoverObject !== -1)?_c('div',{staticClass:"objectRectangle",style:({
                height: (_vm.objects[_vm.hoverObject].height / _vm.photo.height * 100) + '%',
                left: (_vm.objects[_vm.hoverObject].left / _vm.photo.width * 100) + '%',
                top: (_vm.objects[_vm.hoverObject].top / _vm.photo.height * 100) + '%',
                transform: 'rotate(' + _vm.objects[_vm.hoverObject].angle + 'deg)',
                width: (_vm.objects[_vm.hoverObject].width / _vm.photo.width * 100) + '%',
              }),on:{"dragstart":function($event){$event.preventDefault();}}}):_vm._e(),_vm._v(" "),(_vm.activeObject !== -1)?_c('div',{staticClass:"objectRectangle",style:({
                height: (_vm.objects[_vm.activeObject].height / _vm.photo.height * 100) + '%',
                left: (_vm.objects[_vm.activeObject].left / _vm.photo.width * 100) + '%',
                top: (_vm.objects[_vm.activeObject].top / _vm.photo.height * 100) + '%',
                transform: 'rotate(' + _vm.objects[_vm.activeObject].angle + 'deg)',
                width: (_vm.objects[_vm.activeObject].width / _vm.photo.width * 100) + '%',
              }),on:{"dragstart":function($event){$event.preventDefault();}}}):_vm._e()],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.rectangleActive && !_vm.panLock),expression:"rectangleActive && !panLock"}],staticClass:"rectangleHandles"},[_c('div',{staticStyle:{"cursor":"nwse-resize"},style:({
                transform: 'translate3d(' + ((_vm.photoTransform.translateX + _vm.locationRect.left) * _vm.photoTransform.scale + ((_vm.availableWidth - _vm.photoTransform.visibleWidth) / 2)) + 'px, ' + ((_vm.photoTransform.translateY + _vm.locationRect.top) * _vm.photoTransform.scale + ((_vm.availableHeight - _vm.photoTransform.visibleHeight) / 2)) + 'px, 0px) translate3d(-6px, -6px, 0px)',
                transition: _vm.animateTransition ? 'transform 0.6s ease' : ''
              }),on:{"dragstart":function($event){$event.preventDefault();},"mousedown":function($event){$event.stopPropagation();_vm.rectangleHandleMouseDown($event, 'left top')},"touchstart":function($event){$event.preventDefault();_vm.rectangleHandleTouchStart($event, 'left top')}}}),_vm._v(" "),_c('div',{staticStyle:{"cursor":"ns-resize"},style:({ transform: 'translate3d(' + ((_vm.photoTransform.translateX + _vm.locationRect.left) * _vm.photoTransform.scale + ((_vm.availableWidth - _vm.photoTransform.visibleWidth) / 2)) + 'px, ' + ((_vm.photoTransform.translateY + _vm.locationRect.top) * _vm.photoTransform.scale + ((_vm.availableHeight - _vm.photoTransform.visibleHeight) / 2)) + 'px, 0px) translate3d(-7px, -6px, 0px) translate3d(' + (_vm.locationRect.width * _vm.photoTransform.scale / 2) + 'px, 0px, 0px)', transition: _vm.animateTransition ? 'transform 0.6s ease' : '' }),on:{"dragstart":function($event){$event.preventDefault();},"mousedown":function($event){$event.stopPropagation();_vm.rectangleHandleMouseDown($event, 'center top')},"touchstart":function($event){$event.preventDefault();_vm.rectangleHandleTouchStart($event, 'center top')}}}),_vm._v(" "),_c('div',{staticStyle:{"cursor":"nesw-resize"},style:({ transform: 'translate3d(' + ((_vm.photoTransform.translateX + _vm.locationRect.left) * _vm.photoTransform.scale + ((_vm.availableWidth - _vm.photoTransform.visibleWidth) / 2)) + 'px, ' + ((_vm.photoTransform.translateY + _vm.locationRect.top) * _vm.photoTransform.scale + ((_vm.availableHeight - _vm.photoTransform.visibleHeight) / 2)) + 'px, 0px) translate3d(-9px, -6px, 0px) translate3d(' + (_vm.locationRect.width * _vm.photoTransform.scale) + 'px, 0px, 0px)', transition: _vm.animateTransition ? 'transform 0.6s ease' : '' }),on:{"dragstart":function($event){$event.preventDefault();},"mousedown":function($event){$event.stopPropagation();_vm.rectangleHandleMouseDown($event, 'right top')},"touchstart":function($event){$event.preventDefault();_vm.rectangleHandleTouchStart($event, 'right top')}}}),_vm._v(" "),_c('div',{staticStyle:{"cursor":"ew-resize"},style:({ transform: 'translate3d(' + ((_vm.photoTransform.translateX + _vm.locationRect.left) * _vm.photoTransform.scale + ((_vm.availableWidth - _vm.photoTransform.visibleWidth) / 2)) + 'px, ' + ((_vm.photoTransform.translateY + _vm.locationRect.top) * _vm.photoTransform.scale + ((_vm.availableHeight - _vm.photoTransform.visibleHeight) / 2)) + 'px, 0px) translate3d(-9px, -7px, 0px) translate3d(' + (_vm.locationRect.width * _vm.photoTransform.scale) + 'px, ' + (_vm.locationRect.height * _vm.photoTransform.scale / 2) + 'px, 0px)', transition: _vm.animateTransition ? 'transform 0.6s ease' : '' }),on:{"dragstart":function($event){$event.preventDefault();},"mousedown":function($event){$event.stopPropagation();_vm.rectangleHandleMouseDown($event, 'right middle')},"touchstart":function($event){$event.preventDefault();_vm.rectangleHandleTouchStart($event, 'right middle')}}}),_vm._v(" "),_c('div',{staticStyle:{"cursor":"nwse-resize"},style:({ transform: 'translate3d(' + ((_vm.photoTransform.translateX + _vm.locationRect.left) * _vm.photoTransform.scale + ((_vm.availableWidth - _vm.photoTransform.visibleWidth) / 2)) + 'px, ' + ((_vm.photoTransform.translateY + _vm.locationRect.top) * _vm.photoTransform.scale + ((_vm.availableHeight - _vm.photoTransform.visibleHeight) / 2)) + 'px, 0px) translate3d(-9px, -9px, 0px) translate3d(' + (_vm.locationRect.width * _vm.photoTransform.scale) + 'px, ' + (_vm.locationRect.height * _vm.photoTransform.scale) + 'px, 0px)', transition: _vm.animateTransition ? 'transform 0.6s ease' : '' }),on:{"dragstart":function($event){$event.preventDefault();},"mousedown":function($event){$event.stopPropagation();_vm.rectangleHandleMouseDown($event, 'right bottom')},"touchstart":function($event){$event.preventDefault();_vm.rectangleHandleTouchStart($event, 'right bottom')}}}),_vm._v(" "),_c('div',{staticStyle:{"cursor":"ns-resize"},style:({ transform: 'translate3d(' + ((_vm.photoTransform.translateX + _vm.locationRect.left) * _vm.photoTransform.scale + ((_vm.availableWidth - _vm.photoTransform.visibleWidth) / 2)) + 'px, ' + ((_vm.photoTransform.translateY + _vm.locationRect.top) * _vm.photoTransform.scale + ((_vm.availableHeight - _vm.photoTransform.visibleHeight) / 2)) + 'px, 0px) translate3d(-7px, -9px, 0px) translate3d(' + (_vm.locationRect.width * _vm.photoTransform.scale / 2) + 'px, ' + (_vm.locationRect.height * _vm.photoTransform.scale) + 'px, 0px)', transition: _vm.animateTransition ? 'transform 0.6s ease' : '' }),on:{"dragstart":function($event){$event.preventDefault();},"mousedown":function($event){$event.stopPropagation();_vm.rectangleHandleMouseDown($event, 'center bottom')},"touchstart":function($event){$event.preventDefault();_vm.rectangleHandleTouchStart($event, 'center bottom')}}}),_vm._v(" "),_c('div',{staticStyle:{"cursor":"nesw-resize"},style:({ transform: 'translate3d(' + ((_vm.photoTransform.translateX + _vm.locationRect.left) * _vm.photoTransform.scale + ((_vm.availableWidth - _vm.photoTransform.visibleWidth) / 2)) + 'px, ' + ((_vm.photoTransform.translateY + _vm.locationRect.top) * _vm.photoTransform.scale + ((_vm.availableHeight - _vm.photoTransform.visibleHeight) / 2)) + 'px, 0px) translate3d(-6px, -9px, 0px) translate3d(0px, ' + (_vm.locationRect.height * _vm.photoTransform.scale) + 'px, 0px)', transition: _vm.animateTransition ? 'transform 0.6s ease' : '' }),on:{"dragstart":function($event){$event.preventDefault();},"mousedown":function($event){$event.stopPropagation();_vm.rectangleHandleMouseDown($event, 'left bottom')},"touchstart":function($event){$event.preventDefault();_vm.rectangleHandleTouchStart($event, 'left bottom')}}}),_vm._v(" "),_c('div',{staticStyle:{"cursor":"ew-resize"},style:({ transform: 'translate3d(' + ((_vm.photoTransform.translateX + _vm.locationRect.left) * _vm.photoTransform.scale + ((_vm.availableWidth - _vm.photoTransform.visibleWidth) / 2)) + 'px, ' + ((_vm.photoTransform.translateY + _vm.locationRect.top) * _vm.photoTransform.scale + ((_vm.availableHeight - _vm.photoTransform.visibleHeight) / 2)) + 'px, 0px) translate3d(-6px, -7px, 0px) translate3d(0px, ' + (_vm.locationRect.height * _vm.photoTransform.scale / 2) + 'px, 0px)', transition: _vm.animateTransition ? 'transform 0.6s ease' : '' }),on:{"dragstart":function($event){$event.preventDefault();},"mousedown":function($event){$event.stopPropagation();_vm.rectangleHandleMouseDown($event, 'left middle')},"touchstart":function($event){$event.preventDefault();_vm.rectangleHandleTouchStart($event, 'left middle')}}})]),_vm._v(" "),(_vm.activeObject !== -1 && _vm.mode === 'select' && !_vm.panLock)?_c('div',[_c('div',{staticClass:"objectHandle",style:({
                cursor: _vm.objectCursorStyles[0],
                transform:
                  'translate3d(' + (((_vm.objects[_vm.activeObject].left + _vm.photoTransform.translateX) * _vm.photoTransform.scale) + ((_vm.availableWidth - _vm.photoTransform.visibleWidth) / 2)) + 'px, ' + (((_vm.objects[_vm.activeObject].top + _vm.photoTransform.translateY) * _vm.photoTransform.scale) + ((_vm.availableHeight - _vm.photoTransform.visibleHeight) / 2)) + 'px, 0px)' +
                  ' translate3d(' + (_vm.objects[_vm.activeObject].width / 2 * _vm.photoTransform.scale) + 'px, ' + (_vm.objects[_vm.activeObject].height / 2 * _vm.photoTransform.scale) + 'px, 0px)' +
                  ' rotate(' + _vm.objects[_vm.activeObject].angle + 'deg)' +
                  ' translate3d(' + (-_vm.objects[_vm.activeObject].width / 2 * _vm.photoTransform.scale) + 'px, ' + (-_vm.objects[_vm.activeObject].height / 2 * _vm.photoTransform.scale) + 'px, 0px)' +
                  ' translate3d(-7px, -7px, 0px)',
                transition: _vm.animateTransition ? 'transform 0.6s ease' : ''
              }),on:{"dragstart":function($event){$event.preventDefault();},"mousedown":function($event){$event.stopPropagation();_vm.objectHandleMouseDown($event, 'left top')},"touchstart":function($event){$event.preventDefault();_vm.objectHandleTouchStart($event, 'left top')}}}),_vm._v(" "),_c('div',{staticClass:"objectHandle",style:({
                cursor: _vm.objectCursorStyles[1],
                transform:
                  'translate3d(' + (((_vm.objects[_vm.activeObject].left + _vm.photoTransform.translateX) * _vm.photoTransform.scale) + ((_vm.availableWidth - _vm.photoTransform.visibleWidth) / 2)) + 'px, ' + (((_vm.objects[_vm.activeObject].top + _vm.photoTransform.translateY) * _vm.photoTransform.scale) + ((_vm.availableHeight - _vm.photoTransform.visibleHeight) / 2)) + 'px, 0px)' +
                  ' translate3d(' + (_vm.objects[_vm.activeObject].width / 2 * _vm.photoTransform.scale) + 'px, ' + (_vm.objects[_vm.activeObject].height / 2 * _vm.photoTransform.scale) + 'px, 0px)' +
                  ' rotate(' + _vm.objects[_vm.activeObject].angle + 'deg)' +
                  ' translate3d(' + (-_vm.objects[_vm.activeObject].width / 2 * _vm.photoTransform.scale) + 'px, ' + (-_vm.objects[_vm.activeObject].height / 2 * _vm.photoTransform.scale) + 'px, 0px)' +
                  ' translate3d(-7px, -7px, 0px)' +
                  ' translate3d(' + (_vm.objects[_vm.activeObject].width * _vm.photoTransform.scale / 2) + 'px, 0px, 0px)',
                transition: _vm.animateTransition ? 'transform 0.6s ease' : ''
              }),on:{"dragstart":function($event){$event.preventDefault();},"mousedown":function($event){$event.stopPropagation();_vm.objectHandleMouseDown($event, 'center top')},"touchstart":function($event){$event.preventDefault();_vm.objectHandleTouchStart($event, 'center top')}}}),_vm._v(" "),_c('div',{staticClass:"objectHandle",style:({
                cursor: _vm.objectCursorStyles[2],
                transform:
                  'translate3d(' + (((_vm.objects[_vm.activeObject].left + _vm.photoTransform.translateX) * _vm.photoTransform.scale) + ((_vm.availableWidth - _vm.photoTransform.visibleWidth) / 2)) + 'px, ' + (((_vm.objects[_vm.activeObject].top + _vm.photoTransform.translateY) * _vm.photoTransform.scale) + ((_vm.availableHeight - _vm.photoTransform.visibleHeight) / 2)) + 'px, 0px)' +
                  ' translate3d(' + (_vm.objects[_vm.activeObject].width / 2 * _vm.photoTransform.scale) + 'px, ' + (_vm.objects[_vm.activeObject].height / 2 * _vm.photoTransform.scale) + 'px, 0px)' +
                  ' rotate(' + _vm.objects[_vm.activeObject].angle + 'deg)' +
                  ' translate3d(' + (-_vm.objects[_vm.activeObject].width / 2 * _vm.photoTransform.scale) + 'px, ' + (-_vm.objects[_vm.activeObject].height / 2 * _vm.photoTransform.scale) + 'px, 0px)' +
                  ' translate3d(-9px, -7px, 0px)' +
                  ' translate3d(' + (_vm.objects[_vm.activeObject].width * _vm.photoTransform.scale) + 'px, 0px, 0px)',
                transition: _vm.animateTransition ? 'transform 0.6s ease' : ''
              }),on:{"dragstart":function($event){$event.preventDefault();},"mousedown":function($event){$event.stopPropagation();_vm.objectHandleMouseDown($event, 'right top')},"touchstart":function($event){$event.preventDefault();_vm.objectHandleTouchStart($event, 'right top')}}}),_vm._v(" "),_c('div',{staticClass:"objectHandle",style:({
                cursor: _vm.objectCursorStyles[3],
                transform:
                  'translate3d(' + (((_vm.objects[_vm.activeObject].left + _vm.photoTransform.translateX) * _vm.photoTransform.scale) + ((_vm.availableWidth - _vm.photoTransform.visibleWidth) / 2)) + 'px, ' + (((_vm.objects[_vm.activeObject].top + _vm.photoTransform.translateY) * _vm.photoTransform.scale) + ((_vm.availableHeight - _vm.photoTransform.visibleHeight) / 2)) + 'px, 0px)' +
                  ' translate3d(' + (_vm.objects[_vm.activeObject].width / 2 * _vm.photoTransform.scale) + 'px, ' + (_vm.objects[_vm.activeObject].height / 2 * _vm.photoTransform.scale) + 'px, 0px)' +
                  ' rotate(' + _vm.objects[_vm.activeObject].angle + 'deg)' +
                  ' translate3d(' + (-_vm.objects[_vm.activeObject].width / 2 * _vm.photoTransform.scale) + 'px, ' + (-_vm.objects[_vm.activeObject].height / 2 * _vm.photoTransform.scale) + 'px, 0px)' +
                  ' translate3d(-9px, -7px, 0px)' +
                  ' translate3d(' + (_vm.objects[_vm.activeObject].width * _vm.photoTransform.scale) + 'px, ' + (_vm.objects[_vm.activeObject].height * _vm.photoTransform.scale / 2) + 'px, 0px)',
                transition: _vm.animateTransition ? 'transform 0.6s ease' : ''
              }),on:{"dragstart":function($event){$event.preventDefault();},"mousedown":function($event){$event.stopPropagation();_vm.objectHandleMouseDown($event, 'right middle')},"touchstart":function($event){$event.preventDefault();_vm.objectHandleTouchStart($event, 'right middle')}}}),_vm._v(" "),_c('div',{staticClass:"objectHandle",style:({
                cursor: _vm.objectCursorStyles[4],
                transform:
                  'translate3d(' + (((_vm.objects[_vm.activeObject].left + _vm.photoTransform.translateX) * _vm.photoTransform.scale) + ((_vm.availableWidth - _vm.photoTransform.visibleWidth) / 2)) + 'px, ' + (((_vm.objects[_vm.activeObject].top + _vm.photoTransform.translateY) * _vm.photoTransform.scale) + ((_vm.availableHeight - _vm.photoTransform.visibleHeight) / 2)) + 'px, 0px)' +
                  ' translate3d(' + (_vm.objects[_vm.activeObject].width / 2 * _vm.photoTransform.scale) + 'px, ' + (_vm.objects[_vm.activeObject].height / 2 * _vm.photoTransform.scale) + 'px, 0px)' +
                  ' rotate(' + _vm.objects[_vm.activeObject].angle + 'deg)' +
                  ' translate3d(' + (-_vm.objects[_vm.activeObject].width / 2 * _vm.photoTransform.scale) + 'px, ' + (-_vm.objects[_vm.activeObject].height / 2 * _vm.photoTransform.scale) + 'px, 0px)' +
                  ' translate3d(-9px, -9px, 0px)' +
                  ' translate3d(' + (_vm.objects[_vm.activeObject].width * _vm.photoTransform.scale) + 'px, ' + (_vm.objects[_vm.activeObject].height * _vm.photoTransform.scale) + 'px, 0px)',
                transition: _vm.animateTransition ? 'transform 0.6s ease' : ''
              }),on:{"dragstart":function($event){$event.preventDefault();},"mousedown":function($event){$event.stopPropagation();_vm.objectHandleMouseDown($event, 'right bottom')},"touchstart":function($event){$event.preventDefault();_vm.objectHandleTouchStart($event, 'right bottom')}}}),_vm._v(" "),_c('div',{staticClass:"objectHandle",style:({
                cursor: _vm.objectCursorStyles[5],
                transform:
                  'translate3d(' + (((_vm.objects[_vm.activeObject].left + _vm.photoTransform.translateX) * _vm.photoTransform.scale) + ((_vm.availableWidth - _vm.photoTransform.visibleWidth) / 2)) + 'px, ' + (((_vm.objects[_vm.activeObject].top + _vm.photoTransform.translateY) * _vm.photoTransform.scale) + ((_vm.availableHeight - _vm.photoTransform.visibleHeight) / 2)) + 'px, 0px)' +
                  ' translate3d(' + (_vm.objects[_vm.activeObject].width / 2 * _vm.photoTransform.scale) + 'px, ' + (_vm.objects[_vm.activeObject].height / 2 * _vm.photoTransform.scale) + 'px, 0px)' +
                  ' rotate(' + _vm.objects[_vm.activeObject].angle + 'deg)' +
                  ' translate3d(' + (-_vm.objects[_vm.activeObject].width / 2 * _vm.photoTransform.scale) + 'px, ' + (-_vm.objects[_vm.activeObject].height / 2 * _vm.photoTransform.scale) + 'px, 0px)' +
                  ' translate3d(-7px, -9px, 0px)' +
                  ' translate3d(' + (_vm.objects[_vm.activeObject].width * _vm.photoTransform.scale / 2) + 'px, ' + (_vm.objects[_vm.activeObject].height * _vm.photoTransform.scale) + 'px, 0px)',
                transition: _vm.animateTransition ? 'transform 0.6s ease' : ''
              }),on:{"dragstart":function($event){$event.preventDefault();},"mousedown":function($event){$event.stopPropagation();_vm.objectHandleMouseDown($event, 'center bottom')},"touchstart":function($event){$event.preventDefault();_vm.objectHandleTouchStart($event, 'center bottom')}}}),_vm._v(" "),_c('div',{staticClass:"objectHandle",style:({
                cursor: _vm.objectCursorStyles[6],
                transform:
                  'translate3d(' + (((_vm.objects[_vm.activeObject].left + _vm.photoTransform.translateX) * _vm.photoTransform.scale) + ((_vm.availableWidth - _vm.photoTransform.visibleWidth) / 2)) + 'px, ' + (((_vm.objects[_vm.activeObject].top + _vm.photoTransform.translateY) * _vm.photoTransform.scale) + ((_vm.availableHeight - _vm.photoTransform.visibleHeight) / 2)) + 'px, 0px)' +
                  ' translate3d(' + (_vm.objects[_vm.activeObject].width / 2 * _vm.photoTransform.scale) + 'px, ' + (_vm.objects[_vm.activeObject].height / 2 * _vm.photoTransform.scale) + 'px, 0px)' +
                  ' rotate(' + _vm.objects[_vm.activeObject].angle + 'deg)' +
                  ' translate3d(' + (-_vm.objects[_vm.activeObject].width / 2 * _vm.photoTransform.scale) + 'px, ' + (-_vm.objects[_vm.activeObject].height / 2 * _vm.photoTransform.scale) + 'px, 0px)' +
                  ' translate3d(-7px, -9px, 0px)' +
                  ' translate3d(0px, ' + (_vm.objects[_vm.activeObject].height * _vm.photoTransform.scale) + 'px, 0px)',
                transition: _vm.animateTransition ? 'transform 0.6s ease' : ''
              }),on:{"dragstart":function($event){$event.preventDefault();},"mousedown":function($event){$event.stopPropagation();_vm.objectHandleMouseDown($event, 'left bottom')},"touchstart":function($event){$event.preventDefault();_vm.objectHandleTouchStart($event, 'left bottom')}}}),_vm._v(" "),_c('div',{staticClass:"objectHandle",style:({
                cursor: _vm.objectCursorStyles[7],
                transform:
                  'translate3d(' + (((_vm.objects[_vm.activeObject].left + _vm.photoTransform.translateX) * _vm.photoTransform.scale) + ((_vm.availableWidth - _vm.photoTransform.visibleWidth) / 2)) + 'px, ' + (((_vm.objects[_vm.activeObject].top + _vm.photoTransform.translateY) * _vm.photoTransform.scale) + ((_vm.availableHeight - _vm.photoTransform.visibleHeight) / 2)) + 'px, 0px)' +
                  ' translate3d(' + (_vm.objects[_vm.activeObject].width / 2 * _vm.photoTransform.scale) + 'px, ' + (_vm.objects[_vm.activeObject].height / 2 * _vm.photoTransform.scale) + 'px, 0px)' +
                  ' rotate(' + _vm.objects[_vm.activeObject].angle + 'deg)' +
                  ' translate3d(' + (-_vm.objects[_vm.activeObject].width / 2 * _vm.photoTransform.scale) + 'px, ' + (-_vm.objects[_vm.activeObject].height / 2 * _vm.photoTransform.scale) + 'px, 0px)' +
                  ' translate3d(-7px, -7px, 0px)' +
                  ' translate3d(0px, ' + (_vm.objects[_vm.activeObject].height * _vm.photoTransform.scale / 2) + 'px, 0px)',
                transition: _vm.animateTransition ? 'transform 0.6s ease' : ''
              }),on:{"dragstart":function($event){$event.preventDefault();},"mousedown":function($event){$event.stopPropagation();_vm.objectHandleMouseDown($event, 'left middle')},"touchstart":function($event){$event.preventDefault();_vm.objectHandleTouchStart($event, 'left middle')}}}),_vm._v(" "),_c('div',{staticClass:"objectHandle rotationHandle",style:({
                transform:
                  'translate3d(' + (((_vm.objects[_vm.activeObject].left + _vm.photoTransform.translateX) * _vm.photoTransform.scale) + ((_vm.availableWidth - _vm.photoTransform.visibleWidth) / 2)) + 'px, ' + (((_vm.objects[_vm.activeObject].top + _vm.photoTransform.translateY) * _vm.photoTransform.scale) + ((_vm.availableHeight - _vm.photoTransform.visibleHeight) / 2)) + 'px, 0px)' +
                  ' translate3d(' + (_vm.objects[_vm.activeObject].width / 2 * _vm.photoTransform.scale) + 'px, ' + (_vm.objects[_vm.activeObject].height / 2 * _vm.photoTransform.scale) + 'px, 0px)' +
                  ' rotate(' + _vm.objects[_vm.activeObject].angle + 'deg)' +
                  ' translate3d(' + (-_vm.objects[_vm.activeObject].width / 2 * _vm.photoTransform.scale) + 'px, ' + (-_vm.objects[_vm.activeObject].height / 2 * _vm.photoTransform.scale) + 'px, 0px)' +
                  ' translate3d(-7px, -7px, 0px)' +
                  ' translate3d(' + (_vm.objects[_vm.activeObject].width * _vm.photoTransform.scale / 2) + 'px, -40px, 0px)',
                transition: _vm.animateTransition ? 'transform 0.6s ease' : ''
              }),on:{"dragstart":function($event){$event.preventDefault();},"mousedown":function($event){$event.stopPropagation();_vm.objectRotationMouseDown($event)},"touchstart":function($event){$event.preventDefault();_vm.objectRotationTouchStart($event)}}}),_vm._v(" "),(_vm.activeObject !== -1 && _vm.mode === 'select' && !_vm.panLock)?_c('div',{staticClass:"objectRotationLine",style:({
                transform:
                  'translate3d(' + (((_vm.objects[_vm.activeObject].left + _vm.photoTransform.translateX) * _vm.photoTransform.scale) + ((_vm.availableWidth - _vm.photoTransform.visibleWidth) / 2)) + 'px, ' + (((_vm.objects[_vm.activeObject].top + _vm.photoTransform.translateY) * _vm.photoTransform.scale) + ((_vm.availableHeight - _vm.photoTransform.visibleHeight) / 2)) + 'px, 0px)' +
                  ' translate3d(' + (_vm.objects[_vm.activeObject].width / 2 * _vm.photoTransform.scale) + 'px, ' + (_vm.objects[_vm.activeObject].height / 2 * _vm.photoTransform.scale) + 'px, 0px)' +
                  ' rotate(' + _vm.objects[_vm.activeObject].angle + 'deg)' +
                  ' translate3d(' + (-_vm.objects[_vm.activeObject].width / 2 * _vm.photoTransform.scale) + 'px, ' + (-_vm.objects[_vm.activeObject].height / 2 * _vm.photoTransform.scale) + 'px, 0px)' +
                  ' translate3d(' + (_vm.objects[_vm.activeObject].width * _vm.photoTransform.scale / 2) + 'px, -40px, 0px)',
                transition: _vm.animateTransition ? 'transform 0.6s ease' : ''
              }),on:{"dragstart":function($event){$event.preventDefault();}}}):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{class:{'narrowButtons': !_vm.tabsText},staticStyle:{"margin-top":"0.5rem"}},[(!_vm.touch)?_c('button',{staticClass:"ui icon button summaryImageButton",class:{active: _vm.panLock},attrs:{"id":"panLockButton","data-tooltip":_vm.text.memoSetPanLock,"data-position":"top left"},on:{"click":function($event){_vm.panLockClick()}}},[_c('i',{class:{'lock icon': _vm.panLock, 'unlock icon': !_vm.panLock}})]):_vm._e(),_vm._v(" "),(_vm.touch)?_c('button',{staticClass:"ui icon button summaryImageButton",class:{active: _vm.panLock},attrs:{"id":"panLockButton"},on:{"click":function($event){_vm.panLockClick()}}},[_c('i',{class:{'lock icon': _vm.panLock, 'unlock icon': !_vm.panLock}})]):_vm._e(),_vm._v(" "),(!_vm.touch)?_c('button',{staticClass:"ui icon button summaryImageButton",attrs:{"data-tooltip":_vm.text.memoSetZoomIn},on:{"click":function($event){_vm.zoomIn(1.7, $event, null, true)}}},[_c('i',{staticClass:"zoom in icon"})]):_vm._e(),_vm._v(" "),(_vm.touch)?_c('button',{staticClass:"ui icon button summaryImageButton",on:{"click":function($event){_vm.zoomIn(1.7, $event, null, true)}}},[_c('i',{staticClass:"zoom in icon"})]):_vm._e(),_vm._v(" "),(!_vm.touch)?_c('div',{staticStyle:{"display":"inline-block"},attrs:{"data-tooltip":_vm.text.memoSetZoomOut}},[_c('button',{staticClass:"ui icon button summaryImageButton",class:{disabled: _vm.photoTransform.visibleWidth === _vm.photo.width * _vm.photoTransform.scale && _vm.photoTransform.visibleHeight === _vm.photo.height * _vm.photoTransform.scale},on:{"click":function($event){_vm.zoomOut(1.7, $event, null, true)}}},[_c('i',{staticClass:"zoom out icon"})])]):_vm._e(),_vm._v(" "),(_vm.touch)?_c('button',{staticClass:"ui icon button summaryImageButton",class:{disabled: _vm.photoTransform.visibleWidth === _vm.photo.width * _vm.photoTransform.scale && _vm.photoTransform.visibleHeight === _vm.photo.height * _vm.photoTransform.scale},on:{"click":function($event){_vm.zoomOut(1.7, $event, null, true)}}},[_c('i',{staticClass:"zoom out icon"})]):_vm._e(),_vm._v(" "),(!_vm.touch)?_c('button',{staticClass:"ui icon button summaryImageButton",attrs:{"id":"zoomToSelectedButton","data-tooltip":_vm.text.memoSetZoomToSelected},on:{"click":function($event){_vm.zoomToSelected()}}},[_c('i',{staticClass:"expand icon"})]):_vm._e(),_vm._v(" "),(_vm.touch)?_c('button',{staticClass:"ui icon button summaryImageButton",attrs:{"id":"zoomToSelectedButton"},on:{"click":function($event){_vm.zoomToSelected()}}},[_c('i',{staticClass:"expand icon"})]):_vm._e(),_vm._v(" "),(!_vm.touch)?_c('div',{staticStyle:{"float":"right"},attrs:{"data-tooltip":_vm.text.commonRedo,"data-position":"top right"}},[_c('button',{staticClass:"ui icon button summaryImageButton",class:{disabled: _vm.summaryImage.undoArrayIndex === _vm.summaryImage.undoArrayIndexMax},attrs:{"id":"redoButton"},on:{"click":function($event){_vm.summaryImageRedoClick()}}},[_c('i',{staticClass:"redo alternate icon"})])]):_vm._e(),_vm._v(" "),(_vm.touch)?_c('button',{staticClass:"ui right floated icon button summaryImageButton",class:{disabled: _vm.summaryImage.undoArrayIndex === _vm.summaryImage.undoArrayIndexMax},attrs:{"id":"redoButton"},on:{"click":function($event){_vm.summaryImageRedoClick()}}},[_c('i',{staticClass:"redo alternate icon"})]):_vm._e(),_vm._v(" "),(!_vm.touch)?_c('div',{staticStyle:{"float":"right"},attrs:{"data-tooltip":_vm.text.commonUndo}},[_c('button',{staticClass:"ui icon button summaryImageButton",class:{disabled: !_vm.summaryImage.undoArrayIndex},attrs:{"id":"undoButton"},on:{"click":function($event){_vm.summaryImageUndoClick()}}},[_c('i',{staticClass:"undo alternate icon"})])]):_vm._e(),_vm._v(" "),(_vm.touch)?_c('button',{staticClass:"ui right floated icon button summaryImageButton",class:{disabled: !_vm.summaryImage.undoArrayIndex},attrs:{"id":"undoButton"},on:{"click":function($event){_vm.summaryImageUndoClick()}}},[_c('i',{staticClass:"undo alternate icon"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"thinScroll",staticStyle:{"margin-top":"0.5rem","overflow-x":"auto","padding-bottom":"0.5rem","white-space":"nowrap"}},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeObject === -1),expression:"activeObject === -1"}],staticClass:"ui button summaryImageButton",on:{"click":function($event){_vm.addImageClick($event)}}},[_c('i',{staticClass:"plus icon"}),_vm._v("\n            "+_vm._s(_vm.text.memoSetAddImage)+"\n          ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeObject !== -1 && _vm.activeObjectOverlap),expression:"activeObject !== -1 && activeObjectOverlap"}],staticClass:"ui button summaryImageButton",class:{disabled: _vm.activeObject === -1},on:{"click":function($event){_vm.sendToBackClick($event)}}},[_c('i',{staticClass:"arrow down icon"}),_vm._v("\n            "+_vm._s(_vm.text.memoSetSendToBack)+"\n          ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeObject !== -1),expression:"activeObject !== -1"}],staticClass:"ui button summaryImageButton",class:{ active: _vm.mode === 'clip' },attrs:{"id":"clipButton"},on:{"click":function($event){_vm.clipClick()}}},[_c('i',{staticClass:"cut icon"}),_vm._v("\n            "+_vm._s(_vm.text.memoSetClip)+"\n          ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeObject !== -1),expression:"activeObject !== -1"}],staticClass:"ui button summaryImageButton",class:{ active: _vm.mode === 'draw' },attrs:{"id":"drawTransparentButton"},on:{"click":function($event){_vm.drawTransparentClick()}}},[_c('i',{staticClass:"eraser icon"}),_vm._v("\n            "+_vm._s(_vm.text.memoSetErase)+"\n          ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeObject !== -1),expression:"activeObject !== -1"}],staticClass:"ui button summaryImageButton",class:{ active: _vm.mode === 'remove' },attrs:{"id":"removeColorButton"},on:{"click":function($event){_vm.removeColorClick()}}},[_c('i',{staticClass:"eye dropper icon"}),_vm._v("\n            "+_vm._s(_vm.text.memoSetRemoveColor)+"\n          ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeObject !== -1),expression:"activeObject !== -1"}],staticClass:"ui button summaryImageButton",on:{"click":function($event){_vm.flipClick($event, 'x')}}},[_c('i',{staticClass:"arrows alternate horizontal icon"}),_vm._v("\n            "+_vm._s(_vm.text.memoSetFlipHorizontal)+"\n          ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeObject !== -1),expression:"activeObject !== -1"}],staticClass:"ui button summaryImageButton",on:{"click":function($event){_vm.flipClick($event, 'y')}}},[_c('i',{staticClass:"arrows alternate vertical icon"}),_vm._v("\n            "+_vm._s(_vm.text.memoSetFlipVertical)+"\n          ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeObject !== -1),expression:"activeObject !== -1"}],staticClass:"ui button summaryImageButton",attrs:{"id":"deleteImageButton"},on:{"click":function($event){_vm.deleteImageClick()}}},[_c('i',{staticClass:"trash alternate icon"}),_vm._v("\n            "+_vm._s(_vm.text.memoSetDeleteImage)+"\n          ")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.summaryImage.page === 'add'),expression:"summaryImage.page === 'add'"}],staticStyle:{"height":"65vh"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.addImage.loading),expression:"addImage.loading"}],staticClass:"ui small centered active inline loader modalLoader"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.addImage.loading),expression:"!addImage.loading"}]},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.addImage.url),expression:"addImage.url"}],staticStyle:{"height":"65vh"}},[_c('img',{staticClass:"ui rounded image",staticStyle:{"height":"100%","object-fit":"contain","width":"100%"},attrs:{"id":"addImageImage","src":_vm.addImage.url},on:{"load":function($event){_vm.imageLoad()}}}),_vm._v(" "),_c('button',{staticClass:"ui red button resetImageButton",on:{"click":function($event){_vm.xxx()}}},[_vm._v("Reset")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.addImage.url),expression:"!addImage.url"}]},[_vm._m(12),_vm._v(" "),_c('input',{attrs:{"type":"file","accept":"image/*","id":"imageFile"},on:{"change":function($event){_vm.addImageFileChange($event.target.files[0])}}}),_vm._v(" "),_c('div',{staticClass:"ui horizontal divider"},[_vm._v("\n              Or\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              Copy any image you find on the web by right-clicking on the image and choosing 'Copy image'.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              Then paste the image into the box below.\n            ")]),_vm._v(" "),_vm._m(13),_vm._v(" "),_c('textarea',{staticClass:"pasteImageHere",attrs:{"placeholder":_vm.text.memoSetPasteImageHere,"tabindex":"0"},on:{"keypress":function($event){$event.preventDefault();},"paste":function($event){$event.preventDefault();_vm.imagePaste($event)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"ui primary ok button"},[_vm._v(_vm._s(_vm.text.commonOK))]),_vm._v(" "),_c('button',{staticClass:"ui cancel button"},[_vm._v(_vm._s(_vm.text.commonCancel))])])]),_vm._v(" "),_c('div',{staticClass:"ui modal viewAlternatives",class:[_vm.modalClass, {'fullHeight fullscreen fullscreenMobileModal': _vm.mobile}]},[_c('div',{staticClass:"ui header noBottomBorder"},[_vm._v("\n      Alternatives\n    ")]),_vm._v(" "),_c('div',{staticClass:"content",class:{noSidePadding: _vm.mobile}},[_c('table',{staticClass:"ui selectable unstackable basic table alternatives"},[_c('thead',[_c('tr',[_c('th',{staticClass:"two wide"}),_vm._v(" "),_c('th',{staticClass:"six wide noLeftPadding"},[_vm._v("Value")]),_vm._v(" "),_c('th',{staticClass:"five wide"},[_vm._v("Author")]),_vm._v(" "),_c('th',{staticClass:"two wide"},[_vm._v(_vm._s(_vm.text.memoSetPublic))]),_vm._v(" "),_c('th',{staticClass:"one wide"})])]),_vm._v(" "),(_vm.rows[_vm.rowIndex])?_c('tbody',_vm._l((_vm.visibleCellAlternatives),function(alternative){return _c('tr',{key:alternative.index,class:{positive: alternative.index === _vm.selectedAlternativeIndex},on:{"click":function($event){_vm.selectedAlternativeIndex = alternative.index}}},[_c('td',{staticClass:"center aligned"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(alternative.index === _vm.selectedAlternativeIndex),expression:"alternative.index === selectedAlternativeIndex"}],staticClass:"tick"},[_vm._v("✓")])]),_vm._v(" "),_c('td',{staticClass:"cellTd"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.sanitize(alternative.value))}})]),_vm._v(" "),_c('td',[_vm._v("\n              "+_vm._s(alternative.author)+"\n            ")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"ui fitted checkbox",on:{"click":function($event){$event.stopPropagation();}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(alternative.public),expression:"alternative.public"}],attrs:{"type":"checkbox","disabled":alternative.authorId !== _vm.user.id},domProps:{"checked":Array.isArray(alternative.public)?_vm._i(alternative.public,null)>-1:(alternative.public)},on:{"change":function($event){var $$a=alternative.public,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(alternative, "public", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(alternative, "public", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(alternative, "public", $$c)}}}}),_vm._v(" "),_c('label')])]),_vm._v(" "),_c('td',{class:{noLeftPadding: !_vm.mobile}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(alternative.authorId === _vm.user.id && !alternative.public && _vm.selectedAlternativeIndex !== alternative.index),expression:"alternative.authorId === user.id && !alternative.public && selectedAlternativeIndex !== alternative.index"}],staticClass:"ui small compact icon button",on:{"click":function($event){$event.stopPropagation();_vm.deleteAlternativeClick(alternative.index)}}},[_c('i',{staticClass:"trash alternate icon"})])])])})):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"ui primary ok button",class:{disabled: _vm.backgroundPhotoTab === 'backgroundPhotoAdd' && !_vm.addPhoto.url}},[_vm._v(_vm._s(_vm.text.commonOK))]),_vm._v(" "),_c('button',{staticClass:"ui cancel button"},[_vm._v(_vm._s(_vm.text.commonCancel))])])]),_vm._v(" "),_c('div',{staticClass:"ui fullscreen modal walkThrough fullHeight fullscreenModal",class:_vm.modalClass},[_c('div',{staticClass:"content noPadding"},[_c('div',{attrs:{"id":"walkThroughMaxWidth"}}),_vm._v(" "),_c('button',{staticClass:"ui large compact icon button closeButton",on:{"click":function($event){_vm.closeWalkThrough()}}},[_c('i',{staticClass:"large close icon"})]),_vm._v(" "),_c('div',{staticClass:"walkThroughWrapper",style:({
          height: _vm.availableHeight + 'px',
          width: _vm.availableWidth + 'px',
        })},[_c('div',{staticStyle:{"position":"relative"},style:({
            opacity: _vm.photoOpacity,
            transition: _vm.animateTransition ? 'opacity 0.5s ease' : ''
          })},[_c('div',{staticClass:"walkThroughView",style:({
              height: (_vm.photo.height * _vm.photoTransform.scale) + 'px',
              marginLeft: (_vm.photoTransform.translateX * _vm.photoTransform.scale + ((_vm.availableWidth - _vm.photoTransform.visibleWidth) / 2)) + 'px',
              marginTop: (_vm.photoTransform.translateY * _vm.photoTransform.scale + ((_vm.availableHeight - _vm.photoTransform.visibleHeight) / 2)) + 'px',
              transition: _vm.animateTransition && !_vm.photoTransition ? 'all 0.8s ease-in-out' : '',
              width: (_vm.photo.width * _vm.photoTransform.scale) + 'px'
            })},[(_vm.walkThroughCurrentPhoto.url)?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.walkThroughCurrentPhoto.url}}):_vm._e(),_vm._v(" "),_vm._l((_vm.walkThroughCurrentPhoto.locations),function(location){return _c('div',{key:location.rowIndex,class:{walkThroughLocationRectangle: _vm.walkThrough.steps[_vm.walkThrough.stepNum] && !_vm.walkThrough.steps[_vm.walkThrough.stepNum].summary && _vm.walkThrough.steps[_vm.walkThrough.stepNum].rowIndex === location.rowIndex},style:({
                height: (location.height / _vm.photo.height * 100) + '%',
                left: (location.left / _vm.photo.width * 100) + '%',
                top: (location.top / _vm.photo.height * 100) + '%',
                width: (location.width / _vm.photo.width * 100) + '%'
              })})}),_vm._v(" "),(!_vm.walkThroughCurrentPhoto.url)?_c('div',{staticClass:"noPhotoRect",style:({
                height: _vm.locationRect.height + 'px',
                transform: 'translate(' + _vm.locationRect.left + 'px, ' + _vm.locationRect.top + 'px)',
                width: _vm.locationRect.width + 'px'
              })}):_vm._e(),_vm._v(" "),_vm._l((_vm.walkThroughCurrentPhoto.objects),function(obj,objectIndex){return _c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.objectsVisible),expression:"objectsVisible"}],key:'walkThroughObj_' + obj.key,style:({
                height: (obj.height / _vm.photo.height * 100) + '%',
                left: (obj.left / _vm.photo.width * 100) + '%',
                transform:
                  'rotate(' + obj.angle + 'deg)' +
                  (obj.flipX ? ' scaleX(-1)' : '') +
                  (obj.flipY ? ' scaleY(-1)' : ''),
                top: (obj.top / _vm.photo.height * 100) + '%',
                width: (obj.width / _vm.photo.width * 100) + '%',
                zIndex: objectIndex + 1
              }),attrs:{"src":obj.url,"crossorigin":"anonymous"}})})],2)])]),_vm._v(" "),_c('div',{staticClass:"ui grid walkThroughData",class:{'dataHidden': !_vm.dataVisible || _vm.walkThrough.steps[_vm.walkThrough.stepNum].summary, 'mobile': _vm.mobile},attrs:{"id":"walkThroughData"}},[_c('div',{staticClass:"row noBottomPadding",class:{'noTopPadding': _vm.mobile}},[(_vm.fields && _vm.walkThrough.steps[_vm.walkThrough.stepNum])?_c('table',{staticClass:"ui celled selectable unstackable table walkThroughDataTable"},[_c('thead',[_c('tr',{staticClass:"middle aligned"},[_vm._l((_vm.fields),function(field){return _c('th',{key:field.fieldId,staticClass:"two wide",class:{hideField: _vm.mobile && !_vm.rows[_vm.walkThrough.steps[_vm.walkThrough.stepNum].rowIndex].data[field.fieldId]}},[_vm._v("\n                  "+_vm._s(field.heading)+"\n                ")])}),_vm._v(" "),_c('th',{staticClass:"three wide",class:{hideField: _vm.mobile && !_vm.rows[_vm.walkThrough.steps[_vm.walkThrough.stepNum].rowIndex].data.notes}},[_vm._v(_vm._s(_vm.text.memoSetNotes))])],2)]),_vm._v(" "),_c('tbody',[_c('tr',{staticClass:"middle aligned",on:{"click":function($event){_vm.walkThroughGoToRowClick()}}},[_vm._l((_vm.fields),function(field){return _c('td',{key:field.fieldId,class:{cardsCell: _vm.cardStyle(_vm.rows[_vm.walkThrough.steps[_vm.walkThrough.stepNum].rowIndex].data[field.fieldId]), hideField: _vm.mobile && !_vm.rows[_vm.walkThrough.steps[_vm.walkThrough.stepNum].rowIndex].data[field.fieldId]},style:(_vm.cardStyle(_vm.rows[_vm.walkThrough.steps[_vm.walkThrough.stepNum].rowIndex].data[field.fieldId]))},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.sanitize(_vm.rows[_vm.walkThrough.steps[_vm.walkThrough.stepNum].rowIndex].data[field.fieldId]))}})])}),_vm._v(" "),_c('td',{class:{hideField: _vm.mobile && !_vm.rows[_vm.walkThrough.steps[_vm.walkThrough.stepNum].rowIndex].data.notes}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.sanitize(_vm.rows[_vm.walkThrough.steps[_vm.walkThrough.stepNum].rowIndex].data.notes))}})])],2)])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"ui centered grid walkThroughGrid",class:{'noPadding': _vm.mobile}},[_c('div',{staticClass:"row"},[_c('button',{staticClass:"ui compact button",class:{green: _vm.objectsVisible, icon: !_vm.walkThroughLabelsVisible, walkThroughButtonDesktop: _vm.walkThroughLabelsVisible, walkThroughButtonMid: !_vm.mobile && !_vm.walkThroughLabelsVisible, walkThroughButtonMobile: _vm.mobile},on:{"click":function($event){_vm.showObjectsClick($event)}}},[_c('i',{staticClass:"large eye icon"}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.walkThroughLabelsVisible),expression:"walkThroughLabelsVisible"}]},[_vm._v("Images")])]),_vm._v(" "),_c('button',{staticClass:"ui compact button",class:{green: _vm.dataVisible, icon: !_vm.walkThroughLabelsVisible, walkThroughButtonDesktop: _vm.walkThroughLabelsVisible, walkThroughButtonMid: !_vm.mobile && !_vm.walkThroughLabelsVisible, walkThroughButtonMobile: _vm.mobile},on:{"click":function($event){_vm.showDataClick($event)}}},[_c('i',{staticClass:"large table icon"}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.walkThroughLabelsVisible),expression:"walkThroughLabelsVisible"}]},[_vm._v("Data")])]),_vm._v(" "),_c('div',{staticClass:"ui teal labeled ticked slider",class:{sliderMid: !_vm.mobile && !_vm.walkThroughLabelsVisible, sliderMobile: _vm.mobile},attrs:{"id":"walkThroughSlider"}}),_vm._v(" "),_c('button',{staticClass:"ui compact primary button",class:{disabled: _vm.walkThrough.stepNum === 0, icon: !_vm.walkThroughLabelsVisible,walkThroughButtonDesktop: _vm.walkThroughLabelsVisible, walkThroughButtonMid: !_vm.mobile && !_vm.walkThroughLabelsVisible, walkThroughButtonMobile: _vm.mobile},on:{"click":function($event){_vm.walkThroughMove(-1, 'button', $event)}}},[_c('i',{staticClass:"large left arrow icon"}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.walkThroughLabelsVisible),expression:"walkThroughLabelsVisible"}]},[_vm._v("Previous")])]),_vm._v(" "),_c('button',{staticClass:"ui compact primary button noRightMargin",class:{disabled: _vm.walkThrough.stepNum === _vm.walkThrough.steps.length - 1, icon: !_vm.walkThroughLabelsVisible, walkThroughButtonDesktop: _vm.walkThroughLabelsVisible, walkThroughButtonMid: !_vm.mobile && !_vm.walkThroughLabelsVisible, walkThroughButtonMobile: _vm.mobile},on:{"click":function($event){_vm.walkThroughMove(1, 'button', $event)}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.walkThroughLabelsVisible),expression:"walkThroughLabelsVisible"}]},[_vm._v("Next")]),_c('i',{staticClass:"large right arrow icon"})])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"-1rem","position":"absolute"}},[_c('i',{staticClass:"star icon largeInactiveStar"}),_vm._v(" "),_c('i',{staticClass:"star icon largeInactiveStar"}),_vm._v(" "),_c('i',{staticClass:"star icon largeInactiveStar"}),_vm._v(" "),_c('i',{staticClass:"star icon largeInactiveStar"}),_vm._v(" "),_c('i',{staticClass:"star icon largeInactiveStar"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"cellAudioFile"}},[_c('div',{staticClass:"ui button"},[_c('i',{staticClass:"large file audio outline icon"}),_vm._v("\n              Select Audio File\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"cellImageFile"}},[_c('div',{staticClass:"ui button"},[_c('i',{staticClass:"camera icon"}),_vm._v("\n              Upload / Take Photo\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"six wide center aligned"},[_c('span',{staticClass:"backgroundPhotoNone"},[_vm._v("No photo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"photoFile"}},[_c('div',{staticClass:"ui button selectPhotoFile"},[_c('i',{staticClass:"camera icon"}),_vm._v("\n                Upload / Take Photo\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui header"},[_c('i',{staticClass:"green check icon"}),_vm._v("Memo Set Copied\n    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui fluid selection dropdown populateColumnDataSet"},[_c('input',{attrs:{"type":"hidden"}}),_vm._v(" "),_c('i',{staticClass:"dropdown icon"}),_vm._v(" "),_c('div',{staticClass:"default text"},[_vm._v("Select the data type...")]),_vm._v(" "),_c('div',{staticClass:"menu"},[_c('div',{staticClass:"item",attrs:{"data-value":"c1"}},[_vm._v("Cards – 1 card")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"c2"}},[_vm._v("Cards – 2 cards")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"n"}},[_vm._v("Numbers")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu"},[_c('div',{staticClass:"item",attrs:{"data-value":"CDHS"}},[_c('span',{staticClass:"suits"},[_vm._v("♣"),_c('span',{staticClass:"redSuit"},[_vm._v("♦♥")]),_vm._v("♠")])]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"CDSH"}},[_c('span',{staticClass:"suits"},[_vm._v("♣"),_c('span',{staticClass:"redSuit"},[_vm._v("♦")]),_vm._v("♠"),_c('span',{staticClass:"redSuit"},[_vm._v("♥")])])]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"CHDS"}},[_c('span',{staticClass:"suits"},[_vm._v("♣"),_c('span',{staticClass:"redSuit"},[_vm._v("♥♦")]),_vm._v("♠")])]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"CHSD"}},[_c('span',{staticClass:"suits"},[_vm._v("♣"),_c('span',{staticClass:"redSuit"},[_vm._v("♥")]),_vm._v("♠"),_c('span',{staticClass:"redSuit"},[_vm._v("♦")])])]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"CSDH"}},[_c('span',{staticClass:"suits"},[_vm._v("♣♠"),_c('span',{staticClass:"redSuit"},[_vm._v("♦♥")])])]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"CSHD"}},[_c('span',{staticClass:"suits"},[_vm._v("♣♠"),_c('span',{staticClass:"redSuit"},[_vm._v("♥♦")])])]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"DCHS"}},[_c('span',{staticClass:"suits"},[_c('span',{staticClass:"redSuit"},[_vm._v("♦")]),_vm._v("♣"),_c('span',{staticClass:"redSuit"},[_vm._v("♥")]),_vm._v("♠")])]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"DCSH"}},[_c('span',{staticClass:"suits"},[_c('span',{staticClass:"redSuit"},[_vm._v("♦")]),_vm._v("♣♠"),_c('span',{staticClass:"redSuit"},[_vm._v("♥")])])]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"DHCS"}},[_c('span',{staticClass:"suits"},[_c('span',{staticClass:"redSuit"},[_vm._v("♦♥")]),_vm._v("♣♠")])]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"DHSC"}},[_c('span',{staticClass:"suits"},[_c('span',{staticClass:"redSuit"},[_vm._v("♦♥")]),_vm._v("♠♣")])]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"DSCH"}},[_c('span',{staticClass:"suits"},[_c('span',{staticClass:"redSuit"},[_vm._v("♦")]),_vm._v("♠♣"),_c('span',{staticClass:"redSuit"},[_vm._v("♥")])])]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"DSHC"}},[_c('span',{staticClass:"suits"},[_c('span',{staticClass:"redSuit"},[_vm._v("♦")]),_vm._v("♠"),_c('span',{staticClass:"redSuit"},[_vm._v("♥")]),_vm._v("♣")])]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"HCDS"}},[_c('span',{staticClass:"suits"},[_c('span',{staticClass:"redSuit"},[_vm._v("♥")]),_vm._v("♣"),_c('span',{staticClass:"redSuit"},[_vm._v("♦")]),_vm._v("♠")])]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"HCSD"}},[_c('span',{staticClass:"suits"},[_c('span',{staticClass:"redSuit"},[_vm._v("♥")]),_vm._v("♣♠"),_c('span',{staticClass:"redSuit"},[_vm._v("♦")])])]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"HDCS"}},[_c('span',{staticClass:"suits"},[_c('span',{staticClass:"redSuit"},[_vm._v("♥♦")]),_vm._v("♣♠")])]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"HDSC"}},[_c('span',{staticClass:"suits"},[_c('span',{staticClass:"redSuit"},[_vm._v("♥♦")]),_vm._v("♠♣")])]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"HSCD"}},[_c('span',{staticClass:"suits"},[_c('span',{staticClass:"redSuit"},[_vm._v("♥")]),_vm._v("♠♣"),_c('span',{staticClass:"redSuit"},[_vm._v("♦")])])]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"HSDC"}},[_c('span',{staticClass:"suits"},[_c('span',{staticClass:"redSuit"},[_vm._v("♥")]),_vm._v("♠"),_c('span',{staticClass:"redSuit"},[_vm._v("♦")]),_vm._v("♣")])]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"SCDH"}},[_c('span',{staticClass:"suits"},[_vm._v("♠♣"),_c('span',{staticClass:"redSuit"},[_vm._v("♦♥")])])]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"SCHD"}},[_c('span',{staticClass:"suits"},[_vm._v("♠♣"),_c('span',{staticClass:"redSuit"},[_vm._v("♥♦")])])]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"SDCH"}},[_c('span',{staticClass:"suits"},[_vm._v("♠"),_c('span',{staticClass:"redSuit"},[_vm._v("♦")]),_vm._v("♣"),_c('span',{staticClass:"redSuit"},[_vm._v("♥")])])]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"SDHC"}},[_c('span',{staticClass:"suits"},[_vm._v("♠"),_c('span',{staticClass:"redSuit"},[_vm._v("♦♥")]),_vm._v("♣")])]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"SHCD"}},[_c('span',{staticClass:"suits"},[_vm._v("♠"),_c('span',{staticClass:"redSuit"},[_vm._v("♥")]),_vm._v("♣"),_c('span',{staticClass:"redSuit"},[_vm._v("♦")])])]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"SHDC"}},[_c('span',{staticClass:"suits"},[_vm._v("♠"),_c('span',{staticClass:"redSuit"},[_vm._v("♥♦")]),_vm._v("♣")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu"},[_c('div',{staticClass:"item",attrs:{"data-value":"A-K"}},[_vm._v("A – K")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"K-A"}},[_vm._v("K – A")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"2-A"}},[_vm._v("2 – A")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"A-2"}},[_vm._v("A – 2")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu"},[_c('div',{staticClass:"item",attrs:{"data-value":"L"}},[_vm._v("Left")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"R"}},[_vm._v("Right")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu"},[_c('div',{staticClass:"item",attrs:{"data-value":"Y"}},[_vm._v("Yes")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"N"}},[_vm._v("No")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"coverImageFile"}},[_c('div',{staticClass:"ui button"},[_c('i',{staticClass:"camera icon"}),_vm._v("\n              Upload / Take Photo\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"imageFile"}},[_c('div',{staticClass:"ui button selectImageFile"},[_c('i',{staticClass:"camera icon"}),_vm._v("\n                Upload / Take Photo\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui message"},[_c('p',[_c('strong',[_vm._v("Note:")]),_vm._v(" for animated images, first download them, then upload them using the button above.\n              ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemoSets_vue__ = __webpack_require__(89);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69de994f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemoSets_vue__ = __webpack_require__(191);
function injectStyle (ssrContext) {
  __webpack_require__(190)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69de994f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemoSets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69de994f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemoSets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_vm._v(" "),_c('div',{staticClass:"innerWrapper",class:{'mobile': _vm.mobile}},[_c('div',{staticClass:"ui fluid search container"},[_c('div',{staticClass:"ui fluid icon input"},[_c('input',{staticClass:"prompt",attrs:{"type":"text","placeholder":_vm.text.commonSearchPlaceholder}}),_vm._v(" "),_c('i',{staticClass:"search icon"})]),_vm._v(" "),_c('div',{staticClass:"results"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.ready),expression:"!ready"}],staticClass:"ui small active inline loader readyLoader"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready),expression:"ready"}],staticClass:"accordionWrapper"},[_c('div',{staticClass:"ui styled accordion",class:{'mobile': _vm.mobile},on:{"contextmenu":function($event){_vm.disableMenuForTouch($event)}}},[_vm._l((_vm.folders),function(folder,folderIndex){return [_c('div',{key:'folderName_' + folder.seq,staticClass:"title",class:{
              insertAbove:
                (_vm.draggingFolder || _vm.touchMovingFolder) &&
                folderIndex === _vm.toFolderIndex &&
                folderIndex <= _vm.fromFolderIndex,
              insertBelow:
                  (_vm.draggingFolder || _vm.touchMovingFolder) &&
                  folderIndex === _vm.toFolderIndex &&
                  folderIndex > _vm.fromFolderIndex
            },attrs:{"draggable":"true"},on:{"drag":function($event){_vm.scrollPage($event.clientY)},"dragend":function($event){_vm.folderDragEnd()},"dragenter":function($event){_vm.folderDragEnter(folderIndex)},"dragover":function($event){$event.preventDefault();},"dragleave":function($event){_vm.folderDragLeave()},"dragstart":function($event){_vm.folderDragStart(folderIndex)},"drop":function($event){_vm.folderDrop()},"touchend":function($event){_vm.folderTouchEnd()},"touchmove":function($event){_vm.folderTouchMove($event)},"touchstart":function($event){_vm.folderTouchStart(folderIndex, $event)}}},[_c('div',{staticClass:"accordionTitleInnerWrapper",class:{
                pendingFolder:
                  (_vm.draggingMemoSet || _vm.touchMovingMemoSet) &&
                  folderIndex === _vm.pendingFolder &&
                  !_vm.accordionState[folderIndex]
              }},[_c('i',{staticClass:"large grey folder icon folderIcon"}),_vm._v(" "),_c('i',{staticClass:"large grey folder open icon folderIcon"}),_vm._v(" "),_c('div',{staticClass:"folderTitle",attrs:{"id":'folder' + folderIndex,"contenteditable":_vm.renamingFolder === folderIndex},on:{"blur":function($event){_vm.folderNameBlur($event)},"click":function($event){_vm.folderTitleClick($event, folderIndex)},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();$event.target.blur()},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }$event.target.blur()}]}},[_vm._v("\n                "+_vm._s(folder.folderName)+"\n              ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.folders.length >= 2 && (!folder.memoSets || folder.memoSets.length === 0)),expression:"folders.length >= 2 && (!folder.memoSets || folder.memoSets.length === 0)"}],staticClass:"ui compact large icon button folderButton",on:{"click":function($event){$event.stopPropagation();_vm.deleteFolderClick(folderIndex)}}},[_c('i',{staticClass:"trash alternate icon"})]),_vm._v(" "),_c('button',{staticClass:"ui compact large icon button folderButton",on:{"click":function($event){$event.stopPropagation();_vm.renameFolderClick(folderIndex)}}},[_c('i',{staticClass:"edit icon"})])])]),_vm._v(" "),_c('div',{key:'folderContent' + folderIndex,staticClass:"content"},[(folder.memoSets && folder.memoSets.length)?_c('table',{staticClass:"ui selectable unstackable table",class:{compact: _vm.mobile}},[_c('thead',[_c('tr',{on:{"dragenter":function($event){_vm.tableHeadDragEnter(folderIndex)},"dragleave":function($event){_vm.tableHeadDragLeave()},"dragover":function($event){$event.preventDefault();},"drop":function($event){_vm.tableHeadDrop()}}},[_c('th',{staticClass:"two wide"},[_vm._v(_vm._s(_vm.text.memoSetsColumnImage))]),_vm._v(" "),_c('th',{staticClass:"six wide"},[_vm._v(_vm._s(_vm.text.memoSetsColumnMemoSet))]),_vm._v(" "),_c('th',{staticClass:"two wide"},[_vm._v(_vm._s(_vm.text.memoSetsColumnRows))]),_vm._v(" "),_c('th',{staticClass:"four wide"},[_vm._v(_vm._s(_vm.text.commonStatus))])])]),_vm._v(" "),_c('tbody',_vm._l((folder.memoSets),function(memoSet,memoSetIndex){return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(memoSet.memoSetId !== _vm.addingMemoSetId),expression:"memoSet.memoSetId !== addingMemoSetId"}],key:memoSet.memoSetId,attrs:{"draggable":"true"},on:{"drag":function($event){_vm.scrollPage($event.clientY)},"dragend":function($event){_vm.memoSetDragEnd()},"dragenter":function($event){_vm.memoSetDragEnter(folderIndex, memoSetIndex)},"dragleave":function($event){_vm.memoSetDragLeave()},"dragover":function($event){$event.preventDefault();},"dragstart":function($event){_vm.memoSetDragStart(folderIndex, memoSetIndex)},"drop":function($event){_vm.memoSetDrop()},"touchend":function($event){_vm.memoSetTouchEnd()},"touchmove":function($event){_vm.memoSetTouchMove($event)},"touchstart":function($event){_vm.memoSetTouchStart(folderIndex, memoSetIndex, $event)}}},[_c('td',{staticClass:"imgCell",class:{
                      insertAbove:
                        /* Dragging a memo set up within the same folder or to a different folder */
                        (_vm.draggingMemoSet || _vm.touchMovingMemoSet) &&
                        folderIndex === _vm.toFolderIndex && (
                          (
                            folderIndex === _vm.fromFolderIndex &&
                            memoSetIndex === _vm.toMemoSetIndex &&
                            memoSetIndex <= _vm.fromMemoSetIndex
                          ) || (
                            folderIndex !== _vm.fromFolderIndex &&
                            memoSetIndex === _vm.toMemoSetIndex
                          )
                        ),
                      insertBelow:
                        /* Dragging a memo set down within the same folder */
                        (_vm.draggingMemoSet || _vm.touchMovingMemoSet) &&
                        folderIndex === _vm.toFolderIndex &&
                        folderIndex === _vm.fromFolderIndex &&
                        memoSetIndex === _vm.toMemoSetIndex &&
                        memoSetIndex > _vm.fromMemoSetIndex
                    }},[_c('router-link',{attrs:{"to":'memo-sets/' + memoSet.memoSetId + '/' + memoSet.slug,"draggable":"false"}},[_c('div',{staticClass:"coverImageWrapper"},[_c('img',{staticClass:"ui centered rounded image",attrs:{"src":memoSet.coverImage,"draggable":"false"}})])])],1),_vm._v(" "),_c('td',{class:{
                      insertAbove:
                        /* Dragging a memo set up within the same folder or to a different folder */
                        (_vm.draggingMemoSet || _vm.touchMovingMemoSet) &&
                        folderIndex === _vm.toFolderIndex && (
                          (
                            folderIndex === _vm.fromFolderIndex &&
                            memoSetIndex === _vm.toMemoSetIndex &&
                            memoSetIndex <= _vm.fromMemoSetIndex
                          ) || (
                            folderIndex !== _vm.fromFolderIndex &&
                            memoSetIndex === _vm.toMemoSetIndex
                          )
                        ),
                      insertBelow:
                        /* Dragging a memo set down within the same folder */
                        (_vm.draggingMemoSet || _vm.touchMovingMemoSet) &&
                        folderIndex === _vm.toFolderIndex &&
                        folderIndex === _vm.fromFolderIndex &&
                        memoSetIndex === _vm.toMemoSetIndex &&
                        memoSetIndex > _vm.fromMemoSetIndex
                    }},[_c('router-link',{attrs:{"to":'memo-sets/' + memoSet.memoSetId + '/' + memoSet.slug,"draggable":"false"}},[_vm._v("\n                      "+_vm._s(memoSet.title)+"\n                    ")])],1),_vm._v(" "),_c('td',{staticClass:"locationNum",class:{
                      insertAbove:
                        /* Dragging a memo set up within the same folder or to a different folder */
                        (_vm.draggingMemoSet || _vm.touchMovingMemoSet) &&
                        folderIndex === _vm.toFolderIndex && (
                          (
                            folderIndex === _vm.fromFolderIndex &&
                            memoSetIndex === _vm.toMemoSetIndex &&
                            memoSetIndex <= _vm.fromMemoSetIndex
                          ) || (
                            folderIndex !== _vm.fromFolderIndex &&
                            memoSetIndex === _vm.toMemoSetIndex
                          )
                        ),
                      insertBelow:
                        /* Dragging a memo set down within the same folder */
                        (_vm.draggingMemoSet || _vm.touchMovingMemoSet) &&
                        folderIndex === _vm.toFolderIndex &&
                        folderIndex === _vm.fromFolderIndex &&
                        memoSetIndex === _vm.toMemoSetIndex &&
                        memoSetIndex > _vm.fromMemoSetIndex
                    }},[_c('router-link',{attrs:{"to":'memo-sets/' + memoSet.memoSetId + '/' + memoSet.slug,"draggable":"false"}},[_c('span',{class:{'indent1': memoSet.rowCount < 1000, 'indent2': memoSet.rowCount < 100, 'indent3': memoSet.rowCount < 10}},[_vm._v(_vm._s(memoSet.rowCount))])])],1),_vm._v(" "),_c('td',{class:{
                      insertAbove:
                        /* Dragging a memo set up within the same folder or to a different folder */
                        (_vm.draggingMemoSet || _vm.touchMovingMemoSet) &&
                        folderIndex === _vm.toFolderIndex && (
                          (
                            folderIndex === _vm.fromFolderIndex &&
                            memoSetIndex === _vm.toMemoSetIndex &&
                            memoSetIndex <= _vm.fromMemoSetIndex
                          ) || (
                            folderIndex !== _vm.fromFolderIndex &&
                            memoSetIndex === _vm.toMemoSetIndex
                          )
                        ),
                      insertBelow:
                        /* Dragging a memo set down within the same folder */
                        (_vm.draggingMemoSet || _vm.touchMovingMemoSet) &&
                        folderIndex === _vm.toFolderIndex &&
                        folderIndex === _vm.fromFolderIndex &&
                        memoSetIndex === _vm.toMemoSetIndex &&
                        memoSetIndex > _vm.fromMemoSetIndex
                    }},[_c('router-link',{attrs:{"to":'memo-sets/' + memoSet.memoSetId + '/' + memoSet.slug,"draggable":"false"}},[(_vm.statuses && _vm.statuses[memoSet.memoSetId])?_c('status-bar',{attrs:{"mobile":_vm.mobile,"page":"MemoSets","statuses":_vm.statusesWithSpeed[memoSet.memoSetId],"window":_vm.window}}):_vm._e()],1)],1)])}))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"addMemoSetWrapper",class:{
                insertAbove:
                    _vm.draggingMemoSet &&
                    folderIndex === _vm.toFolderIndex &&
                    _vm.toMemoSetIndex === (folder.memoSets ? folder.memoSets.length : 0)
                  ||
                    _vm.touchMovingMemoSet &&
                    folderIndex === _vm.toFolderIndex &&
                    _vm.toMemoSetIndex === (folder.memoSets ? folder.memoSets.length : 0)
              },on:{"dragenter":function($event){_vm.addMemoSetWrapperDragEnter(folderIndex)},"dragover":function($event){$event.preventDefault();},"dragleave":function($event){_vm.addMemoSetWrapperDragLeave()},"drop":function($event){_vm.memoSetDrop()}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.addingMemoSetId),expression:"addingMemoSetId"}],staticClass:"ui small active inline loader"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.addingMemoSetId),expression:"!addingMemoSetId"}],staticClass:"addMemoSetLink",on:{"click":function($event){_vm.addMemoSetClick(folderIndex)}}},[_c('i',{staticClass:"plus icon"}),_vm._v(_vm._s(_vm.text.memoSetsAddAMemoSet))])])])]})],2),_vm._v(" "),_c('div',{staticClass:"addFolderWrapper"},[_c('span',{staticClass:"addFolderLink",on:{"click":function($event){_vm.addFolderClick($event)}}},[_c('i',{staticClass:"plus icon"}),_vm._v(_vm._s(_vm.text.memoSetsAddAFolder))])])])]),_vm._v(" "),_c('br')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicMemoSets_vue__ = __webpack_require__(90);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82d705dc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicMemoSets_vue__ = __webpack_require__(194);
function injectStyle (ssrContext) {
  __webpack_require__(193)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-82d705dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicMemoSets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82d705dc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicMemoSets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_vm._v(" "),_c('div',{staticClass:"innerWrapper",class:{'mobile': _vm.mobile}},[_c('div',{staticClass:"ui fluid icon input container",staticStyle:{"margin-bottom":"1rem"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"searchInput",attrs:{"id":"searchText","type":"text","placeholder":_vm.text.commonSearchPlaceholder,"autocomplete":"off","autofocus":"true"},domProps:{"value":(_vm.searchText)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value},function($event){_vm.searchInput()}],"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.searchEnter()}}}),_vm._v(" "),_c('i',{staticClass:"search icon"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.searching),expression:"searching"}],staticClass:"ui small active inline loader"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.searching),expression:"!searching"}]},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.searchText && !_vm.searchResults.length),expression:"searchText && !searchResults.length"}],staticClass:"ui error message noResults"},[_vm._v(_vm._s(_vm.text.publicNoMemoSets))]),_vm._v(" "),_c('div',{staticClass:"ui link divided items"},_vm._l((_vm.searchResults),function(memoSet){return _c('router-link',{key:memoSet.memoSetId,staticClass:"item",attrs:{"to":'public-memo-sets/' + memoSet.memoSetId + '/' + memoSet.slug}},[_c('div',{staticClass:"ui small image"},[_c('img',{attrs:{"src":memoSet.coverImage}})]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"ui grid"},[_c('div',{class:{'eight wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"ui header noBottomMargin"},[_vm._v("\n                  "+_vm._s(memoSet.title)+"\n                ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(memoSet.description),expression:"memoSet.description"}],staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.sanitize(memoSet.description))}})]),_vm._v(" "),_c('div',{class:{'eight wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',[_c('h4',{staticClass:"rightLabel"},[_c('b',[_vm._v(_vm._s(_vm.text.publicAuthor)+":")])]),_vm._v("\n                  "+_vm._s(memoSet.ownerName)+"\n                  "),_c('br'),_vm._v(" "),_c('h4',{staticClass:"rightLabel"},[_c('b',[_vm._v(_vm._s(_vm.text.commonRows)+":")])]),_vm._v("\n                  "+_vm._s(memoSet.rowCount)+"\n                  "),_c('br'),_vm._v(" "),_c('h4',{staticClass:"rightLabel"},[_c('b',[_vm._v(_vm._s(_vm.text.publicRating)+":")])]),_vm._v(" "),_c('div',{staticClass:"ui yellow star rating",staticStyle:{"position":"relative","width":"7rem"}},[_c('div',{staticStyle:{"margin-top":"-1rem","position":"absolute"}},[_c('i',{staticClass:"star icon largeInactiveStar"}),_vm._v(" "),_c('i',{staticClass:"star icon largeInactiveStar"}),_vm._v(" "),_c('i',{staticClass:"star icon largeInactiveStar"}),_vm._v(" "),_c('i',{staticClass:"star icon largeInactiveStar"}),_vm._v(" "),_c('i',{staticClass:"star icon largeInactiveStar"})]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"-1rem","position":"absolute","overflow-x":"hidden"},style:({width: memoSet.ratingWidth + 'rem'})},[_c('i',{staticClass:"star active icon"}),_vm._v(" "),_c('i',{staticClass:"star active icon"}),_vm._v(" "),_c('i',{staticClass:"star active icon"}),_vm._v(" "),_c('i',{staticClass:"star active icon"}),_vm._v(" "),_c('i',{staticClass:"star active icon"})])]),_vm._v(" "),_c('span',{staticClass:"ratingsCount"},[_vm._v("("+_vm._s(memoSet.ratingsCount)+")")])])])])])])}))]),_vm._v(" "),_c('br'),_c('br')])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SharedMemoSets_vue__ = __webpack_require__(91);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5efa3e7c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SharedMemoSets_vue__ = __webpack_require__(197);
function injectStyle (ssrContext) {
  __webpack_require__(196)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5efa3e7c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SharedMemoSets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5efa3e7c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SharedMemoSets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_vm._v(" "),_c('div',{staticClass:"innerWrapper",class:{'mobile': _vm.mobile}},[_c('div',{staticClass:"ui link divided items"},_vm._l((_vm.sharedMemoSets),function(memoSet){return _c('router-link',{key:memoSet.memoSetId,staticClass:"item",attrs:{"to":'shared-memo-sets/' + memoSet.memoSetId + '/' + memoSet.slug}},[_c('div',{staticClass:"ui small image"},[_c('img',{attrs:{"src":memoSet.coverImage}})]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"ui grid"},[_c('div',{class:{'eight wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',{staticClass:"ui header"},[_vm._v("\n                "+_vm._s(memoSet.title)+"\n              ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(memoSet.description !== _vm.text.memoSetDefaultDescription),expression:"memoSet.description !== text.memoSetDefaultDescription"}],staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.sanitize(memoSet.description))}})]),_vm._v(" "),_c('div',{class:{'eight wide column': !_vm.mobile, 'sixteen wide column': _vm.mobile}},[_c('div',[_c('div',{staticClass:"rightLabel"},[_c('b',[_vm._v(_vm._s(_vm.text.publicAuthor)+":")])]),_vm._v("\n                "+_vm._s(memoSet.ownerName)+"\n                "),_c('br'),_vm._v(" "),_c('div',{staticClass:"rightLabel"},[_c('b',[_vm._v(_vm._s(_vm.text.commonRows)+":")])]),_vm._v("\n                "+_vm._s(memoSet.rowCount)+"\n              ")])])])])])})),_vm._v(" "),_c('br'),_c('br')])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 198 */,
/* 199 */,
/* 200 */
/***/ (function(module, exports) {

module.exports = {"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}

/***/ }),
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 209 */,
/* 210 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[116]);


// WEBPACK FOOTER //
// static/js/app.ec7bf77c97d1b1268425.js